type SomeOf<T> = T[keyof T];

/** post /v1/pub/clerk/webhook */
type PostV1PubClerkWebhookInput = {} & any;

/** post /v1/pub/clerk/webhook */
type PostV1PubClerkWebhookPositiveVariant1 = {
    status: "success";
    data: {
        success: boolean;
        message: string;
    };
};

/** post /v1/pub/clerk/webhook */
interface PostV1PubClerkWebhookPositiveResponseVariants {
    200: PostV1PubClerkWebhookPositiveVariant1;
}

/** post /v1/pub/clerk/webhook */
type PostV1PubClerkWebhookNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/pub/clerk/webhook */
interface PostV1PubClerkWebhookNegativeResponseVariants {
    400: PostV1PubClerkWebhookNegativeVariant1;
}

/** post /v1/pub/login */
type PostV1PubLoginInput = {
    password: string;
};

/** post /v1/pub/login */
type PostV1PubLoginPositiveVariant1 = {
    status: "success";
    data: {
        success: boolean;
    };
};

/** post /v1/pub/login */
interface PostV1PubLoginPositiveResponseVariants {
    200: PostV1PubLoginPositiveVariant1;
}

/** post /v1/pub/login */
type PostV1PubLoginNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/pub/login */
interface PostV1PubLoginNegativeResponseVariants {
    400: PostV1PubLoginNegativeVariant1;
}

/** get /v1/pub/campaigns */
type GetV1PubCampaignsInput = {
    page?: number | undefined;
    size?: number | undefined;
};

/** get /v1/pub/campaigns */
type GetV1PubCampaignsPositiveVariant1 = {
    status: "success";
    data: {
        campaigns: {
            _id: string;
            name: string;
            description: string;
            status: "DRAFT" | "PENDING_PAYMENT" | "ACTIVE" | "PAUSED" | "FINISHED";
            framing: {
                startDate: string;
                endDate?: string | undefined;
                maxBudgetPerPost?: number | undefined;
            };
            brand: {
                name: string;
                websiteUrl?: string | undefined;
                logoSource?: string | undefined;
            };
        }[];
        hasMore: boolean;
        total: number;
        currency: "EUR" | "USD";
    };
};

/** get /v1/pub/campaigns */
interface GetV1PubCampaignsPositiveResponseVariants {
    200: GetV1PubCampaignsPositiveVariant1;
}

/** get /v1/pub/campaigns */
type GetV1PubCampaignsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/pub/campaigns */
interface GetV1PubCampaignsNegativeResponseVariants {
    400: GetV1PubCampaignsNegativeVariant1;
}

/** get /v1/pub/campaign-invitations/:token */
type GetV1PubCampaignInvitationsTokenInput = {
    token: string;
};

/** get /v1/pub/campaign-invitations/:token */
type GetV1PubCampaignInvitationsTokenPositiveVariant1 = {
    status: "success";
    data: {
        state: "open" | "accepted" | "declined";
        nextStep?: ("create_account" | "connect_linkedin") | undefined;
        signupUrl?: string | undefined;
        expiresAt: string;
        creator: {
            firstName: string;
        };
        brand: {
            name: string;
            domain?: string | undefined;
        };
        campaign: {
            name: string;
            startDate?: string | undefined;
            endDate?: string | undefined;
            brief: {
                keyMessage?: string | undefined;
                do: string[];
                avoid: string[];
                tones: ("concrete" | "educational" | "personal" | "light_humour")[];
            };
        };
        offer: {
            capStatus: "known" | "pending";
            cap?: number | undefined;
            cpm: number;
            capReachedAtViews?: number | undefined;
            creatorFee?: number | undefined;
            creatorFeePercent: number;
            netAfterFee?: number | undefined;
            publishedAt: string;
            viewsCountedAt: string;
            paymentDate: string;
            example?: {
                views: number;
                gross: number;
                net: number;
            } | undefined;
        };
    };
};

/** get /v1/pub/campaign-invitations/:token */
interface GetV1PubCampaignInvitationsTokenPositiveResponseVariants {
    200: GetV1PubCampaignInvitationsTokenPositiveVariant1;
}

/** get /v1/pub/campaign-invitations/:token */
type GetV1PubCampaignInvitationsTokenNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/pub/campaign-invitations/:token */
interface GetV1PubCampaignInvitationsTokenNegativeResponseVariants {
    400: GetV1PubCampaignInvitationsTokenNegativeVariant1;
}

/** post /v1/pub/campaign-invitations/:token/accept */
type PostV1PubCampaignInvitationsTokenAcceptInput = {
    token: string;
};

/** post /v1/pub/campaign-invitations/:token/accept */
type PostV1PubCampaignInvitationsTokenAcceptPositiveVariant1 = {
    status: "success";
    data: {
        state: "accepted" | "declined";
        nextStep?: ("create_account" | "connect_linkedin") | undefined;
        signupUrl?: string | undefined;
    };
};

/** post /v1/pub/campaign-invitations/:token/accept */
interface PostV1PubCampaignInvitationsTokenAcceptPositiveResponseVariants {
    200: PostV1PubCampaignInvitationsTokenAcceptPositiveVariant1;
}

/** post /v1/pub/campaign-invitations/:token/accept */
type PostV1PubCampaignInvitationsTokenAcceptNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/pub/campaign-invitations/:token/accept */
interface PostV1PubCampaignInvitationsTokenAcceptNegativeResponseVariants {
    400: PostV1PubCampaignInvitationsTokenAcceptNegativeVariant1;
}

/** post /v1/pub/campaign-invitations/:token/decline */
type PostV1PubCampaignInvitationsTokenDeclineInput = {
    token: string;
};

/** post /v1/pub/campaign-invitations/:token/decline */
type PostV1PubCampaignInvitationsTokenDeclinePositiveVariant1 = {
    status: "success";
    data: {
        state: "accepted" | "declined";
        nextStep?: ("create_account" | "connect_linkedin") | undefined;
        signupUrl?: string | undefined;
    };
};

/** post /v1/pub/campaign-invitations/:token/decline */
interface PostV1PubCampaignInvitationsTokenDeclinePositiveResponseVariants {
    200: PostV1PubCampaignInvitationsTokenDeclinePositiveVariant1;
}

/** post /v1/pub/campaign-invitations/:token/decline */
type PostV1PubCampaignInvitationsTokenDeclineNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/pub/campaign-invitations/:token/decline */
interface PostV1PubCampaignInvitationsTokenDeclineNegativeResponseVariants {
    400: PostV1PubCampaignInvitationsTokenDeclineNegativeVariant1;
}

/** get /v1/pub/creator-signup/:token */
type GetV1PubCreatorSignupTokenInput = {
    token: string;
};

/** get /v1/pub/creator-signup/:token */
type GetV1PubCreatorSignupTokenPositiveVariant1 = {
    status: "success";
    data: {
        givenName: string;
        familyName: string;
        title?: string | undefined;
        linkedinUrl: string;
        location?: string | undefined;
        expiresAt: string;
    };
};

/** get /v1/pub/creator-signup/:token */
interface GetV1PubCreatorSignupTokenPositiveResponseVariants {
    200: GetV1PubCreatorSignupTokenPositiveVariant1;
}

/** get /v1/pub/creator-signup/:token */
type GetV1PubCreatorSignupTokenNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/pub/creator-signup/:token */
interface GetV1PubCreatorSignupTokenNegativeResponseVariants {
    400: GetV1PubCreatorSignupTokenNegativeVariant1;
}

/** post /v1/pub/webhook/stripe */
type PostV1PubWebhookStripeInput = {};

/** post /v1/pub/webhook/stripe */
type PostV1PubWebhookStripePositiveVariant1 = {
    status: "success";
    data: {};
};

/** post /v1/pub/webhook/stripe */
interface PostV1PubWebhookStripePositiveResponseVariants {
    200: PostV1PubWebhookStripePositiveVariant1;
}

/** post /v1/pub/webhook/stripe */
type PostV1PubWebhookStripeNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/pub/webhook/stripe */
interface PostV1PubWebhookStripeNegativeResponseVariants {
    400: PostV1PubWebhookStripeNegativeVariant1;
}

/** get /v1/pub/creators */
type GetV1PubCreatorsInput = {
    creatorId: string;
};

/** get /v1/pub/creators */
type GetV1PubCreatorsPositiveVariant1 = {
    status: "success";
    data: {
        _id: string;
        smmUserId?: string | undefined;
        name?: string | undefined;
        givenName: string;
        familyName: string;
        linkedinId?: string | undefined;
        linkedinUrl?: string | undefined;
        title?: string | undefined;
        picture?: (string | null) | undefined;
        language?: string | undefined;
        avgViewsPerPost?: (number | null) | undefined;
        medianViewsPerPost?: (number | null) | undefined;
        followers?: number | undefined;
        membersReached?: number | undefined;
        sector?: string | undefined;
        pricePerPost?: (number | null) | undefined;
        defaultCap?: (number | null) | undefined;
        impressions?: ({
            timeRange: "past_7_days" | "past_14_days" | "past_28_days" | "past_90_days" | "past_365_days" | "custom_timerange";
            data: {
                totalValue?: (number | null) | undefined;
                percentageChange?: (number | null) | undefined;
                series: {
                    value?: (number | null) | undefined;
                    date?: (string | null) | undefined;
                }[];
                impressions: {
                    value?: (string | null) | undefined;
                    percentageChange?: (number | null) | undefined;
                };
                reached: {
                    value?: (string | null) | undefined;
                    percentageChange?: (number | null) | undefined;
                };
                topPosts?: {
                    urn: string;
                    reactions?: (number | null) | undefined;
                    comments?: (number | null) | undefined;
                    shares?: (number | null) | undefined;
                    text?: string | undefined;
                    impressions?: string | undefined;
                    date?: string | undefined;
                }[] | undefined;
            };
        }[] | null) | undefined;
        followersDemographics?: ({
            category: "occupation_title" | "location" | "industry" | "occupation_seniority" | "company_size" | "company_name";
            data: {
                label: string;
                value: number;
                normalizedLabel?: (string | null) | undefined;
            }[];
        }[] | null) | undefined;
        updatedAt?: string | undefined;
        isPrivate?: boolean | undefined;
        favoriteTopics: {
            type: string;
            content: string;
        }[];
        lists: {
            _id: string;
            name: string;
        }[];
        campaigns: Record<("DRAFT" | "PENDING_PAYMENT" | "ACTIVE" | "PAUSED" | "FINISHED") | never, {
            _id: string;
            name: string;
        }[]>;
        creatorApplicationsCounts: Record<("pending" | "accepted" | "rejected" | "excluded" | "invited") | never, number>;
    };
};

/** get /v1/pub/creators */
interface GetV1PubCreatorsPositiveResponseVariants {
    200: GetV1PubCreatorsPositiveVariant1;
}

/** get /v1/pub/creators */
type GetV1PubCreatorsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/pub/creators */
interface GetV1PubCreatorsNegativeResponseVariants {
    400: GetV1PubCreatorsNegativeVariant1;
}

/** get /v1/pub/creators/dashboard */
type GetV1PubCreatorsDashboardInput = {
    creatorId: string;
};

/** get /v1/pub/creators/dashboard */
type GetV1PubCreatorsDashboardPositiveVariant1 = {
    status: "success";
    data: {
        dashboard: {
            linkedinNumId: string;
            impressions: {
                timeRange: "past_7_days" | "past_14_days" | "past_28_days" | "past_90_days" | "past_365_days" | "custom_timerange";
                data: {
                    totalValue?: (number | null) | undefined;
                    percentageChange?: (number | null) | undefined;
                    series: {
                        value?: (number | null) | undefined;
                        date?: (string | null) | undefined;
                    }[];
                    impressions: {
                        value?: (string | null) | undefined;
                        percentageChange?: (number | null) | undefined;
                    };
                    reached: {
                        value?: (string | null) | undefined;
                        percentageChange?: (number | null) | undefined;
                    };
                    topPosts?: {
                        urn: string;
                        reactions?: (number | null) | undefined;
                        comments?: (number | null) | undefined;
                        shares?: (number | null) | undefined;
                        text?: string | undefined;
                        impressions?: string | undefined;
                        date?: string | undefined;
                    }[] | undefined;
                };
            }[];
            engagements: {
                timeRange: "past_7_days" | "past_14_days" | "past_28_days" | "past_90_days" | "past_365_days" | "custom_timerange";
                data: {
                    totalValue?: (number | null) | undefined;
                    percentageChange?: (number | null) | undefined;
                    series: {
                        value?: (number | null) | undefined;
                        date?: (string | null) | undefined;
                    }[];
                    reactions: string;
                    comments: string;
                    reposts: string;
                };
            }[];
            audiences: {
                timeRange: "past_7_days" | "past_14_days" | "past_28_days" | "past_90_days" | "past_365_days" | "custom_timerange";
                data: {
                    totalValue?: (number | null) | undefined;
                    percentageChange?: (number | null) | undefined;
                    series: {
                        value?: (number | null) | undefined;
                        date?: (string | null) | undefined;
                    }[];
                };
            }[];
            followersDemographics?: ({
                category: "occupation_title" | "location" | "industry" | "occupation_seniority" | "company_size" | "company_name";
                data: {
                    label: string;
                    value: number;
                    normalizedLabel?: (string | null) | undefined;
                }[];
            }[] | null) | undefined;
            _id: string;
            createdAt: string;
            updatedAt: string;
        } | "creators_data_are_private";
    };
};

/** get /v1/pub/creators/dashboard */
interface GetV1PubCreatorsDashboardPositiveResponseVariants {
    200: GetV1PubCreatorsDashboardPositiveVariant1;
}

/** get /v1/pub/creators/dashboard */
type GetV1PubCreatorsDashboardNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/pub/creators/dashboard */
interface GetV1PubCreatorsDashboardNegativeResponseVariants {
    400: GetV1PubCreatorsDashboardNegativeVariant1;
}

/** get /v1/pub/creators/posts */
type GetV1PubCreatorsPostsInput = {
    creatorId: string;
    linkedinId: string;
    page?: number | undefined;
    size?: number | undefined;
};

/** get /v1/pub/creators/posts */
type GetV1PubCreatorsPostsPositiveVariant1 = {
    status: "success";
    data: {
        posts: {
            content: {
                text?: string | undefined;
                mediaTypes?: string[] | undefined;
                medias?: any[] | undefined;
                edited?: boolean | undefined;
                language?: string | undefined;
            };
            numImpressions?: (number | null) | undefined;
            numLikes?: (number | null) | undefined;
            numComments?: (number | null) | undefined;
            date?: string | undefined;
            shareUrn?: string | undefined;
        }[];
    };
};

/** get /v1/pub/creators/posts */
interface GetV1PubCreatorsPostsPositiveResponseVariants {
    200: GetV1PubCreatorsPostsPositiveVariant1;
}

/** get /v1/pub/creators/posts */
type GetV1PubCreatorsPostsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/pub/creators/posts */
interface GetV1PubCreatorsPostsNegativeResponseVariants {
    400: GetV1PubCreatorsPostsNegativeVariant1;
}

/** get /v1/pub/creators/sitemap */
type GetV1PubCreatorsSitemapInput = {};

/** get /v1/pub/creators/sitemap */
type GetV1PubCreatorsSitemapPositiveVariant1 = {
    status: "success";
    data: {
        creators: {
            _id: string;
            name?: string | undefined;
            updatedAt?: string | undefined;
        }[];
    };
};

/** get /v1/pub/creators/sitemap */
interface GetV1PubCreatorsSitemapPositiveResponseVariants {
    200: GetV1PubCreatorsSitemapPositiveVariant1;
}

/** get /v1/pub/creators/sitemap */
type GetV1PubCreatorsSitemapNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/pub/creators/sitemap */
interface GetV1PubCreatorsSitemapNegativeResponseVariants {
    400: GetV1PubCreatorsSitemapNegativeVariant1;
}

/** get /v1/pub/health */
type GetV1PubHealthInput = {};

/** get /v1/pub/health */
type GetV1PubHealthPositiveVariant1 = {
    status: "success";
    data: {
        status: "ok";
    };
};

/** get /v1/pub/health */
interface GetV1PubHealthPositiveResponseVariants {
    200: GetV1PubHealthPositiveVariant1;
}

/** get /v1/pub/health */
type GetV1PubHealthNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/pub/health */
interface GetV1PubHealthNegativeResponseVariants {
    400: GetV1PubHealthNegativeVariant1;
}

/** get /v1/pub/sponsoring/stats */
type GetV1PubSponsoringStatsInput = {};

/** get /v1/pub/sponsoring/stats */
type GetV1PubSponsoringStatsPositiveVariant1 = {
    status: "success";
    data: {
        totalPaidLast30DaysAmount: number;
        activeCampaignsCount: number;
        recentPayouts: {
            creatorLabel: string;
            amount: number;
        }[];
        typicalPayoutRange: {
            min: number;
            max: number;
        } | null;
        brandsCount: number;
        creatorsCount: number;
        maxBudgetPerPost: number;
    };
};

/** get /v1/pub/sponsoring/stats */
interface GetV1PubSponsoringStatsPositiveResponseVariants {
    200: GetV1PubSponsoringStatsPositiveVariant1;
}

/** get /v1/pub/sponsoring/stats */
type GetV1PubSponsoringStatsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/pub/sponsoring/stats */
interface GetV1PubSponsoringStatsNegativeResponseVariants {
    400: GetV1PubSponsoringStatsNegativeVariant1;
}

/** get /v1/pub/translations/:language */
type GetV1PubTranslationsLanguageInput = {
    language: "en" | "fr" | "es" | "de";
};

/** get /v1/pub/translations/:language */
type GetV1PubTranslationsLanguagePositiveVariant1 = {
    status: "success";
    data: {
        translations: Record<string, unknown>;
    };
};

/** get /v1/pub/translations/:language */
interface GetV1PubTranslationsLanguagePositiveResponseVariants {
    200: GetV1PubTranslationsLanguagePositiveVariant1;
}

/** get /v1/pub/translations/:language */
type GetV1PubTranslationsLanguageNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/pub/translations/:language */
interface GetV1PubTranslationsLanguageNegativeResponseVariants {
    400: GetV1PubTranslationsLanguageNegativeVariant1;
}

/** get /v1/prv/lists */
type GetV1PrvListsInput = {
    listId: string;
};

/** get /v1/prv/lists */
type GetV1PrvListsPositiveVariant1 = {
    status: "success";
    data: {
        listFound: {
            _id: string;
            name: string;
            creatorIds: string[];
            userId: string;
        };
    };
};

/** get /v1/prv/lists */
interface GetV1PrvListsPositiveResponseVariants {
    200: GetV1PrvListsPositiveVariant1;
}

/** get /v1/prv/lists */
type GetV1PrvListsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/lists */
interface GetV1PrvListsNegativeResponseVariants {
    400: GetV1PrvListsNegativeVariant1;
}

/** post /v1/prv/lists */
type PostV1PrvListsInput = {
    name: string;
    creatorIds?: string[] | undefined;
};

/** post /v1/prv/lists */
type PostV1PrvListsPositiveVariant1 = {
    status: "success";
    data: {
        createdListId: string;
    };
};

/** post /v1/prv/lists */
interface PostV1PrvListsPositiveResponseVariants {
    200: PostV1PrvListsPositiveVariant1;
}

/** post /v1/prv/lists */
type PostV1PrvListsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/prv/lists */
interface PostV1PrvListsNegativeResponseVariants {
    400: PostV1PrvListsNegativeVariant1;
}

/** put /v1/prv/lists */
type PutV1PrvListsInput = {
    listId: string;
    newListName: string;
};

/** put /v1/prv/lists */
type PutV1PrvListsPositiveVariant1 = {
    status: "success";
    data: {
        modifiedCount: number;
    };
};

/** put /v1/prv/lists */
interface PutV1PrvListsPositiveResponseVariants {
    200: PutV1PrvListsPositiveVariant1;
}

/** put /v1/prv/lists */
type PutV1PrvListsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** put /v1/prv/lists */
interface PutV1PrvListsNegativeResponseVariants {
    400: PutV1PrvListsNegativeVariant1;
}

/** post /v1/prv/lists/delete */
type PostV1PrvListsDeleteInput = {} & ({
    mode: "selectedOnly";
    selectedIds: string[];
} | {
    mode: "all";
    filters: {};
    excludedIds: string[];
});

/** post /v1/prv/lists/delete */
type PostV1PrvListsDeletePositiveVariant1 = {
    status: "success";
    data: {
        deletedCount: number;
    };
};

/** post /v1/prv/lists/delete */
interface PostV1PrvListsDeletePositiveResponseVariants {
    200: PostV1PrvListsDeletePositiveVariant1;
}

/** post /v1/prv/lists/delete */
type PostV1PrvListsDeleteNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/prv/lists/delete */
interface PostV1PrvListsDeleteNegativeResponseVariants {
    400: PostV1PrvListsDeleteNegativeVariant1;
}

/** get /v1/prv/lists/all */
type GetV1PrvListsAllInput = {
    page?: number | undefined;
    size?: number | undefined;
    sort?: string | undefined;
};

/** get /v1/prv/lists/all */
type GetV1PrvListsAllPositiveVariant1 = {
    status: "success";
    data: {
        total: number;
        lists: {
            _id: string;
            name: string;
            creatorCount: number;
            viewsLast28Days: number;
            userId: string;
        }[];
    };
};

/** get /v1/prv/lists/all */
interface GetV1PrvListsAllPositiveResponseVariants {
    200: GetV1PrvListsAllPositiveVariant1;
}

/** get /v1/prv/lists/all */
type GetV1PrvListsAllNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/lists/all */
interface GetV1PrvListsAllNegativeResponseVariants {
    400: GetV1PrvListsAllNegativeVariant1;
}

/** put /v1/prv/lists/creators/add */
type PutV1PrvListsCreatorsAddInput = {} & ({
    listId: string;
} & ({
    mode: "selectedOnly";
    selectedIds: string[];
} | {
    mode: "all";
    filters: any;
    excludedIds: string[];
}));

/** put /v1/prv/lists/creators/add */
type PutV1PrvListsCreatorsAddPositiveVariant1 = {
    status: "success";
    data: {
        modifiedCount: number;
    };
};

/** put /v1/prv/lists/creators/add */
interface PutV1PrvListsCreatorsAddPositiveResponseVariants {
    200: PutV1PrvListsCreatorsAddPositiveVariant1;
}

/** put /v1/prv/lists/creators/add */
type PutV1PrvListsCreatorsAddNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** put /v1/prv/lists/creators/add */
interface PutV1PrvListsCreatorsAddNegativeResponseVariants {
    400: PutV1PrvListsCreatorsAddNegativeVariant1;
}

/** put /v1/prv/lists/creators/remove */
type PutV1PrvListsCreatorsRemoveInput = {} & ({
    listId: string;
} & ({
    mode: "selectedOnly";
    selectedIds: string[];
} | {
    mode: "all";
    filters: any;
    excludedIds: string[];
}));

/** put /v1/prv/lists/creators/remove */
type PutV1PrvListsCreatorsRemovePositiveVariant1 = {
    status: "success";
    data: {
        modifiedCount: number;
    };
};

/** put /v1/prv/lists/creators/remove */
interface PutV1PrvListsCreatorsRemovePositiveResponseVariants {
    200: PutV1PrvListsCreatorsRemovePositiveVariant1;
}

/** put /v1/prv/lists/creators/remove */
type PutV1PrvListsCreatorsRemoveNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** put /v1/prv/lists/creators/remove */
interface PutV1PrvListsCreatorsRemoveNegativeResponseVariants {
    400: PutV1PrvListsCreatorsRemoveNegativeVariant1;
}

/** put /v1/prv/lists/creators/empty */
type PutV1PrvListsCreatorsEmptyInput = {
    listId: string;
};

/** put /v1/prv/lists/creators/empty */
type PutV1PrvListsCreatorsEmptyPositiveVariant1 = {
    status: "success";
    data: {
        modifiedCount: number;
    };
};

/** put /v1/prv/lists/creators/empty */
interface PutV1PrvListsCreatorsEmptyPositiveResponseVariants {
    200: PutV1PrvListsCreatorsEmptyPositiveVariant1;
}

/** put /v1/prv/lists/creators/empty */
type PutV1PrvListsCreatorsEmptyNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** put /v1/prv/lists/creators/empty */
interface PutV1PrvListsCreatorsEmptyNegativeResponseVariants {
    400: PutV1PrvListsCreatorsEmptyNegativeVariant1;
}

/** get /v1/prv/brands */
type GetV1PrvBrandsInput = {};

/** get /v1/prv/brands */
type GetV1PrvBrandsPositiveVariant1 = {
    status: "success";
    data: {
        brands: {
            _id: string;
            name: string;
            websiteUrl?: string | undefined;
            country?: string | undefined;
            language?: string | undefined;
            description?: string | undefined;
            logoKey?: string | undefined;
            filesKeys?: string[] | undefined;
            keyFeatures?: string | undefined;
            linkedinUrl?: string | undefined;
            socialProofs?: ({
                type: "metric";
                value: number;
                name: string;
            } | {
                type: "rating";
                rating: number;
                maxRating?: number | undefined;
                plateform: string;
            })[] | undefined;
            targetAudience?: {
                occupations: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | null;
                occupationSeniority: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | null;
                companySize: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | null;
                industries: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | null;
                locations: string[] | null;
            } | undefined;
            targetCustomers?: string | undefined;
            analyzedAt?: string | undefined;
            logoSource?: string | undefined;
            filesMetadatas?: {
                fileName: string;
                fileSizeBytes?: number | undefined;
                lastModified?: string | undefined;
            }[] | undefined;
            numberOfActiveCampaigns: number;
            campaignsCount: number;
            publishedPostsCount: number;
            analysisStale: boolean;
            runningCampaign?: {
                name: string;
                startDate?: string | undefined;
                endDate?: string | undefined;
                publishedPostsCount: number;
            } | undefined;
        }[];
    };
};

/** get /v1/prv/brands */
interface GetV1PrvBrandsPositiveResponseVariants {
    200: GetV1PrvBrandsPositiveVariant1;
}

/** get /v1/prv/brands */
type GetV1PrvBrandsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/brands */
interface GetV1PrvBrandsNegativeResponseVariants {
    400: GetV1PrvBrandsNegativeVariant1;
}

/** post /v1/prv/brands */
type PostV1PrvBrandsInput = {
    name: string;
    websiteUrl?: undefined | undefined;
    country?: string | undefined;
    language?: string | undefined;
    description?: undefined | undefined;
    logoKey?: string | undefined;
    filesKeys?: string[] | undefined;
    keyFeatures?: string | undefined;
    linkedinUrl?: undefined | undefined;
    socialProofs?: ({
        type: "metric";
        value: number;
        name: string;
    } | {
        type: "rating";
        rating: number;
        maxRating?: number | undefined;
        plateform: string;
    })[] | undefined;
    targetAudience?: {
        occupations: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | null;
        occupationSeniority: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | null;
        companySize: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | null;
        industries: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | null;
        locations: string[] | null;
    } | undefined;
    targetCustomers?: undefined | undefined;
    analysisId?: string | undefined;
    imageUrls?: string[] | undefined;
};

/** post /v1/prv/brands */
type PostV1PrvBrandsPositiveVariant1 = {
    status: "success";
    data: {
        brand: {
            _id: string;
            name: string;
            websiteUrl?: string | undefined;
            country?: string | undefined;
            language?: string | undefined;
            description?: string | undefined;
            logoKey?: string | undefined;
            filesKeys?: string[] | undefined;
            keyFeatures?: string | undefined;
            linkedinUrl?: string | undefined;
            socialProofs?: ({
                type: "metric";
                value: number;
                name: string;
            } | {
                type: "rating";
                rating: number;
                maxRating?: number | undefined;
                plateform: string;
            })[] | undefined;
            targetAudience?: {
                occupations: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | null;
                occupationSeniority: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | null;
                companySize: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | null;
                industries: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | null;
                locations: string[] | null;
            } | undefined;
            targetCustomers?: string | undefined;
            analyzedAt?: string | undefined;
        };
    };
};

/** post /v1/prv/brands */
interface PostV1PrvBrandsPositiveResponseVariants {
    200: PostV1PrvBrandsPositiveVariant1;
}

/** post /v1/prv/brands */
type PostV1PrvBrandsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/prv/brands */
interface PostV1PrvBrandsNegativeResponseVariants {
    400: PostV1PrvBrandsNegativeVariant1;
}

/** put /v1/prv/brands */
type PutV1PrvBrandsInput = {
    _id: string;
    name: string;
    websiteUrl?: undefined | undefined;
    country?: string | undefined;
    language?: string | undefined;
    description?: undefined | undefined;
    logoKey?: string | undefined;
    filesKeys?: string[] | undefined;
    keyFeatures?: string | undefined;
    linkedinUrl?: undefined | undefined;
    socialProofs?: ({
        type: "metric";
        value: number;
        name: string;
    } | {
        type: "rating";
        rating: number;
        maxRating?: number | undefined;
        plateform: string;
    })[] | undefined;
    targetAudience?: {
        occupations: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | null;
        occupationSeniority: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | null;
        companySize: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | null;
        industries: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | null;
        locations: string[] | null;
    } | undefined;
    targetCustomers?: undefined | undefined;
};

/** put /v1/prv/brands */
type PutV1PrvBrandsPositiveVariant1 = {
    status: "success";
    data: {
        brandId: string;
    };
};

/** put /v1/prv/brands */
interface PutV1PrvBrandsPositiveResponseVariants {
    200: PutV1PrvBrandsPositiveVariant1;
}

/** put /v1/prv/brands */
type PutV1PrvBrandsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** put /v1/prv/brands */
interface PutV1PrvBrandsNegativeResponseVariants {
    400: PutV1PrvBrandsNegativeVariant1;
}

/** delete /v1/prv/brands */
type DeleteV1PrvBrandsInput = {
    brandId: string;
};

/** delete /v1/prv/brands */
type DeleteV1PrvBrandsPositiveVariant1 = {
    status: "success";
    data: {
        success: boolean;
    };
};

/** delete /v1/prv/brands */
interface DeleteV1PrvBrandsPositiveResponseVariants {
    200: DeleteV1PrvBrandsPositiveVariant1;
}

/** delete /v1/prv/brands */
type DeleteV1PrvBrandsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** delete /v1/prv/brands */
interface DeleteV1PrvBrandsNegativeResponseVariants {
    400: DeleteV1PrvBrandsNegativeVariant1;
}

/** post /v1/prv/brands/analyze */
type PostV1PrvBrandsAnalyzeInput = {
    url: string;
    brandId?: string | undefined;
    userLanguage?: string | undefined;
};

/** post /v1/prv/brands/analyze */
type PostV1PrvBrandsAnalyzePositiveVariant1 = {
    status: "success";
    data: {
        analysisId: string;
    };
};

/** post /v1/prv/brands/analyze */
interface PostV1PrvBrandsAnalyzePositiveResponseVariants {
    200: PostV1PrvBrandsAnalyzePositiveVariant1;
}

/** post /v1/prv/brands/analyze */
type PostV1PrvBrandsAnalyzeNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/prv/brands/analyze */
interface PostV1PrvBrandsAnalyzeNegativeResponseVariants {
    400: PostV1PrvBrandsAnalyzeNegativeVariant1;
}

/** get /v1/prv/brands/analyze/:analysisId */
type GetV1PrvBrandsAnalyzeAnalysisIdInput = {
    analysisId: string;
};

/** get /v1/prv/brands/analyze/:analysisId */
type GetV1PrvBrandsAnalyzeAnalysisIdPositiveVariant1 = {
    status: "success";
    data: {
        status: "running" | "done" | "failed";
        steps: {
            key: "home" | "pages" | "reviews" | "writing";
            label: string;
            state: "pending" | "running" | "done";
            count?: number | undefined;
        }[];
        result?: {
            name: string;
            logoUrl?: string | undefined;
            country?: string | undefined;
            language?: string | undefined;
            linkedinUrl?: string | undefined;
            description: string;
            keyFeatures: string[];
            socialProofs: ({
                type: "metric";
                value: number;
                name: string;
            } | {
                type: "rating";
                rating: number;
                maxRating?: number | undefined;
                plateform: string;
            })[];
            imageUrls?: string[] | undefined;
            targetAudience: {
                occupations: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | null;
                occupationSeniority: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | null;
                companySize: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | null;
                industries: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | null;
                locations: string[] | null;
            };
            suggestedTargets: {
                label: string;
                targets: {
                    minFollowers?: (number | null) | undefined;
                    minViews?: (number | null) | undefined;
                    minViewsLast28Days?: (number | null) | undefined;
                    language?: (string | null) | undefined;
                    audienceLocation?: string[] | undefined;
                    hierarchyLevel?: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | undefined;
                    industry?: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | undefined;
                    companySize?: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | undefined;
                    occupation?: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | undefined;
                };
                eligibleCount: number | null;
                reason?: string | undefined;
                audienceReached?: string[] | undefined;
            }[];
        } | undefined;
        error?: string | undefined;
    };
};

/** get /v1/prv/brands/analyze/:analysisId */
interface GetV1PrvBrandsAnalyzeAnalysisIdPositiveResponseVariants {
    200: GetV1PrvBrandsAnalyzeAnalysisIdPositiveVariant1;
}

/** get /v1/prv/brands/analyze/:analysisId */
type GetV1PrvBrandsAnalyzeAnalysisIdNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/brands/analyze/:analysisId */
interface GetV1PrvBrandsAnalyzeAnalysisIdNegativeResponseVariants {
    400: GetV1PrvBrandsAnalyzeAnalysisIdNegativeVariant1;
}

/** get /v1/prv/brands/:brandId */
type GetV1PrvBrandsBrandIdInput = {
    brandId: string;
};

/** get /v1/prv/brands/:brandId */
type GetV1PrvBrandsBrandIdPositiveVariant1 = {
    status: "success";
    data: {
        brand: {
            _id: string;
            name: string;
            websiteUrl?: string | undefined;
            country?: string | undefined;
            language?: string | undefined;
            description?: string | undefined;
            logoKey?: string | undefined;
            filesKeys?: string[] | undefined;
            keyFeatures?: string | undefined;
            linkedinUrl?: string | undefined;
            socialProofs?: ({
                type: "metric";
                value: number;
                name: string;
            } | {
                type: "rating";
                rating: number;
                maxRating?: number | undefined;
                plateform: string;
            })[] | undefined;
            targetAudience?: {
                occupations: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | null;
                occupationSeniority: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | null;
                companySize: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | null;
                industries: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | null;
                locations: string[] | null;
            } | undefined;
            targetCustomers?: string | undefined;
            analyzedAt?: string | undefined;
            logoSource?: string | undefined;
            filesMetadatas?: {
                fileName: string;
                fileSizeBytes?: number | undefined;
                lastModified?: string | undefined;
            }[] | undefined;
        };
    };
};

/** get /v1/prv/brands/:brandId */
interface GetV1PrvBrandsBrandIdPositiveResponseVariants {
    200: GetV1PrvBrandsBrandIdPositiveVariant1;
}

/** get /v1/prv/brands/:brandId */
type GetV1PrvBrandsBrandIdNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/brands/:brandId */
interface GetV1PrvBrandsBrandIdNegativeResponseVariants {
    400: GetV1PrvBrandsBrandIdNegativeVariant1;
}

/** patch /v1/prv/brands/:brandId */
type PatchV1PrvBrandsBrandIdInput = {
    brandId: string;
    name?: string | undefined;
    description?: string | undefined;
    keyFeatures?: string[] | undefined;
    targetCustomers?: string | undefined;
};

/** patch /v1/prv/brands/:brandId */
type PatchV1PrvBrandsBrandIdPositiveVariant1 = {
    status: "success";
    data: {
        brandId: string;
    };
};

/** patch /v1/prv/brands/:brandId */
interface PatchV1PrvBrandsBrandIdPositiveResponseVariants {
    200: PatchV1PrvBrandsBrandIdPositiveVariant1;
}

/** patch /v1/prv/brands/:brandId */
type PatchV1PrvBrandsBrandIdNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** patch /v1/prv/brands/:brandId */
interface PatchV1PrvBrandsBrandIdNegativeResponseVariants {
    400: PatchV1PrvBrandsBrandIdNegativeVariant1;
}

/** get /v1/prv/brands/:brandId/subscription */
type GetV1PrvBrandsBrandIdSubscriptionInput = {
    brandId: string;
};

/** get /v1/prv/brands/:brandId/subscription */
type GetV1PrvBrandsBrandIdSubscriptionPositiveVariant1 = {
    status: "success";
    data: {
        subscription: {
            status: "none" | "trialing" | "active" | "past_due" | "unpaid" | "canceled" | "incomplete" | "incomplete_expired" | "paused";
            hasAccess: boolean;
            trialEndsAt: string | null;
            currentPeriodEndsAt: string | null;
            cancelAtPeriodEnd: boolean;
            canStartTrial: boolean;
            existingBrandTrial: boolean;
        };
    };
};

/** get /v1/prv/brands/:brandId/subscription */
interface GetV1PrvBrandsBrandIdSubscriptionPositiveResponseVariants {
    200: GetV1PrvBrandsBrandIdSubscriptionPositiveVariant1;
}

/** get /v1/prv/brands/:brandId/subscription */
type GetV1PrvBrandsBrandIdSubscriptionNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/brands/:brandId/subscription */
interface GetV1PrvBrandsBrandIdSubscriptionNegativeResponseVariants {
    400: GetV1PrvBrandsBrandIdSubscriptionNegativeVariant1;
}

/** post /v1/prv/brands/:brandId/subscription/checkout */
type PostV1PrvBrandsBrandIdSubscriptionCheckoutInput = {
    brandId: string;
    surface?: ("legacy" | "agent" | "agent-account") | undefined;
    campaignId?: string | undefined;
};

/** post /v1/prv/brands/:brandId/subscription/checkout */
type PostV1PrvBrandsBrandIdSubscriptionCheckoutPositiveVariant1 = {
    status: "success";
    data: {
        url: string;
    };
};

/** post /v1/prv/brands/:brandId/subscription/checkout */
interface PostV1PrvBrandsBrandIdSubscriptionCheckoutPositiveResponseVariants {
    200: PostV1PrvBrandsBrandIdSubscriptionCheckoutPositiveVariant1;
}

/** post /v1/prv/brands/:brandId/subscription/checkout */
type PostV1PrvBrandsBrandIdSubscriptionCheckoutNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/prv/brands/:brandId/subscription/checkout */
interface PostV1PrvBrandsBrandIdSubscriptionCheckoutNegativeResponseVariants {
    400: PostV1PrvBrandsBrandIdSubscriptionCheckoutNegativeVariant1;
}

/** post /v1/prv/brands/:brandId/subscription/portal */
type PostV1PrvBrandsBrandIdSubscriptionPortalInput = {
    brandId: string;
    surface?: ("legacy" | "agent" | "agent-account") | undefined;
    campaignId?: string | undefined;
};

/** post /v1/prv/brands/:brandId/subscription/portal */
type PostV1PrvBrandsBrandIdSubscriptionPortalPositiveVariant1 = {
    status: "success";
    data: {
        url: string;
    };
};

/** post /v1/prv/brands/:brandId/subscription/portal */
interface PostV1PrvBrandsBrandIdSubscriptionPortalPositiveResponseVariants {
    200: PostV1PrvBrandsBrandIdSubscriptionPortalPositiveVariant1;
}

/** post /v1/prv/brands/:brandId/subscription/portal */
type PostV1PrvBrandsBrandIdSubscriptionPortalNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/prv/brands/:brandId/subscription/portal */
interface PostV1PrvBrandsBrandIdSubscriptionPortalNegativeResponseVariants {
    400: PostV1PrvBrandsBrandIdSubscriptionPortalNegativeVariant1;
}

/** post /v1/prv/brands/:brandId/subscription/cancel */
type PostV1PrvBrandsBrandIdSubscriptionCancelInput = {
    brandId: string;
};

/** post /v1/prv/brands/:brandId/subscription/cancel */
type PostV1PrvBrandsBrandIdSubscriptionCancelPositiveVariant1 = {
    status: "success";
    data: {
        subscription: {
            status: "none" | "trialing" | "active" | "past_due" | "unpaid" | "canceled" | "incomplete" | "incomplete_expired" | "paused";
            hasAccess: boolean;
            trialEndsAt: string | null;
            currentPeriodEndsAt: string | null;
            cancelAtPeriodEnd: boolean;
            canStartTrial: boolean;
            existingBrandTrial: boolean;
        };
    };
};

/** post /v1/prv/brands/:brandId/subscription/cancel */
interface PostV1PrvBrandsBrandIdSubscriptionCancelPositiveResponseVariants {
    200: PostV1PrvBrandsBrandIdSubscriptionCancelPositiveVariant1;
}

/** post /v1/prv/brands/:brandId/subscription/cancel */
type PostV1PrvBrandsBrandIdSubscriptionCancelNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/prv/brands/:brandId/subscription/cancel */
interface PostV1PrvBrandsBrandIdSubscriptionCancelNegativeResponseVariants {
    400: PostV1PrvBrandsBrandIdSubscriptionCancelNegativeVariant1;
}

/** post /v1/prv/brands/upload/logo */
type PostV1PrvBrandsUploadLogoInput = {
    brandId: string;
    logo: any;
};

/** post /v1/prv/brands/upload/logo */
type PostV1PrvBrandsUploadLogoPositiveVariant1 = {
    status: "success";
    data: {
        fileKey: string;
    };
};

/** post /v1/prv/brands/upload/logo */
interface PostV1PrvBrandsUploadLogoPositiveResponseVariants {
    200: PostV1PrvBrandsUploadLogoPositiveVariant1;
}

/** post /v1/prv/brands/upload/logo */
type PostV1PrvBrandsUploadLogoNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/prv/brands/upload/logo */
interface PostV1PrvBrandsUploadLogoNegativeResponseVariants {
    400: PostV1PrvBrandsUploadLogoNegativeVariant1;
}

/** post /v1/prv/brands/upload/file */
type PostV1PrvBrandsUploadFileInput = {
    brandId: string;
    file: any;
};

/** post /v1/prv/brands/upload/file */
type PostV1PrvBrandsUploadFilePositiveVariant1 = {
    status: "success";
    data: {
        fileKey: string;
    };
};

/** post /v1/prv/brands/upload/file */
interface PostV1PrvBrandsUploadFilePositiveResponseVariants {
    200: PostV1PrvBrandsUploadFilePositiveVariant1;
}

/** post /v1/prv/brands/upload/file */
type PostV1PrvBrandsUploadFileNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/prv/brands/upload/file */
interface PostV1PrvBrandsUploadFileNegativeResponseVariants {
    400: PostV1PrvBrandsUploadFileNegativeVariant1;
}

/** get /v1/prv/brands/download/file */
type GetV1PrvBrandsDownloadFileInput = {
    brandId: string;
    fileName: string;
};

/** get /v1/prv/brands/download/file */
type GetV1PrvBrandsDownloadFilePositiveVariant1 = {
    status: "success";
    data: {
        downloadUrl: string;
    };
};

/** get /v1/prv/brands/download/file */
interface GetV1PrvBrandsDownloadFilePositiveResponseVariants {
    200: GetV1PrvBrandsDownloadFilePositiveVariant1;
}

/** get /v1/prv/brands/download/file */
type GetV1PrvBrandsDownloadFileNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/brands/download/file */
interface GetV1PrvBrandsDownloadFileNegativeResponseVariants {
    400: GetV1PrvBrandsDownloadFileNegativeVariant1;
}

/** post /v1/prv/brands/download/files */
type PostV1PrvBrandsDownloadFilesInput = {
    brandId: string;
    fileNames: string[];
};

/** post /v1/prv/brands/download/files */
type PostV1PrvBrandsDownloadFilesPositiveVariant1 = {
    status: "success";
    data: {
        downloadUrls: {
            fileName: string;
            downloadUrl: string;
        }[];
    };
};

/** post /v1/prv/brands/download/files */
interface PostV1PrvBrandsDownloadFilesPositiveResponseVariants {
    200: PostV1PrvBrandsDownloadFilesPositiveVariant1;
}

/** post /v1/prv/brands/download/files */
type PostV1PrvBrandsDownloadFilesNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/prv/brands/download/files */
interface PostV1PrvBrandsDownloadFilesNegativeResponseVariants {
    400: PostV1PrvBrandsDownloadFilesNegativeVariant1;
}

/** get /v1/prv/creators */
type GetV1PrvCreatorsInput = {
    creatorId: string;
};

/** get /v1/prv/creators */
type GetV1PrvCreatorsPositiveVariant1 = {
    status: "success";
    data: {
        _id: string;
        smmUserId?: string | undefined;
        name?: string | undefined;
        givenName: string;
        familyName: string;
        linkedinId?: string | undefined;
        linkedinUrl?: string | undefined;
        title?: string | undefined;
        picture?: (string | null) | undefined;
        language?: string | undefined;
        avgViewsPerPost?: (number | null) | undefined;
        medianViewsPerPost?: (number | null) | undefined;
        followers?: number | undefined;
        membersReached?: number | undefined;
        sector?: string | undefined;
        pricePerPost?: (number | null) | undefined;
        defaultCap?: (number | null) | undefined;
        impressions?: ({
            timeRange: "past_7_days" | "past_14_days" | "past_28_days" | "past_90_days" | "past_365_days" | "custom_timerange";
            data: {
                totalValue?: (number | null) | undefined;
                percentageChange?: (number | null) | undefined;
                series: {
                    value?: (number | null) | undefined;
                    date?: (string | null) | undefined;
                }[];
                impressions: {
                    value?: (string | null) | undefined;
                    percentageChange?: (number | null) | undefined;
                };
                reached: {
                    value?: (string | null) | undefined;
                    percentageChange?: (number | null) | undefined;
                };
                topPosts?: {
                    urn: string;
                    reactions?: (number | null) | undefined;
                    comments?: (number | null) | undefined;
                    shares?: (number | null) | undefined;
                    text?: string | undefined;
                    impressions?: string | undefined;
                    date?: string | undefined;
                }[] | undefined;
            };
        }[] | null) | undefined;
        followersDemographics?: ({
            category: "occupation_title" | "location" | "industry" | "occupation_seniority" | "company_size" | "company_name";
            data: {
                label: string;
                value: number;
                normalizedLabel?: (string | null) | undefined;
            }[];
        }[] | null) | undefined;
        updatedAt?: string | undefined;
        isPrivate?: boolean | undefined;
        favoriteTopics: {
            type: string;
            content: string;
        }[];
        lists: {
            _id: string;
            name: string;
        }[];
        campaigns: Record<("DRAFT" | "PENDING_PAYMENT" | "ACTIVE" | "PAUSED" | "FINISHED") | never, {
            _id: string;
            name: string;
        }[]>;
        creatorApplicationsCounts: Record<("pending" | "accepted" | "rejected" | "excluded" | "invited") | never, number>;
    };
};

/** get /v1/prv/creators */
interface GetV1PrvCreatorsPositiveResponseVariants {
    200: GetV1PrvCreatorsPositiveVariant1;
}

/** get /v1/prv/creators */
type GetV1PrvCreatorsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/creators */
interface GetV1PrvCreatorsNegativeResponseVariants {
    400: GetV1PrvCreatorsNegativeVariant1;
}

/** post /v1/prv/creators/exclude */
type PostV1PrvCreatorsExcludeInput = {
    creatorId: string;
    creatorApplicationId: string;
    exclusionReason: string;
};

/** post /v1/prv/creators/exclude */
type PostV1PrvCreatorsExcludePositiveVariant1 = {
    status: "success";
    data: {
        success: boolean;
    };
};

/** post /v1/prv/creators/exclude */
interface PostV1PrvCreatorsExcludePositiveResponseVariants {
    200: PostV1PrvCreatorsExcludePositiveVariant1;
}

/** post /v1/prv/creators/exclude */
type PostV1PrvCreatorsExcludeNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/prv/creators/exclude */
interface PostV1PrvCreatorsExcludeNegativeResponseVariants {
    400: PostV1PrvCreatorsExcludeNegativeVariant1;
}

/** get /v1/prv/creators/checkCanExclude */
type GetV1PrvCreatorsCheckCanExcludeInput = {
    creatorId: string;
    creatorApplicationId: string;
};

/** get /v1/prv/creators/checkCanExclude */
type GetV1PrvCreatorsCheckCanExcludePositiveVariant1 = {
    status: "success";
    data: {
        canBeExcluded: boolean;
    };
};

/** get /v1/prv/creators/checkCanExclude */
interface GetV1PrvCreatorsCheckCanExcludePositiveResponseVariants {
    200: GetV1PrvCreatorsCheckCanExcludePositiveVariant1;
}

/** get /v1/prv/creators/checkCanExclude */
type GetV1PrvCreatorsCheckCanExcludeNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/creators/checkCanExclude */
interface GetV1PrvCreatorsCheckCanExcludeNegativeResponseVariants {
    400: GetV1PrvCreatorsCheckCanExcludeNegativeVariant1;
}

/** get /v1/prv/creators/all */
type GetV1PrvCreatorsAllInput = {
    ids?: undefined | undefined;
    excludedIds?: undefined | undefined;
    creatorListId?: string | undefined;
    searchQuery?: string | undefined;
    followers?: number | undefined;
    language?: string | undefined;
    viewsPeriod?: ("past_7_days" | "past_14_days" | "past_28_days" | "past_90_days" | "past_365_days" | "custom_timerange") | undefined;
    viewsCountForPeriod?: number | undefined;
    viewsPerPost?: number | undefined;
    industry?: undefined | undefined;
    occupationSeniority?: undefined | undefined;
    occupation?: undefined | undefined;
    location?: undefined | undefined;
    companySize?: undefined | undefined;
    pricePerPost?: number | undefined;
    postKeyword?: string | undefined;
    postKeywordDays?: number | undefined;
    page?: number | undefined;
    size?: number | undefined;
    sort?: any | undefined;
};

/** get /v1/prv/creators/all */
type GetV1PrvCreatorsAllPositiveVariant1 = {
    status: "success";
    data: {
        total: number;
        creators: {
            _id: string;
            smmUserId?: string | undefined;
            name?: string | undefined;
            givenName: string;
            familyName: string;
            linkedinId?: string | undefined;
            linkedinUrl?: string | undefined;
            title?: string | undefined;
            picture?: (string | null) | undefined;
            language?: string | undefined;
            avgViewsPerPost?: (number | null) | undefined;
            medianViewsPerPost?: (number | null) | undefined;
            followers?: number | undefined;
            membersReached?: number | undefined;
            sector?: string | undefined;
            pricePerPost?: (number | null) | undefined;
            defaultCap?: (number | null) | undefined;
            impressions?: ({
                timeRange: "past_7_days" | "past_14_days" | "past_28_days" | "past_90_days" | "past_365_days" | "custom_timerange";
                data: {
                    totalValue?: (number | null) | undefined;
                    percentageChange?: (number | null) | undefined;
                    series: {
                        value?: (number | null) | undefined;
                        date?: (string | null) | undefined;
                    }[];
                    impressions: {
                        value?: (string | null) | undefined;
                        percentageChange?: (number | null) | undefined;
                    };
                    reached: {
                        value?: (string | null) | undefined;
                        percentageChange?: (number | null) | undefined;
                    };
                    topPosts?: {
                        urn: string;
                        reactions?: (number | null) | undefined;
                        comments?: (number | null) | undefined;
                        shares?: (number | null) | undefined;
                        text?: string | undefined;
                        impressions?: string | undefined;
                        date?: string | undefined;
                    }[] | undefined;
                };
            }[] | null) | undefined;
            followersDemographics?: ({
                category: "occupation_title" | "location" | "industry" | "occupation_seniority" | "company_size" | "company_name";
                data: {
                    label: string;
                    value: number;
                    normalizedLabel?: (string | null) | undefined;
                }[];
            }[] | null) | undefined;
            updatedAt?: string | undefined;
            isPrivate?: boolean | undefined;
        }[];
    };
};

/** get /v1/prv/creators/all */
interface GetV1PrvCreatorsAllPositiveResponseVariants {
    200: GetV1PrvCreatorsAllPositiveVariant1;
}

/** get /v1/prv/creators/all */
type GetV1PrvCreatorsAllNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/creators/all */
interface GetV1PrvCreatorsAllNegativeResponseVariants {
    400: GetV1PrvCreatorsAllNegativeVariant1;
}

/** get /v1/prv/creators/with-published-campaign-post */
type GetV1PrvCreatorsWithPublishedCampaignPostInput = {
    campaignId: string;
};

/** get /v1/prv/creators/with-published-campaign-post */
type GetV1PrvCreatorsWithPublishedCampaignPostPositiveVariant1 = {
    status: "success";
    data: {
        creators: {
            _id: string;
            name?: string | undefined;
            posts: {
                _id: string;
                linkedinPostId: string;
                content: string;
            }[];
        }[];
    };
};

/** get /v1/prv/creators/with-published-campaign-post */
interface GetV1PrvCreatorsWithPublishedCampaignPostPositiveResponseVariants {
    200: GetV1PrvCreatorsWithPublishedCampaignPostPositiveVariant1;
}

/** get /v1/prv/creators/with-published-campaign-post */
type GetV1PrvCreatorsWithPublishedCampaignPostNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/creators/with-published-campaign-post */
interface GetV1PrvCreatorsWithPublishedCampaignPostNegativeResponseVariants {
    400: GetV1PrvCreatorsWithPublishedCampaignPostNegativeVariant1;
}

/** get /v1/prv/creators/dormant */
type GetV1PrvCreatorsDormantInput = {
    campaignId: string;
};

/** get /v1/prv/creators/dormant */
type GetV1PrvCreatorsDormantPositiveVariant1 = {
    status: "success";
    data: {
        dormantCreators: {
            applicationId: string;
            creatorId: string;
            creatorName: string;
            creatorPicture?: string | undefined;
            price: number;
            cpm?: number | undefined;
            status: "not_started" | "draft_pending" | "extension_inactive" | "changes_requested" | "awaiting_validation";
            canRelaunch: boolean;
            publishReminderCount: number;
            lastPublishReminderAt?: string | undefined;
            reminderExhausted: boolean;
        }[];
    };
};

/** get /v1/prv/creators/dormant */
interface GetV1PrvCreatorsDormantPositiveResponseVariants {
    200: GetV1PrvCreatorsDormantPositiveVariant1;
}

/** get /v1/prv/creators/dormant */
type GetV1PrvCreatorsDormantNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/creators/dormant */
interface GetV1PrvCreatorsDormantNegativeResponseVariants {
    400: GetV1PrvCreatorsDormantNegativeVariant1;
}

/** post /v1/prv/creators/relaunch */
type PostV1PrvCreatorsRelaunchInput = {
    creatorApplicationId: string;
};

/** post /v1/prv/creators/relaunch */
type PostV1PrvCreatorsRelaunchPositiveVariant1 = {
    status: "success";
    data: {
        success: boolean;
        status: "not_started" | "draft_pending" | "extension_inactive" | "changes_requested";
    };
};

/** post /v1/prv/creators/relaunch */
interface PostV1PrvCreatorsRelaunchPositiveResponseVariants {
    200: PostV1PrvCreatorsRelaunchPositiveVariant1;
}

/** post /v1/prv/creators/relaunch */
type PostV1PrvCreatorsRelaunchNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/prv/creators/relaunch */
interface PostV1PrvCreatorsRelaunchNegativeResponseVariants {
    400: PostV1PrvCreatorsRelaunchNegativeVariant1;
}

/** get /v1/prv/campaigns */
type GetV1PrvCampaignsInput = {
    status?: ("DRAFT" | "PENDING_PAYMENT" | "ACTIVE" | "PAUSED" | "FINISHED") | undefined;
    includeDrafts?: ("true" | "false") | undefined;
    brandIds?: string | undefined;
    searchQuery?: string | undefined;
    page?: number | undefined;
    size?: number | undefined;
};

/** get /v1/prv/campaigns */
type GetV1PrvCampaignsPositiveVariant1 = {
    status: "success";
    data: {
        campaigns: {
            _id: string;
            userId: string;
            name: string;
            description: string;
            status: "DRAFT" | "PENDING_PAYMENT" | "ACTIVE" | "PAUSED" | "FINISHED";
            paymentStatus: "PENDING" | "PAID" | "FAILED";
            paymentDeclineCode?: string | undefined;
            targets: {
                minFollowers?: (number | null) | undefined;
                minViews?: (number | null) | undefined;
                minViewsLast28Days?: (number | null) | undefined;
                language?: (string | null) | undefined;
                audienceLocation?: string[] | undefined;
                hierarchyLevel?: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | undefined;
                industry?: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | undefined;
                companySize?: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | undefined;
                occupation?: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | undefined;
            };
            framing: {
                startDate: string;
                endDate?: string | undefined;
                publicationStartDate?: string | undefined;
                publicationEndDate?: string | undefined;
                maxBudgetPerPost?: number | undefined;
                cpm?: number | undefined;
                totalBudget: number;
                totalUsedBudget?: number | undefined;
                autoValidateContent: boolean;
                autoAcceptCreators: boolean;
                autonomousCpmCeilingMultiplier?: (1 | 1.1 | 1.2) | undefined;
                capMode?: ("auto" | "fixed") | undefined;
                fixedCap?: number | undefined;
            };
            objective?: ("awareness" | "traffic" | "demos") | undefined;
            brief?: {
                keyMessage?: string | undefined;
                tones?: ("concrete" | "educational" | "personal" | "light_humour")[] | undefined;
                do?: string[] | undefined;
                avoid?: string[] | undefined;
            } | undefined;
            regions?: string[] | undefined;
            rules?: {
                minTargetAudienceShare?: number | undefined;
                askIfMostlyAbroad?: boolean | undefined;
            } | undefined;
            invitationTemplate?: string | undefined;
            sender?: {
                kind: "own_profile" | "kawaak_managed";
            } | undefined;
            postAcceptanceMode?: ("agent_auto" | "review_24h" | "manual") | undefined;
            draftStep?: ("brand" | "proposal" | "budget" | "launch") | undefined;
            suggestedTargets?: {
                label: string;
                targets: {
                    minFollowers?: (number | null) | undefined;
                    minViews?: (number | null) | undefined;
                    minViewsLast28Days?: (number | null) | undefined;
                    language?: (string | null) | undefined;
                    audienceLocation?: string[] | undefined;
                    hierarchyLevel?: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | undefined;
                    industry?: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | undefined;
                    companySize?: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | undefined;
                    occupation?: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | undefined;
                };
                eligibleCount: number | null;
                reason?: string | undefined;
                audienceReached?: string[] | undefined;
            }[] | undefined;
            agentInstructions?: string[] | undefined;
            budgetReservationTrigger?: ("acceptance" | "post_submission") | undefined;
            nbPostsToReview: number;
            utmLink?: string | undefined;
            promoCode?: string | undefined;
            stripePaymentIntentId?: string | undefined;
            stripeInvoiceId?: string | undefined;
            stripeCheckoutSessionId?: string | undefined;
            stripeRefundId?: string | undefined;
            stripeCreditNoteId?: string | undefined;
            stripeDeferredClosePaymentIntentId?: string | undefined;
            stripeDeferredCloseInvoiceId?: string | undefined;
            paymentSnapshot?: {
                source: "stripe_checkout" | "stripe_payment_intent" | "out_of_band";
                currency: "eur" | "usd";
                conversionRateFromEUR: number;
                budgetAmountInCents: number;
                platformFeeAmountInCents: number;
                taxAmountInCents: number;
                totalAmountInCents: number;
                paidAt: string;
                stripePaymentIntentId?: string | undefined;
                stripeInvoiceId?: string | undefined;
                stripeCheckoutSessionId?: string | undefined;
                externalReference?: string | undefined;
                outOfBandProof?: {
                    proofDocumentKey: string;
                    proofDocumentSha256: string;
                    proofDocumentEtag: string;
                    proofDocumentSizeBytes: number;
                    proofDocumentLastModified: string;
                    proofDocumentContentType: string;
                    proofDocumentVersionId?: string | undefined;
                    bankTransactionReference: string;
                    invoiceReference: string;
                    submittedAt: string;
                    submittedByStaffId: string;
                    approvedAt: string;
                    approvedByStaffId: string;
                } | undefined;
            } | undefined;
            paymentAttempt?: {
                attemptId: string;
                version: number;
                purpose: "INITIAL_DEPOSIT" | "DEFERRED_USAGE";
                state: "creating" | "awaiting_payment" | "paid" | "failed" | "canceled";
                currency: "eur" | "usd";
                conversionRateFromEUR: number;
                budgetAmountInCents: number;
                platformFeeAmountInCents: number;
                customerId: string;
                createdAt: string;
                updatedAt: string;
                cardCheckout?: {
                    expiresAt: number;
                    successUrl: string;
                    cancelUrl: string;
                } | undefined;
                checkoutSessionId?: string | undefined;
                stripeInvoiceId?: string | undefined;
                stripePaymentIntentId?: string | undefined;
                failureCode?: string | undefined;
            } | undefined;
            paymentAttemptHistory?: {
                attemptId: string;
                version: number;
                purpose: "INITIAL_DEPOSIT" | "DEFERRED_USAGE";
                state: "creating" | "awaiting_payment" | "paid" | "failed" | "canceled";
                currency: "eur" | "usd";
                conversionRateFromEUR: number;
                budgetAmountInCents: number;
                platformFeeAmountInCents: number;
                customerId: string;
                createdAt: string;
                updatedAt: string;
                cardCheckout?: {
                    expiresAt: number;
                    successUrl: string;
                    cancelUrl: string;
                } | undefined;
                checkoutSessionId?: string | undefined;
                stripeInvoiceId?: string | undefined;
                stripePaymentIntentId?: string | undefined;
                failureCode?: string | undefined;
            }[] | undefined;
            paymentReconciliationIssues?: {
                attemptId: string;
                stripePaymentIntentId: string;
                amountInCents: number;
                currency: string;
                reason: string;
                detectedAt: string;
            }[] | undefined;
            financialClose?: {
                state: "closing" | "awaiting_deferred_payment" | "manual_refund_required" | "manual_refund_awaiting_approval" | "manual_refund_confirmed" | "refund_pending" | "refund_failed";
                requestedAt: string;
                projectedUsedBudgetInEuros: number;
                ownerId?: string | undefined;
                leaseId?: string | undefined;
                leaseExpiresAt?: string | undefined;
                refundAmountInCents?: number | undefined;
                currency?: ("eur" | "usd") | undefined;
                error?: string | undefined;
                refundFailedAlertedAt?: string | undefined;
            } | undefined;
            agent?: {
                enabled: boolean;
                autonomyLevel?: ("assisted" | "review" | "autonomous") | undefined;
                pausedAt?: string | undefined;
                autonomyStats?: {
                    firstMessagesSent?: number | undefined;
                    firstMessagesApprovedStreak?: number | undefined;
                    repliesSent?: number | undefined;
                    repliesApprovedStreak?: number | undefined;
                } | undefined;
                autonomyProposal?: {
                    status: "proposed" | "accepted" | "refused";
                    trigger: "first_messages_sent" | "first_messages_approved" | "replies_sent" | "replies_approved";
                    proposedAt: string;
                    refusals: number;
                    firstRefusedAt?: string | undefined;
                    nextProposalAt?: string | undefined;
                } | undefined;
                poolExhaustedAt?: {
                    in_app?: string | undefined;
                    linkedin?: string | undefined;
                } | undefined;
                linkedinSourcing?: {
                    nextRunAfter?: string | undefined;
                    lastRunAt?: string | undefined;
                    lastOutcome?: string | undefined;
                    keywords?: string[] | undefined;
                    searchKey?: string | undefined;
                    nextPage?: number | undefined;
                } | undefined;
            } | undefined;
            payoutCreationLocks?: string[] | undefined;
            scheduledPayoutClaims?: string[] | undefined;
            refundedAt?: string | undefined;
            refundedBudgetInCents?: number | undefined;
            refundedFeeInCents?: number | undefined;
            refundedTaxInCents?: number | undefined;
            refundMethod?: ("stripe" | "manual") | undefined;
            manualRefundReference?: string | undefined;
            manualRefundedByStaffId?: string | undefined;
            manualRefundProof?: {
                reference: string;
                amountInCents: number;
                currency: "eur" | "usd";
                executedAt: string;
                proofDocumentKey: string;
                proofDocumentEtag: string;
                proofDocumentSizeBytes: number;
                proofDocumentLastModified: string;
                proofDocumentContentType: string;
                submittedAt: string;
                submittedByStaffId: string;
                confirmedAt?: string | undefined;
                confirmedByStaffId?: string | undefined;
            } | undefined;
            depositedAt?: string | undefined;
            firstMessagesToAcceptedCreators?: ({
                type: "text";
                text: string;
                priceEUR?: number | undefined;
                cpmEUR?: number | undefined;
            } | {
                type: "image";
                src?: string | undefined;
                metadata: {
                    name: string;
                    size: number;
                    type: string;
                    fileKey: string;
                };
            } | {
                type: "file";
                src?: string | undefined;
                metadata: {
                    name: string;
                    size: number;
                    type: string;
                    fileKey: string;
                };
            })[] | undefined;
            closedByStaffAt?: string | undefined;
            deletedAt?: string | undefined;
            currencyConversion: {
                currency: "USD";
                rateFromEUR: number;
                lockedAt: string;
            };
            initialBudgetQuote?: {
                currency: "eur" | "usd";
                budgetAmountInCents: number;
                budgetAmountInEurCents: number;
                conversionRateFromEUR: number;
                quotedAt: string;
            } | undefined;
            budgetDepositStatus?: ("PENDING" | "DEPOSITED") | undefined;
            creatorsPaidByBrand?: boolean | undefined;
            createdAt?: string | undefined;
            brand: {
                _id: string;
                name: string;
                websiteUrl?: string | undefined;
                country?: string | undefined;
                language?: string | undefined;
                description?: string | undefined;
                logoKey?: string | undefined;
                filesKeys?: string[] | undefined;
                keyFeatures?: string | undefined;
                linkedinUrl?: string | undefined;
                socialProofs?: ({
                    type: "metric";
                    value: number;
                    name: string;
                } | {
                    type: "rating";
                    rating: number;
                    maxRating?: number | undefined;
                    plateform: string;
                })[] | undefined;
                targetAudience?: {
                    occupations: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | null;
                    occupationSeniority: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | null;
                    companySize: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | null;
                    industries: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | null;
                    locations: string[] | null;
                } | undefined;
                targetCustomers?: string | undefined;
                analyzedAt?: string | undefined;
                logoSource?: string | undefined;
            };
        }[];
    };
};

/** get /v1/prv/campaigns */
interface GetV1PrvCampaignsPositiveResponseVariants {
    200: GetV1PrvCampaignsPositiveVariant1;
}

/** get /v1/prv/campaigns */
type GetV1PrvCampaignsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/campaigns */
interface GetV1PrvCampaignsNegativeResponseVariants {
    400: GetV1PrvCampaignsNegativeVariant1;
}

/** post /v1/prv/campaigns */
type PostV1PrvCampaignsInput = {
    campaignData: {
        name: string;
        description: string;
        brandId: string;
        targets: {
            minFollowers?: (number | null) | undefined;
            minViews?: (number | null) | undefined;
            minViewsLast28Days?: (number | null) | undefined;
            language?: (string | null) | undefined;
            audienceLocation?: string[] | undefined;
            hierarchyLevel?: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | undefined;
            industry?: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | undefined;
            companySize?: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | undefined;
            occupation?: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | undefined;
        };
        framing: {
            startDate: string;
            endDate?: string | undefined;
            publicationStartDate?: string | undefined;
            publicationEndDate?: string | undefined;
            maxBudgetPerPost?: number | undefined;
            cpm?: number | undefined;
            totalBudget: number;
            totalUsedBudget?: number | undefined;
            autoValidateContent: boolean;
            autoAcceptCreators: boolean;
        };
        utmLink?: string | undefined;
        promoCode?: string | undefined;
        firstMessagesToAcceptedCreators?: ({
            type: "text";
            text: string;
            priceEUR?: number | undefined;
            cpmEUR?: number | undefined;
        } | {
            type: "image";
            src?: string | undefined;
            metadata: {
                name: string;
                size: number;
                type: string;
                fileKey: string;
            };
        } | {
            type: "file";
            src?: string | undefined;
            metadata: {
                name: string;
                size: number;
                type: string;
                fileKey: string;
            };
        })[] | undefined;
    };
};

/** post /v1/prv/campaigns */
type PostV1PrvCampaignsPositiveVariant1 = {
    status: "success";
    data: {
        newCampaignId: string;
    };
};

/** post /v1/prv/campaigns */
interface PostV1PrvCampaignsPositiveResponseVariants {
    200: PostV1PrvCampaignsPositiveVariant1;
}

/** post /v1/prv/campaigns */
type PostV1PrvCampaignsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/prv/campaigns */
interface PostV1PrvCampaignsNegativeResponseVariants {
    400: PostV1PrvCampaignsNegativeVariant1;
}

/** put /v1/prv/campaigns */
type PutV1PrvCampaignsInput = {
    campaignId: string;
    name?: string | undefined;
    description?: string | undefined;
    brandId?: string | undefined;
    targets?: {
        minFollowers?: (number | null) | undefined;
        minViews?: (number | null) | undefined;
        minViewsLast28Days?: (number | null) | undefined;
        language?: (string | null) | undefined;
        audienceLocation?: string[] | undefined;
        hierarchyLevel?: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | undefined;
        industry?: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | undefined;
        companySize?: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | undefined;
        occupation?: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | undefined;
    } | undefined;
    utmLink?: string | undefined;
    promoCode?: string | undefined;
    firstMessagesToAcceptedCreators?: ({
        type: "text";
        text: string;
        priceEUR?: number | undefined;
        cpmEUR?: number | undefined;
    } | {
        type: "image";
        src?: string | undefined;
        metadata: {
            name: string;
            size: number;
            type: string;
            fileKey: string;
        };
    } | {
        type: "file";
        src?: string | undefined;
        metadata: {
            name: string;
            size: number;
            type: string;
            fileKey: string;
        };
    })[] | undefined;
    framing?: {
        startDate?: string | undefined;
        endDate?: string | undefined;
        publicationStartDate?: string | undefined;
        publicationEndDate?: string | undefined;
        maxBudgetPerPost?: number | undefined;
        cpm?: number | undefined;
        totalBudget?: number | undefined;
        totalUsedBudget?: number | undefined;
        autoValidateContent?: boolean | undefined;
        autoAcceptCreators?: boolean | undefined;
    } | undefined;
};

/** put /v1/prv/campaigns */
type PutV1PrvCampaignsPositiveVariant1 = {
    status: "success";
    data: {
        success: boolean;
    };
};

/** put /v1/prv/campaigns */
interface PutV1PrvCampaignsPositiveResponseVariants {
    200: PutV1PrvCampaignsPositiveVariant1;
}

/** put /v1/prv/campaigns */
type PutV1PrvCampaignsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** put /v1/prv/campaigns */
interface PutV1PrvCampaignsNegativeResponseVariants {
    400: PutV1PrvCampaignsNegativeVariant1;
}

/** get /v1/prv/campaigns/open-to-offer */
type GetV1PrvCampaignsOpenToOfferInput = {
    brandIds: string;
    creatorIds: string;
};

/** get /v1/prv/campaigns/open-to-offer */
type GetV1PrvCampaignsOpenToOfferPositiveVariant1 = {
    status: "success";
    data: {
        campaignIds: string[];
    };
};

/** get /v1/prv/campaigns/open-to-offer */
interface GetV1PrvCampaignsOpenToOfferPositiveResponseVariants {
    200: GetV1PrvCampaignsOpenToOfferPositiveVariant1;
}

/** get /v1/prv/campaigns/open-to-offer */
type GetV1PrvCampaignsOpenToOfferNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/campaigns/open-to-offer */
interface GetV1PrvCampaignsOpenToOfferNegativeResponseVariants {
    400: GetV1PrvCampaignsOpenToOfferNegativeVariant1;
}

/** get /v1/prv/campaigns/total */
type GetV1PrvCampaignsTotalInput = {
    status: "DRAFT" | "PENDING_PAYMENT" | "ACTIVE" | "PAUSED" | "FINISHED";
};

/** get /v1/prv/campaigns/total */
type GetV1PrvCampaignsTotalPositiveVariant1 = {
    status: "success";
    data: {
        totalCampaigns: number;
    };
};

/** get /v1/prv/campaigns/total */
interface GetV1PrvCampaignsTotalPositiveResponseVariants {
    200: GetV1PrvCampaignsTotalPositiveVariant1;
}

/** get /v1/prv/campaigns/total */
type GetV1PrvCampaignsTotalNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/campaigns/total */
interface GetV1PrvCampaignsTotalNegativeResponseVariants {
    400: GetV1PrvCampaignsTotalNegativeVariant1;
}

/** post /v1/prv/campaigns/has-enough-creators */
type PostV1PrvCampaignsHasEnoughCreatorsInput = {
    minFollowers?: (number | null) | undefined;
    minViews?: (number | null) | undefined;
    minViewsLast28Days?: (number | null) | undefined;
    language?: (string | null) | undefined;
    audienceLocation?: string[] | undefined;
    hierarchyLevel?: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | undefined;
    industry?: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | undefined;
    companySize?: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | undefined;
    occupation?: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | undefined;
};

/** post /v1/prv/campaigns/has-enough-creators */
type PostV1PrvCampaignsHasEnoughCreatorsPositiveVariant1 = {
    status: "success";
    data: {
        hasEnoughCreators: boolean;
        medianViewsPerPost: number | null;
        eligibleCount: number;
        potentialReachPerPost: number;
    };
};

/** post /v1/prv/campaigns/has-enough-creators */
interface PostV1PrvCampaignsHasEnoughCreatorsPositiveResponseVariants {
    200: PostV1PrvCampaignsHasEnoughCreatorsPositiveVariant1;
}

/** post /v1/prv/campaigns/has-enough-creators */
type PostV1PrvCampaignsHasEnoughCreatorsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/prv/campaigns/has-enough-creators */
interface PostV1PrvCampaignsHasEnoughCreatorsNegativeResponseVariants {
    400: PostV1PrvCampaignsHasEnoughCreatorsNegativeVariant1;
}

/** get /v1/prv/campaigns/failed-payment */
type GetV1PrvCampaignsFailedPaymentInput = {};

/** get /v1/prv/campaigns/failed-payment */
type GetV1PrvCampaignsFailedPaymentPositiveVariant1 = {
    status: "success";
    data: {
        campaign: {
            _id: string;
            userId: string;
            brandId: string;
            name: string;
            description: string;
            status: "DRAFT" | "PENDING_PAYMENT" | "ACTIVE" | "PAUSED" | "FINISHED";
            paymentStatus: "PENDING" | "PAID" | "FAILED";
            paymentDeclineCode?: string | undefined;
            targets: {
                minFollowers?: (number | null) | undefined;
                minViews?: (number | null) | undefined;
                minViewsLast28Days?: (number | null) | undefined;
                language?: (string | null) | undefined;
                audienceLocation?: string[] | undefined;
                hierarchyLevel?: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | undefined;
                industry?: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | undefined;
                companySize?: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | undefined;
                occupation?: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | undefined;
            };
            framing: {
                startDate: string;
                endDate?: string | undefined;
                publicationStartDate?: string | undefined;
                publicationEndDate?: string | undefined;
                maxBudgetPerPost?: number | undefined;
                cpm?: number | undefined;
                totalBudget: number;
                totalUsedBudget?: number | undefined;
                autoValidateContent: boolean;
                autoAcceptCreators: boolean;
                autonomousCpmCeilingMultiplier?: (1 | 1.1 | 1.2) | undefined;
                capMode?: ("auto" | "fixed") | undefined;
                fixedCap?: number | undefined;
            };
            objective?: ("awareness" | "traffic" | "demos") | undefined;
            brief?: {
                keyMessage?: string | undefined;
                tones?: ("concrete" | "educational" | "personal" | "light_humour")[] | undefined;
                do?: string[] | undefined;
                avoid?: string[] | undefined;
            } | undefined;
            regions?: string[] | undefined;
            rules?: {
                minTargetAudienceShare?: number | undefined;
                askIfMostlyAbroad?: boolean | undefined;
            } | undefined;
            invitationTemplate?: string | undefined;
            sender?: {
                kind: "own_profile" | "kawaak_managed";
            } | undefined;
            postAcceptanceMode?: ("agent_auto" | "review_24h" | "manual") | undefined;
            draftStep?: ("brand" | "proposal" | "budget" | "launch") | undefined;
            suggestedTargets?: {
                label: string;
                targets: {
                    minFollowers?: (number | null) | undefined;
                    minViews?: (number | null) | undefined;
                    minViewsLast28Days?: (number | null) | undefined;
                    language?: (string | null) | undefined;
                    audienceLocation?: string[] | undefined;
                    hierarchyLevel?: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | undefined;
                    industry?: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | undefined;
                    companySize?: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | undefined;
                    occupation?: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | undefined;
                };
                eligibleCount: number | null;
                reason?: string | undefined;
                audienceReached?: string[] | undefined;
            }[] | undefined;
            agentInstructions?: string[] | undefined;
            budgetReservationTrigger?: ("acceptance" | "post_submission") | undefined;
            nbPostsToReview: number;
            utmLink?: string | undefined;
            promoCode?: string | undefined;
            stripePaymentIntentId?: string | undefined;
            stripeInvoiceId?: string | undefined;
            stripeCheckoutSessionId?: string | undefined;
            stripeRefundId?: string | undefined;
            stripeCreditNoteId?: string | undefined;
            stripeDeferredClosePaymentIntentId?: string | undefined;
            stripeDeferredCloseInvoiceId?: string | undefined;
            paymentSnapshot?: {
                source: "stripe_checkout" | "stripe_payment_intent" | "out_of_band";
                currency: "eur" | "usd";
                conversionRateFromEUR: number;
                budgetAmountInCents: number;
                platformFeeAmountInCents: number;
                taxAmountInCents: number;
                totalAmountInCents: number;
                paidAt: string;
                stripePaymentIntentId?: string | undefined;
                stripeInvoiceId?: string | undefined;
                stripeCheckoutSessionId?: string | undefined;
                externalReference?: string | undefined;
                outOfBandProof?: {
                    proofDocumentKey: string;
                    proofDocumentSha256: string;
                    proofDocumentEtag: string;
                    proofDocumentSizeBytes: number;
                    proofDocumentLastModified: string;
                    proofDocumentContentType: string;
                    proofDocumentVersionId?: string | undefined;
                    bankTransactionReference: string;
                    invoiceReference: string;
                    submittedAt: string;
                    submittedByStaffId: string;
                    approvedAt: string;
                    approvedByStaffId: string;
                } | undefined;
            } | undefined;
            paymentAttempt?: {
                attemptId: string;
                version: number;
                purpose: "INITIAL_DEPOSIT" | "DEFERRED_USAGE";
                state: "creating" | "awaiting_payment" | "paid" | "failed" | "canceled";
                currency: "eur" | "usd";
                conversionRateFromEUR: number;
                budgetAmountInCents: number;
                platformFeeAmountInCents: number;
                customerId: string;
                createdAt: string;
                updatedAt: string;
                cardCheckout?: {
                    expiresAt: number;
                    successUrl: string;
                    cancelUrl: string;
                } | undefined;
                checkoutSessionId?: string | undefined;
                stripeInvoiceId?: string | undefined;
                stripePaymentIntentId?: string | undefined;
                failureCode?: string | undefined;
            } | undefined;
            paymentAttemptHistory?: {
                attemptId: string;
                version: number;
                purpose: "INITIAL_DEPOSIT" | "DEFERRED_USAGE";
                state: "creating" | "awaiting_payment" | "paid" | "failed" | "canceled";
                currency: "eur" | "usd";
                conversionRateFromEUR: number;
                budgetAmountInCents: number;
                platformFeeAmountInCents: number;
                customerId: string;
                createdAt: string;
                updatedAt: string;
                cardCheckout?: {
                    expiresAt: number;
                    successUrl: string;
                    cancelUrl: string;
                } | undefined;
                checkoutSessionId?: string | undefined;
                stripeInvoiceId?: string | undefined;
                stripePaymentIntentId?: string | undefined;
                failureCode?: string | undefined;
            }[] | undefined;
            paymentReconciliationIssues?: {
                attemptId: string;
                stripePaymentIntentId: string;
                amountInCents: number;
                currency: string;
                reason: string;
                detectedAt: string;
            }[] | undefined;
            financialClose?: {
                state: "closing" | "awaiting_deferred_payment" | "manual_refund_required" | "manual_refund_awaiting_approval" | "manual_refund_confirmed" | "refund_pending" | "refund_failed";
                requestedAt: string;
                projectedUsedBudgetInEuros: number;
                ownerId?: string | undefined;
                leaseId?: string | undefined;
                leaseExpiresAt?: string | undefined;
                refundAmountInCents?: number | undefined;
                currency?: ("eur" | "usd") | undefined;
                error?: string | undefined;
                refundFailedAlertedAt?: string | undefined;
            } | undefined;
            agent?: {
                enabled: boolean;
                autonomyLevel?: ("assisted" | "review" | "autonomous") | undefined;
                pausedAt?: string | undefined;
                autonomyStats?: {
                    firstMessagesSent?: number | undefined;
                    firstMessagesApprovedStreak?: number | undefined;
                    repliesSent?: number | undefined;
                    repliesApprovedStreak?: number | undefined;
                } | undefined;
                autonomyProposal?: {
                    status: "proposed" | "accepted" | "refused";
                    trigger: "first_messages_sent" | "first_messages_approved" | "replies_sent" | "replies_approved";
                    proposedAt: string;
                    refusals: number;
                    firstRefusedAt?: string | undefined;
                    nextProposalAt?: string | undefined;
                } | undefined;
                poolExhaustedAt?: {
                    in_app?: string | undefined;
                    linkedin?: string | undefined;
                } | undefined;
                linkedinSourcing?: {
                    nextRunAfter?: string | undefined;
                    lastRunAt?: string | undefined;
                    lastOutcome?: string | undefined;
                    keywords?: string[] | undefined;
                    searchKey?: string | undefined;
                    nextPage?: number | undefined;
                } | undefined;
            } | undefined;
            payoutCreationLocks?: string[] | undefined;
            scheduledPayoutClaims?: string[] | undefined;
            refundedAt?: string | undefined;
            refundedBudgetInCents?: number | undefined;
            refundedFeeInCents?: number | undefined;
            refundedTaxInCents?: number | undefined;
            refundMethod?: ("stripe" | "manual") | undefined;
            manualRefundReference?: string | undefined;
            manualRefundedByStaffId?: string | undefined;
            manualRefundProof?: {
                reference: string;
                amountInCents: number;
                currency: "eur" | "usd";
                executedAt: string;
                proofDocumentKey: string;
                proofDocumentEtag: string;
                proofDocumentSizeBytes: number;
                proofDocumentLastModified: string;
                proofDocumentContentType: string;
                submittedAt: string;
                submittedByStaffId: string;
                confirmedAt?: string | undefined;
                confirmedByStaffId?: string | undefined;
            } | undefined;
            depositedAt?: string | undefined;
            firstMessagesToAcceptedCreators?: ({
                type: "text";
                text: string;
                priceEUR?: number | undefined;
                cpmEUR?: number | undefined;
            } | {
                type: "image";
                src?: string | undefined;
                metadata: {
                    name: string;
                    size: number;
                    type: string;
                    fileKey: string;
                };
            } | {
                type: "file";
                src?: string | undefined;
                metadata: {
                    name: string;
                    size: number;
                    type: string;
                    fileKey: string;
                };
            })[] | undefined;
            closedByStaffAt?: string | undefined;
            deletedAt?: string | undefined;
            currencyConversion: {
                currency: "USD";
                rateFromEUR: number;
                lockedAt: string;
            };
            initialBudgetQuote?: {
                currency: "eur" | "usd";
                budgetAmountInCents: number;
                budgetAmountInEurCents: number;
                conversionRateFromEUR: number;
                quotedAt: string;
            } | undefined;
            budgetDepositStatus?: ("PENDING" | "DEPOSITED") | undefined;
            creatorsPaidByBrand?: boolean | undefined;
            createdAt?: string | undefined;
        } | null;
    };
};

/** get /v1/prv/campaigns/failed-payment */
interface GetV1PrvCampaignsFailedPaymentPositiveResponseVariants {
    200: GetV1PrvCampaignsFailedPaymentPositiveVariant1;
}

/** get /v1/prv/campaigns/failed-payment */
type GetV1PrvCampaignsFailedPaymentNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/campaigns/failed-payment */
interface GetV1PrvCampaignsFailedPaymentNegativeResponseVariants {
    400: GetV1PrvCampaignsFailedPaymentNegativeVariant1;
}

/** post /v1/prv/campaigns/draft */
type PostV1PrvCampaignsDraftInput = {
    brandId: string;
    analysisId?: string | undefined;
};

/** post /v1/prv/campaigns/draft */
type PostV1PrvCampaignsDraftPositiveVariant1 = {
    status: "success";
    data: {
        campaignId: string;
    };
};

/** post /v1/prv/campaigns/draft */
interface PostV1PrvCampaignsDraftPositiveResponseVariants {
    200: PostV1PrvCampaignsDraftPositiveVariant1;
}

/** post /v1/prv/campaigns/draft */
type PostV1PrvCampaignsDraftNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/prv/campaigns/draft */
interface PostV1PrvCampaignsDraftNegativeResponseVariants {
    400: PostV1PrvCampaignsDraftNegativeVariant1;
}

/** get /v1/prv/campaigns/audience-locations */
type GetV1PrvCampaignsAudienceLocationsInput = {};

/** get /v1/prv/campaigns/audience-locations */
type GetV1PrvCampaignsAudienceLocationsPositiveVariant1 = {
    status: "success";
    data: {
        locations: {
            code: string;
            value: string;
        }[];
    };
};

/** get /v1/prv/campaigns/audience-locations */
interface GetV1PrvCampaignsAudienceLocationsPositiveResponseVariants {
    200: GetV1PrvCampaignsAudienceLocationsPositiveVariant1;
}

/** get /v1/prv/campaigns/audience-locations */
type GetV1PrvCampaignsAudienceLocationsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/campaigns/audience-locations */
interface GetV1PrvCampaignsAudienceLocationsNegativeResponseVariants {
    400: GetV1PrvCampaignsAudienceLocationsNegativeVariant1;
}

/** get /v1/prv/campaigns/overview */
type GetV1PrvCampaignsOverviewInput = {};

/** get /v1/prv/campaigns/overview */
type GetV1PrvCampaignsOverviewPositiveVariant1 = {
    status: "success";
    data: {
        campaigns: {
            campaignId: string;
            senders: {
                accountId: string;
                name: string;
                avatarUrl?: string | undefined;
                managed: boolean;
            }[];
            funnel: {
                found: number;
                invited: number;
                replied: number;
                saidYes: number;
                accepted: number;
                published: number;
                excluded: number;
            };
            results: {
                publishedPostsCount: number;
                views: number;
            };
            lastEvent?: {
                _id: string;
                campaignId: string;
                kind: "agent_paused" | "agent_resumed" | "settings_updated" | "thread_taken_over" | "thread_handed_back" | "message_sent_by_brand" | "message_sent_by_agent" | "decision_created" | "decision_resolved" | "decision_due_reminder" | "agent_action" | "action_skipped" | "brand_manual_message" | "autonomy_proposed" | "autonomy_proposal_accepted" | "autonomy_proposal_refused" | "creator_answered_invitation" | "linkedin_invitation_accepted" | "linkedin_sender_restricted" | "creator_excluded" | "sourcing_pool_exhausted" | "sourcing_pool_refilled";
                threadId?: string | undefined;
                creatorId?: string | undefined;
                decisionId?: string | undefined;
                reason: string;
                reasonCode?: ("free_text" | "thread_taken_over" | "thread_handed_back" | "brand_message_sent" | "brand_manual_message" | "agent_paused" | "agent_resumed" | "settings_updated" | "autonomy_proposed" | "autonomy_accepted" | "autonomy_refused" | "autonomy_refused_final" | "decision_created" | "decision_resolved" | "decision_reminder" | "invitation_page_accepted" | "invitation_page_accepted_cpm" | "cap_reserved_after_linkedin" | "cap_budget_exceeded_after_linkedin" | "awaiting_linkedin_expired" | "invitation_page_declined" | "draft_dropped_creator_wrote" | "creator_declined" | "creator_declined_thanked" | "no_answer" | "linkedin_invitation_not_accepted" | "invitation_pending_too_long" | "handed_to_brand" | "hand_off_too_many_drafts" | "hand_off_no_conversation" | "hand_off_price_above_ceiling" | "hand_off_budget_exceeded" | "hand_off_no_cpm_deal" | "hand_off_unreadable_conversation" | "hand_off_linkedin_send_failed" | "brand_took_over_during_decision" | "draft_prepared" | "message_sent_will_follow_up" | "waiting_before_writing" | "agent_stopped" | "agent_answered" | "deal_accepted" | "counter_offer_made" | "invited_in_app" | "creator_not_invitable" | "invitation_failed" | "nothing_honest_to_write" | "invitation_text_refused" | "no_writer_configured" | "creator_already_answered" | "first_message_sent" | "follow_up_sent" | "closing_sent" | "no_planned_message" | "planned_message_no_conversation" | "linkedin_existing_conversation_signal" | "linkedin_existing_conversation" | "linkedin_invited" | "linkedin_creator_retry_later" | "linkedin_account_paused" | "linkedin_invitation_failed" | "linkedin_invitation_accepted" | "linkedin_creator_answered" | "linkedin_sender_restricted" | "sourcing_audience_off_target" | "sourcing_existing_linkedin_conversation" | "sourcing_pool_exhausted_in_app" | "sourcing_pool_exhausted_linkedin" | "sourcing_pool_refilled" | "invitations_held_budget_reserved" | "guard_needs_human" | "guard_two_follow_ups_hand_off" | "guard_two_follow_ups_stop" | "guard_message_refused" | "guard_acceptance_is_yours") | undefined;
                reasonParams?: Record<string, string | number> | undefined;
                createdAt: string;
                creatorName?: string | undefined;
            } | undefined;
        }[];
    };
};

/** get /v1/prv/campaigns/overview */
interface GetV1PrvCampaignsOverviewPositiveResponseVariants {
    200: GetV1PrvCampaignsOverviewPositiveVariant1;
}

/** get /v1/prv/campaigns/overview */
type GetV1PrvCampaignsOverviewNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/campaigns/overview */
interface GetV1PrvCampaignsOverviewNegativeResponseVariants {
    400: GetV1PrvCampaignsOverviewNegativeVariant1;
}

/** get /v1/prv/campaigns/:campaignId */
type GetV1PrvCampaignsCampaignIdInput = {
    campaignId: string;
};

/** get /v1/prv/campaigns/:campaignId */
type GetV1PrvCampaignsCampaignIdPositiveVariant1 = {
    status: "success";
    data: {
        campaign: {
            _id: string;
            userId: string;
            name: string;
            description: string;
            status: "DRAFT" | "PENDING_PAYMENT" | "ACTIVE" | "PAUSED" | "FINISHED";
            paymentStatus: "PENDING" | "PAID" | "FAILED";
            paymentDeclineCode?: string | undefined;
            targets: {
                minFollowers?: (number | null) | undefined;
                minViews?: (number | null) | undefined;
                minViewsLast28Days?: (number | null) | undefined;
                language?: (string | null) | undefined;
                audienceLocation?: string[] | undefined;
                hierarchyLevel?: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | undefined;
                industry?: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | undefined;
                companySize?: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | undefined;
                occupation?: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | undefined;
            };
            framing: {
                startDate: string;
                endDate?: string | undefined;
                publicationStartDate?: string | undefined;
                publicationEndDate?: string | undefined;
                maxBudgetPerPost?: number | undefined;
                cpm?: number | undefined;
                totalBudget: number;
                totalUsedBudget?: number | undefined;
                autoValidateContent: boolean;
                autoAcceptCreators: boolean;
                autonomousCpmCeilingMultiplier?: (1 | 1.1 | 1.2) | undefined;
                capMode?: ("auto" | "fixed") | undefined;
                fixedCap?: number | undefined;
            };
            objective?: ("awareness" | "traffic" | "demos") | undefined;
            brief?: {
                keyMessage?: string | undefined;
                tones?: ("concrete" | "educational" | "personal" | "light_humour")[] | undefined;
                do?: string[] | undefined;
                avoid?: string[] | undefined;
            } | undefined;
            regions?: string[] | undefined;
            rules?: {
                minTargetAudienceShare?: number | undefined;
                askIfMostlyAbroad?: boolean | undefined;
            } | undefined;
            invitationTemplate?: string | undefined;
            sender?: {
                kind: "own_profile" | "kawaak_managed";
            } | undefined;
            postAcceptanceMode?: ("agent_auto" | "review_24h" | "manual") | undefined;
            draftStep?: ("brand" | "proposal" | "budget" | "launch") | undefined;
            suggestedTargets?: {
                label: string;
                targets: {
                    minFollowers?: (number | null) | undefined;
                    minViews?: (number | null) | undefined;
                    minViewsLast28Days?: (number | null) | undefined;
                    language?: (string | null) | undefined;
                    audienceLocation?: string[] | undefined;
                    hierarchyLevel?: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | undefined;
                    industry?: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | undefined;
                    companySize?: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | undefined;
                    occupation?: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | undefined;
                };
                eligibleCount: number | null;
                reason?: string | undefined;
                audienceReached?: string[] | undefined;
            }[] | undefined;
            agentInstructions?: string[] | undefined;
            budgetReservationTrigger?: ("acceptance" | "post_submission") | undefined;
            nbPostsToReview: number;
            utmLink?: string | undefined;
            promoCode?: string | undefined;
            stripePaymentIntentId?: string | undefined;
            stripeInvoiceId?: string | undefined;
            stripeCheckoutSessionId?: string | undefined;
            stripeRefundId?: string | undefined;
            stripeCreditNoteId?: string | undefined;
            stripeDeferredClosePaymentIntentId?: string | undefined;
            stripeDeferredCloseInvoiceId?: string | undefined;
            paymentSnapshot?: {
                source: "stripe_checkout" | "stripe_payment_intent" | "out_of_band";
                currency: "eur" | "usd";
                conversionRateFromEUR: number;
                budgetAmountInCents: number;
                platformFeeAmountInCents: number;
                taxAmountInCents: number;
                totalAmountInCents: number;
                paidAt: string;
                stripePaymentIntentId?: string | undefined;
                stripeInvoiceId?: string | undefined;
                stripeCheckoutSessionId?: string | undefined;
                externalReference?: string | undefined;
                outOfBandProof?: {
                    proofDocumentKey: string;
                    proofDocumentSha256: string;
                    proofDocumentEtag: string;
                    proofDocumentSizeBytes: number;
                    proofDocumentLastModified: string;
                    proofDocumentContentType: string;
                    proofDocumentVersionId?: string | undefined;
                    bankTransactionReference: string;
                    invoiceReference: string;
                    submittedAt: string;
                    submittedByStaffId: string;
                    approvedAt: string;
                    approvedByStaffId: string;
                } | undefined;
            } | undefined;
            paymentAttempt?: {
                attemptId: string;
                version: number;
                purpose: "INITIAL_DEPOSIT" | "DEFERRED_USAGE";
                state: "creating" | "awaiting_payment" | "paid" | "failed" | "canceled";
                currency: "eur" | "usd";
                conversionRateFromEUR: number;
                budgetAmountInCents: number;
                platformFeeAmountInCents: number;
                customerId: string;
                createdAt: string;
                updatedAt: string;
                cardCheckout?: {
                    expiresAt: number;
                    successUrl: string;
                    cancelUrl: string;
                } | undefined;
                checkoutSessionId?: string | undefined;
                stripeInvoiceId?: string | undefined;
                stripePaymentIntentId?: string | undefined;
                failureCode?: string | undefined;
            } | undefined;
            paymentAttemptHistory?: {
                attemptId: string;
                version: number;
                purpose: "INITIAL_DEPOSIT" | "DEFERRED_USAGE";
                state: "creating" | "awaiting_payment" | "paid" | "failed" | "canceled";
                currency: "eur" | "usd";
                conversionRateFromEUR: number;
                budgetAmountInCents: number;
                platformFeeAmountInCents: number;
                customerId: string;
                createdAt: string;
                updatedAt: string;
                cardCheckout?: {
                    expiresAt: number;
                    successUrl: string;
                    cancelUrl: string;
                } | undefined;
                checkoutSessionId?: string | undefined;
                stripeInvoiceId?: string | undefined;
                stripePaymentIntentId?: string | undefined;
                failureCode?: string | undefined;
            }[] | undefined;
            paymentReconciliationIssues?: {
                attemptId: string;
                stripePaymentIntentId: string;
                amountInCents: number;
                currency: string;
                reason: string;
                detectedAt: string;
            }[] | undefined;
            financialClose?: {
                state: "closing" | "awaiting_deferred_payment" | "manual_refund_required" | "manual_refund_awaiting_approval" | "manual_refund_confirmed" | "refund_pending" | "refund_failed";
                requestedAt: string;
                projectedUsedBudgetInEuros: number;
                ownerId?: string | undefined;
                leaseId?: string | undefined;
                leaseExpiresAt?: string | undefined;
                refundAmountInCents?: number | undefined;
                currency?: ("eur" | "usd") | undefined;
                error?: string | undefined;
                refundFailedAlertedAt?: string | undefined;
            } | undefined;
            agent?: {
                enabled: boolean;
                autonomyLevel?: ("assisted" | "review" | "autonomous") | undefined;
                pausedAt?: string | undefined;
                autonomyStats?: {
                    firstMessagesSent?: number | undefined;
                    firstMessagesApprovedStreak?: number | undefined;
                    repliesSent?: number | undefined;
                    repliesApprovedStreak?: number | undefined;
                } | undefined;
                autonomyProposal?: {
                    status: "proposed" | "accepted" | "refused";
                    trigger: "first_messages_sent" | "first_messages_approved" | "replies_sent" | "replies_approved";
                    proposedAt: string;
                    refusals: number;
                    firstRefusedAt?: string | undefined;
                    nextProposalAt?: string | undefined;
                } | undefined;
                poolExhaustedAt?: {
                    in_app?: string | undefined;
                    linkedin?: string | undefined;
                } | undefined;
                linkedinSourcing?: {
                    nextRunAfter?: string | undefined;
                    lastRunAt?: string | undefined;
                    lastOutcome?: string | undefined;
                    keywords?: string[] | undefined;
                    searchKey?: string | undefined;
                    nextPage?: number | undefined;
                } | undefined;
            } | undefined;
            payoutCreationLocks?: string[] | undefined;
            scheduledPayoutClaims?: string[] | undefined;
            refundedAt?: string | undefined;
            refundedBudgetInCents?: number | undefined;
            refundedFeeInCents?: number | undefined;
            refundedTaxInCents?: number | undefined;
            refundMethod?: ("stripe" | "manual") | undefined;
            manualRefundReference?: string | undefined;
            manualRefundedByStaffId?: string | undefined;
            manualRefundProof?: {
                reference: string;
                amountInCents: number;
                currency: "eur" | "usd";
                executedAt: string;
                proofDocumentKey: string;
                proofDocumentEtag: string;
                proofDocumentSizeBytes: number;
                proofDocumentLastModified: string;
                proofDocumentContentType: string;
                submittedAt: string;
                submittedByStaffId: string;
                confirmedAt?: string | undefined;
                confirmedByStaffId?: string | undefined;
            } | undefined;
            depositedAt?: string | undefined;
            firstMessagesToAcceptedCreators?: ({
                type: "text";
                text: string;
                priceEUR?: number | undefined;
                cpmEUR?: number | undefined;
            } | {
                type: "image";
                src?: string | undefined;
                metadata: {
                    name: string;
                    size: number;
                    type: string;
                    fileKey: string;
                };
            } | {
                type: "file";
                src?: string | undefined;
                metadata: {
                    name: string;
                    size: number;
                    type: string;
                    fileKey: string;
                };
            })[] | undefined;
            closedByStaffAt?: string | undefined;
            deletedAt?: string | undefined;
            currencyConversion: {
                currency: "USD";
                rateFromEUR: number;
                lockedAt: string;
            };
            initialBudgetQuote?: {
                currency: "eur" | "usd";
                budgetAmountInCents: number;
                budgetAmountInEurCents: number;
                conversionRateFromEUR: number;
                quotedAt: string;
            } | undefined;
            budgetDepositStatus?: ("PENDING" | "DEPOSITED") | undefined;
            creatorsPaidByBrand?: boolean | undefined;
            createdAt?: string | undefined;
            brand: {
                _id: string;
                name: string;
                websiteUrl?: string | undefined;
                country?: string | undefined;
                language?: string | undefined;
                description?: string | undefined;
                logoKey?: string | undefined;
                filesKeys?: string[] | undefined;
                keyFeatures?: string | undefined;
                linkedinUrl?: string | undefined;
                socialProofs?: ({
                    type: "metric";
                    value: number;
                    name: string;
                } | {
                    type: "rating";
                    rating: number;
                    maxRating?: number | undefined;
                    plateform: string;
                })[] | undefined;
                targetAudience?: {
                    occupations: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | null;
                    occupationSeniority: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | null;
                    companySize: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | null;
                    industries: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | null;
                    locations: string[] | null;
                } | undefined;
                targetCustomers?: string | undefined;
                analyzedAt?: string | undefined;
                logoSource?: string | undefined;
            };
        };
    };
};

/** get /v1/prv/campaigns/:campaignId */
interface GetV1PrvCampaignsCampaignIdPositiveResponseVariants {
    200: GetV1PrvCampaignsCampaignIdPositiveVariant1;
}

/** get /v1/prv/campaigns/:campaignId */
type GetV1PrvCampaignsCampaignIdNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/campaigns/:campaignId */
interface GetV1PrvCampaignsCampaignIdNegativeResponseVariants {
    400: GetV1PrvCampaignsCampaignIdNegativeVariant1;
}

/** put /v1/prv/campaigns/:campaignId */
type PutV1PrvCampaignsCampaignIdInput = {
    campaignId: string;
    name?: string | undefined;
    description?: string | undefined;
    brandId?: string | undefined;
    targets?: {
        minFollowers?: (number | null) | undefined;
        minViews?: (number | null) | undefined;
        minViewsLast28Days?: (number | null) | undefined;
        language?: (string | null) | undefined;
        audienceLocation?: string[] | undefined;
        hierarchyLevel?: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | undefined;
        industry?: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | undefined;
        companySize?: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | undefined;
        occupation?: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | undefined;
    } | undefined;
    utmLink?: string | undefined;
    promoCode?: string | undefined;
    firstMessagesToAcceptedCreators?: ({
        type: "text";
        text: string;
        priceEUR?: number | undefined;
        cpmEUR?: number | undefined;
    } | {
        type: "image";
        src?: string | undefined;
        metadata: {
            name: string;
            size: number;
            type: string;
            fileKey: string;
        };
    } | {
        type: "file";
        src?: string | undefined;
        metadata: {
            name: string;
            size: number;
            type: string;
            fileKey: string;
        };
    })[] | undefined;
    framing?: {
        startDate?: string | undefined;
        endDate?: string | undefined;
        publicationStartDate?: string | undefined;
        publicationEndDate?: string | undefined;
        maxBudgetPerPost?: number | undefined;
        cpm?: number | undefined;
        totalBudget?: number | undefined;
        totalUsedBudget?: number | undefined;
        autoValidateContent?: boolean | undefined;
        autoAcceptCreators?: boolean | undefined;
    } | undefined;
};

/** put /v1/prv/campaigns/:campaignId */
type PutV1PrvCampaignsCampaignIdPositiveVariant1 = {
    status: "success";
    data: {
        success: boolean;
    };
};

/** put /v1/prv/campaigns/:campaignId */
interface PutV1PrvCampaignsCampaignIdPositiveResponseVariants {
    200: PutV1PrvCampaignsCampaignIdPositiveVariant1;
}

/** put /v1/prv/campaigns/:campaignId */
type PutV1PrvCampaignsCampaignIdNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** put /v1/prv/campaigns/:campaignId */
interface PutV1PrvCampaignsCampaignIdNegativeResponseVariants {
    400: PutV1PrvCampaignsCampaignIdNegativeVariant1;
}

/** patch /v1/prv/campaigns/:campaignId/draft */
type PatchV1PrvCampaignsCampaignIdDraftInput = {
    campaignId: string;
    name?: string | undefined;
    targets?: {
        minFollowers?: (number | null) | undefined;
        minViews?: (number | null) | undefined;
        minViewsLast28Days?: (number | null) | undefined;
        language?: (string | null) | undefined;
        audienceLocation?: string[] | undefined;
        hierarchyLevel?: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | undefined;
        industry?: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | undefined;
        companySize?: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | undefined;
        occupation?: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | undefined;
    } | undefined;
    framing?: {
        creatorsBudget?: number | undefined;
        cpm?: (20 | 25 | 30 | 35) | undefined;
        autonomousCpmCeilingMultiplier?: (1 | 1.1 | 1.2) | undefined;
        capMode?: ("auto" | "fixed") | undefined;
        fixedCap?: (150 | 250) | undefined;
        startDate?: string | undefined;
        endDate?: string | undefined;
    } | undefined;
    objective?: ("awareness" | "traffic" | "demos") | undefined;
    brief?: {
        keyMessage?: string | undefined;
        tones?: ("concrete" | "educational" | "personal" | "light_humour")[] | undefined;
        do?: string[] | undefined;
        avoid?: string[] | undefined;
    } | undefined;
    regions?: string[] | undefined;
    rules?: {
        minTargetAudienceShare?: number | undefined;
        askIfMostlyAbroad?: boolean | undefined;
    } | undefined;
    invitationTemplate?: string | undefined;
    sender?: {
        kind: "own_profile" | "kawaak_managed";
    } | undefined;
    postAcceptanceMode?: ("agent_auto" | "review_24h" | "manual") | undefined;
    draftStep?: ("brand" | "proposal" | "budget" | "launch") | undefined;
};

/** patch /v1/prv/campaigns/:campaignId/draft */
type PatchV1PrvCampaignsCampaignIdDraftPositiveVariant1 = {
    status: "success";
    data: {
        campaign: {
            _id: string;
            userId: string;
            brandId: string;
            name: string;
            description: string;
            status: "DRAFT" | "PENDING_PAYMENT" | "ACTIVE" | "PAUSED" | "FINISHED";
            paymentStatus: "PENDING" | "PAID" | "FAILED";
            paymentDeclineCode?: string | undefined;
            targets: {
                minFollowers?: (number | null) | undefined;
                minViews?: (number | null) | undefined;
                minViewsLast28Days?: (number | null) | undefined;
                language?: (string | null) | undefined;
                audienceLocation?: string[] | undefined;
                hierarchyLevel?: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | undefined;
                industry?: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | undefined;
                companySize?: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | undefined;
                occupation?: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | undefined;
            };
            framing: {
                startDate: string;
                endDate?: string | undefined;
                publicationStartDate?: string | undefined;
                publicationEndDate?: string | undefined;
                maxBudgetPerPost?: number | undefined;
                cpm?: number | undefined;
                totalBudget: number;
                totalUsedBudget?: number | undefined;
                autoValidateContent: boolean;
                autoAcceptCreators: boolean;
                autonomousCpmCeilingMultiplier?: (1 | 1.1 | 1.2) | undefined;
                capMode?: ("auto" | "fixed") | undefined;
                fixedCap?: number | undefined;
            };
            objective?: ("awareness" | "traffic" | "demos") | undefined;
            brief?: {
                keyMessage?: string | undefined;
                tones?: ("concrete" | "educational" | "personal" | "light_humour")[] | undefined;
                do?: string[] | undefined;
                avoid?: string[] | undefined;
            } | undefined;
            regions?: string[] | undefined;
            rules?: {
                minTargetAudienceShare?: number | undefined;
                askIfMostlyAbroad?: boolean | undefined;
            } | undefined;
            invitationTemplate?: string | undefined;
            sender?: {
                kind: "own_profile" | "kawaak_managed";
            } | undefined;
            postAcceptanceMode?: ("agent_auto" | "review_24h" | "manual") | undefined;
            draftStep?: ("brand" | "proposal" | "budget" | "launch") | undefined;
            suggestedTargets?: {
                label: string;
                targets: {
                    minFollowers?: (number | null) | undefined;
                    minViews?: (number | null) | undefined;
                    minViewsLast28Days?: (number | null) | undefined;
                    language?: (string | null) | undefined;
                    audienceLocation?: string[] | undefined;
                    hierarchyLevel?: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | undefined;
                    industry?: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | undefined;
                    companySize?: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | undefined;
                    occupation?: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | undefined;
                };
                eligibleCount: number | null;
                reason?: string | undefined;
                audienceReached?: string[] | undefined;
            }[] | undefined;
            agentInstructions?: string[] | undefined;
            budgetReservationTrigger?: ("acceptance" | "post_submission") | undefined;
            nbPostsToReview: number;
            utmLink?: string | undefined;
            promoCode?: string | undefined;
            stripePaymentIntentId?: string | undefined;
            stripeInvoiceId?: string | undefined;
            stripeCheckoutSessionId?: string | undefined;
            stripeRefundId?: string | undefined;
            stripeCreditNoteId?: string | undefined;
            stripeDeferredClosePaymentIntentId?: string | undefined;
            stripeDeferredCloseInvoiceId?: string | undefined;
            paymentSnapshot?: {
                source: "stripe_checkout" | "stripe_payment_intent" | "out_of_band";
                currency: "eur" | "usd";
                conversionRateFromEUR: number;
                budgetAmountInCents: number;
                platformFeeAmountInCents: number;
                taxAmountInCents: number;
                totalAmountInCents: number;
                paidAt: string;
                stripePaymentIntentId?: string | undefined;
                stripeInvoiceId?: string | undefined;
                stripeCheckoutSessionId?: string | undefined;
                externalReference?: string | undefined;
                outOfBandProof?: {
                    proofDocumentKey: string;
                    proofDocumentSha256: string;
                    proofDocumentEtag: string;
                    proofDocumentSizeBytes: number;
                    proofDocumentLastModified: string;
                    proofDocumentContentType: string;
                    proofDocumentVersionId?: string | undefined;
                    bankTransactionReference: string;
                    invoiceReference: string;
                    submittedAt: string;
                    submittedByStaffId: string;
                    approvedAt: string;
                    approvedByStaffId: string;
                } | undefined;
            } | undefined;
            paymentAttempt?: {
                attemptId: string;
                version: number;
                purpose: "INITIAL_DEPOSIT" | "DEFERRED_USAGE";
                state: "creating" | "awaiting_payment" | "paid" | "failed" | "canceled";
                currency: "eur" | "usd";
                conversionRateFromEUR: number;
                budgetAmountInCents: number;
                platformFeeAmountInCents: number;
                customerId: string;
                createdAt: string;
                updatedAt: string;
                cardCheckout?: {
                    expiresAt: number;
                    successUrl: string;
                    cancelUrl: string;
                } | undefined;
                checkoutSessionId?: string | undefined;
                stripeInvoiceId?: string | undefined;
                stripePaymentIntentId?: string | undefined;
                failureCode?: string | undefined;
            } | undefined;
            paymentAttemptHistory?: {
                attemptId: string;
                version: number;
                purpose: "INITIAL_DEPOSIT" | "DEFERRED_USAGE";
                state: "creating" | "awaiting_payment" | "paid" | "failed" | "canceled";
                currency: "eur" | "usd";
                conversionRateFromEUR: number;
                budgetAmountInCents: number;
                platformFeeAmountInCents: number;
                customerId: string;
                createdAt: string;
                updatedAt: string;
                cardCheckout?: {
                    expiresAt: number;
                    successUrl: string;
                    cancelUrl: string;
                } | undefined;
                checkoutSessionId?: string | undefined;
                stripeInvoiceId?: string | undefined;
                stripePaymentIntentId?: string | undefined;
                failureCode?: string | undefined;
            }[] | undefined;
            paymentReconciliationIssues?: {
                attemptId: string;
                stripePaymentIntentId: string;
                amountInCents: number;
                currency: string;
                reason: string;
                detectedAt: string;
            }[] | undefined;
            financialClose?: {
                state: "closing" | "awaiting_deferred_payment" | "manual_refund_required" | "manual_refund_awaiting_approval" | "manual_refund_confirmed" | "refund_pending" | "refund_failed";
                requestedAt: string;
                projectedUsedBudgetInEuros: number;
                ownerId?: string | undefined;
                leaseId?: string | undefined;
                leaseExpiresAt?: string | undefined;
                refundAmountInCents?: number | undefined;
                currency?: ("eur" | "usd") | undefined;
                error?: string | undefined;
                refundFailedAlertedAt?: string | undefined;
            } | undefined;
            agent?: {
                enabled: boolean;
                autonomyLevel?: ("assisted" | "review" | "autonomous") | undefined;
                pausedAt?: string | undefined;
                autonomyStats?: {
                    firstMessagesSent?: number | undefined;
                    firstMessagesApprovedStreak?: number | undefined;
                    repliesSent?: number | undefined;
                    repliesApprovedStreak?: number | undefined;
                } | undefined;
                autonomyProposal?: {
                    status: "proposed" | "accepted" | "refused";
                    trigger: "first_messages_sent" | "first_messages_approved" | "replies_sent" | "replies_approved";
                    proposedAt: string;
                    refusals: number;
                    firstRefusedAt?: string | undefined;
                    nextProposalAt?: string | undefined;
                } | undefined;
                poolExhaustedAt?: {
                    in_app?: string | undefined;
                    linkedin?: string | undefined;
                } | undefined;
                linkedinSourcing?: {
                    nextRunAfter?: string | undefined;
                    lastRunAt?: string | undefined;
                    lastOutcome?: string | undefined;
                    keywords?: string[] | undefined;
                    searchKey?: string | undefined;
                    nextPage?: number | undefined;
                } | undefined;
            } | undefined;
            payoutCreationLocks?: string[] | undefined;
            scheduledPayoutClaims?: string[] | undefined;
            refundedAt?: string | undefined;
            refundedBudgetInCents?: number | undefined;
            refundedFeeInCents?: number | undefined;
            refundedTaxInCents?: number | undefined;
            refundMethod?: ("stripe" | "manual") | undefined;
            manualRefundReference?: string | undefined;
            manualRefundedByStaffId?: string | undefined;
            manualRefundProof?: {
                reference: string;
                amountInCents: number;
                currency: "eur" | "usd";
                executedAt: string;
                proofDocumentKey: string;
                proofDocumentEtag: string;
                proofDocumentSizeBytes: number;
                proofDocumentLastModified: string;
                proofDocumentContentType: string;
                submittedAt: string;
                submittedByStaffId: string;
                confirmedAt?: string | undefined;
                confirmedByStaffId?: string | undefined;
            } | undefined;
            depositedAt?: string | undefined;
            firstMessagesToAcceptedCreators?: ({
                type: "text";
                text: string;
                priceEUR?: number | undefined;
                cpmEUR?: number | undefined;
            } | {
                type: "image";
                src?: string | undefined;
                metadata: {
                    name: string;
                    size: number;
                    type: string;
                    fileKey: string;
                };
            } | {
                type: "file";
                src?: string | undefined;
                metadata: {
                    name: string;
                    size: number;
                    type: string;
                    fileKey: string;
                };
            })[] | undefined;
            closedByStaffAt?: string | undefined;
            deletedAt?: string | undefined;
            currencyConversion: {
                currency: "USD";
                rateFromEUR: number;
                lockedAt: string;
            };
            initialBudgetQuote?: {
                currency: "eur" | "usd";
                budgetAmountInCents: number;
                budgetAmountInEurCents: number;
                conversionRateFromEUR: number;
                quotedAt: string;
            } | undefined;
            budgetDepositStatus?: ("PENDING" | "DEPOSITED") | undefined;
            creatorsPaidByBrand?: boolean | undefined;
            createdAt?: string | undefined;
        };
        draftStep?: ("brand" | "proposal" | "budget" | "launch") | undefined;
    };
};

/** patch /v1/prv/campaigns/:campaignId/draft */
interface PatchV1PrvCampaignsCampaignIdDraftPositiveResponseVariants {
    200: PatchV1PrvCampaignsCampaignIdDraftPositiveVariant1;
}

/** patch /v1/prv/campaigns/:campaignId/draft */
type PatchV1PrvCampaignsCampaignIdDraftNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** patch /v1/prv/campaigns/:campaignId/draft */
interface PatchV1PrvCampaignsCampaignIdDraftNegativeResponseVariants {
    400: PatchV1PrvCampaignsCampaignIdDraftNegativeVariant1;
}

/** delete /v1/prv/campaigns/:campaignId/draft */
type DeleteV1PrvCampaignsCampaignIdDraftInput = {
    campaignId: string;
};

/** delete /v1/prv/campaigns/:campaignId/draft */
type DeleteV1PrvCampaignsCampaignIdDraftPositiveVariant1 = {
    status: "success";
    data: {
        campaignId: string;
    };
};

/** delete /v1/prv/campaigns/:campaignId/draft */
interface DeleteV1PrvCampaignsCampaignIdDraftPositiveResponseVariants {
    200: DeleteV1PrvCampaignsCampaignIdDraftPositiveVariant1;
}

/** delete /v1/prv/campaigns/:campaignId/draft */
type DeleteV1PrvCampaignsCampaignIdDraftNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** delete /v1/prv/campaigns/:campaignId/draft */
interface DeleteV1PrvCampaignsCampaignIdDraftNegativeResponseVariants {
    400: DeleteV1PrvCampaignsCampaignIdDraftNegativeVariant1;
}

/** post /v1/prv/campaigns/:campaignId/estimate */
type PostV1PrvCampaignsCampaignIdEstimateInput = {
    campaignId: string;
    targets: {
        minFollowers?: (number | null) | undefined;
        minViews?: (number | null) | undefined;
        minViewsLast28Days?: (number | null) | undefined;
        language?: (string | null) | undefined;
        audienceLocation?: string[] | undefined;
        hierarchyLevel?: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | undefined;
        industry?: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | undefined;
        companySize?: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | undefined;
        occupation?: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | undefined;
    };
    framing: {
        cpm?: (20 | 25 | 30 | 35) | undefined;
        autonomousCpmCeilingMultiplier?: (1 | 1.1 | 1.2) | undefined;
        capMode?: ("auto" | "fixed") | undefined;
        fixedCap?: (150 | 250) | undefined;
        startDate?: string | undefined;
        endDate?: string | undefined;
        creatorsBudget: number;
    };
};

/** post /v1/prv/campaigns/:campaignId/estimate */
type PostV1PrvCampaignsCampaignIdEstimatePositiveVariant1 = {
    status: "success";
    data: {
        eligibleCount: number;
        publishingCount: number;
        minViewsThreshold: number;
        estimatedCreators: number;
        estimatedPosts: number;
        estimatedViews: number;
        totals: {
            creatorsBudget: number;
            brandFee: number;
            totalHt: number;
        };
        widenings: {
            kind: "lower_min_views" | "drop_occupation" | "drop_industry" | "drop_hierarchy_level" | "drop_company_size" | "drop_audience_location";
            label: string;
            patch: {
                minFollowers?: (number | null) | undefined;
                minViews?: (number | null) | undefined;
                minViewsLast28Days?: (number | null) | undefined;
                language?: (string | null) | undefined;
                audienceLocation?: string[] | undefined;
                hierarchyLevel?: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | undefined;
                industry?: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | undefined;
                companySize?: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | undefined;
                occupation?: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | undefined;
            };
            eligibleCount: number;
        }[];
        minEligibleCreators: number;
        brandFeeRatePercent: number;
        cpmCeilingOptions: {
            multiplier: 1 | 1.1 | 1.2;
            ceilingCpmInCents: number;
        }[];
        durationWeeks: number | null;
        sampleCreators: {
            creatorId: string;
            givenName: string;
            familyName: string;
            title?: string | undefined;
            picture?: string | undefined;
            followers?: number | undefined;
            medianViewsPerPost?: number | undefined;
        }[];
        poolWarning?: {
            eligibleCount: number;
            expectedCreators: number;
        } | undefined;
    };
};

/** post /v1/prv/campaigns/:campaignId/estimate */
interface PostV1PrvCampaignsCampaignIdEstimatePositiveResponseVariants {
    200: PostV1PrvCampaignsCampaignIdEstimatePositiveVariant1;
}

/** post /v1/prv/campaigns/:campaignId/estimate */
type PostV1PrvCampaignsCampaignIdEstimateNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/prv/campaigns/:campaignId/estimate */
interface PostV1PrvCampaignsCampaignIdEstimateNegativeResponseVariants {
    400: PostV1PrvCampaignsCampaignIdEstimateNegativeVariant1;
}

/** post /v1/prv/campaigns/:campaignId/invitation-preview */
type PostV1PrvCampaignsCampaignIdInvitationPreviewInput = {
    campaignId: string;
    creatorId: string;
    template?: string | undefined;
};

/** post /v1/prv/campaigns/:campaignId/invitation-preview */
type PostV1PrvCampaignsCampaignIdInvitationPreviewPositiveVariant1 = {
    status: "success";
    data: {
        text: string;
        capStatus: "known" | "pending";
        cap?: number | undefined;
        cpm: number;
        capReachedAtViews?: number | undefined;
        creatorFee?: number | undefined;
        creatorFeePercent: number;
        netAfterFee?: number | undefined;
        publishedAt: string;
        viewsCountedAt: string;
        paymentDate: string;
        example?: {
            views: number;
            gross: number;
            net: number;
        } | undefined;
    };
};

/** post /v1/prv/campaigns/:campaignId/invitation-preview */
interface PostV1PrvCampaignsCampaignIdInvitationPreviewPositiveResponseVariants {
    200: PostV1PrvCampaignsCampaignIdInvitationPreviewPositiveVariant1;
}

/** post /v1/prv/campaigns/:campaignId/invitation-preview */
type PostV1PrvCampaignsCampaignIdInvitationPreviewNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/prv/campaigns/:campaignId/invitation-preview */
interface PostV1PrvCampaignsCampaignIdInvitationPreviewNegativeResponseVariants {
    400: PostV1PrvCampaignsCampaignIdInvitationPreviewNegativeVariant1;
}

/** post /v1/prv/campaigns/:campaignId/key-message-suggestion */
type PostV1PrvCampaignsCampaignIdKeyMessageSuggestionInput = {
    campaignId: string;
    objective?: ("awareness" | "traffic" | "demos") | undefined;
    language?: string | undefined;
};

/** post /v1/prv/campaigns/:campaignId/key-message-suggestion */
type PostV1PrvCampaignsCampaignIdKeyMessageSuggestionPositiveVariant1 = {
    status: "success";
    data: {
        message: string | null;
    };
};

/** post /v1/prv/campaigns/:campaignId/key-message-suggestion */
interface PostV1PrvCampaignsCampaignIdKeyMessageSuggestionPositiveResponseVariants {
    200: PostV1PrvCampaignsCampaignIdKeyMessageSuggestionPositiveVariant1;
}

/** post /v1/prv/campaigns/:campaignId/key-message-suggestion */
type PostV1PrvCampaignsCampaignIdKeyMessageSuggestionNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/prv/campaigns/:campaignId/key-message-suggestion */
interface PostV1PrvCampaignsCampaignIdKeyMessageSuggestionNegativeResponseVariants {
    400: PostV1PrvCampaignsCampaignIdKeyMessageSuggestionNegativeVariant1;
}

/** get /v1/prv/campaigns/:campaignId/can-close */
type GetV1PrvCampaignsCampaignIdCanCloseInput = {
    campaignId: string;
};

/** get /v1/prv/campaigns/:campaignId/can-close */
type GetV1PrvCampaignsCampaignIdCanClosePositiveVariant1 = {
    status: "success";
    data: {
        status: "can_close" | "blocked";
        blockingReasons: ("payment_pending" | "payment_reconciliation_required" | "in_flight_post" | "pending_payout")[];
        refundPreview: {
            remainingBudgetInCents: number;
            prorataFeeRefundInCents: number;
            taxRefundInCents: number;
            totalRefundInCents: number;
            currency: "eur" | "usd";
            method: "stripe" | "manual";
        } | null;
        deferredCharge: {
            usedBudgetInCents: number;
            prorataFeeInCents: number;
            currency: "eur" | "usd";
        } | null;
    };
};

/** get /v1/prv/campaigns/:campaignId/can-close */
interface GetV1PrvCampaignsCampaignIdCanClosePositiveResponseVariants {
    200: GetV1PrvCampaignsCampaignIdCanClosePositiveVariant1;
}

/** get /v1/prv/campaigns/:campaignId/can-close */
type GetV1PrvCampaignsCampaignIdCanCloseNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/campaigns/:campaignId/can-close */
interface GetV1PrvCampaignsCampaignIdCanCloseNegativeResponseVariants {
    400: GetV1PrvCampaignsCampaignIdCanCloseNegativeVariant1;
}

/** post /v1/prv/campaigns/:campaignId/close */
type PostV1PrvCampaignsCampaignIdCloseInput = {
    campaignId: string;
};

/** post /v1/prv/campaigns/:campaignId/close */
type PostV1PrvCampaignsCampaignIdClosePositiveVariant1 = {
    status: "success";
    data: {
        success: boolean;
        requiresPayment: boolean;
        hostedInstructionsUrl?: string | undefined;
        requiresManualRefund?: boolean | undefined;
        manualRefundAmountInCents?: number | undefined;
        manualRefundCurrency?: ("eur" | "usd") | undefined;
    };
};

/** post /v1/prv/campaigns/:campaignId/close */
interface PostV1PrvCampaignsCampaignIdClosePositiveResponseVariants {
    200: PostV1PrvCampaignsCampaignIdClosePositiveVariant1;
}

/** post /v1/prv/campaigns/:campaignId/close */
type PostV1PrvCampaignsCampaignIdCloseNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/prv/campaigns/:campaignId/close */
interface PostV1PrvCampaignsCampaignIdCloseNegativeResponseVariants {
    400: PostV1PrvCampaignsCampaignIdCloseNegativeVariant1;
}

/** post /v1/prv/campaigns/:campaignId/invite */
type PostV1PrvCampaignsCampaignIdInviteInput = {
    campaignId: string;
    price?: number | undefined;
    cpm?: number | undefined;
    maxAmount?: number | undefined;
    reason: string;
    useAutoPrice?: boolean | undefined;
    filters: {
        mode: "selectedOnly";
        selectedIds: string[];
    } | {
        mode: "all";
        filters: any;
        excludedIds: string[];
    };
};

/** post /v1/prv/campaigns/:campaignId/invite */
type PostV1PrvCampaignsCampaignIdInvitePositiveVariant1 = {
    status: "success";
    data: {
        invited: number;
        ignored: number;
    };
};

/** post /v1/prv/campaigns/:campaignId/invite */
interface PostV1PrvCampaignsCampaignIdInvitePositiveResponseVariants {
    200: PostV1PrvCampaignsCampaignIdInvitePositiveVariant1;
}

/** post /v1/prv/campaigns/:campaignId/invite */
type PostV1PrvCampaignsCampaignIdInviteNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/prv/campaigns/:campaignId/invite */
interface PostV1PrvCampaignsCampaignIdInviteNegativeResponseVariants {
    400: PostV1PrvCampaignsCampaignIdInviteNegativeVariant1;
}

/** post /v1/prv/campaigns/:campaignId/upload */
type PostV1PrvCampaignsCampaignIdUploadInput = {
    campaignId: string;
    file: any;
};

/** post /v1/prv/campaigns/:campaignId/upload */
type PostV1PrvCampaignsCampaignIdUploadPositiveVariant1 = {
    status: "success";
    data: {
        campaign: {
            _id: string;
            userId: string;
            brandId: string;
            name: string;
            description: string;
            status: "DRAFT" | "PENDING_PAYMENT" | "ACTIVE" | "PAUSED" | "FINISHED";
            paymentStatus: "PENDING" | "PAID" | "FAILED";
            paymentDeclineCode?: string | undefined;
            targets: {
                minFollowers?: (number | null) | undefined;
                minViews?: (number | null) | undefined;
                minViewsLast28Days?: (number | null) | undefined;
                language?: (string | null) | undefined;
                audienceLocation?: string[] | undefined;
                hierarchyLevel?: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | undefined;
                industry?: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | undefined;
                companySize?: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | undefined;
                occupation?: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | undefined;
            };
            framing: {
                startDate: string;
                endDate?: string | undefined;
                publicationStartDate?: string | undefined;
                publicationEndDate?: string | undefined;
                maxBudgetPerPost?: number | undefined;
                cpm?: number | undefined;
                totalBudget: number;
                totalUsedBudget?: number | undefined;
                autoValidateContent: boolean;
                autoAcceptCreators: boolean;
                autonomousCpmCeilingMultiplier?: (1 | 1.1 | 1.2) | undefined;
                capMode?: ("auto" | "fixed") | undefined;
                fixedCap?: number | undefined;
            };
            objective?: ("awareness" | "traffic" | "demos") | undefined;
            brief?: {
                keyMessage?: string | undefined;
                tones?: ("concrete" | "educational" | "personal" | "light_humour")[] | undefined;
                do?: string[] | undefined;
                avoid?: string[] | undefined;
            } | undefined;
            regions?: string[] | undefined;
            rules?: {
                minTargetAudienceShare?: number | undefined;
                askIfMostlyAbroad?: boolean | undefined;
            } | undefined;
            invitationTemplate?: string | undefined;
            sender?: {
                kind: "own_profile" | "kawaak_managed";
            } | undefined;
            postAcceptanceMode?: ("agent_auto" | "review_24h" | "manual") | undefined;
            draftStep?: ("brand" | "proposal" | "budget" | "launch") | undefined;
            suggestedTargets?: {
                label: string;
                targets: {
                    minFollowers?: (number | null) | undefined;
                    minViews?: (number | null) | undefined;
                    minViewsLast28Days?: (number | null) | undefined;
                    language?: (string | null) | undefined;
                    audienceLocation?: string[] | undefined;
                    hierarchyLevel?: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | undefined;
                    industry?: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | undefined;
                    companySize?: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | undefined;
                    occupation?: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | undefined;
                };
                eligibleCount: number | null;
                reason?: string | undefined;
                audienceReached?: string[] | undefined;
            }[] | undefined;
            agentInstructions?: string[] | undefined;
            budgetReservationTrigger?: ("acceptance" | "post_submission") | undefined;
            nbPostsToReview: number;
            utmLink?: string | undefined;
            promoCode?: string | undefined;
            stripePaymentIntentId?: string | undefined;
            stripeInvoiceId?: string | undefined;
            stripeCheckoutSessionId?: string | undefined;
            stripeRefundId?: string | undefined;
            stripeCreditNoteId?: string | undefined;
            stripeDeferredClosePaymentIntentId?: string | undefined;
            stripeDeferredCloseInvoiceId?: string | undefined;
            paymentSnapshot?: {
                source: "stripe_checkout" | "stripe_payment_intent" | "out_of_band";
                currency: "eur" | "usd";
                conversionRateFromEUR: number;
                budgetAmountInCents: number;
                platformFeeAmountInCents: number;
                taxAmountInCents: number;
                totalAmountInCents: number;
                paidAt: string;
                stripePaymentIntentId?: string | undefined;
                stripeInvoiceId?: string | undefined;
                stripeCheckoutSessionId?: string | undefined;
                externalReference?: string | undefined;
                outOfBandProof?: {
                    proofDocumentKey: string;
                    proofDocumentSha256: string;
                    proofDocumentEtag: string;
                    proofDocumentSizeBytes: number;
                    proofDocumentLastModified: string;
                    proofDocumentContentType: string;
                    proofDocumentVersionId?: string | undefined;
                    bankTransactionReference: string;
                    invoiceReference: string;
                    submittedAt: string;
                    submittedByStaffId: string;
                    approvedAt: string;
                    approvedByStaffId: string;
                } | undefined;
            } | undefined;
            paymentAttempt?: {
                attemptId: string;
                version: number;
                purpose: "INITIAL_DEPOSIT" | "DEFERRED_USAGE";
                state: "creating" | "awaiting_payment" | "paid" | "failed" | "canceled";
                currency: "eur" | "usd";
                conversionRateFromEUR: number;
                budgetAmountInCents: number;
                platformFeeAmountInCents: number;
                customerId: string;
                createdAt: string;
                updatedAt: string;
                cardCheckout?: {
                    expiresAt: number;
                    successUrl: string;
                    cancelUrl: string;
                } | undefined;
                checkoutSessionId?: string | undefined;
                stripeInvoiceId?: string | undefined;
                stripePaymentIntentId?: string | undefined;
                failureCode?: string | undefined;
            } | undefined;
            paymentAttemptHistory?: {
                attemptId: string;
                version: number;
                purpose: "INITIAL_DEPOSIT" | "DEFERRED_USAGE";
                state: "creating" | "awaiting_payment" | "paid" | "failed" | "canceled";
                currency: "eur" | "usd";
                conversionRateFromEUR: number;
                budgetAmountInCents: number;
                platformFeeAmountInCents: number;
                customerId: string;
                createdAt: string;
                updatedAt: string;
                cardCheckout?: {
                    expiresAt: number;
                    successUrl: string;
                    cancelUrl: string;
                } | undefined;
                checkoutSessionId?: string | undefined;
                stripeInvoiceId?: string | undefined;
                stripePaymentIntentId?: string | undefined;
                failureCode?: string | undefined;
            }[] | undefined;
            paymentReconciliationIssues?: {
                attemptId: string;
                stripePaymentIntentId: string;
                amountInCents: number;
                currency: string;
                reason: string;
                detectedAt: string;
            }[] | undefined;
            financialClose?: {
                state: "closing" | "awaiting_deferred_payment" | "manual_refund_required" | "manual_refund_awaiting_approval" | "manual_refund_confirmed" | "refund_pending" | "refund_failed";
                requestedAt: string;
                projectedUsedBudgetInEuros: number;
                ownerId?: string | undefined;
                leaseId?: string | undefined;
                leaseExpiresAt?: string | undefined;
                refundAmountInCents?: number | undefined;
                currency?: ("eur" | "usd") | undefined;
                error?: string | undefined;
                refundFailedAlertedAt?: string | undefined;
            } | undefined;
            agent?: {
                enabled: boolean;
                autonomyLevel?: ("assisted" | "review" | "autonomous") | undefined;
                pausedAt?: string | undefined;
                autonomyStats?: {
                    firstMessagesSent?: number | undefined;
                    firstMessagesApprovedStreak?: number | undefined;
                    repliesSent?: number | undefined;
                    repliesApprovedStreak?: number | undefined;
                } | undefined;
                autonomyProposal?: {
                    status: "proposed" | "accepted" | "refused";
                    trigger: "first_messages_sent" | "first_messages_approved" | "replies_sent" | "replies_approved";
                    proposedAt: string;
                    refusals: number;
                    firstRefusedAt?: string | undefined;
                    nextProposalAt?: string | undefined;
                } | undefined;
                poolExhaustedAt?: {
                    in_app?: string | undefined;
                    linkedin?: string | undefined;
                } | undefined;
                linkedinSourcing?: {
                    nextRunAfter?: string | undefined;
                    lastRunAt?: string | undefined;
                    lastOutcome?: string | undefined;
                    keywords?: string[] | undefined;
                    searchKey?: string | undefined;
                    nextPage?: number | undefined;
                } | undefined;
            } | undefined;
            payoutCreationLocks?: string[] | undefined;
            scheduledPayoutClaims?: string[] | undefined;
            refundedAt?: string | undefined;
            refundedBudgetInCents?: number | undefined;
            refundedFeeInCents?: number | undefined;
            refundedTaxInCents?: number | undefined;
            refundMethod?: ("stripe" | "manual") | undefined;
            manualRefundReference?: string | undefined;
            manualRefundedByStaffId?: string | undefined;
            manualRefundProof?: {
                reference: string;
                amountInCents: number;
                currency: "eur" | "usd";
                executedAt: string;
                proofDocumentKey: string;
                proofDocumentEtag: string;
                proofDocumentSizeBytes: number;
                proofDocumentLastModified: string;
                proofDocumentContentType: string;
                submittedAt: string;
                submittedByStaffId: string;
                confirmedAt?: string | undefined;
                confirmedByStaffId?: string | undefined;
            } | undefined;
            depositedAt?: string | undefined;
            firstMessagesToAcceptedCreators?: ({
                type: "text";
                text: string;
                priceEUR?: number | undefined;
                cpmEUR?: number | undefined;
            } | {
                type: "image";
                src?: string | undefined;
                metadata: {
                    name: string;
                    size: number;
                    type: string;
                    fileKey: string;
                };
            } | {
                type: "file";
                src?: string | undefined;
                metadata: {
                    name: string;
                    size: number;
                    type: string;
                    fileKey: string;
                };
            })[] | undefined;
            closedByStaffAt?: string | undefined;
            deletedAt?: string | undefined;
            currencyConversion: {
                currency: "USD";
                rateFromEUR: number;
                lockedAt: string;
            };
            initialBudgetQuote?: {
                currency: "eur" | "usd";
                budgetAmountInCents: number;
                budgetAmountInEurCents: number;
                conversionRateFromEUR: number;
                quotedAt: string;
            } | undefined;
            budgetDepositStatus?: ("PENDING" | "DEPOSITED") | undefined;
            creatorsPaidByBrand?: boolean | undefined;
            createdAt?: string | undefined;
        };
    };
};

/** post /v1/prv/campaigns/:campaignId/upload */
interface PostV1PrvCampaignsCampaignIdUploadPositiveResponseVariants {
    200: PostV1PrvCampaignsCampaignIdUploadPositiveVariant1;
}

/** post /v1/prv/campaigns/:campaignId/upload */
type PostV1PrvCampaignsCampaignIdUploadNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/prv/campaigns/:campaignId/upload */
interface PostV1PrvCampaignsCampaignIdUploadNegativeResponseVariants {
    400: PostV1PrvCampaignsCampaignIdUploadNegativeVariant1;
}

/** get /v1/prv/campaigns/:campaignId/agent */
type GetV1PrvCampaignsCampaignIdAgentInput = {
    campaignId: string;
};

/** get /v1/prv/campaigns/:campaignId/agent */
type GetV1PrvCampaignsCampaignIdAgentPositiveVariant1 = {
    status: "success";
    data: {
        activity?: {
            observedAt: string;
            workerLastSucceededAt?: string | undefined;
            workerStale?: boolean | undefined;
            senderKind: "own_profile" | "kawaak_managed";
            senderStatus: "ready" | "disconnected" | "pending" | "paused" | "disabled" | "managed_unavailable";
            restriction?: string | undefined;
            inAppContacts: number;
            linkedinInvitations: number;
            awaitingAcceptance: number;
            awaitingReply: number;
            awaitingReplyByChannel: {
                in_app: number;
                linkedin: number;
            };
            openDecisions: number;
            draftsToReview: number;
            pendingApplications: number;
            uncertainActions: number;
            budgetHeld: boolean;
            poolExhausted: boolean;
            recentContactAt?: string | undefined;
            nextFollowUpAt?: string | undefined;
            nextContactAt?: string | undefined;
            sendingSchedule?: {
                timeZone: string;
                startHour: number;
                endHour: number;
                days: ("Mon" | "Tue" | "Wed" | "Thu" | "Fri" | "Sat" | "Sun")[];
            } | undefined;
            quota: {
                scope: "account" | "campaign";
                daily?: {
                    used: number;
                    limit: number;
                } | undefined;
                weekly: {
                    used: number;
                    limit: number;
                };
            };
        } | undefined;
        enabled: boolean;
        status: "active" | "paused";
        autonomyLevel: "assisted" | "review" | "autonomous";
        postAcceptanceMode: "agent_auto" | "review_24h" | "manual";
        autonomousCpmCeilingMultiplier: 1 | 1.1 | 1.2;
        invitationsLeftThisWeek: number;
        funnel: {
            found: number;
            invited: number;
            replied: number;
            saidYes: number;
            accepted: number;
            published: number;
            excluded: number;
        };
        autonomyProposal?: {
            trigger: "first_messages_sent" | "first_messages_approved" | "replies_sent" | "replies_approved";
            proposedAt: string;
        } | undefined;
        linkedinSenderRestriction?: {
            reason: "desktop_connect_restricted" | "auth_repeated" | "sending_limit" | "sending_unavailable" | "disconnected";
            since: string;
            pausedUntil?: string | undefined;
        } | undefined;
    };
};

/** get /v1/prv/campaigns/:campaignId/agent */
interface GetV1PrvCampaignsCampaignIdAgentPositiveResponseVariants {
    200: GetV1PrvCampaignsCampaignIdAgentPositiveVariant1;
}

/** get /v1/prv/campaigns/:campaignId/agent */
type GetV1PrvCampaignsCampaignIdAgentNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/campaigns/:campaignId/agent */
interface GetV1PrvCampaignsCampaignIdAgentNegativeResponseVariants {
    400: GetV1PrvCampaignsCampaignIdAgentNegativeVariant1;
}

/** patch /v1/prv/campaigns/:campaignId/agent */
type PatchV1PrvCampaignsCampaignIdAgentInput = {
    campaignId: string;
    status?: ("active" | "paused") | undefined;
    autonomyLevel?: ("assisted" | "review" | "autonomous") | undefined;
    postAcceptanceMode?: ("agent_auto" | "review_24h" | "manual") | undefined;
    autonomousCpmCeilingMultiplier?: (1 | 1.1 | 1.2) | undefined;
    autonomyProposal?: ("accept" | "refuse") | undefined;
};

/** patch /v1/prv/campaigns/:campaignId/agent */
type PatchV1PrvCampaignsCampaignIdAgentPositiveVariant1 = {
    status: "success";
    data: {
        activity?: {
            observedAt: string;
            workerLastSucceededAt?: string | undefined;
            workerStale?: boolean | undefined;
            senderKind: "own_profile" | "kawaak_managed";
            senderStatus: "ready" | "disconnected" | "pending" | "paused" | "disabled" | "managed_unavailable";
            restriction?: string | undefined;
            inAppContacts: number;
            linkedinInvitations: number;
            awaitingAcceptance: number;
            awaitingReply: number;
            awaitingReplyByChannel: {
                in_app: number;
                linkedin: number;
            };
            openDecisions: number;
            draftsToReview: number;
            pendingApplications: number;
            uncertainActions: number;
            budgetHeld: boolean;
            poolExhausted: boolean;
            recentContactAt?: string | undefined;
            nextFollowUpAt?: string | undefined;
            nextContactAt?: string | undefined;
            sendingSchedule?: {
                timeZone: string;
                startHour: number;
                endHour: number;
                days: ("Mon" | "Tue" | "Wed" | "Thu" | "Fri" | "Sat" | "Sun")[];
            } | undefined;
            quota: {
                scope: "account" | "campaign";
                daily?: {
                    used: number;
                    limit: number;
                } | undefined;
                weekly: {
                    used: number;
                    limit: number;
                };
            };
        } | undefined;
        enabled: boolean;
        status: "active" | "paused";
        autonomyLevel: "assisted" | "review" | "autonomous";
        postAcceptanceMode: "agent_auto" | "review_24h" | "manual";
        autonomousCpmCeilingMultiplier: 1 | 1.1 | 1.2;
        invitationsLeftThisWeek: number;
        funnel: {
            found: number;
            invited: number;
            replied: number;
            saidYes: number;
            accepted: number;
            published: number;
            excluded: number;
        };
        autonomyProposal?: {
            trigger: "first_messages_sent" | "first_messages_approved" | "replies_sent" | "replies_approved";
            proposedAt: string;
        } | undefined;
        linkedinSenderRestriction?: {
            reason: "desktop_connect_restricted" | "auth_repeated" | "sending_limit" | "sending_unavailable" | "disconnected";
            since: string;
            pausedUntil?: string | undefined;
        } | undefined;
    };
};

/** patch /v1/prv/campaigns/:campaignId/agent */
interface PatchV1PrvCampaignsCampaignIdAgentPositiveResponseVariants {
    200: PatchV1PrvCampaignsCampaignIdAgentPositiveVariant1;
}

/** patch /v1/prv/campaigns/:campaignId/agent */
type PatchV1PrvCampaignsCampaignIdAgentNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** patch /v1/prv/campaigns/:campaignId/agent */
interface PatchV1PrvCampaignsCampaignIdAgentNegativeResponseVariants {
    400: PatchV1PrvCampaignsCampaignIdAgentNegativeVariant1;
}

/** get /v1/prv/campaigns/:campaignId/agent/creators */
type GetV1PrvCampaignsCampaignIdAgentCreatorsInput = {
    campaignId: string;
    tab?: ("to_decide" | "in_discussion" | "no_answer" | "pending" | "accepted" | "declined" | "excluded") | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
};

/** get /v1/prv/campaigns/:campaignId/agent/creators */
type GetV1PrvCampaignsCampaignIdAgentCreatorsPositiveVariant1 = {
    status: "success";
    data: {
        creators: {
            creatorId: string;
            name: string;
            title?: string | undefined;
            picture?: string | undefined;
            tab: "to_decide" | "in_discussion" | "no_answer" | "pending" | "accepted" | "declined" | "excluded";
            applicationId?: string | undefined;
            applicationStatus?: string | undefined;
            threadId?: string | undefined;
            threadState?: ("found" | "excluded" | "invited" | "no_answer" | "replied" | "negotiating" | "to_decide" | "awaiting_linkedin" | "accepted" | "declined" | "post_submitted" | "post_accepted" | "published" | "settled" | "paid" | "cancelled") | undefined;
            owner?: ("agent" | "brand") | undefined;
            channel?: ("in_app" | "linkedin") | undefined;
            nextActionAt?: string | undefined;
            nextActionKind?: ("send_invitation" | "follow_up" | "closing_message" | "reply" | "first_message") | undefined;
            invitedAt?: string | undefined;
            hasDraft: boolean;
            price?: number | undefined;
            cpm?: number | undefined;
            maxAmount?: number | undefined;
        }[];
        total: number;
        counts: Record<"to_decide" | "in_discussion" | "no_answer" | "pending" | "accepted" | "declined" | "excluded", number>;
    };
};

/** get /v1/prv/campaigns/:campaignId/agent/creators */
interface GetV1PrvCampaignsCampaignIdAgentCreatorsPositiveResponseVariants {
    200: GetV1PrvCampaignsCampaignIdAgentCreatorsPositiveVariant1;
}

/** get /v1/prv/campaigns/:campaignId/agent/creators */
type GetV1PrvCampaignsCampaignIdAgentCreatorsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/campaigns/:campaignId/agent/creators */
interface GetV1PrvCampaignsCampaignIdAgentCreatorsNegativeResponseVariants {
    400: GetV1PrvCampaignsCampaignIdAgentCreatorsNegativeVariant1;
}

/** get /v1/prv/campaigns/:campaignId/agent/creators/:creatorId/timeline */
type GetV1PrvCampaignsCampaignIdAgentCreatorsCreatorIdTimelineInput = {
    campaignId: string;
    creatorId: string;
};

/** get /v1/prv/campaigns/:campaignId/agent/creators/:creatorId/timeline */
type GetV1PrvCampaignsCampaignIdAgentCreatorsCreatorIdTimelinePositiveVariant1 = {
    status: "success";
    data: {
        entries: {
            kind: string;
            at: string;
            reason?: string | undefined;
            reasonCode?: ("free_text" | "thread_taken_over" | "thread_handed_back" | "brand_message_sent" | "brand_manual_message" | "agent_paused" | "agent_resumed" | "settings_updated" | "autonomy_proposed" | "autonomy_accepted" | "autonomy_refused" | "autonomy_refused_final" | "decision_created" | "decision_resolved" | "decision_reminder" | "invitation_page_accepted" | "invitation_page_accepted_cpm" | "cap_reserved_after_linkedin" | "cap_budget_exceeded_after_linkedin" | "awaiting_linkedin_expired" | "invitation_page_declined" | "draft_dropped_creator_wrote" | "creator_declined" | "creator_declined_thanked" | "no_answer" | "linkedin_invitation_not_accepted" | "invitation_pending_too_long" | "handed_to_brand" | "hand_off_too_many_drafts" | "hand_off_no_conversation" | "hand_off_price_above_ceiling" | "hand_off_budget_exceeded" | "hand_off_no_cpm_deal" | "hand_off_unreadable_conversation" | "hand_off_linkedin_send_failed" | "brand_took_over_during_decision" | "draft_prepared" | "message_sent_will_follow_up" | "waiting_before_writing" | "agent_stopped" | "agent_answered" | "deal_accepted" | "counter_offer_made" | "invited_in_app" | "creator_not_invitable" | "invitation_failed" | "nothing_honest_to_write" | "invitation_text_refused" | "no_writer_configured" | "creator_already_answered" | "first_message_sent" | "follow_up_sent" | "closing_sent" | "no_planned_message" | "planned_message_no_conversation" | "linkedin_existing_conversation_signal" | "linkedin_existing_conversation" | "linkedin_invited" | "linkedin_creator_retry_later" | "linkedin_account_paused" | "linkedin_invitation_failed" | "linkedin_invitation_accepted" | "linkedin_creator_answered" | "linkedin_sender_restricted" | "sourcing_audience_off_target" | "sourcing_existing_linkedin_conversation" | "sourcing_pool_exhausted_in_app" | "sourcing_pool_exhausted_linkedin" | "sourcing_pool_refilled" | "invitations_held_budget_reserved" | "guard_needs_human" | "guard_two_follow_ups_hand_off" | "guard_two_follow_ups_stop" | "guard_message_refused" | "guard_acceptance_is_yours") | undefined;
            reasonParams?: Record<string, string | number> | undefined;
            eventId?: string | undefined;
            decisionId?: string | undefined;
        }[];
        nextAction?: {
            kind: "send_invitation" | "follow_up" | "closing_message" | "reply" | "first_message";
            at: string;
        } | undefined;
        thread?: {
            _id: string;
            campaignId: string;
            creatorId: string;
            applicationId?: string | undefined;
            conversationId?: string | undefined;
            state: "found" | "excluded" | "invited" | "no_answer" | "replied" | "negotiating" | "to_decide" | "awaiting_linkedin" | "accepted" | "declined" | "post_submitted" | "post_accepted" | "published" | "settled" | "paid" | "cancelled";
            owner: "agent" | "brand";
            channel: "in_app" | "linkedin";
            nextActionAt?: string | undefined;
            nextActionKind?: ("send_invitation" | "follow_up" | "closing_message" | "reply" | "first_message") | undefined;
            followUpsSent: number;
            lastCategory?: string | undefined;
            draft?: string | undefined;
            linkedinMessages?: {
                id: string;
                text: string;
                fromBrand: boolean;
                createdAt: string;
            }[] | undefined;
            createdAt?: string | undefined;
            updatedAt?: string | undefined;
        } | undefined;
    };
};

/** get /v1/prv/campaigns/:campaignId/agent/creators/:creatorId/timeline */
interface GetV1PrvCampaignsCampaignIdAgentCreatorsCreatorIdTimelinePositiveResponseVariants {
    200: GetV1PrvCampaignsCampaignIdAgentCreatorsCreatorIdTimelinePositiveVariant1;
}

/** get /v1/prv/campaigns/:campaignId/agent/creators/:creatorId/timeline */
type GetV1PrvCampaignsCampaignIdAgentCreatorsCreatorIdTimelineNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/campaigns/:campaignId/agent/creators/:creatorId/timeline */
interface GetV1PrvCampaignsCampaignIdAgentCreatorsCreatorIdTimelineNegativeResponseVariants {
    400: GetV1PrvCampaignsCampaignIdAgentCreatorsCreatorIdTimelineNegativeVariant1;
}

/** get /v1/prv/campaigns/:campaignId/agent/decisions */
type GetV1PrvCampaignsCampaignIdAgentDecisionsInput = {
    campaignId: string;
    status?: ("open" | "resolved") | undefined;
};

/** get /v1/prv/campaigns/:campaignId/agent/decisions */
type GetV1PrvCampaignsCampaignIdAgentDecisionsPositiveVariant1 = {
    status: "success";
    data: {
        decisions: {
            decisionId: string;
            campaignId: string;
            threadId: string;
            creatorId: string;
            applicationId?: string | undefined;
            kind: "price_above_ceiling" | "audience_off_target" | "legal_or_exclusivity" | "unplanned_format" | "product_question" | "human_requested" | "conflict";
            status: "open" | "resolved";
            summary: string;
            recommendation: string;
            recommendedOptionKey: string;
            options: {
                key: string;
                label: string;
                effect: "accept_application" | "reject_application" | "counter_offer" | "hand_back" | "none";
                price?: number | undefined;
                cpm?: number | undefined;
                maxAmount?: number | undefined;
            }[];
            dueAt: string;
            resolvedBy?: ("brand") | undefined;
            resolvedOptionKey?: string | undefined;
            resolvedAt?: string | undefined;
            createdAt?: string | undefined;
        }[];
    };
};

/** get /v1/prv/campaigns/:campaignId/agent/decisions */
interface GetV1PrvCampaignsCampaignIdAgentDecisionsPositiveResponseVariants {
    200: GetV1PrvCampaignsCampaignIdAgentDecisionsPositiveVariant1;
}

/** get /v1/prv/campaigns/:campaignId/agent/decisions */
type GetV1PrvCampaignsCampaignIdAgentDecisionsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/campaigns/:campaignId/agent/decisions */
interface GetV1PrvCampaignsCampaignIdAgentDecisionsNegativeResponseVariants {
    400: GetV1PrvCampaignsCampaignIdAgentDecisionsNegativeVariant1;
}

/** post /v1/prv/campaigns/:campaignId/agent/decisions/:decisionId */
type PostV1PrvCampaignsCampaignIdAgentDecisionsDecisionIdInput = {
    campaignId: string;
    decisionId: string;
    optionKey: string;
};

/** post /v1/prv/campaigns/:campaignId/agent/decisions/:decisionId */
type PostV1PrvCampaignsCampaignIdAgentDecisionsDecisionIdPositiveVariant1 = {
    status: "success";
    data: {
        decision: {
            decisionId: string;
            campaignId: string;
            threadId: string;
            creatorId: string;
            applicationId?: string | undefined;
            kind: "price_above_ceiling" | "audience_off_target" | "legal_or_exclusivity" | "unplanned_format" | "product_question" | "human_requested" | "conflict";
            status: "open" | "resolved";
            summary: string;
            recommendation: string;
            recommendedOptionKey: string;
            options: {
                key: string;
                label: string;
                effect: "accept_application" | "reject_application" | "counter_offer" | "hand_back" | "none";
                price?: number | undefined;
                cpm?: number | undefined;
                maxAmount?: number | undefined;
            }[];
            dueAt: string;
            resolvedBy?: ("brand") | undefined;
            resolvedOptionKey?: string | undefined;
            resolvedAt?: string | undefined;
            createdAt?: string | undefined;
        };
    };
};

/** post /v1/prv/campaigns/:campaignId/agent/decisions/:decisionId */
interface PostV1PrvCampaignsCampaignIdAgentDecisionsDecisionIdPositiveResponseVariants {
    200: PostV1PrvCampaignsCampaignIdAgentDecisionsDecisionIdPositiveVariant1;
}

/** post /v1/prv/campaigns/:campaignId/agent/decisions/:decisionId */
type PostV1PrvCampaignsCampaignIdAgentDecisionsDecisionIdNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/prv/campaigns/:campaignId/agent/decisions/:decisionId */
interface PostV1PrvCampaignsCampaignIdAgentDecisionsDecisionIdNegativeResponseVariants {
    400: PostV1PrvCampaignsCampaignIdAgentDecisionsDecisionIdNegativeVariant1;
}

/** post /v1/prv/campaigns/:campaignId/agent/follow-up-now */
type PostV1PrvCampaignsCampaignIdAgentFollowUpNowInput = {
    campaignId: string;
    threadIds: string[];
};

/** post /v1/prv/campaigns/:campaignId/agent/follow-up-now */
type PostV1PrvCampaignsCampaignIdAgentFollowUpNowPositiveVariant1 = {
    status: "success";
    data: {
        scheduled: number;
        skipped: number;
    };
};

/** post /v1/prv/campaigns/:campaignId/agent/follow-up-now */
interface PostV1PrvCampaignsCampaignIdAgentFollowUpNowPositiveResponseVariants {
    200: PostV1PrvCampaignsCampaignIdAgentFollowUpNowPositiveVariant1;
}

/** post /v1/prv/campaigns/:campaignId/agent/follow-up-now */
type PostV1PrvCampaignsCampaignIdAgentFollowUpNowNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/prv/campaigns/:campaignId/agent/follow-up-now */
interface PostV1PrvCampaignsCampaignIdAgentFollowUpNowNegativeResponseVariants {
    400: PostV1PrvCampaignsCampaignIdAgentFollowUpNowNegativeVariant1;
}

/** get /v1/prv/campaigns/:campaignId/agent/events */
type GetV1PrvCampaignsCampaignIdAgentEventsInput = {
    campaignId: string;
    cursor?: string | undefined;
    limit?: number | undefined;
};

/** get /v1/prv/campaigns/:campaignId/agent/events */
type GetV1PrvCampaignsCampaignIdAgentEventsPositiveVariant1 = {
    status: "success";
    data: {
        events: {
            _id: string;
            campaignId: string;
            kind: "agent_paused" | "agent_resumed" | "settings_updated" | "thread_taken_over" | "thread_handed_back" | "message_sent_by_brand" | "message_sent_by_agent" | "decision_created" | "decision_resolved" | "decision_due_reminder" | "agent_action" | "action_skipped" | "brand_manual_message" | "autonomy_proposed" | "autonomy_proposal_accepted" | "autonomy_proposal_refused" | "creator_answered_invitation" | "linkedin_invitation_accepted" | "linkedin_sender_restricted" | "creator_excluded" | "sourcing_pool_exhausted" | "sourcing_pool_refilled";
            threadId?: string | undefined;
            creatorId?: string | undefined;
            decisionId?: string | undefined;
            reason: string;
            reasonCode?: ("free_text" | "thread_taken_over" | "thread_handed_back" | "brand_message_sent" | "brand_manual_message" | "agent_paused" | "agent_resumed" | "settings_updated" | "autonomy_proposed" | "autonomy_accepted" | "autonomy_refused" | "autonomy_refused_final" | "decision_created" | "decision_resolved" | "decision_reminder" | "invitation_page_accepted" | "invitation_page_accepted_cpm" | "cap_reserved_after_linkedin" | "cap_budget_exceeded_after_linkedin" | "awaiting_linkedin_expired" | "invitation_page_declined" | "draft_dropped_creator_wrote" | "creator_declined" | "creator_declined_thanked" | "no_answer" | "linkedin_invitation_not_accepted" | "invitation_pending_too_long" | "handed_to_brand" | "hand_off_too_many_drafts" | "hand_off_no_conversation" | "hand_off_price_above_ceiling" | "hand_off_budget_exceeded" | "hand_off_no_cpm_deal" | "hand_off_unreadable_conversation" | "hand_off_linkedin_send_failed" | "brand_took_over_during_decision" | "draft_prepared" | "message_sent_will_follow_up" | "waiting_before_writing" | "agent_stopped" | "agent_answered" | "deal_accepted" | "counter_offer_made" | "invited_in_app" | "creator_not_invitable" | "invitation_failed" | "nothing_honest_to_write" | "invitation_text_refused" | "no_writer_configured" | "creator_already_answered" | "first_message_sent" | "follow_up_sent" | "closing_sent" | "no_planned_message" | "planned_message_no_conversation" | "linkedin_existing_conversation_signal" | "linkedin_existing_conversation" | "linkedin_invited" | "linkedin_creator_retry_later" | "linkedin_account_paused" | "linkedin_invitation_failed" | "linkedin_invitation_accepted" | "linkedin_creator_answered" | "linkedin_sender_restricted" | "sourcing_audience_off_target" | "sourcing_existing_linkedin_conversation" | "sourcing_pool_exhausted_in_app" | "sourcing_pool_exhausted_linkedin" | "sourcing_pool_refilled" | "invitations_held_budget_reserved" | "guard_needs_human" | "guard_two_follow_ups_hand_off" | "guard_two_follow_ups_stop" | "guard_message_refused" | "guard_acceptance_is_yours") | undefined;
            reasonParams?: Record<string, string | number> | undefined;
            createdAt: string;
        }[];
        nextCursor?: string | undefined;
        todayCount: number;
    };
};

/** get /v1/prv/campaigns/:campaignId/agent/events */
interface GetV1PrvCampaignsCampaignIdAgentEventsPositiveResponseVariants {
    200: GetV1PrvCampaignsCampaignIdAgentEventsPositiveVariant1;
}

/** get /v1/prv/campaigns/:campaignId/agent/events */
type GetV1PrvCampaignsCampaignIdAgentEventsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/campaigns/:campaignId/agent/events */
interface GetV1PrvCampaignsCampaignIdAgentEventsNegativeResponseVariants {
    400: GetV1PrvCampaignsCampaignIdAgentEventsNegativeVariant1;
}

/** post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/take-over */
type PostV1PrvCampaignsCampaignIdAgentThreadsThreadIdTakeOverInput = {
    campaignId: string;
    threadId: string;
};

/** post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/take-over */
type PostV1PrvCampaignsCampaignIdAgentThreadsThreadIdTakeOverPositiveVariant1 = {
    status: "success";
    data: {
        thread: {
            _id: string;
            campaignId: string;
            creatorId: string;
            applicationId?: string | undefined;
            conversationId?: string | undefined;
            state: "found" | "excluded" | "invited" | "no_answer" | "replied" | "negotiating" | "to_decide" | "awaiting_linkedin" | "accepted" | "declined" | "post_submitted" | "post_accepted" | "published" | "settled" | "paid" | "cancelled";
            owner: "agent" | "brand";
            channel: "in_app" | "linkedin";
            nextActionAt?: string | undefined;
            nextActionKind?: ("send_invitation" | "follow_up" | "closing_message" | "reply" | "first_message") | undefined;
            followUpsSent: number;
            lastCategory?: string | undefined;
            draft?: string | undefined;
            linkedinMessages?: {
                id: string;
                text: string;
                fromBrand: boolean;
                createdAt: string;
            }[] | undefined;
            createdAt?: string | undefined;
            updatedAt?: string | undefined;
        };
    };
};

/** post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/take-over */
interface PostV1PrvCampaignsCampaignIdAgentThreadsThreadIdTakeOverPositiveResponseVariants {
    200: PostV1PrvCampaignsCampaignIdAgentThreadsThreadIdTakeOverPositiveVariant1;
}

/** post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/take-over */
type PostV1PrvCampaignsCampaignIdAgentThreadsThreadIdTakeOverNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/take-over */
interface PostV1PrvCampaignsCampaignIdAgentThreadsThreadIdTakeOverNegativeResponseVariants {
    400: PostV1PrvCampaignsCampaignIdAgentThreadsThreadIdTakeOverNegativeVariant1;
}

/** post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/hand-back */
type PostV1PrvCampaignsCampaignIdAgentThreadsThreadIdHandBackInput = {
    campaignId: string;
    threadId: string;
};

/** post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/hand-back */
type PostV1PrvCampaignsCampaignIdAgentThreadsThreadIdHandBackPositiveVariant1 = {
    status: "success";
    data: {
        thread: {
            _id: string;
            campaignId: string;
            creatorId: string;
            applicationId?: string | undefined;
            conversationId?: string | undefined;
            state: "found" | "excluded" | "invited" | "no_answer" | "replied" | "negotiating" | "to_decide" | "awaiting_linkedin" | "accepted" | "declined" | "post_submitted" | "post_accepted" | "published" | "settled" | "paid" | "cancelled";
            owner: "agent" | "brand";
            channel: "in_app" | "linkedin";
            nextActionAt?: string | undefined;
            nextActionKind?: ("send_invitation" | "follow_up" | "closing_message" | "reply" | "first_message") | undefined;
            followUpsSent: number;
            lastCategory?: string | undefined;
            draft?: string | undefined;
            linkedinMessages?: {
                id: string;
                text: string;
                fromBrand: boolean;
                createdAt: string;
            }[] | undefined;
            createdAt?: string | undefined;
            updatedAt?: string | undefined;
        };
    };
};

/** post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/hand-back */
interface PostV1PrvCampaignsCampaignIdAgentThreadsThreadIdHandBackPositiveResponseVariants {
    200: PostV1PrvCampaignsCampaignIdAgentThreadsThreadIdHandBackPositiveVariant1;
}

/** post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/hand-back */
type PostV1PrvCampaignsCampaignIdAgentThreadsThreadIdHandBackNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/hand-back */
interface PostV1PrvCampaignsCampaignIdAgentThreadsThreadIdHandBackNegativeResponseVariants {
    400: PostV1PrvCampaignsCampaignIdAgentThreadsThreadIdHandBackNegativeVariant1;
}

/** get /v1/prv/campaigns/:campaignId/agent/threads/:threadId/draft */
type GetV1PrvCampaignsCampaignIdAgentThreadsThreadIdDraftInput = {
    campaignId: string;
    threadId: string;
};

/** get /v1/prv/campaigns/:campaignId/agent/threads/:threadId/draft */
type GetV1PrvCampaignsCampaignIdAgentThreadsThreadIdDraftPositiveVariant1 = {
    status: "success";
    data: {
        text: string;
        instruction?: string | undefined;
    };
};

/** get /v1/prv/campaigns/:campaignId/agent/threads/:threadId/draft */
interface GetV1PrvCampaignsCampaignIdAgentThreadsThreadIdDraftPositiveResponseVariants {
    200: GetV1PrvCampaignsCampaignIdAgentThreadsThreadIdDraftPositiveVariant1;
}

/** get /v1/prv/campaigns/:campaignId/agent/threads/:threadId/draft */
type GetV1PrvCampaignsCampaignIdAgentThreadsThreadIdDraftNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/campaigns/:campaignId/agent/threads/:threadId/draft */
interface GetV1PrvCampaignsCampaignIdAgentThreadsThreadIdDraftNegativeResponseVariants {
    400: GetV1PrvCampaignsCampaignIdAgentThreadsThreadIdDraftNegativeVariant1;
}

/** post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/draft */
type PostV1PrvCampaignsCampaignIdAgentThreadsThreadIdDraftInput = {
    campaignId: string;
    threadId: string;
    instruction: string;
};

/** post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/draft */
type PostV1PrvCampaignsCampaignIdAgentThreadsThreadIdDraftPositiveVariant1 = {
    status: "success";
    data: {
        text: string;
        instruction?: string | undefined;
    };
};

/** post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/draft */
interface PostV1PrvCampaignsCampaignIdAgentThreadsThreadIdDraftPositiveResponseVariants {
    200: PostV1PrvCampaignsCampaignIdAgentThreadsThreadIdDraftPositiveVariant1;
}

/** post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/draft */
type PostV1PrvCampaignsCampaignIdAgentThreadsThreadIdDraftNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/draft */
interface PostV1PrvCampaignsCampaignIdAgentThreadsThreadIdDraftNegativeResponseVariants {
    400: PostV1PrvCampaignsCampaignIdAgentThreadsThreadIdDraftNegativeVariant1;
}

/** put /v1/prv/campaigns/:campaignId/agent/threads/:threadId/draft */
type PutV1PrvCampaignsCampaignIdAgentThreadsThreadIdDraftInput = {
    campaignId: string;
    threadId: string;
    text: string;
};

/** put /v1/prv/campaigns/:campaignId/agent/threads/:threadId/draft */
type PutV1PrvCampaignsCampaignIdAgentThreadsThreadIdDraftPositiveVariant1 = {
    status: "success";
    data: {
        text: string;
        instruction?: string | undefined;
    };
};

/** put /v1/prv/campaigns/:campaignId/agent/threads/:threadId/draft */
interface PutV1PrvCampaignsCampaignIdAgentThreadsThreadIdDraftPositiveResponseVariants {
    200: PutV1PrvCampaignsCampaignIdAgentThreadsThreadIdDraftPositiveVariant1;
}

/** put /v1/prv/campaigns/:campaignId/agent/threads/:threadId/draft */
type PutV1PrvCampaignsCampaignIdAgentThreadsThreadIdDraftNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** put /v1/prv/campaigns/:campaignId/agent/threads/:threadId/draft */
interface PutV1PrvCampaignsCampaignIdAgentThreadsThreadIdDraftNegativeResponseVariants {
    400: PutV1PrvCampaignsCampaignIdAgentThreadsThreadIdDraftNegativeVariant1;
}

/** post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/send */
type PostV1PrvCampaignsCampaignIdAgentThreadsThreadIdSendInput = {
    campaignId: string;
    threadId: string;
    text: string;
    requestId?: string | undefined;
};

/** post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/send */
type PostV1PrvCampaignsCampaignIdAgentThreadsThreadIdSendPositiveVariant1 = {
    status: "success";
    data: {
        thread: {
            _id: string;
            campaignId: string;
            creatorId: string;
            applicationId?: string | undefined;
            conversationId?: string | undefined;
            state: "found" | "excluded" | "invited" | "no_answer" | "replied" | "negotiating" | "to_decide" | "awaiting_linkedin" | "accepted" | "declined" | "post_submitted" | "post_accepted" | "published" | "settled" | "paid" | "cancelled";
            owner: "agent" | "brand";
            channel: "in_app" | "linkedin";
            nextActionAt?: string | undefined;
            nextActionKind?: ("send_invitation" | "follow_up" | "closing_message" | "reply" | "first_message") | undefined;
            followUpsSent: number;
            lastCategory?: string | undefined;
            draft?: string | undefined;
            linkedinMessages?: {
                id: string;
                text: string;
                fromBrand: boolean;
                createdAt: string;
            }[] | undefined;
            createdAt?: string | undefined;
            updatedAt?: string | undefined;
        };
    };
};

/** post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/send */
interface PostV1PrvCampaignsCampaignIdAgentThreadsThreadIdSendPositiveResponseVariants {
    200: PostV1PrvCampaignsCampaignIdAgentThreadsThreadIdSendPositiveVariant1;
}

/** post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/send */
type PostV1PrvCampaignsCampaignIdAgentThreadsThreadIdSendNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/send */
interface PostV1PrvCampaignsCampaignIdAgentThreadsThreadIdSendNegativeResponseVariants {
    400: PostV1PrvCampaignsCampaignIdAgentThreadsThreadIdSendNegativeVariant1;
}

/** get /v1/prv/campaigns/:campaignId/posts/:postId/checks */
type GetV1PrvCampaignsCampaignIdPostsPostIdChecksInput = {
    campaignId: string;
    postId: string;
};

/** get /v1/prv/campaigns/:campaignId/posts/:postId/checks */
type GetV1PrvCampaignsCampaignIdPostsPostIdChecksPositiveVariant1 = {
    status: "success";
    data: {
        checks: {
            key: "key_message" | "partnership_mention" | "tracked_link" | "avoid_list";
            state: "ok" | "doubt" | "fail" | "running";
            detail: string;
        }[];
        upToDate: boolean;
        postAcceptanceMode?: ("agent_auto" | "review_24h" | "manual") | undefined;
        autoAcceptAt?: string | undefined;
        autoAcceptInHours?: number | undefined;
        autoAcceptOutcome?: ("accepted" | "left_to_brand" | "cancelled_conflict" | "failed") | undefined;
        brandName: string;
        trackedLinkDomain?: string | undefined;
    };
};

/** get /v1/prv/campaigns/:campaignId/posts/:postId/checks */
interface GetV1PrvCampaignsCampaignIdPostsPostIdChecksPositiveResponseVariants {
    200: GetV1PrvCampaignsCampaignIdPostsPostIdChecksPositiveVariant1;
}

/** get /v1/prv/campaigns/:campaignId/posts/:postId/checks */
type GetV1PrvCampaignsCampaignIdPostsPostIdChecksNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/campaigns/:campaignId/posts/:postId/checks */
interface GetV1PrvCampaignsCampaignIdPostsPostIdChecksNegativeResponseVariants {
    400: GetV1PrvCampaignsCampaignIdPostsPostIdChecksNegativeVariant1;
}

/** get /v1/prv/campaigns/:campaignId/posts/:postId/reminder */
type GetV1PrvCampaignsCampaignIdPostsPostIdReminderInput = {
    campaignId: string;
    postId: string;
};

/** get /v1/prv/campaigns/:campaignId/posts/:postId/reminder */
type GetV1PrvCampaignsCampaignIdPostsPostIdReminderPositiveVariant1 = {
    status: "success";
    data: {
        state: "scheduled" | "exhausted" | "paused" | "none";
        nextReminderAt?: string | undefined;
        lastReminderAt?: string | undefined;
        remindersSent: number;
        maxReminders: number;
    };
};

/** get /v1/prv/campaigns/:campaignId/posts/:postId/reminder */
interface GetV1PrvCampaignsCampaignIdPostsPostIdReminderPositiveResponseVariants {
    200: GetV1PrvCampaignsCampaignIdPostsPostIdReminderPositiveVariant1;
}

/** get /v1/prv/campaigns/:campaignId/posts/:postId/reminder */
type GetV1PrvCampaignsCampaignIdPostsPostIdReminderNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/campaigns/:campaignId/posts/:postId/reminder */
interface GetV1PrvCampaignsCampaignIdPostsPostIdReminderNegativeResponseVariants {
    400: GetV1PrvCampaignsCampaignIdPostsPostIdReminderNegativeVariant1;
}

/** get /v1/prv/campaigns/:campaignId/posts/:postId/refusal-draft */
type GetV1PrvCampaignsCampaignIdPostsPostIdRefusalDraftInput = {
    campaignId: string;
    postId: string;
};

/** get /v1/prv/campaigns/:campaignId/posts/:postId/refusal-draft */
type GetV1PrvCampaignsCampaignIdPostsPostIdRefusalDraftPositiveVariant1 = {
    status: "success";
    data: {
        draft?: string | undefined;
        instructions: string[];
    };
};

/** get /v1/prv/campaigns/:campaignId/posts/:postId/refusal-draft */
interface GetV1PrvCampaignsCampaignIdPostsPostIdRefusalDraftPositiveResponseVariants {
    200: GetV1PrvCampaignsCampaignIdPostsPostIdRefusalDraftPositiveVariant1;
}

/** get /v1/prv/campaigns/:campaignId/posts/:postId/refusal-draft */
type GetV1PrvCampaignsCampaignIdPostsPostIdRefusalDraftNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/campaigns/:campaignId/posts/:postId/refusal-draft */
interface GetV1PrvCampaignsCampaignIdPostsPostIdRefusalDraftNegativeResponseVariants {
    400: GetV1PrvCampaignsCampaignIdPostsPostIdRefusalDraftNegativeVariant1;
}

/** post /v1/prv/campaigns/:campaignId/applications/:applicationId/rejection-draft */
type PostV1PrvCampaignsCampaignIdApplicationsApplicationIdRejectionDraftInput = {
    campaignId: string;
    applicationId: string;
    notes?: string | undefined;
};

/** post /v1/prv/campaigns/:campaignId/applications/:applicationId/rejection-draft */
type PostV1PrvCampaignsCampaignIdApplicationsApplicationIdRejectionDraftPositiveVariant1 = {
    status: "success";
    data: {
        draft: string;
    };
};

/** post /v1/prv/campaigns/:campaignId/applications/:applicationId/rejection-draft */
interface PostV1PrvCampaignsCampaignIdApplicationsApplicationIdRejectionDraftPositiveResponseVariants {
    200: PostV1PrvCampaignsCampaignIdApplicationsApplicationIdRejectionDraftPositiveVariant1;
}

/** post /v1/prv/campaigns/:campaignId/applications/:applicationId/rejection-draft */
type PostV1PrvCampaignsCampaignIdApplicationsApplicationIdRejectionDraftNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/prv/campaigns/:campaignId/applications/:applicationId/rejection-draft */
interface PostV1PrvCampaignsCampaignIdApplicationsApplicationIdRejectionDraftNegativeResponseVariants {
    400: PostV1PrvCampaignsCampaignIdApplicationsApplicationIdRejectionDraftNegativeVariant1;
}

/** put /v1/prv/campaigns/:campaignId/agent-instructions */
type PutV1PrvCampaignsCampaignIdAgentInstructionsInput = {
    campaignId: string;
    instructions: string[];
};

/** put /v1/prv/campaigns/:campaignId/agent-instructions */
type PutV1PrvCampaignsCampaignIdAgentInstructionsPositiveVariant1 = {
    status: "success";
    data: {
        instructions: string[];
    };
};

/** put /v1/prv/campaigns/:campaignId/agent-instructions */
interface PutV1PrvCampaignsCampaignIdAgentInstructionsPositiveResponseVariants {
    200: PutV1PrvCampaignsCampaignIdAgentInstructionsPositiveVariant1;
}

/** put /v1/prv/campaigns/:campaignId/agent-instructions */
type PutV1PrvCampaignsCampaignIdAgentInstructionsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** put /v1/prv/campaigns/:campaignId/agent-instructions */
interface PutV1PrvCampaignsCampaignIdAgentInstructionsNegativeResponseVariants {
    400: PutV1PrvCampaignsCampaignIdAgentInstructionsNegativeVariant1;
}

/** get /v1/prv/campaigns/:campaignId/tracked-links/clicks */
type GetV1PrvCampaignsCampaignIdTrackedLinksClicksInput = {
    campaignId: string;
};

/** get /v1/prv/campaigns/:campaignId/tracked-links/clicks */
type GetV1PrvCampaignsCampaignIdTrackedLinksClicksPositiveVariant1 = {
    status: "success";
    data: {
        clicks: number;
    };
};

/** get /v1/prv/campaigns/:campaignId/tracked-links/clicks */
interface GetV1PrvCampaignsCampaignIdTrackedLinksClicksPositiveResponseVariants {
    200: GetV1PrvCampaignsCampaignIdTrackedLinksClicksPositiveVariant1;
}

/** get /v1/prv/campaigns/:campaignId/tracked-links/clicks */
type GetV1PrvCampaignsCampaignIdTrackedLinksClicksNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/campaigns/:campaignId/tracked-links/clicks */
interface GetV1PrvCampaignsCampaignIdTrackedLinksClicksNegativeResponseVariants {
    400: GetV1PrvCampaignsCampaignIdTrackedLinksClicksNegativeVariant1;
}

/** put /v1/prv/conversations/:conversationId/inbox */
type PutV1PrvConversationsConversationIdInboxInput = {
    conversationId: string;
    update: {
        pinned?: boolean | undefined;
        reminderAt?: (string | null) | undefined;
    };
};

/** put /v1/prv/conversations/:conversationId/inbox */
type PutV1PrvConversationsConversationIdInboxPositiveVariant1 = {
    status: "success";
    data: {
        success: boolean;
    };
};

/** put /v1/prv/conversations/:conversationId/inbox */
interface PutV1PrvConversationsConversationIdInboxPositiveResponseVariants {
    200: PutV1PrvConversationsConversationIdInboxPositiveVariant1;
}

/** put /v1/prv/conversations/:conversationId/inbox */
type PutV1PrvConversationsConversationIdInboxNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** put /v1/prv/conversations/:conversationId/inbox */
interface PutV1PrvConversationsConversationIdInboxNegativeResponseVariants {
    400: PutV1PrvConversationsConversationIdInboxNegativeVariant1;
}

/** post /v1/prv/conversations/:conversationId/suggest-reply */
type PostV1PrvConversationsConversationIdSuggestReplyInput = {
    conversationId: string;
    language: string;
    instruction?: string | undefined;
};

/** post /v1/prv/conversations/:conversationId/suggest-reply */
type PostV1PrvConversationsConversationIdSuggestReplyPositiveVariant1 = {
    status: "success";
    data: {
        text: string;
        context: string;
        missingInformation: string[];
    };
};

/** post /v1/prv/conversations/:conversationId/suggest-reply */
interface PostV1PrvConversationsConversationIdSuggestReplyPositiveResponseVariants {
    200: PostV1PrvConversationsConversationIdSuggestReplyPositiveVariant1;
}

/** post /v1/prv/conversations/:conversationId/suggest-reply */
type PostV1PrvConversationsConversationIdSuggestReplyNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/prv/conversations/:conversationId/suggest-reply */
interface PostV1PrvConversationsConversationIdSuggestReplyNegativeResponseVariants {
    400: PostV1PrvConversationsConversationIdSuggestReplyNegativeVariant1;
}

/** get /v1/prv/conversations */
type GetV1PrvConversationsInput = {
    filters: any;
    page?: number | undefined;
    size?: number | undefined;
};

/** get /v1/prv/conversations */
type GetV1PrvConversationsPositiveVariant1 = {
    status: "success";
    data: {
        conversations: {
            _id: string;
            brandInbox?: {
                pinned?: boolean | undefined;
                reminderAt?: (string | null) | undefined;
                needsReply?: boolean | undefined;
            } | undefined;
            smmUserId: string;
            brandId: string;
            campaignId: string;
            creatorId: string;
            applicationId: string;
            influenceUserId: string;
            hasUnreadMessages: boolean;
            needsReply?: boolean | undefined;
            lastMessage?: ({
                _id: string;
                idempotencyKey?: string | undefined;
                conversationId: string;
                authorId: string;
                type: "user";
                content: {
                    type: "text";
                    text: string;
                    priceEUR?: number | undefined;
                    cpmEUR?: number | undefined;
                } | {
                    type: "image";
                    src?: string | undefined;
                    metadata: {
                        name: string;
                        size: number;
                        type: string;
                        fileKey: string;
                    };
                } | {
                    type: "file";
                    src?: string | undefined;
                    metadata: {
                        name: string;
                        size: number;
                        type: string;
                        fileKey: string;
                    };
                };
                createdAt: string;
            } | {
                _id: string;
                idempotencyKey?: string | undefined;
                conversationId: string;
                type: "automatic";
                content: {
                    notificationType: "creator_offer_submitted";
                    price: number;
                    cpm?: number | undefined;
                    maxAmount?: number | undefined;
                } | {
                    notificationType: "creator_offer_accepted";
                    utmLink?: string | undefined;
                    promoCode?: string | undefined;
                    creatorsPaidByBrand?: boolean | undefined;
                } | {
                    notificationType: "creator_offer_rejected";
                    rejectionReason: string;
                } | {
                    notificationType: "creator_counter_offer";
                    price: number;
                    cpm?: number | undefined;
                    maxAmount?: number | undefined;
                    reason?: string | undefined;
                } | {
                    notificationType: "creator_excluded_from_campaign";
                    exclusionReason: string;
                } | {
                    notificationType: "campaign_offer_submitted";
                    price: number;
                    cpm?: number | undefined;
                    maxAmount?: number | undefined;
                } | {
                    notificationType: "campaign_offer_accepted";
                    utmLink?: string | undefined;
                    promoCode?: string | undefined;
                    creatorsPaidByBrand?: boolean | undefined;
                } | {
                    notificationType: "campaign_offer_rejected";
                } | {
                    notificationType: "campaign_counter_offer";
                    price: number;
                    cpm?: number | undefined;
                    maxAmount?: number | undefined;
                    reason?: string | undefined;
                } | {
                    notificationType: "post_to_review";
                    postId: string;
                    campaignId: string;
                } | {
                    notificationType: "post_scheduled";
                    postId: string;
                    campaignId: string;
                } | {
                    notificationType: "post_published";
                    postId: string;
                    linkedinPostId?: string | undefined;
                } | {
                    notificationType: "post_rejected";
                    postId: string;
                    campaignId: string;
                    rejectionReason: string;
                } | {
                    notificationType: "post_validated";
                    postId: string;
                    campaignId: string;
                } | {
                    notificationType: "post_comment_added";
                    postId: string;
                    campaignId: string;
                    commentId: string;
                } | {
                    notificationType: "post_comment_updated";
                    postId: string;
                    campaignId: string;
                    commentId: string;
                } | {
                    notificationType: "post_comment_removed";
                    postId: string;
                    campaignId: string;
                    commentId: string;
                } | {
                    notificationType: "post_attachment_added";
                    postId: string;
                    campaignId: string;
                    attachmentName: string;
                } | {
                    notificationType: "post_attachment_updated";
                    postId: string;
                    campaignId: string;
                    attachmentName: string;
                } | {
                    notificationType: "post_attachment_removed";
                    postId: string;
                    campaignId: string;
                    attachmentName: string;
                } | {
                    notificationType: "sponsored_post_payment_received";
                    linkedinPostId?: string | undefined;
                    campaignId: string;
                    campaignName: string;
                    amount: number;
                    currency?: ("EUR" | "USD") | undefined;
                } | {
                    notificationType: "sponsored_post_payment_failed";
                    linkedinPostId?: string | undefined;
                    campaignId: string;
                    campaignName: string;
                    amount: number;
                    currency?: ("EUR" | "USD") | undefined;
                } | {
                    notificationType: "campaign_closed";
                    campaignId: string;
                    campaignName: string;
                };
                createdAt: string;
            }) | undefined;
            participant: {
                id: string;
                type: "campaign" | "creator";
                avatarSrc: string;
                name: string;
                givenName?: string | undefined;
                familyName?: string | undefined;
            };
            currencyConversion: {
                currency: "USD";
                rateFromEUR: number;
                lockedAt: string;
            };
        }[];
        totalCount: number;
        hasMore: boolean;
    };
};

/** get /v1/prv/conversations */
interface GetV1PrvConversationsPositiveResponseVariants {
    200: GetV1PrvConversationsPositiveVariant1;
}

/** get /v1/prv/conversations */
type GetV1PrvConversationsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/conversations */
interface GetV1PrvConversationsNegativeResponseVariants {
    400: GetV1PrvConversationsNegativeVariant1;
}

/** get /v1/prv/conversations/unread-count */
type GetV1PrvConversationsUnreadCountInput = {};

/** get /v1/prv/conversations/unread-count */
type GetV1PrvConversationsUnreadCountPositiveVariant1 = {
    status: "success";
    data: {
        count: number;
    };
};

/** get /v1/prv/conversations/unread-count */
interface GetV1PrvConversationsUnreadCountPositiveResponseVariants {
    200: GetV1PrvConversationsUnreadCountPositiveVariant1;
}

/** get /v1/prv/conversations/unread-count */
type GetV1PrvConversationsUnreadCountNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/conversations/unread-count */
interface GetV1PrvConversationsUnreadCountNegativeResponseVariants {
    400: GetV1PrvConversationsUnreadCountNegativeVariant1;
}

/** post /v1/prv/conversations/bulk-message */
type PostV1PrvConversationsBulkMessageInput = {
    data: {
        creatorIds: string[];
        campaignId: string;
        content: {
            type: "text";
            text: string;
            priceEUR?: number | undefined;
            cpmEUR?: number | undefined;
        } | {
            type: "image";
            src?: string | undefined;
            metadata: {
                name: string;
                size: number;
                type: string;
                fileKey: string;
            };
        } | {
            type: "file";
            src?: string | undefined;
            metadata: {
                name: string;
                size: number;
                type: string;
                fileKey: string;
            };
        };
    };
};

/** post /v1/prv/conversations/bulk-message */
type PostV1PrvConversationsBulkMessagePositiveVariant1 = {
    status: "success";
    data: {
        messages: ({
            _id: string;
            idempotencyKey?: string | undefined;
            conversationId: string;
            authorId: string;
            type: "user";
            content: {
                type: "text";
                text: string;
                priceEUR?: number | undefined;
                cpmEUR?: number | undefined;
            } | {
                type: "image";
                src?: string | undefined;
                metadata: {
                    name: string;
                    size: number;
                    type: string;
                    fileKey: string;
                };
            } | {
                type: "file";
                src?: string | undefined;
                metadata: {
                    name: string;
                    size: number;
                    type: string;
                    fileKey: string;
                };
            };
            createdAt: string;
        } | {
            _id: string;
            idempotencyKey?: string | undefined;
            conversationId: string;
            type: "automatic";
            content: {
                notificationType: "creator_offer_submitted";
                price: number;
                cpm?: number | undefined;
                maxAmount?: number | undefined;
            } | {
                notificationType: "creator_offer_accepted";
                utmLink?: string | undefined;
                promoCode?: string | undefined;
                creatorsPaidByBrand?: boolean | undefined;
            } | {
                notificationType: "creator_offer_rejected";
                rejectionReason: string;
            } | {
                notificationType: "creator_counter_offer";
                price: number;
                cpm?: number | undefined;
                maxAmount?: number | undefined;
                reason?: string | undefined;
            } | {
                notificationType: "creator_excluded_from_campaign";
                exclusionReason: string;
            } | {
                notificationType: "campaign_offer_submitted";
                price: number;
                cpm?: number | undefined;
                maxAmount?: number | undefined;
            } | {
                notificationType: "campaign_offer_accepted";
                utmLink?: string | undefined;
                promoCode?: string | undefined;
                creatorsPaidByBrand?: boolean | undefined;
            } | {
                notificationType: "campaign_offer_rejected";
            } | {
                notificationType: "campaign_counter_offer";
                price: number;
                cpm?: number | undefined;
                maxAmount?: number | undefined;
                reason?: string | undefined;
            } | {
                notificationType: "post_to_review";
                postId: string;
                campaignId: string;
            } | {
                notificationType: "post_scheduled";
                postId: string;
                campaignId: string;
            } | {
                notificationType: "post_published";
                postId: string;
                linkedinPostId?: string | undefined;
            } | {
                notificationType: "post_rejected";
                postId: string;
                campaignId: string;
                rejectionReason: string;
            } | {
                notificationType: "post_validated";
                postId: string;
                campaignId: string;
            } | {
                notificationType: "post_comment_added";
                postId: string;
                campaignId: string;
                commentId: string;
            } | {
                notificationType: "post_comment_updated";
                postId: string;
                campaignId: string;
                commentId: string;
            } | {
                notificationType: "post_comment_removed";
                postId: string;
                campaignId: string;
                commentId: string;
            } | {
                notificationType: "post_attachment_added";
                postId: string;
                campaignId: string;
                attachmentName: string;
            } | {
                notificationType: "post_attachment_updated";
                postId: string;
                campaignId: string;
                attachmentName: string;
            } | {
                notificationType: "post_attachment_removed";
                postId: string;
                campaignId: string;
                attachmentName: string;
            } | {
                notificationType: "sponsored_post_payment_received";
                linkedinPostId?: string | undefined;
                campaignId: string;
                campaignName: string;
                amount: number;
                currency?: ("EUR" | "USD") | undefined;
            } | {
                notificationType: "sponsored_post_payment_failed";
                linkedinPostId?: string | undefined;
                campaignId: string;
                campaignName: string;
                amount: number;
                currency?: ("EUR" | "USD") | undefined;
            } | {
                notificationType: "campaign_closed";
                campaignId: string;
                campaignName: string;
            };
            createdAt: string;
        })[];
    };
};

/** post /v1/prv/conversations/bulk-message */
interface PostV1PrvConversationsBulkMessagePositiveResponseVariants {
    200: PostV1PrvConversationsBulkMessagePositiveVariant1;
}

/** post /v1/prv/conversations/bulk-message */
type PostV1PrvConversationsBulkMessageNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/prv/conversations/bulk-message */
interface PostV1PrvConversationsBulkMessageNegativeResponseVariants {
    400: PostV1PrvConversationsBulkMessageNegativeVariant1;
}

/** post /v1/prv/conversations/file/:campaignId/:creatorIds */
type PostV1PrvConversationsFileCampaignIdCreatorIdsInput = {
    creatorIds: string;
    campaignId: string;
    file: any;
};

/** post /v1/prv/conversations/file/:campaignId/:creatorIds */
type PostV1PrvConversationsFileCampaignIdCreatorIdsPositiveVariant1 = {
    status: "success";
    data: {
        messages: ({
            _id: string;
            idempotencyKey?: string | undefined;
            conversationId: string;
            authorId: string;
            type: "user";
            content: {
                type: "text";
                text: string;
                priceEUR?: number | undefined;
                cpmEUR?: number | undefined;
            } | {
                type: "image";
                src?: string | undefined;
                metadata: {
                    name: string;
                    size: number;
                    type: string;
                    fileKey: string;
                };
            } | {
                type: "file";
                src?: string | undefined;
                metadata: {
                    name: string;
                    size: number;
                    type: string;
                    fileKey: string;
                };
            };
            createdAt: string;
        } | {
            _id: string;
            idempotencyKey?: string | undefined;
            conversationId: string;
            type: "automatic";
            content: {
                notificationType: "creator_offer_submitted";
                price: number;
                cpm?: number | undefined;
                maxAmount?: number | undefined;
            } | {
                notificationType: "creator_offer_accepted";
                utmLink?: string | undefined;
                promoCode?: string | undefined;
                creatorsPaidByBrand?: boolean | undefined;
            } | {
                notificationType: "creator_offer_rejected";
                rejectionReason: string;
            } | {
                notificationType: "creator_counter_offer";
                price: number;
                cpm?: number | undefined;
                maxAmount?: number | undefined;
                reason?: string | undefined;
            } | {
                notificationType: "creator_excluded_from_campaign";
                exclusionReason: string;
            } | {
                notificationType: "campaign_offer_submitted";
                price: number;
                cpm?: number | undefined;
                maxAmount?: number | undefined;
            } | {
                notificationType: "campaign_offer_accepted";
                utmLink?: string | undefined;
                promoCode?: string | undefined;
                creatorsPaidByBrand?: boolean | undefined;
            } | {
                notificationType: "campaign_offer_rejected";
            } | {
                notificationType: "campaign_counter_offer";
                price: number;
                cpm?: number | undefined;
                maxAmount?: number | undefined;
                reason?: string | undefined;
            } | {
                notificationType: "post_to_review";
                postId: string;
                campaignId: string;
            } | {
                notificationType: "post_scheduled";
                postId: string;
                campaignId: string;
            } | {
                notificationType: "post_published";
                postId: string;
                linkedinPostId?: string | undefined;
            } | {
                notificationType: "post_rejected";
                postId: string;
                campaignId: string;
                rejectionReason: string;
            } | {
                notificationType: "post_validated";
                postId: string;
                campaignId: string;
            } | {
                notificationType: "post_comment_added";
                postId: string;
                campaignId: string;
                commentId: string;
            } | {
                notificationType: "post_comment_updated";
                postId: string;
                campaignId: string;
                commentId: string;
            } | {
                notificationType: "post_comment_removed";
                postId: string;
                campaignId: string;
                commentId: string;
            } | {
                notificationType: "post_attachment_added";
                postId: string;
                campaignId: string;
                attachmentName: string;
            } | {
                notificationType: "post_attachment_updated";
                postId: string;
                campaignId: string;
                attachmentName: string;
            } | {
                notificationType: "post_attachment_removed";
                postId: string;
                campaignId: string;
                attachmentName: string;
            } | {
                notificationType: "sponsored_post_payment_received";
                linkedinPostId?: string | undefined;
                campaignId: string;
                campaignName: string;
                amount: number;
                currency?: ("EUR" | "USD") | undefined;
            } | {
                notificationType: "sponsored_post_payment_failed";
                linkedinPostId?: string | undefined;
                campaignId: string;
                campaignName: string;
                amount: number;
                currency?: ("EUR" | "USD") | undefined;
            } | {
                notificationType: "campaign_closed";
                campaignId: string;
                campaignName: string;
            };
            createdAt: string;
        })[];
    };
};

/** post /v1/prv/conversations/file/:campaignId/:creatorIds */
interface PostV1PrvConversationsFileCampaignIdCreatorIdsPositiveResponseVariants {
    200: PostV1PrvConversationsFileCampaignIdCreatorIdsPositiveVariant1;
}

/** post /v1/prv/conversations/file/:campaignId/:creatorIds */
type PostV1PrvConversationsFileCampaignIdCreatorIdsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/prv/conversations/file/:campaignId/:creatorIds */
interface PostV1PrvConversationsFileCampaignIdCreatorIdsNegativeResponseVariants {
    400: PostV1PrvConversationsFileCampaignIdCreatorIdsNegativeVariant1;
}

/** get /v1/prv/conversations/:conversationId/messages */
type GetV1PrvConversationsConversationIdMessagesInput = {
    conversationId: string;
    lastMessageId?: string | undefined;
    size?: number | undefined;
};

/** get /v1/prv/conversations/:conversationId/messages */
type GetV1PrvConversationsConversationIdMessagesPositiveVariant1 = {
    status: "success";
    data: {
        messages: ({
            _id: string;
            idempotencyKey?: string | undefined;
            conversationId: string;
            authorId: string;
            type: "user";
            content: {
                type: "text";
                text: string;
                priceEUR?: number | undefined;
                cpmEUR?: number | undefined;
            } | {
                type: "image";
                src?: string | undefined;
                metadata: {
                    name: string;
                    size: number;
                    type: string;
                    fileKey: string;
                };
            } | {
                type: "file";
                src?: string | undefined;
                metadata: {
                    name: string;
                    size: number;
                    type: string;
                    fileKey: string;
                };
            };
            createdAt: string;
        } | {
            _id: string;
            idempotencyKey?: string | undefined;
            conversationId: string;
            type: "automatic";
            content: {
                notificationType: "creator_offer_submitted";
                price: number;
                cpm?: number | undefined;
                maxAmount?: number | undefined;
            } | {
                notificationType: "creator_offer_accepted";
                utmLink?: string | undefined;
                promoCode?: string | undefined;
                creatorsPaidByBrand?: boolean | undefined;
            } | {
                notificationType: "creator_offer_rejected";
                rejectionReason: string;
            } | {
                notificationType: "creator_counter_offer";
                price: number;
                cpm?: number | undefined;
                maxAmount?: number | undefined;
                reason?: string | undefined;
            } | {
                notificationType: "creator_excluded_from_campaign";
                exclusionReason: string;
            } | {
                notificationType: "campaign_offer_submitted";
                price: number;
                cpm?: number | undefined;
                maxAmount?: number | undefined;
            } | {
                notificationType: "campaign_offer_accepted";
                utmLink?: string | undefined;
                promoCode?: string | undefined;
                creatorsPaidByBrand?: boolean | undefined;
            } | {
                notificationType: "campaign_offer_rejected";
            } | {
                notificationType: "campaign_counter_offer";
                price: number;
                cpm?: number | undefined;
                maxAmount?: number | undefined;
                reason?: string | undefined;
            } | {
                notificationType: "post_to_review";
                postId: string;
                campaignId: string;
            } | {
                notificationType: "post_scheduled";
                postId: string;
                campaignId: string;
            } | {
                notificationType: "post_published";
                postId: string;
                linkedinPostId?: string | undefined;
            } | {
                notificationType: "post_rejected";
                postId: string;
                campaignId: string;
                rejectionReason: string;
            } | {
                notificationType: "post_validated";
                postId: string;
                campaignId: string;
            } | {
                notificationType: "post_comment_added";
                postId: string;
                campaignId: string;
                commentId: string;
            } | {
                notificationType: "post_comment_updated";
                postId: string;
                campaignId: string;
                commentId: string;
            } | {
                notificationType: "post_comment_removed";
                postId: string;
                campaignId: string;
                commentId: string;
            } | {
                notificationType: "post_attachment_added";
                postId: string;
                campaignId: string;
                attachmentName: string;
            } | {
                notificationType: "post_attachment_updated";
                postId: string;
                campaignId: string;
                attachmentName: string;
            } | {
                notificationType: "post_attachment_removed";
                postId: string;
                campaignId: string;
                attachmentName: string;
            } | {
                notificationType: "sponsored_post_payment_received";
                linkedinPostId?: string | undefined;
                campaignId: string;
                campaignName: string;
                amount: number;
                currency?: ("EUR" | "USD") | undefined;
            } | {
                notificationType: "sponsored_post_payment_failed";
                linkedinPostId?: string | undefined;
                campaignId: string;
                campaignName: string;
                amount: number;
                currency?: ("EUR" | "USD") | undefined;
            } | {
                notificationType: "campaign_closed";
                campaignId: string;
                campaignName: string;
            };
            createdAt: string;
        })[];
        hasMore: boolean;
    };
};

/** get /v1/prv/conversations/:conversationId/messages */
interface GetV1PrvConversationsConversationIdMessagesPositiveResponseVariants {
    200: GetV1PrvConversationsConversationIdMessagesPositiveVariant1;
}

/** get /v1/prv/conversations/:conversationId/messages */
type GetV1PrvConversationsConversationIdMessagesNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/conversations/:conversationId/messages */
interface GetV1PrvConversationsConversationIdMessagesNegativeResponseVariants {
    400: GetV1PrvConversationsConversationIdMessagesNegativeVariant1;
}

/** post /v1/prv/conversations/:conversationId/messages */
type PostV1PrvConversationsConversationIdMessagesInput = {
    data: {
        conversationId: string;
        content: {
            type: "text";
            text: string;
            priceEUR?: number | undefined;
            cpmEUR?: number | undefined;
        } | {
            type: "image";
            src?: string | undefined;
            metadata: {
                name: string;
                size: number;
                type: string;
                fileKey: string;
            };
        } | {
            type: "file";
            src?: string | undefined;
            metadata: {
                name: string;
                size: number;
                type: string;
                fileKey: string;
            };
        };
    };
};

/** post /v1/prv/conversations/:conversationId/messages */
type PostV1PrvConversationsConversationIdMessagesPositiveVariant1 = {
    status: "success";
    data: {
        message: {
            _id: string;
            idempotencyKey?: string | undefined;
            conversationId: string;
            authorId: string;
            type: "user";
            content: {
                type: "text";
                text: string;
                priceEUR?: number | undefined;
                cpmEUR?: number | undefined;
            } | {
                type: "image";
                src?: string | undefined;
                metadata: {
                    name: string;
                    size: number;
                    type: string;
                    fileKey: string;
                };
            } | {
                type: "file";
                src?: string | undefined;
                metadata: {
                    name: string;
                    size: number;
                    type: string;
                    fileKey: string;
                };
            };
            createdAt: string;
        } | {
            _id: string;
            idempotencyKey?: string | undefined;
            conversationId: string;
            type: "automatic";
            content: {
                notificationType: "creator_offer_submitted";
                price: number;
                cpm?: number | undefined;
                maxAmount?: number | undefined;
            } | {
                notificationType: "creator_offer_accepted";
                utmLink?: string | undefined;
                promoCode?: string | undefined;
                creatorsPaidByBrand?: boolean | undefined;
            } | {
                notificationType: "creator_offer_rejected";
                rejectionReason: string;
            } | {
                notificationType: "creator_counter_offer";
                price: number;
                cpm?: number | undefined;
                maxAmount?: number | undefined;
                reason?: string | undefined;
            } | {
                notificationType: "creator_excluded_from_campaign";
                exclusionReason: string;
            } | {
                notificationType: "campaign_offer_submitted";
                price: number;
                cpm?: number | undefined;
                maxAmount?: number | undefined;
            } | {
                notificationType: "campaign_offer_accepted";
                utmLink?: string | undefined;
                promoCode?: string | undefined;
                creatorsPaidByBrand?: boolean | undefined;
            } | {
                notificationType: "campaign_offer_rejected";
            } | {
                notificationType: "campaign_counter_offer";
                price: number;
                cpm?: number | undefined;
                maxAmount?: number | undefined;
                reason?: string | undefined;
            } | {
                notificationType: "post_to_review";
                postId: string;
                campaignId: string;
            } | {
                notificationType: "post_scheduled";
                postId: string;
                campaignId: string;
            } | {
                notificationType: "post_published";
                postId: string;
                linkedinPostId?: string | undefined;
            } | {
                notificationType: "post_rejected";
                postId: string;
                campaignId: string;
                rejectionReason: string;
            } | {
                notificationType: "post_validated";
                postId: string;
                campaignId: string;
            } | {
                notificationType: "post_comment_added";
                postId: string;
                campaignId: string;
                commentId: string;
            } | {
                notificationType: "post_comment_updated";
                postId: string;
                campaignId: string;
                commentId: string;
            } | {
                notificationType: "post_comment_removed";
                postId: string;
                campaignId: string;
                commentId: string;
            } | {
                notificationType: "post_attachment_added";
                postId: string;
                campaignId: string;
                attachmentName: string;
            } | {
                notificationType: "post_attachment_updated";
                postId: string;
                campaignId: string;
                attachmentName: string;
            } | {
                notificationType: "post_attachment_removed";
                postId: string;
                campaignId: string;
                attachmentName: string;
            } | {
                notificationType: "sponsored_post_payment_received";
                linkedinPostId?: string | undefined;
                campaignId: string;
                campaignName: string;
                amount: number;
                currency?: ("EUR" | "USD") | undefined;
            } | {
                notificationType: "sponsored_post_payment_failed";
                linkedinPostId?: string | undefined;
                campaignId: string;
                campaignName: string;
                amount: number;
                currency?: ("EUR" | "USD") | undefined;
            } | {
                notificationType: "campaign_closed";
                campaignId: string;
                campaignName: string;
            };
            createdAt: string;
        };
    };
};

/** post /v1/prv/conversations/:conversationId/messages */
interface PostV1PrvConversationsConversationIdMessagesPositiveResponseVariants {
    200: PostV1PrvConversationsConversationIdMessagesPositiveVariant1;
}

/** post /v1/prv/conversations/:conversationId/messages */
type PostV1PrvConversationsConversationIdMessagesNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/prv/conversations/:conversationId/messages */
interface PostV1PrvConversationsConversationIdMessagesNegativeResponseVariants {
    400: PostV1PrvConversationsConversationIdMessagesNegativeVariant1;
}

/** put /v1/prv/conversations/:conversationId/read */
type PutV1PrvConversationsConversationIdReadInput = {
    conversationId: string;
};

/** put /v1/prv/conversations/:conversationId/read */
type PutV1PrvConversationsConversationIdReadPositiveVariant1 = {
    status: "success";
    data: {
        success: boolean;
        modifiedCount: number;
    };
};

/** put /v1/prv/conversations/:conversationId/read */
interface PutV1PrvConversationsConversationIdReadPositiveResponseVariants {
    200: PutV1PrvConversationsConversationIdReadPositiveVariant1;
}

/** put /v1/prv/conversations/:conversationId/read */
type PutV1PrvConversationsConversationIdReadNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** put /v1/prv/conversations/:conversationId/read */
interface PutV1PrvConversationsConversationIdReadNegativeResponseVariants {
    400: PutV1PrvConversationsConversationIdReadNegativeVariant1;
}

/** put /v1/prv/conversations/:conversationId/unread */
type PutV1PrvConversationsConversationIdUnreadInput = {
    conversationId: string;
};

/** put /v1/prv/conversations/:conversationId/unread */
type PutV1PrvConversationsConversationIdUnreadPositiveVariant1 = {
    status: "success";
    data: {
        success: boolean;
        modifiedCount: number;
    };
};

/** put /v1/prv/conversations/:conversationId/unread */
interface PutV1PrvConversationsConversationIdUnreadPositiveResponseVariants {
    200: PutV1PrvConversationsConversationIdUnreadPositiveVariant1;
}

/** put /v1/prv/conversations/:conversationId/unread */
type PutV1PrvConversationsConversationIdUnreadNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** put /v1/prv/conversations/:conversationId/unread */
interface PutV1PrvConversationsConversationIdUnreadNegativeResponseVariants {
    400: PutV1PrvConversationsConversationIdUnreadNegativeVariant1;
}

/** post /v1/prv/conversations/:conversationId/upload */
type PostV1PrvConversationsConversationIdUploadInput = {
    conversationId: string;
    file: any;
};

/** post /v1/prv/conversations/:conversationId/upload */
type PostV1PrvConversationsConversationIdUploadPositiveVariant1 = {
    status: "success";
    data: {
        message: {
            _id: string;
            idempotencyKey?: string | undefined;
            conversationId: string;
            authorId: string;
            type: "user";
            content: {
                type: "text";
                text: string;
                priceEUR?: number | undefined;
                cpmEUR?: number | undefined;
            } | {
                type: "image";
                src?: string | undefined;
                metadata: {
                    name: string;
                    size: number;
                    type: string;
                    fileKey: string;
                };
            } | {
                type: "file";
                src?: string | undefined;
                metadata: {
                    name: string;
                    size: number;
                    type: string;
                    fileKey: string;
                };
            };
            createdAt: string;
        } | {
            _id: string;
            idempotencyKey?: string | undefined;
            conversationId: string;
            type: "automatic";
            content: {
                notificationType: "creator_offer_submitted";
                price: number;
                cpm?: number | undefined;
                maxAmount?: number | undefined;
            } | {
                notificationType: "creator_offer_accepted";
                utmLink?: string | undefined;
                promoCode?: string | undefined;
                creatorsPaidByBrand?: boolean | undefined;
            } | {
                notificationType: "creator_offer_rejected";
                rejectionReason: string;
            } | {
                notificationType: "creator_counter_offer";
                price: number;
                cpm?: number | undefined;
                maxAmount?: number | undefined;
                reason?: string | undefined;
            } | {
                notificationType: "creator_excluded_from_campaign";
                exclusionReason: string;
            } | {
                notificationType: "campaign_offer_submitted";
                price: number;
                cpm?: number | undefined;
                maxAmount?: number | undefined;
            } | {
                notificationType: "campaign_offer_accepted";
                utmLink?: string | undefined;
                promoCode?: string | undefined;
                creatorsPaidByBrand?: boolean | undefined;
            } | {
                notificationType: "campaign_offer_rejected";
            } | {
                notificationType: "campaign_counter_offer";
                price: number;
                cpm?: number | undefined;
                maxAmount?: number | undefined;
                reason?: string | undefined;
            } | {
                notificationType: "post_to_review";
                postId: string;
                campaignId: string;
            } | {
                notificationType: "post_scheduled";
                postId: string;
                campaignId: string;
            } | {
                notificationType: "post_published";
                postId: string;
                linkedinPostId?: string | undefined;
            } | {
                notificationType: "post_rejected";
                postId: string;
                campaignId: string;
                rejectionReason: string;
            } | {
                notificationType: "post_validated";
                postId: string;
                campaignId: string;
            } | {
                notificationType: "post_comment_added";
                postId: string;
                campaignId: string;
                commentId: string;
            } | {
                notificationType: "post_comment_updated";
                postId: string;
                campaignId: string;
                commentId: string;
            } | {
                notificationType: "post_comment_removed";
                postId: string;
                campaignId: string;
                commentId: string;
            } | {
                notificationType: "post_attachment_added";
                postId: string;
                campaignId: string;
                attachmentName: string;
            } | {
                notificationType: "post_attachment_updated";
                postId: string;
                campaignId: string;
                attachmentName: string;
            } | {
                notificationType: "post_attachment_removed";
                postId: string;
                campaignId: string;
                attachmentName: string;
            } | {
                notificationType: "sponsored_post_payment_received";
                linkedinPostId?: string | undefined;
                campaignId: string;
                campaignName: string;
                amount: number;
                currency?: ("EUR" | "USD") | undefined;
            } | {
                notificationType: "sponsored_post_payment_failed";
                linkedinPostId?: string | undefined;
                campaignId: string;
                campaignName: string;
                amount: number;
                currency?: ("EUR" | "USD") | undefined;
            } | {
                notificationType: "campaign_closed";
                campaignId: string;
                campaignName: string;
            };
            createdAt: string;
        };
        fileKey: string;
    };
};

/** post /v1/prv/conversations/:conversationId/upload */
interface PostV1PrvConversationsConversationIdUploadPositiveResponseVariants {
    200: PostV1PrvConversationsConversationIdUploadPositiveVariant1;
}

/** post /v1/prv/conversations/:conversationId/upload */
type PostV1PrvConversationsConversationIdUploadNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/prv/conversations/:conversationId/upload */
interface PostV1PrvConversationsConversationIdUploadNegativeResponseVariants {
    400: PostV1PrvConversationsConversationIdUploadNegativeVariant1;
}

/** get /v1/prv/creator-applications */
type GetV1PrvCreatorApplicationsInput = {
    campaignId: string;
    state?: ("all" | "counterOfferSent" | "pending" | "accepted" | "rejected" | "excluded" | "invited") | undefined;
    page?: number | undefined;
    size?: number | undefined;
    searchQuery?: string | undefined;
    sort?: any | undefined;
    creatorIds?: string | undefined;
};

/** get /v1/prv/creator-applications */
type GetV1PrvCreatorApplicationsPositiveVariant1 = {
    status: "success";
    data: {
        creatorApplications: {
            _id: string;
            uniquenessKey?: string | undefined;
            sideEffectOutboxVersion?: number | undefined;
            inviteSideEffectsEnqueuedAt?: string | undefined;
            price: number;
            cpm?: number | undefined;
            maxAmount?: number | undefined;
            state: "pending" | "accepted" | "rejected" | "excluded" | "invited";
            reason: string;
            rejectionReason?: string | undefined;
            exclusionReason?: string | undefined;
            isUserOfBrand: boolean;
            smmUserId: string;
            expectedAuthorLinkedinNumId?: string | undefined;
            linkedinIdentityFrozenAt?: string | undefined;
            createdAt: string;
            updatedAt: string;
            acceptedAt?: string | undefined;
            budgetReservedAt?: string | undefined;
            capacityExcludedAt?: string | undefined;
            lastPublishReminderAt?: string | undefined;
            publishReminderCount?: number | undefined;
            publishReminderExhausted?: boolean | undefined;
            changesRequestedAt?: string | undefined;
            changesRequestReason?: string | undefined;
            lastNegotiation?: {
                price: number;
                cpm?: number | undefined;
                maxAmount?: number | undefined;
                proposedBy: "creator" | "campaign";
                proposedAt: string;
                reason?: string | undefined;
            } | undefined;
            campaign: {
                _id: string;
                userId: string;
                brandId: string;
                name: string;
                description: string;
                status: "DRAFT" | "PENDING_PAYMENT" | "ACTIVE" | "PAUSED" | "FINISHED";
                paymentStatus: "PENDING" | "PAID" | "FAILED";
                paymentDeclineCode?: string | undefined;
                targets: {
                    minFollowers?: (number | null) | undefined;
                    minViews?: (number | null) | undefined;
                    minViewsLast28Days?: (number | null) | undefined;
                    language?: (string | null) | undefined;
                    audienceLocation?: string[] | undefined;
                    hierarchyLevel?: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | undefined;
                    industry?: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | undefined;
                    companySize?: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | undefined;
                    occupation?: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | undefined;
                };
                framing: {
                    startDate: string;
                    endDate?: string | undefined;
                    publicationStartDate?: string | undefined;
                    publicationEndDate?: string | undefined;
                    maxBudgetPerPost?: number | undefined;
                    cpm?: number | undefined;
                    totalBudget: number;
                    totalUsedBudget?: number | undefined;
                    autoValidateContent: boolean;
                    autoAcceptCreators: boolean;
                    autonomousCpmCeilingMultiplier?: (1 | 1.1 | 1.2) | undefined;
                    capMode?: ("auto" | "fixed") | undefined;
                    fixedCap?: number | undefined;
                };
                objective?: ("awareness" | "traffic" | "demos") | undefined;
                brief?: {
                    keyMessage?: string | undefined;
                    tones?: ("concrete" | "educational" | "personal" | "light_humour")[] | undefined;
                    do?: string[] | undefined;
                    avoid?: string[] | undefined;
                } | undefined;
                regions?: string[] | undefined;
                rules?: {
                    minTargetAudienceShare?: number | undefined;
                    askIfMostlyAbroad?: boolean | undefined;
                } | undefined;
                invitationTemplate?: string | undefined;
                sender?: {
                    kind: "own_profile" | "kawaak_managed";
                } | undefined;
                postAcceptanceMode?: ("agent_auto" | "review_24h" | "manual") | undefined;
                draftStep?: ("brand" | "proposal" | "budget" | "launch") | undefined;
                suggestedTargets?: {
                    label: string;
                    targets: {
                        minFollowers?: (number | null) | undefined;
                        minViews?: (number | null) | undefined;
                        minViewsLast28Days?: (number | null) | undefined;
                        language?: (string | null) | undefined;
                        audienceLocation?: string[] | undefined;
                        hierarchyLevel?: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | undefined;
                        industry?: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | undefined;
                        companySize?: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | undefined;
                        occupation?: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | undefined;
                    };
                    eligibleCount: number | null;
                    reason?: string | undefined;
                    audienceReached?: string[] | undefined;
                }[] | undefined;
                agentInstructions?: string[] | undefined;
                budgetReservationTrigger?: ("acceptance" | "post_submission") | undefined;
                nbPostsToReview: number;
                utmLink?: string | undefined;
                promoCode?: string | undefined;
                stripePaymentIntentId?: string | undefined;
                stripeInvoiceId?: string | undefined;
                stripeCheckoutSessionId?: string | undefined;
                stripeRefundId?: string | undefined;
                stripeCreditNoteId?: string | undefined;
                stripeDeferredClosePaymentIntentId?: string | undefined;
                stripeDeferredCloseInvoiceId?: string | undefined;
                paymentSnapshot?: {
                    source: "stripe_checkout" | "stripe_payment_intent" | "out_of_band";
                    currency: "eur" | "usd";
                    conversionRateFromEUR: number;
                    budgetAmountInCents: number;
                    platformFeeAmountInCents: number;
                    taxAmountInCents: number;
                    totalAmountInCents: number;
                    paidAt: string;
                    stripePaymentIntentId?: string | undefined;
                    stripeInvoiceId?: string | undefined;
                    stripeCheckoutSessionId?: string | undefined;
                    externalReference?: string | undefined;
                    outOfBandProof?: {
                        proofDocumentKey: string;
                        proofDocumentSha256: string;
                        proofDocumentEtag: string;
                        proofDocumentSizeBytes: number;
                        proofDocumentLastModified: string;
                        proofDocumentContentType: string;
                        proofDocumentVersionId?: string | undefined;
                        bankTransactionReference: string;
                        invoiceReference: string;
                        submittedAt: string;
                        submittedByStaffId: string;
                        approvedAt: string;
                        approvedByStaffId: string;
                    } | undefined;
                } | undefined;
                paymentAttempt?: {
                    attemptId: string;
                    version: number;
                    purpose: "INITIAL_DEPOSIT" | "DEFERRED_USAGE";
                    state: "creating" | "awaiting_payment" | "paid" | "failed" | "canceled";
                    currency: "eur" | "usd";
                    conversionRateFromEUR: number;
                    budgetAmountInCents: number;
                    platformFeeAmountInCents: number;
                    customerId: string;
                    createdAt: string;
                    updatedAt: string;
                    cardCheckout?: {
                        expiresAt: number;
                        successUrl: string;
                        cancelUrl: string;
                    } | undefined;
                    checkoutSessionId?: string | undefined;
                    stripeInvoiceId?: string | undefined;
                    stripePaymentIntentId?: string | undefined;
                    failureCode?: string | undefined;
                } | undefined;
                paymentAttemptHistory?: {
                    attemptId: string;
                    version: number;
                    purpose: "INITIAL_DEPOSIT" | "DEFERRED_USAGE";
                    state: "creating" | "awaiting_payment" | "paid" | "failed" | "canceled";
                    currency: "eur" | "usd";
                    conversionRateFromEUR: number;
                    budgetAmountInCents: number;
                    platformFeeAmountInCents: number;
                    customerId: string;
                    createdAt: string;
                    updatedAt: string;
                    cardCheckout?: {
                        expiresAt: number;
                        successUrl: string;
                        cancelUrl: string;
                    } | undefined;
                    checkoutSessionId?: string | undefined;
                    stripeInvoiceId?: string | undefined;
                    stripePaymentIntentId?: string | undefined;
                    failureCode?: string | undefined;
                }[] | undefined;
                paymentReconciliationIssues?: {
                    attemptId: string;
                    stripePaymentIntentId: string;
                    amountInCents: number;
                    currency: string;
                    reason: string;
                    detectedAt: string;
                }[] | undefined;
                financialClose?: {
                    state: "closing" | "awaiting_deferred_payment" | "manual_refund_required" | "manual_refund_awaiting_approval" | "manual_refund_confirmed" | "refund_pending" | "refund_failed";
                    requestedAt: string;
                    projectedUsedBudgetInEuros: number;
                    ownerId?: string | undefined;
                    leaseId?: string | undefined;
                    leaseExpiresAt?: string | undefined;
                    refundAmountInCents?: number | undefined;
                    currency?: ("eur" | "usd") | undefined;
                    error?: string | undefined;
                    refundFailedAlertedAt?: string | undefined;
                } | undefined;
                agent?: {
                    enabled: boolean;
                    autonomyLevel?: ("assisted" | "review" | "autonomous") | undefined;
                    pausedAt?: string | undefined;
                    autonomyStats?: {
                        firstMessagesSent?: number | undefined;
                        firstMessagesApprovedStreak?: number | undefined;
                        repliesSent?: number | undefined;
                        repliesApprovedStreak?: number | undefined;
                    } | undefined;
                    autonomyProposal?: {
                        status: "proposed" | "accepted" | "refused";
                        trigger: "first_messages_sent" | "first_messages_approved" | "replies_sent" | "replies_approved";
                        proposedAt: string;
                        refusals: number;
                        firstRefusedAt?: string | undefined;
                        nextProposalAt?: string | undefined;
                    } | undefined;
                    poolExhaustedAt?: {
                        in_app?: string | undefined;
                        linkedin?: string | undefined;
                    } | undefined;
                    linkedinSourcing?: {
                        nextRunAfter?: string | undefined;
                        lastRunAt?: string | undefined;
                        lastOutcome?: string | undefined;
                        keywords?: string[] | undefined;
                        searchKey?: string | undefined;
                        nextPage?: number | undefined;
                    } | undefined;
                } | undefined;
                payoutCreationLocks?: string[] | undefined;
                scheduledPayoutClaims?: string[] | undefined;
                refundedAt?: string | undefined;
                refundedBudgetInCents?: number | undefined;
                refundedFeeInCents?: number | undefined;
                refundedTaxInCents?: number | undefined;
                refundMethod?: ("stripe" | "manual") | undefined;
                manualRefundReference?: string | undefined;
                manualRefundedByStaffId?: string | undefined;
                manualRefundProof?: {
                    reference: string;
                    amountInCents: number;
                    currency: "eur" | "usd";
                    executedAt: string;
                    proofDocumentKey: string;
                    proofDocumentEtag: string;
                    proofDocumentSizeBytes: number;
                    proofDocumentLastModified: string;
                    proofDocumentContentType: string;
                    submittedAt: string;
                    submittedByStaffId: string;
                    confirmedAt?: string | undefined;
                    confirmedByStaffId?: string | undefined;
                } | undefined;
                depositedAt?: string | undefined;
                firstMessagesToAcceptedCreators?: ({
                    type: "text";
                    text: string;
                    priceEUR?: number | undefined;
                    cpmEUR?: number | undefined;
                } | {
                    type: "image";
                    src?: string | undefined;
                    metadata: {
                        name: string;
                        size: number;
                        type: string;
                        fileKey: string;
                    };
                } | {
                    type: "file";
                    src?: string | undefined;
                    metadata: {
                        name: string;
                        size: number;
                        type: string;
                        fileKey: string;
                    };
                })[] | undefined;
                closedByStaffAt?: string | undefined;
                deletedAt?: string | undefined;
                currencyConversion: {
                    currency: "USD";
                    rateFromEUR: number;
                    lockedAt: string;
                };
                initialBudgetQuote?: {
                    currency: "eur" | "usd";
                    budgetAmountInCents: number;
                    budgetAmountInEurCents: number;
                    conversionRateFromEUR: number;
                    quotedAt: string;
                } | undefined;
                budgetDepositStatus?: ("PENDING" | "DEPOSITED") | undefined;
                creatorsPaidByBrand?: boolean | undefined;
                createdAt?: string | undefined;
            };
            brand: {
                _id: string;
                name: string;
                websiteUrl?: string | undefined;
                country?: string | undefined;
                language?: string | undefined;
                description?: string | undefined;
                logoKey?: string | undefined;
                filesKeys?: string[] | undefined;
                keyFeatures?: string | undefined;
                linkedinUrl?: string | undefined;
                socialProofs?: ({
                    type: "metric";
                    value: number;
                    name: string;
                } | {
                    type: "rating";
                    rating: number;
                    maxRating?: number | undefined;
                    plateform: string;
                })[] | undefined;
                targetAudience?: {
                    occupations: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | null;
                    occupationSeniority: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | null;
                    companySize: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | null;
                    industries: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | null;
                    locations: string[] | null;
                } | undefined;
                targetCustomers?: string | undefined;
                analyzedAt?: string | undefined;
                logoSource?: string | undefined;
            };
            creator: {
                _id: string;
                smmUserId?: string | undefined;
                name?: string | undefined;
                givenName: string;
                familyName: string;
                linkedinId?: string | undefined;
                linkedinUrl?: string | undefined;
                title?: string | undefined;
                picture?: (string | null) | undefined;
                language?: string | undefined;
                avgViewsPerPost?: (number | null) | undefined;
                medianViewsPerPost?: (number | null) | undefined;
                followers?: number | undefined;
                membersReached?: number | undefined;
                sector?: string | undefined;
                pricePerPost?: (number | null) | undefined;
                defaultCap?: (number | null) | undefined;
                impressions?: ({
                    timeRange: "past_7_days" | "past_14_days" | "past_28_days" | "past_90_days" | "past_365_days" | "custom_timerange";
                    data: {
                        totalValue?: (number | null) | undefined;
                        percentageChange?: (number | null) | undefined;
                        series: {
                            value?: (number | null) | undefined;
                            date?: (string | null) | undefined;
                        }[];
                        impressions: {
                            value?: (string | null) | undefined;
                            percentageChange?: (number | null) | undefined;
                        };
                        reached: {
                            value?: (string | null) | undefined;
                            percentageChange?: (number | null) | undefined;
                        };
                        topPosts?: {
                            urn: string;
                            reactions?: (number | null) | undefined;
                            comments?: (number | null) | undefined;
                            shares?: (number | null) | undefined;
                            text?: string | undefined;
                            impressions?: string | undefined;
                            date?: string | undefined;
                        }[] | undefined;
                    };
                }[] | null) | undefined;
                followersDemographics?: ({
                    category: "occupation_title" | "location" | "industry" | "occupation_seniority" | "company_size" | "company_name";
                    data: {
                        label: string;
                        value: number;
                        normalizedLabel?: (string | null) | undefined;
                    }[];
                }[] | null) | undefined;
                updatedAt?: string | undefined;
                isPrivate?: boolean | undefined;
            };
        }[];
        total: number;
    };
};

/** get /v1/prv/creator-applications */
interface GetV1PrvCreatorApplicationsPositiveResponseVariants {
    200: GetV1PrvCreatorApplicationsPositiveVariant1;
}

/** get /v1/prv/creator-applications */
type GetV1PrvCreatorApplicationsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/creator-applications */
interface GetV1PrvCreatorApplicationsNegativeResponseVariants {
    400: GetV1PrvCreatorApplicationsNegativeVariant1;
}

/** put /v1/prv/creator-applications */
type PutV1PrvCreatorApplicationsInput = {} & ({
    applicationIds: string[];
    status: "accepted";
    campaignId: string;
} | {
    applicationIds: string[];
    status: "rejected";
    rejectionReason: string;
    campaignId: string;
});

/** put /v1/prv/creator-applications */
type PutV1PrvCreatorApplicationsPositiveVariant1 = {
    status: "success";
    data: {
        applications: {
            _id: string;
            uniquenessKey?: string | undefined;
            sideEffectOutboxVersion?: number | undefined;
            inviteSideEffectsEnqueuedAt?: string | undefined;
            price: number;
            cpm?: number | undefined;
            maxAmount?: number | undefined;
            campaignId: string;
            state: "pending" | "accepted" | "rejected" | "excluded" | "invited";
            reason: string;
            rejectionReason?: string | undefined;
            exclusionReason?: string | undefined;
            isUserOfBrand: boolean;
            creatorId: string;
            smmUserId: string;
            expectedAuthorLinkedinNumId?: string | undefined;
            linkedinIdentityFrozenAt?: string | undefined;
            brandId: string;
            createdAt: string;
            updatedAt: string;
            acceptedAt?: string | undefined;
            budgetReservedAt?: string | undefined;
            capacityExcludedAt?: string | undefined;
            lastPublishReminderAt?: string | undefined;
            publishReminderCount?: number | undefined;
            publishReminderExhausted?: boolean | undefined;
            changesRequestedAt?: string | undefined;
            changesRequestReason?: string | undefined;
            lastNegotiation?: {
                price: number;
                cpm?: number | undefined;
                maxAmount?: number | undefined;
                proposedBy: "creator" | "campaign";
                proposedAt: string;
                reason?: string | undefined;
            } | undefined;
        }[];
    };
};

/** put /v1/prv/creator-applications */
interface PutV1PrvCreatorApplicationsPositiveResponseVariants {
    200: PutV1PrvCreatorApplicationsPositiveVariant1;
}

/** put /v1/prv/creator-applications */
type PutV1PrvCreatorApplicationsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** put /v1/prv/creator-applications */
interface PutV1PrvCreatorApplicationsNegativeResponseVariants {
    400: PutV1PrvCreatorApplicationsNegativeVariant1;
}

/** get /v1/prv/creator-applications/:creatorApplicationId */
type GetV1PrvCreatorApplicationsCreatorApplicationIdInput = {
    creatorApplicationId: string;
};

/** get /v1/prv/creator-applications/:creatorApplicationId */
type GetV1PrvCreatorApplicationsCreatorApplicationIdPositiveVariant1 = {
    status: "success";
    data: {
        creatorApplication: {
            _id: string;
            uniquenessKey?: string | undefined;
            sideEffectOutboxVersion?: number | undefined;
            inviteSideEffectsEnqueuedAt?: string | undefined;
            price: number;
            cpm?: number | undefined;
            maxAmount?: number | undefined;
            state: "pending" | "accepted" | "rejected" | "excluded" | "invited";
            reason: string;
            rejectionReason?: string | undefined;
            exclusionReason?: string | undefined;
            isUserOfBrand: boolean;
            smmUserId: string;
            expectedAuthorLinkedinNumId?: string | undefined;
            linkedinIdentityFrozenAt?: string | undefined;
            createdAt: string;
            updatedAt: string;
            acceptedAt?: string | undefined;
            budgetReservedAt?: string | undefined;
            capacityExcludedAt?: string | undefined;
            lastPublishReminderAt?: string | undefined;
            publishReminderCount?: number | undefined;
            publishReminderExhausted?: boolean | undefined;
            changesRequestedAt?: string | undefined;
            changesRequestReason?: string | undefined;
            lastNegotiation?: {
                price: number;
                cpm?: number | undefined;
                maxAmount?: number | undefined;
                proposedBy: "creator" | "campaign";
                proposedAt: string;
                reason?: string | undefined;
            } | undefined;
            campaign: {
                _id: string;
                userId: string;
                brandId: string;
                name: string;
                description: string;
                status: "DRAFT" | "PENDING_PAYMENT" | "ACTIVE" | "PAUSED" | "FINISHED";
                paymentStatus: "PENDING" | "PAID" | "FAILED";
                paymentDeclineCode?: string | undefined;
                targets: {
                    minFollowers?: (number | null) | undefined;
                    minViews?: (number | null) | undefined;
                    minViewsLast28Days?: (number | null) | undefined;
                    language?: (string | null) | undefined;
                    audienceLocation?: string[] | undefined;
                    hierarchyLevel?: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | undefined;
                    industry?: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | undefined;
                    companySize?: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | undefined;
                    occupation?: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | undefined;
                };
                framing: {
                    startDate: string;
                    endDate?: string | undefined;
                    publicationStartDate?: string | undefined;
                    publicationEndDate?: string | undefined;
                    maxBudgetPerPost?: number | undefined;
                    cpm?: number | undefined;
                    totalBudget: number;
                    totalUsedBudget?: number | undefined;
                    autoValidateContent: boolean;
                    autoAcceptCreators: boolean;
                    autonomousCpmCeilingMultiplier?: (1 | 1.1 | 1.2) | undefined;
                    capMode?: ("auto" | "fixed") | undefined;
                    fixedCap?: number | undefined;
                };
                objective?: ("awareness" | "traffic" | "demos") | undefined;
                brief?: {
                    keyMessage?: string | undefined;
                    tones?: ("concrete" | "educational" | "personal" | "light_humour")[] | undefined;
                    do?: string[] | undefined;
                    avoid?: string[] | undefined;
                } | undefined;
                regions?: string[] | undefined;
                rules?: {
                    minTargetAudienceShare?: number | undefined;
                    askIfMostlyAbroad?: boolean | undefined;
                } | undefined;
                invitationTemplate?: string | undefined;
                sender?: {
                    kind: "own_profile" | "kawaak_managed";
                } | undefined;
                postAcceptanceMode?: ("agent_auto" | "review_24h" | "manual") | undefined;
                draftStep?: ("brand" | "proposal" | "budget" | "launch") | undefined;
                suggestedTargets?: {
                    label: string;
                    targets: {
                        minFollowers?: (number | null) | undefined;
                        minViews?: (number | null) | undefined;
                        minViewsLast28Days?: (number | null) | undefined;
                        language?: (string | null) | undefined;
                        audienceLocation?: string[] | undefined;
                        hierarchyLevel?: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | undefined;
                        industry?: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | undefined;
                        companySize?: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | undefined;
                        occupation?: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | undefined;
                    };
                    eligibleCount: number | null;
                    reason?: string | undefined;
                    audienceReached?: string[] | undefined;
                }[] | undefined;
                agentInstructions?: string[] | undefined;
                budgetReservationTrigger?: ("acceptance" | "post_submission") | undefined;
                nbPostsToReview: number;
                utmLink?: string | undefined;
                promoCode?: string | undefined;
                stripePaymentIntentId?: string | undefined;
                stripeInvoiceId?: string | undefined;
                stripeCheckoutSessionId?: string | undefined;
                stripeRefundId?: string | undefined;
                stripeCreditNoteId?: string | undefined;
                stripeDeferredClosePaymentIntentId?: string | undefined;
                stripeDeferredCloseInvoiceId?: string | undefined;
                paymentSnapshot?: {
                    source: "stripe_checkout" | "stripe_payment_intent" | "out_of_band";
                    currency: "eur" | "usd";
                    conversionRateFromEUR: number;
                    budgetAmountInCents: number;
                    platformFeeAmountInCents: number;
                    taxAmountInCents: number;
                    totalAmountInCents: number;
                    paidAt: string;
                    stripePaymentIntentId?: string | undefined;
                    stripeInvoiceId?: string | undefined;
                    stripeCheckoutSessionId?: string | undefined;
                    externalReference?: string | undefined;
                    outOfBandProof?: {
                        proofDocumentKey: string;
                        proofDocumentSha256: string;
                        proofDocumentEtag: string;
                        proofDocumentSizeBytes: number;
                        proofDocumentLastModified: string;
                        proofDocumentContentType: string;
                        proofDocumentVersionId?: string | undefined;
                        bankTransactionReference: string;
                        invoiceReference: string;
                        submittedAt: string;
                        submittedByStaffId: string;
                        approvedAt: string;
                        approvedByStaffId: string;
                    } | undefined;
                } | undefined;
                paymentAttempt?: {
                    attemptId: string;
                    version: number;
                    purpose: "INITIAL_DEPOSIT" | "DEFERRED_USAGE";
                    state: "creating" | "awaiting_payment" | "paid" | "failed" | "canceled";
                    currency: "eur" | "usd";
                    conversionRateFromEUR: number;
                    budgetAmountInCents: number;
                    platformFeeAmountInCents: number;
                    customerId: string;
                    createdAt: string;
                    updatedAt: string;
                    cardCheckout?: {
                        expiresAt: number;
                        successUrl: string;
                        cancelUrl: string;
                    } | undefined;
                    checkoutSessionId?: string | undefined;
                    stripeInvoiceId?: string | undefined;
                    stripePaymentIntentId?: string | undefined;
                    failureCode?: string | undefined;
                } | undefined;
                paymentAttemptHistory?: {
                    attemptId: string;
                    version: number;
                    purpose: "INITIAL_DEPOSIT" | "DEFERRED_USAGE";
                    state: "creating" | "awaiting_payment" | "paid" | "failed" | "canceled";
                    currency: "eur" | "usd";
                    conversionRateFromEUR: number;
                    budgetAmountInCents: number;
                    platformFeeAmountInCents: number;
                    customerId: string;
                    createdAt: string;
                    updatedAt: string;
                    cardCheckout?: {
                        expiresAt: number;
                        successUrl: string;
                        cancelUrl: string;
                    } | undefined;
                    checkoutSessionId?: string | undefined;
                    stripeInvoiceId?: string | undefined;
                    stripePaymentIntentId?: string | undefined;
                    failureCode?: string | undefined;
                }[] | undefined;
                paymentReconciliationIssues?: {
                    attemptId: string;
                    stripePaymentIntentId: string;
                    amountInCents: number;
                    currency: string;
                    reason: string;
                    detectedAt: string;
                }[] | undefined;
                financialClose?: {
                    state: "closing" | "awaiting_deferred_payment" | "manual_refund_required" | "manual_refund_awaiting_approval" | "manual_refund_confirmed" | "refund_pending" | "refund_failed";
                    requestedAt: string;
                    projectedUsedBudgetInEuros: number;
                    ownerId?: string | undefined;
                    leaseId?: string | undefined;
                    leaseExpiresAt?: string | undefined;
                    refundAmountInCents?: number | undefined;
                    currency?: ("eur" | "usd") | undefined;
                    error?: string | undefined;
                    refundFailedAlertedAt?: string | undefined;
                } | undefined;
                agent?: {
                    enabled: boolean;
                    autonomyLevel?: ("assisted" | "review" | "autonomous") | undefined;
                    pausedAt?: string | undefined;
                    autonomyStats?: {
                        firstMessagesSent?: number | undefined;
                        firstMessagesApprovedStreak?: number | undefined;
                        repliesSent?: number | undefined;
                        repliesApprovedStreak?: number | undefined;
                    } | undefined;
                    autonomyProposal?: {
                        status: "proposed" | "accepted" | "refused";
                        trigger: "first_messages_sent" | "first_messages_approved" | "replies_sent" | "replies_approved";
                        proposedAt: string;
                        refusals: number;
                        firstRefusedAt?: string | undefined;
                        nextProposalAt?: string | undefined;
                    } | undefined;
                    poolExhaustedAt?: {
                        in_app?: string | undefined;
                        linkedin?: string | undefined;
                    } | undefined;
                    linkedinSourcing?: {
                        nextRunAfter?: string | undefined;
                        lastRunAt?: string | undefined;
                        lastOutcome?: string | undefined;
                        keywords?: string[] | undefined;
                        searchKey?: string | undefined;
                        nextPage?: number | undefined;
                    } | undefined;
                } | undefined;
                payoutCreationLocks?: string[] | undefined;
                scheduledPayoutClaims?: string[] | undefined;
                refundedAt?: string | undefined;
                refundedBudgetInCents?: number | undefined;
                refundedFeeInCents?: number | undefined;
                refundedTaxInCents?: number | undefined;
                refundMethod?: ("stripe" | "manual") | undefined;
                manualRefundReference?: string | undefined;
                manualRefundedByStaffId?: string | undefined;
                manualRefundProof?: {
                    reference: string;
                    amountInCents: number;
                    currency: "eur" | "usd";
                    executedAt: string;
                    proofDocumentKey: string;
                    proofDocumentEtag: string;
                    proofDocumentSizeBytes: number;
                    proofDocumentLastModified: string;
                    proofDocumentContentType: string;
                    submittedAt: string;
                    submittedByStaffId: string;
                    confirmedAt?: string | undefined;
                    confirmedByStaffId?: string | undefined;
                } | undefined;
                depositedAt?: string | undefined;
                firstMessagesToAcceptedCreators?: ({
                    type: "text";
                    text: string;
                    priceEUR?: number | undefined;
                    cpmEUR?: number | undefined;
                } | {
                    type: "image";
                    src?: string | undefined;
                    metadata: {
                        name: string;
                        size: number;
                        type: string;
                        fileKey: string;
                    };
                } | {
                    type: "file";
                    src?: string | undefined;
                    metadata: {
                        name: string;
                        size: number;
                        type: string;
                        fileKey: string;
                    };
                })[] | undefined;
                closedByStaffAt?: string | undefined;
                deletedAt?: string | undefined;
                currencyConversion: {
                    currency: "USD";
                    rateFromEUR: number;
                    lockedAt: string;
                };
                initialBudgetQuote?: {
                    currency: "eur" | "usd";
                    budgetAmountInCents: number;
                    budgetAmountInEurCents: number;
                    conversionRateFromEUR: number;
                    quotedAt: string;
                } | undefined;
                budgetDepositStatus?: ("PENDING" | "DEPOSITED") | undefined;
                creatorsPaidByBrand?: boolean | undefined;
                createdAt?: string | undefined;
            };
            brand: {
                _id: string;
                name: string;
                websiteUrl?: string | undefined;
                country?: string | undefined;
                language?: string | undefined;
                description?: string | undefined;
                logoKey?: string | undefined;
                filesKeys?: string[] | undefined;
                keyFeatures?: string | undefined;
                linkedinUrl?: string | undefined;
                socialProofs?: ({
                    type: "metric";
                    value: number;
                    name: string;
                } | {
                    type: "rating";
                    rating: number;
                    maxRating?: number | undefined;
                    plateform: string;
                })[] | undefined;
                targetAudience?: {
                    occupations: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | null;
                    occupationSeniority: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | null;
                    companySize: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | null;
                    industries: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | null;
                    locations: string[] | null;
                } | undefined;
                targetCustomers?: string | undefined;
                analyzedAt?: string | undefined;
                logoSource?: string | undefined;
            };
            creator: {
                _id: string;
                smmUserId?: string | undefined;
                name?: string | undefined;
                givenName: string;
                familyName: string;
                linkedinId?: string | undefined;
                linkedinUrl?: string | undefined;
                title?: string | undefined;
                picture?: (string | null) | undefined;
                language?: string | undefined;
                avgViewsPerPost?: (number | null) | undefined;
                medianViewsPerPost?: (number | null) | undefined;
                followers?: number | undefined;
                membersReached?: number | undefined;
                sector?: string | undefined;
                pricePerPost?: (number | null) | undefined;
                defaultCap?: (number | null) | undefined;
                impressions?: ({
                    timeRange: "past_7_days" | "past_14_days" | "past_28_days" | "past_90_days" | "past_365_days" | "custom_timerange";
                    data: {
                        totalValue?: (number | null) | undefined;
                        percentageChange?: (number | null) | undefined;
                        series: {
                            value?: (number | null) | undefined;
                            date?: (string | null) | undefined;
                        }[];
                        impressions: {
                            value?: (string | null) | undefined;
                            percentageChange?: (number | null) | undefined;
                        };
                        reached: {
                            value?: (string | null) | undefined;
                            percentageChange?: (number | null) | undefined;
                        };
                        topPosts?: {
                            urn: string;
                            reactions?: (number | null) | undefined;
                            comments?: (number | null) | undefined;
                            shares?: (number | null) | undefined;
                            text?: string | undefined;
                            impressions?: string | undefined;
                            date?: string | undefined;
                        }[] | undefined;
                    };
                }[] | null) | undefined;
                followersDemographics?: ({
                    category: "occupation_title" | "location" | "industry" | "occupation_seniority" | "company_size" | "company_name";
                    data: {
                        label: string;
                        value: number;
                        normalizedLabel?: (string | null) | undefined;
                    }[];
                }[] | null) | undefined;
                updatedAt?: string | undefined;
                isPrivate?: boolean | undefined;
            };
        };
    };
};

/** get /v1/prv/creator-applications/:creatorApplicationId */
interface GetV1PrvCreatorApplicationsCreatorApplicationIdPositiveResponseVariants {
    200: GetV1PrvCreatorApplicationsCreatorApplicationIdPositiveVariant1;
}

/** get /v1/prv/creator-applications/:creatorApplicationId */
type GetV1PrvCreatorApplicationsCreatorApplicationIdNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/creator-applications/:creatorApplicationId */
interface GetV1PrvCreatorApplicationsCreatorApplicationIdNegativeResponseVariants {
    400: GetV1PrvCreatorApplicationsCreatorApplicationIdNegativeVariant1;
}

/** get /v1/prv/creator-applications/overview/:campaignId */
type GetV1PrvCreatorApplicationsOverviewCampaignIdInput = {
    campaignId: string;
};

/** get /v1/prv/creator-applications/overview/:campaignId */
type GetV1PrvCreatorApplicationsOverviewCampaignIdPositiveVariant1 = {
    status: "success";
    data: {
        accepted: number;
        rejected: number;
        pending: number;
        invited: number;
        counterOfferSent: number;
        excluded: number;
        total: number;
    };
};

/** get /v1/prv/creator-applications/overview/:campaignId */
interface GetV1PrvCreatorApplicationsOverviewCampaignIdPositiveResponseVariants {
    200: GetV1PrvCreatorApplicationsOverviewCampaignIdPositiveVariant1;
}

/** get /v1/prv/creator-applications/overview/:campaignId */
type GetV1PrvCreatorApplicationsOverviewCampaignIdNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/creator-applications/overview/:campaignId */
interface GetV1PrvCreatorApplicationsOverviewCampaignIdNegativeResponseVariants {
    400: GetV1PrvCreatorApplicationsOverviewCampaignIdNegativeVariant1;
}

/** post /v1/prv/creator-applications/:creatorApplicationId/reinstate */
type PostV1PrvCreatorApplicationsCreatorApplicationIdReinstateInput = {
    creatorApplicationId: string;
};

/** post /v1/prv/creator-applications/:creatorApplicationId/reinstate */
type PostV1PrvCreatorApplicationsCreatorApplicationIdReinstatePositiveVariant1 = {
    status: "success";
    data: {
        reinstated: boolean;
        state: string;
    };
};

/** post /v1/prv/creator-applications/:creatorApplicationId/reinstate */
interface PostV1PrvCreatorApplicationsCreatorApplicationIdReinstatePositiveResponseVariants {
    200: PostV1PrvCreatorApplicationsCreatorApplicationIdReinstatePositiveVariant1;
}

/** post /v1/prv/creator-applications/:creatorApplicationId/reinstate */
type PostV1PrvCreatorApplicationsCreatorApplicationIdReinstateNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/prv/creator-applications/:creatorApplicationId/reinstate */
interface PostV1PrvCreatorApplicationsCreatorApplicationIdReinstateNegativeResponseVariants {
    400: PostV1PrvCreatorApplicationsCreatorApplicationIdReinstateNegativeVariant1;
}

/** get /v1/prv/creator-applications/:campaignId/:creatorId */
type GetV1PrvCreatorApplicationsCampaignIdCreatorIdInput = {
    creatorId: string;
    campaignId: string;
};

/** get /v1/prv/creator-applications/:campaignId/:creatorId */
type GetV1PrvCreatorApplicationsCampaignIdCreatorIdPositiveVariant1 = {
    status: "success";
    data: {
        creatorApplication: {
            _id: string;
            uniquenessKey?: string | undefined;
            sideEffectOutboxVersion?: number | undefined;
            inviteSideEffectsEnqueuedAt?: string | undefined;
            price: number;
            cpm?: number | undefined;
            maxAmount?: number | undefined;
            campaignId: string;
            state: "pending" | "accepted" | "rejected" | "excluded" | "invited";
            reason: string;
            rejectionReason?: string | undefined;
            exclusionReason?: string | undefined;
            isUserOfBrand: boolean;
            creatorId: string;
            smmUserId: string;
            expectedAuthorLinkedinNumId?: string | undefined;
            linkedinIdentityFrozenAt?: string | undefined;
            brandId: string;
            createdAt: string;
            updatedAt: string;
            acceptedAt?: string | undefined;
            budgetReservedAt?: string | undefined;
            capacityExcludedAt?: string | undefined;
            lastPublishReminderAt?: string | undefined;
            publishReminderCount?: number | undefined;
            publishReminderExhausted?: boolean | undefined;
            changesRequestedAt?: string | undefined;
            changesRequestReason?: string | undefined;
            lastNegotiation?: {
                price: number;
                cpm?: number | undefined;
                maxAmount?: number | undefined;
                proposedBy: "creator" | "campaign";
                proposedAt: string;
                reason?: string | undefined;
            } | undefined;
        };
    };
};

/** get /v1/prv/creator-applications/:campaignId/:creatorId */
interface GetV1PrvCreatorApplicationsCampaignIdCreatorIdPositiveResponseVariants {
    200: GetV1PrvCreatorApplicationsCampaignIdCreatorIdPositiveVariant1;
}

/** get /v1/prv/creator-applications/:campaignId/:creatorId */
type GetV1PrvCreatorApplicationsCampaignIdCreatorIdNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/creator-applications/:campaignId/:creatorId */
interface GetV1PrvCreatorApplicationsCampaignIdCreatorIdNegativeResponseVariants {
    400: GetV1PrvCreatorApplicationsCampaignIdCreatorIdNegativeVariant1;
}

/** post /v1/prv/creator-applications/negociate */
type PostV1PrvCreatorApplicationsNegociateInput = {
    applicationIds: string[];
    price: number;
    cpm?: number | undefined;
    maxAmount: number;
    campaignId: string;
    reason?: string | undefined;
};

/** post /v1/prv/creator-applications/negociate */
type PostV1PrvCreatorApplicationsNegociatePositiveVariant1 = {
    status: "success";
    data: {
        applications: {
            _id: string;
            uniquenessKey?: string | undefined;
            sideEffectOutboxVersion?: number | undefined;
            inviteSideEffectsEnqueuedAt?: string | undefined;
            price: number;
            cpm?: number | undefined;
            maxAmount?: number | undefined;
            campaignId: string;
            state: "pending" | "accepted" | "rejected" | "excluded" | "invited";
            reason: string;
            rejectionReason?: string | undefined;
            exclusionReason?: string | undefined;
            isUserOfBrand: boolean;
            creatorId: string;
            smmUserId: string;
            expectedAuthorLinkedinNumId?: string | undefined;
            linkedinIdentityFrozenAt?: string | undefined;
            brandId: string;
            createdAt: string;
            updatedAt: string;
            acceptedAt?: string | undefined;
            budgetReservedAt?: string | undefined;
            capacityExcludedAt?: string | undefined;
            lastPublishReminderAt?: string | undefined;
            publishReminderCount?: number | undefined;
            publishReminderExhausted?: boolean | undefined;
            changesRequestedAt?: string | undefined;
            changesRequestReason?: string | undefined;
            lastNegotiation?: {
                price: number;
                cpm?: number | undefined;
                maxAmount?: number | undefined;
                proposedBy: "creator" | "campaign";
                proposedAt: string;
                reason?: string | undefined;
            } | undefined;
        }[];
    };
};

/** post /v1/prv/creator-applications/negociate */
interface PostV1PrvCreatorApplicationsNegociatePositiveResponseVariants {
    200: PostV1PrvCreatorApplicationsNegociatePositiveVariant1;
}

/** post /v1/prv/creator-applications/negociate */
type PostV1PrvCreatorApplicationsNegociateNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/prv/creator-applications/negociate */
interface PostV1PrvCreatorApplicationsNegociateNegativeResponseVariants {
    400: PostV1PrvCreatorApplicationsNegociateNegativeVariant1;
}

/** get /v1/prv/user */
type GetV1PrvUserInput = {};

/** get /v1/prv/user */
type GetV1PrvUserPositiveVariant1 = {
    status: "success";
    data: {
        user: {
            _id: string;
            id: string;
            isStaff?: boolean | undefined;
            customerId?: string | undefined;
            isTrustedUser?: boolean | undefined;
        };
    };
};

/** get /v1/prv/user */
interface GetV1PrvUserPositiveResponseVariants {
    200: GetV1PrvUserPositiveVariant1;
}

/** get /v1/prv/user */
type GetV1PrvUserNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/user */
interface GetV1PrvUserNegativeResponseVariants {
    400: GetV1PrvUserNegativeVariant1;
}

/** get /v1/prv/user/readonly-token */
type GetV1PrvUserReadonlyTokenInput = {};

/** get /v1/prv/user/readonly-token */
type GetV1PrvUserReadonlyTokenPositiveVariant1 = {
    status: "success";
    data: {
        token: string;
    };
};

/** get /v1/prv/user/readonly-token */
interface GetV1PrvUserReadonlyTokenPositiveResponseVariants {
    200: GetV1PrvUserReadonlyTokenPositiveVariant1;
}

/** get /v1/prv/user/readonly-token */
type GetV1PrvUserReadonlyTokenNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/user/readonly-token */
interface GetV1PrvUserReadonlyTokenNegativeResponseVariants {
    400: GetV1PrvUserReadonlyTokenNegativeVariant1;
}

/** post /v1/prv/user/country */
type PostV1PrvUserCountryInput = {
    country: string;
};

/** post /v1/prv/user/country */
type PostV1PrvUserCountryPositiveVariant1 = {
    status: "success";
    data: {
        success: boolean;
    };
};

/** post /v1/prv/user/country */
interface PostV1PrvUserCountryPositiveResponseVariants {
    200: PostV1PrvUserCountryPositiveVariant1;
}

/** post /v1/prv/user/country */
type PostV1PrvUserCountryNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/prv/user/country */
interface PostV1PrvUserCountryNegativeResponseVariants {
    400: PostV1PrvUserCountryNegativeVariant1;
}

/** get /v1/prv/user/api-key */
type GetV1PrvUserApiKeyInput = {};

/** get /v1/prv/user/api-key */
type GetV1PrvUserApiKeyPositiveVariant1 = {
    status: "success";
    data: {
        apiKey: string | null;
    };
};

/** get /v1/prv/user/api-key */
interface GetV1PrvUserApiKeyPositiveResponseVariants {
    200: GetV1PrvUserApiKeyPositiveVariant1;
}

/** get /v1/prv/user/api-key */
type GetV1PrvUserApiKeyNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/user/api-key */
interface GetV1PrvUserApiKeyNegativeResponseVariants {
    400: GetV1PrvUserApiKeyNegativeVariant1;
}

/** post /v1/prv/user/generate-api-key */
type PostV1PrvUserGenerateApiKeyInput = {};

/** post /v1/prv/user/generate-api-key */
type PostV1PrvUserGenerateApiKeyPositiveVariant1 = {
    status: "success";
    data: {
        apiKey: string;
    };
};

/** post /v1/prv/user/generate-api-key */
interface PostV1PrvUserGenerateApiKeyPositiveResponseVariants {
    200: PostV1PrvUserGenerateApiKeyPositiveVariant1;
}

/** post /v1/prv/user/generate-api-key */
type PostV1PrvUserGenerateApiKeyNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/prv/user/generate-api-key */
interface PostV1PrvUserGenerateApiKeyNegativeResponseVariants {
    400: PostV1PrvUserGenerateApiKeyNegativeVariant1;
}

/** get /v1/prv/campaign-analytics/:campaignId */
type GetV1PrvCampaignAnalyticsCampaignIdInput = {
    campaignId: string;
    creatorId?: string | undefined;
    postId?: string | undefined;
};

/** get /v1/prv/campaign-analytics/:campaignId */
type GetV1PrvCampaignAnalyticsCampaignIdPositiveVariant1 = {
    status: "success";
    data: {
        actualCost: number;
        totalImpressions: number;
        engagementRate: number;
        totalReactions: number;
        totalComments: number;
        totalShares: number;
        totalMembersReached: number;
        audiences: {
            category: "occupation_title" | "location" | "industry" | "occupation_seniority" | "company_size" | "company_name";
            data: {
                label: string;
                percentageValue: number;
            }[];
        }[];
    };
};

/** get /v1/prv/campaign-analytics/:campaignId */
interface GetV1PrvCampaignAnalyticsCampaignIdPositiveResponseVariants {
    200: GetV1PrvCampaignAnalyticsCampaignIdPositiveVariant1;
}

/** get /v1/prv/campaign-analytics/:campaignId */
type GetV1PrvCampaignAnalyticsCampaignIdNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/campaign-analytics/:campaignId */
interface GetV1PrvCampaignAnalyticsCampaignIdNegativeResponseVariants {
    400: GetV1PrvCampaignAnalyticsCampaignIdNegativeVariant1;
}

/** get /v1/prv/campaign-analytics/:campaignId/engagement-profiles */
type GetV1PrvCampaignAnalyticsCampaignIdEngagementProfilesInput = {
    campaignId: string;
    type: "reactions" | "comments" | "reposts";
    creatorId?: string | undefined;
    postId?: string | undefined;
    page?: number | undefined;
    size?: number | undefined;
};

/** get /v1/prv/campaign-analytics/:campaignId/engagement-profiles */
type GetV1PrvCampaignAnalyticsCampaignIdEngagementProfilesPositiveVariant1 = {
    status: "success";
    data: {
        profiles: {
            _id: string;
            name?: string | undefined;
            avatar?: string | undefined;
            url?: string | undefined;
            position?: string | undefined;
            linkedinNumId?: string | undefined;
            memberId?: string | undefined;
        }[];
    };
};

/** get /v1/prv/campaign-analytics/:campaignId/engagement-profiles */
interface GetV1PrvCampaignAnalyticsCampaignIdEngagementProfilesPositiveResponseVariants {
    200: GetV1PrvCampaignAnalyticsCampaignIdEngagementProfilesPositiveVariant1;
}

/** get /v1/prv/campaign-analytics/:campaignId/engagement-profiles */
type GetV1PrvCampaignAnalyticsCampaignIdEngagementProfilesNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/campaign-analytics/:campaignId/engagement-profiles */
interface GetV1PrvCampaignAnalyticsCampaignIdEngagementProfilesNegativeResponseVariants {
    400: GetV1PrvCampaignAnalyticsCampaignIdEngagementProfilesNegativeVariant1;
}

/** get /v1/prv/campaign-analytics/:campaignId/engagement-counts */
type GetV1PrvCampaignAnalyticsCampaignIdEngagementCountsInput = {
    campaignId: string;
    creatorId?: string | undefined;
    postId?: string | undefined;
};

/** get /v1/prv/campaign-analytics/:campaignId/engagement-counts */
type GetV1PrvCampaignAnalyticsCampaignIdEngagementCountsPositiveVariant1 = {
    status: "success";
    data: {
        reactions: number;
        comments: number;
        reposts: number;
    };
};

/** get /v1/prv/campaign-analytics/:campaignId/engagement-counts */
interface GetV1PrvCampaignAnalyticsCampaignIdEngagementCountsPositiveResponseVariants {
    200: GetV1PrvCampaignAnalyticsCampaignIdEngagementCountsPositiveVariant1;
}

/** get /v1/prv/campaign-analytics/:campaignId/engagement-counts */
type GetV1PrvCampaignAnalyticsCampaignIdEngagementCountsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/campaign-analytics/:campaignId/engagement-counts */
interface GetV1PrvCampaignAnalyticsCampaignIdEngagementCountsNegativeResponseVariants {
    400: GetV1PrvCampaignAnalyticsCampaignIdEngagementCountsNegativeVariant1;
}

/** post /v1/prv/campaign-analytics/:campaignId/engagement-profiles-export */
type PostV1PrvCampaignAnalyticsCampaignIdEngagementProfilesExportInput = {
    campaignId: string;
    types: ("reactions" | "comments" | "reposts")[];
    creatorId?: string | undefined;
    postId?: string | undefined;
};

/** post /v1/prv/campaign-analytics/:campaignId/engagement-profiles-export */
type PostV1PrvCampaignAnalyticsCampaignIdEngagementProfilesExportPositiveVariant1 = {
    status: "success";
    data: {
        rows: {
            type: "reactions" | "comments" | "reposts";
            name?: string | undefined;
            avatar?: string | undefined;
            url?: string | undefined;
            position?: string | undefined;
            linkedinNumId?: string | undefined;
            memberId?: string | undefined;
        }[];
    };
};

/** post /v1/prv/campaign-analytics/:campaignId/engagement-profiles-export */
interface PostV1PrvCampaignAnalyticsCampaignIdEngagementProfilesExportPositiveResponseVariants {
    200: PostV1PrvCampaignAnalyticsCampaignIdEngagementProfilesExportPositiveVariant1;
}

/** post /v1/prv/campaign-analytics/:campaignId/engagement-profiles-export */
type PostV1PrvCampaignAnalyticsCampaignIdEngagementProfilesExportNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/prv/campaign-analytics/:campaignId/engagement-profiles-export */
interface PostV1PrvCampaignAnalyticsCampaignIdEngagementProfilesExportNegativeResponseVariants {
    400: PostV1PrvCampaignAnalyticsCampaignIdEngagementProfilesExportNegativeVariant1;
}

/** get /v1/prv/nps */
type GetV1PrvNpsInput = {};

/** get /v1/prv/nps */
type GetV1PrvNpsPositiveVariant1 = {
    status: "success";
    data: {
        npsRating?: {
            rating: number;
            comment?: string | undefined;
            _id: string;
            source: "smm" | "influence";
            userId: string;
            month: string;
            email?: string | undefined;
            name?: string | undefined;
            createdAt: string;
            updatedAt: string;
        } | undefined;
    };
};

/** get /v1/prv/nps */
interface GetV1PrvNpsPositiveResponseVariants {
    200: GetV1PrvNpsPositiveVariant1;
}

/** get /v1/prv/nps */
type GetV1PrvNpsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/nps */
interface GetV1PrvNpsNegativeResponseVariants {
    400: GetV1PrvNpsNegativeVariant1;
}

/** post /v1/prv/nps */
type PostV1PrvNpsInput = {
    rating: number;
    comment?: string | undefined;
};

/** post /v1/prv/nps */
type PostV1PrvNpsPositiveVariant1 = {
    status: "success";
    data: {
        npsRating: {
            rating: number;
            comment?: string | undefined;
            _id: string;
            source: "smm" | "influence";
            userId: string;
            month: string;
            email?: string | undefined;
            name?: string | undefined;
            createdAt: string;
            updatedAt: string;
        };
    };
};

/** post /v1/prv/nps */
interface PostV1PrvNpsPositiveResponseVariants {
    200: PostV1PrvNpsPositiveVariant1;
}

/** post /v1/prv/nps */
type PostV1PrvNpsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/prv/nps */
interface PostV1PrvNpsNegativeResponseVariants {
    400: PostV1PrvNpsNegativeVariant1;
}

/** post /v1/prv/payments/campaign-session */
type PostV1PrvPaymentsCampaignSessionInput = {
    campaignData?: {
        name: string;
        description: string;
        brandId: string;
        targets: {
            minFollowers?: (number | null) | undefined;
            minViews?: (number | null) | undefined;
            minViewsLast28Days?: (number | null) | undefined;
            language?: (string | null) | undefined;
            audienceLocation?: string[] | undefined;
            hierarchyLevel?: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | undefined;
            industry?: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | undefined;
            companySize?: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | undefined;
            occupation?: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | undefined;
        };
        framing: {
            startDate: string;
            endDate?: string | undefined;
            publicationStartDate?: string | undefined;
            publicationEndDate?: string | undefined;
            maxBudgetPerPost?: number | undefined;
            cpm?: number | undefined;
            totalBudget: number;
            totalUsedBudget?: number | undefined;
            autoValidateContent: boolean;
            autoAcceptCreators: boolean;
        };
        utmLink?: string | undefined;
        promoCode?: string | undefined;
        firstMessagesToAcceptedCreators?: ({
            type: "text";
            text: string;
            priceEUR?: number | undefined;
            cpmEUR?: number | undefined;
        } | {
            type: "image";
            src?: string | undefined;
            metadata: {
                name: string;
                size: number;
                type: string;
                fileKey: string;
            };
        } | {
            type: "file";
            src?: string | undefined;
            metadata: {
                name: string;
                size: number;
                type: string;
                fileKey: string;
            };
        })[] | undefined;
    } | undefined;
    campaignId?: string | undefined;
    returnPath?: string | undefined;
    paymentMethod?: ("card") | undefined;
};

/** post /v1/prv/payments/campaign-session */
type PostV1PrvPaymentsCampaignSessionPositiveVariant1 = {
    status: "success";
    data: {
        checkoutUrl?: string | undefined;
        campaignId?: string | undefined;
    };
};

/** post /v1/prv/payments/campaign-session */
interface PostV1PrvPaymentsCampaignSessionPositiveResponseVariants {
    200: PostV1PrvPaymentsCampaignSessionPositiveVariant1;
}

/** post /v1/prv/payments/campaign-session */
type PostV1PrvPaymentsCampaignSessionNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/prv/payments/campaign-session */
interface PostV1PrvPaymentsCampaignSessionNegativeResponseVariants {
    400: PostV1PrvPaymentsCampaignSessionNegativeVariant1;
}

/** post /v1/prv/payments/retry-payment */
type PostV1PrvPaymentsRetryPaymentInput = {
    campaignId: string;
    returnPath?: string | undefined;
};

/** post /v1/prv/payments/retry-payment */
type PostV1PrvPaymentsRetryPaymentPositiveVariant1 = {
    status: "success";
    data: {
        checkoutUrl: string;
    };
};

/** post /v1/prv/payments/retry-payment */
interface PostV1PrvPaymentsRetryPaymentPositiveResponseVariants {
    200: PostV1PrvPaymentsRetryPaymentPositiveVariant1;
}

/** post /v1/prv/payments/retry-payment */
type PostV1PrvPaymentsRetryPaymentNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/prv/payments/retry-payment */
interface PostV1PrvPaymentsRetryPaymentNegativeResponseVariants {
    400: PostV1PrvPaymentsRetryPaymentNegativeVariant1;
}

/** post /v1/prv/payments/deposit-budget */
type PostV1PrvPaymentsDepositBudgetInput = {
    campaignId: string;
};

/** post /v1/prv/payments/deposit-budget */
type PostV1PrvPaymentsDepositBudgetPositiveVariant1 = {
    status: "success";
    data: {
        hostedInstructionsUrl?: string | undefined;
        amountDue?: number | undefined;
        currency?: string | undefined;
        reference?: string | undefined;
        invoiceNumber?: string | undefined;
        billingEmail?: string | undefined;
        iban?: string | undefined;
        bic?: string | undefined;
        accountHolderName?: string | undefined;
        expiresAt?: string | undefined;
        sentAt?: string | undefined;
        startDate?: string | undefined;
        transferBy?: string | undefined;
        creatorsFoundCount?: number | undefined;
    };
};

/** post /v1/prv/payments/deposit-budget */
interface PostV1PrvPaymentsDepositBudgetPositiveResponseVariants {
    200: PostV1PrvPaymentsDepositBudgetPositiveVariant1;
}

/** post /v1/prv/payments/deposit-budget */
type PostV1PrvPaymentsDepositBudgetNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/prv/payments/deposit-budget */
interface PostV1PrvPaymentsDepositBudgetNegativeResponseVariants {
    400: PostV1PrvPaymentsDepositBudgetNegativeVariant1;
}

/** post /v1/prv/payments/checkout-session */
type PostV1PrvPaymentsCheckoutSessionInput = {
    campaignId: string;
    returnPath?: string | undefined;
    paymentMethod?: ("card") | undefined;
};

/** post /v1/prv/payments/checkout-session */
type PostV1PrvPaymentsCheckoutSessionPositiveVariant1 = {
    status: "success";
    data: {
        checkoutUrl: string;
    };
};

/** post /v1/prv/payments/checkout-session */
interface PostV1PrvPaymentsCheckoutSessionPositiveResponseVariants {
    200: PostV1PrvPaymentsCheckoutSessionPositiveVariant1;
}

/** post /v1/prv/payments/checkout-session */
type PostV1PrvPaymentsCheckoutSessionNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/prv/payments/checkout-session */
interface PostV1PrvPaymentsCheckoutSessionNegativeResponseVariants {
    400: PostV1PrvPaymentsCheckoutSessionNegativeVariant1;
}

/** get /v1/prv/payments/campaign-wallet */
type GetV1PrvPaymentsCampaignWalletInput = {
    size?: number | undefined;
    page?: number | undefined;
    brandIds?: string | undefined;
    campaignStatus?: ("DRAFT" | "PENDING_PAYMENT" | "ACTIVE" | "PAUSED" | "FINISHED") | undefined;
    searchQuery?: string | undefined;
    campaignId?: string | undefined;
};

/** get /v1/prv/payments/campaign-wallet */
type GetV1PrvPaymentsCampaignWalletPositiveVariant1 = {
    status: "success";
    data: {
        campaignWallets: {
            totalBudget: number;
            totalUsedBudget: number;
            totalAvailableBudget: number;
            totalReservedBudget: number;
            totalActualSpend: number;
            totalSettledUnpaid?: number | undefined;
            totalCommittedAccepted?: number | undefined;
            totalFreeAfterCommitments?: number | undefined;
            nbPayments: number;
            nbPaymentsCompleted: number;
            totalPaidAmount: number;
            status: "DRAFT" | "PENDING_PAYMENT" | "ACTIVE" | "PAUSED" | "FINISHED";
            budgetDepositStatus?: ("PENDING" | "DEPOSITED") | undefined;
            pendingDepositMethod?: ("card" | "bank_transfer") | undefined;
            campaignId: string;
            name: string;
            currencyConversion: {
                currency: "USD";
                rateFromEUR: number;
                lockedAt: string;
            };
        }[];
    };
};

/** get /v1/prv/payments/campaign-wallet */
interface GetV1PrvPaymentsCampaignWalletPositiveResponseVariants {
    200: GetV1PrvPaymentsCampaignWalletPositiveVariant1;
}

/** get /v1/prv/payments/campaign-wallet */
type GetV1PrvPaymentsCampaignWalletNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/payments/campaign-wallet */
interface GetV1PrvPaymentsCampaignWalletNegativeResponseVariants {
    400: GetV1PrvPaymentsCampaignWalletNegativeVariant1;
}

/** get /v1/prv/payments/payouts */
type GetV1PrvPaymentsPayoutsInput = {
    size?: number | undefined;
    page?: number | undefined;
    brandId?: string | undefined;
    status?: ("paid" | "pending" | "blocked" | "waiting_for_publication" | "waiting_for_settlement" | "paid_by_brand") | undefined;
};

/** get /v1/prv/payments/payouts */
type GetV1PrvPaymentsPayoutsPositiveVariant1 = {
    status: "success";
    data: {
        payouts: ((({
            campaignId: string;
            applicationId?: string | undefined;
            uniquenessKey?: string | undefined;
            date: string;
            amount: number;
            platformFeeAmount?: number | undefined;
            platformFeeRate?: number | undefined;
            postId: string;
            publishedAt?: string | undefined;
            smmUserId: string;
            creatorId: string;
            brandId: string;
            publicationCommitment?: {
                token: string;
                mode: "server" | "server_schedule" | "extension" | "voyager_schedule";
                state: "prepared" | "publishing" | "updating" | "external_confirmed" | "external_rejected" | "reconciliation_required";
                preparedAt: string;
                publishingAt?: string | undefined;
                expectedPublishedAt?: string | undefined;
                pendingExpectedPublishedAt?: string | undefined;
                resourceKey?: string | undefined;
                confirmedLinkedinPostId?: string | undefined;
                confirmedAt?: string | undefined;
                rejectedAt?: string | undefined;
                contentFingerprint: string;
                expectedAuthorLinkedinNumId?: string | undefined;
                expectedMedia?: ({
                    kind: "none";
                } | {
                    kind: "document";
                    title: string;
                    assetUrn?: string | undefined;
                } | {
                    kind: "image";
                    assetUrn?: string | undefined;
                } | {
                    kind: "video";
                    assetUrn?: string | undefined;
                }) | undefined;
                frozenTerms: {
                    model: "fixed";
                    amount: number;
                    platformFeeRate: number;
                    currency: "EUR" | "USD";
                    currencyConversion: {
                        currency: "USD";
                        rateFromEUR: number;
                        lockedAt: string;
                    };
                } | {
                    model: "cpm";
                    cpm: number;
                    cap: number;
                    platformFeeRate: number;
                    currency: "EUR" | "USD";
                    currencyConversion: {
                        currency: "USD";
                        rateFromEUR: number;
                        lockedAt: string;
                    };
                };
            } | undefined;
            publicationIntegritySnapshot?: {
                commitmentToken: string;
                approvedAt: string;
                contentFingerprint: string;
                expectedMedia: {
                    kind: "none";
                } | {
                    kind: "document";
                    title: string;
                    assetUrn: string;
                } | {
                    kind: "image";
                    assetUrn: string;
                } | {
                    kind: "video";
                    assetUrn: string;
                };
                expectedAuthorLinkedinNumId?: string | undefined;
                verifiedPostShareUrn: string;
            } | undefined;
            pricingSnapshot?: ({
                model: "fixed";
                applicationId: string;
                amount: number;
                platformFeeRate: number;
                currency: "EUR" | "USD";
                currencyConversion: {
                    currency: "USD";
                    rateFromEUR: number;
                    lockedAt: string;
                };
                publishedAt: string;
                paymentBatchDate: string;
            } | {
                model: "cpm";
                applicationId: string;
                cpm: number;
                cap: number;
                platformFeeRate: number;
                currency: "EUR" | "USD";
                currencyConversion: {
                    currency: "USD";
                    rateFromEUR: number;
                    lockedAt: string;
                };
                publishedAt: string;
                settlementDate: string;
                paymentBatchDate: string;
                settlementScheduleVersion?: "utc_elapsed_14d_v1" | undefined;
            }) | undefined;
            paypalPayout?: {
                payout_item_status?: ("DENIED" | "PENDING" | "UNCLAIMED" | "PROCESSING" | "SUCCESS" | "CANCELED" | "FAILED" | "HELD" | "REFUNDED" | "BLOCKED" | "RETURNED") | undefined;
                payout_batch_status: "PENDING" | "PROCESSING" | "SUCCESS" | "DENIED";
                payout_batch_id: string;
                payout_item_id?: string | undefined;
                payout_initiated_at: string;
            } | undefined;
            cpm?: number | undefined;
            cap?: number | undefined;
            impressionsAtSettlement?: number | undefined;
            settledAt?: string | undefined;
            impressionsMeasurementRequiredAfter?: string | undefined;
            budgetReconciliationPendingAt?: string | undefined;
            budgetReconciledAt?: string | undefined;
            paidAt?: string | undefined;
            paidByStaffId?: string | undefined;
            paymentBatchReference?: string | undefined;
            paymentRail?: ("SEPA" | "INTERNATIONAL") | undefined;
            paymentNotificationEventKey?: string | undefined;
            paymentNotificationState?: ("pending" | "delivering" | "sent") | undefined;
            paymentNotificationAttemptedAt?: string | undefined;
            paymentNotificationSentAt?: string | undefined;
            paymentNotificationAttempts?: number | undefined;
            paymentNotificationLastError?: string | undefined;
            invoiceRevocationPendingAt?: string | undefined;
            invoiceOrphanedS3Key?: string | undefined;
            invoiceGenerationErrorCode?: string | undefined;
            status: "paid";
            invoice?: {
                id: string;
                key: string;
                url?: string | undefined;
                totalWithTax?: number | undefined;
                currency?: string | undefined;
                invoiceNumber?: string | undefined;
                invoiceSequence?: number | undefined;
                issueDate?: string | undefined;
                serviceDate?: string | undefined;
                dueDate?: string | undefined;
                grossAmount?: number | undefined;
                platformFeeAmount?: number | undefined;
                netAmount?: number | undefined;
                vatRate?: number | undefined;
                vatAmount?: number | undefined;
                taxTreatment?: ("domestic_vat" | "franchise_exemption" | "eu_reverse_charge" | "non_eu_reverse_charge" | "supplier_declared_exempt") | undefined;
                taxDeclaration?: {
                    country: string;
                    vatStatus: "vat_registered" | "fr_franchise_293_b" | "vat_exempt";
                    vatNumber?: string | undefined;
                    vatNumberVerification?: ("format_valid_unverified" | "vies_verified" | "manually_verified" | "not_applicable") | undefined;
                    vatNumberVerificationEvidence?: ({
                        method: "vies";
                        country: string;
                        vatNumber: string;
                        verifiedAt: string;
                        reference: string;
                    } | {
                        method: "manual";
                        country: string;
                        vatNumber: string;
                        verifiedAt: string;
                        reference: string;
                        verifiedBy: string;
                    }) | undefined;
                    vatVerificationRemediatedAt?: string | undefined;
                    vatVerificationRemediatedBy?: string | undefined;
                    taxExemptionReason?: string | undefined;
                } | undefined;
                selfBillingMandate?: {
                    version: string;
                    acceptedAt: string;
                } | undefined;
                paymentDetails?: {
                    rail: "SEPA" | "INTERNATIONAL";
                    beneficiaryName: string;
                    iban?: string | undefined;
                    bic?: string | undefined;
                    internationalDetails?: string | undefined;
                } | undefined;
            } | undefined;
            postShareUrn: string;
        } | {
            campaignId: string;
            applicationId?: string | undefined;
            uniquenessKey?: string | undefined;
            date: string;
            amount: number;
            platformFeeAmount?: number | undefined;
            platformFeeRate?: number | undefined;
            postId: string;
            publishedAt?: string | undefined;
            smmUserId: string;
            creatorId: string;
            brandId: string;
            publicationCommitment?: {
                token: string;
                mode: "server" | "server_schedule" | "extension" | "voyager_schedule";
                state: "prepared" | "publishing" | "updating" | "external_confirmed" | "external_rejected" | "reconciliation_required";
                preparedAt: string;
                publishingAt?: string | undefined;
                expectedPublishedAt?: string | undefined;
                pendingExpectedPublishedAt?: string | undefined;
                resourceKey?: string | undefined;
                confirmedLinkedinPostId?: string | undefined;
                confirmedAt?: string | undefined;
                rejectedAt?: string | undefined;
                contentFingerprint: string;
                expectedAuthorLinkedinNumId?: string | undefined;
                expectedMedia?: ({
                    kind: "none";
                } | {
                    kind: "document";
                    title: string;
                    assetUrn?: string | undefined;
                } | {
                    kind: "image";
                    assetUrn?: string | undefined;
                } | {
                    kind: "video";
                    assetUrn?: string | undefined;
                }) | undefined;
                frozenTerms: {
                    model: "fixed";
                    amount: number;
                    platformFeeRate: number;
                    currency: "EUR" | "USD";
                    currencyConversion: {
                        currency: "USD";
                        rateFromEUR: number;
                        lockedAt: string;
                    };
                } | {
                    model: "cpm";
                    cpm: number;
                    cap: number;
                    platformFeeRate: number;
                    currency: "EUR" | "USD";
                    currencyConversion: {
                        currency: "USD";
                        rateFromEUR: number;
                        lockedAt: string;
                    };
                };
            } | undefined;
            publicationIntegritySnapshot?: {
                commitmentToken: string;
                approvedAt: string;
                contentFingerprint: string;
                expectedMedia: {
                    kind: "none";
                } | {
                    kind: "document";
                    title: string;
                    assetUrn: string;
                } | {
                    kind: "image";
                    assetUrn: string;
                } | {
                    kind: "video";
                    assetUrn: string;
                };
                expectedAuthorLinkedinNumId?: string | undefined;
                verifiedPostShareUrn: string;
            } | undefined;
            pricingSnapshot?: ({
                model: "fixed";
                applicationId: string;
                amount: number;
                platformFeeRate: number;
                currency: "EUR" | "USD";
                currencyConversion: {
                    currency: "USD";
                    rateFromEUR: number;
                    lockedAt: string;
                };
                publishedAt: string;
                paymentBatchDate: string;
            } | {
                model: "cpm";
                applicationId: string;
                cpm: number;
                cap: number;
                platformFeeRate: number;
                currency: "EUR" | "USD";
                currencyConversion: {
                    currency: "USD";
                    rateFromEUR: number;
                    lockedAt: string;
                };
                publishedAt: string;
                settlementDate: string;
                paymentBatchDate: string;
                settlementScheduleVersion?: "utc_elapsed_14d_v1" | undefined;
            }) | undefined;
            paypalPayout?: {
                payout_item_status?: ("DENIED" | "PENDING" | "UNCLAIMED" | "PROCESSING" | "SUCCESS" | "CANCELED" | "FAILED" | "HELD" | "REFUNDED" | "BLOCKED" | "RETURNED") | undefined;
                payout_batch_status: "PENDING" | "PROCESSING" | "SUCCESS" | "DENIED";
                payout_batch_id: string;
                payout_item_id?: string | undefined;
                payout_initiated_at: string;
            } | undefined;
            cpm?: number | undefined;
            cap?: number | undefined;
            impressionsAtSettlement?: number | undefined;
            settledAt?: string | undefined;
            impressionsMeasurementRequiredAfter?: string | undefined;
            budgetReconciliationPendingAt?: string | undefined;
            budgetReconciledAt?: string | undefined;
            invoiceRevocationPendingAt?: string | undefined;
            invoiceOrphanedS3Key?: string | undefined;
            invoiceGenerationErrorCode?: string | undefined;
            status: "pending";
            invoice?: {
                id: string;
                key: string;
                url?: string | undefined;
                totalWithTax?: number | undefined;
                currency?: string | undefined;
                invoiceNumber?: string | undefined;
                invoiceSequence?: number | undefined;
                issueDate?: string | undefined;
                serviceDate?: string | undefined;
                dueDate?: string | undefined;
                grossAmount?: number | undefined;
                platformFeeAmount?: number | undefined;
                netAmount?: number | undefined;
                vatRate?: number | undefined;
                vatAmount?: number | undefined;
                taxTreatment?: ("domestic_vat" | "franchise_exemption" | "eu_reverse_charge" | "non_eu_reverse_charge" | "supplier_declared_exempt") | undefined;
                taxDeclaration?: {
                    country: string;
                    vatStatus: "vat_registered" | "fr_franchise_293_b" | "vat_exempt";
                    vatNumber?: string | undefined;
                    vatNumberVerification?: ("format_valid_unverified" | "vies_verified" | "manually_verified" | "not_applicable") | undefined;
                    vatNumberVerificationEvidence?: ({
                        method: "vies";
                        country: string;
                        vatNumber: string;
                        verifiedAt: string;
                        reference: string;
                    } | {
                        method: "manual";
                        country: string;
                        vatNumber: string;
                        verifiedAt: string;
                        reference: string;
                        verifiedBy: string;
                    }) | undefined;
                    vatVerificationRemediatedAt?: string | undefined;
                    vatVerificationRemediatedBy?: string | undefined;
                    taxExemptionReason?: string | undefined;
                } | undefined;
                selfBillingMandate?: {
                    version: string;
                    acceptedAt: string;
                } | undefined;
                paymentDetails?: {
                    rail: "SEPA" | "INTERNATIONAL";
                    beneficiaryName: string;
                    iban?: string | undefined;
                    bic?: string | undefined;
                    internationalDetails?: string | undefined;
                } | undefined;
            } | undefined;
            invoiceMintingToken?: string | undefined;
            invoiceMintingAt?: string | undefined;
            postShareUrn: string;
        } | {
            campaignId: string;
            applicationId?: string | undefined;
            uniquenessKey?: string | undefined;
            date: string;
            amount: number;
            platformFeeAmount?: number | undefined;
            platformFeeRate?: number | undefined;
            postId: string;
            publishedAt?: string | undefined;
            smmUserId: string;
            creatorId: string;
            brandId: string;
            publicationCommitment?: {
                token: string;
                mode: "server" | "server_schedule" | "extension" | "voyager_schedule";
                state: "prepared" | "publishing" | "updating" | "external_confirmed" | "external_rejected" | "reconciliation_required";
                preparedAt: string;
                publishingAt?: string | undefined;
                expectedPublishedAt?: string | undefined;
                pendingExpectedPublishedAt?: string | undefined;
                resourceKey?: string | undefined;
                confirmedLinkedinPostId?: string | undefined;
                confirmedAt?: string | undefined;
                rejectedAt?: string | undefined;
                contentFingerprint: string;
                expectedAuthorLinkedinNumId?: string | undefined;
                expectedMedia?: ({
                    kind: "none";
                } | {
                    kind: "document";
                    title: string;
                    assetUrn?: string | undefined;
                } | {
                    kind: "image";
                    assetUrn?: string | undefined;
                } | {
                    kind: "video";
                    assetUrn?: string | undefined;
                }) | undefined;
                frozenTerms: {
                    model: "fixed";
                    amount: number;
                    platformFeeRate: number;
                    currency: "EUR" | "USD";
                    currencyConversion: {
                        currency: "USD";
                        rateFromEUR: number;
                        lockedAt: string;
                    };
                } | {
                    model: "cpm";
                    cpm: number;
                    cap: number;
                    platformFeeRate: number;
                    currency: "EUR" | "USD";
                    currencyConversion: {
                        currency: "USD";
                        rateFromEUR: number;
                        lockedAt: string;
                    };
                };
            } | undefined;
            publicationIntegritySnapshot?: {
                commitmentToken: string;
                approvedAt: string;
                contentFingerprint: string;
                expectedMedia: {
                    kind: "none";
                } | {
                    kind: "document";
                    title: string;
                    assetUrn: string;
                } | {
                    kind: "image";
                    assetUrn: string;
                } | {
                    kind: "video";
                    assetUrn: string;
                };
                expectedAuthorLinkedinNumId?: string | undefined;
                verifiedPostShareUrn: string;
            } | undefined;
            pricingSnapshot?: ({
                model: "fixed";
                applicationId: string;
                amount: number;
                platformFeeRate: number;
                currency: "EUR" | "USD";
                currencyConversion: {
                    currency: "USD";
                    rateFromEUR: number;
                    lockedAt: string;
                };
                publishedAt: string;
                paymentBatchDate: string;
            } | {
                model: "cpm";
                applicationId: string;
                cpm: number;
                cap: number;
                platformFeeRate: number;
                currency: "EUR" | "USD";
                currencyConversion: {
                    currency: "USD";
                    rateFromEUR: number;
                    lockedAt: string;
                };
                publishedAt: string;
                settlementDate: string;
                paymentBatchDate: string;
                settlementScheduleVersion?: "utc_elapsed_14d_v1" | undefined;
            }) | undefined;
            paypalPayout?: {
                payout_item_status?: ("DENIED" | "PENDING" | "UNCLAIMED" | "PROCESSING" | "SUCCESS" | "CANCELED" | "FAILED" | "HELD" | "REFUNDED" | "BLOCKED" | "RETURNED") | undefined;
                payout_batch_status: "PENDING" | "PROCESSING" | "SUCCESS" | "DENIED";
                payout_batch_id: string;
                payout_item_id?: string | undefined;
                payout_initiated_at: string;
            } | undefined;
            invoiceRevocationPendingAt?: string | undefined;
            invoiceOrphanedS3Key?: string | undefined;
            invoiceGenerationErrorCode?: string | undefined;
            status: "blocked";
            failureReason: "smm_user_not_found" | "payout_informations_invalid" | "campaign_budget_not_enough" | "campaign_not_paid" | "extension_not_active" | "payout_invoice_stale" | "data_integrity_invalid" | "invoice_generation_failed";
            postShareUrn: string;
        } | {
            campaignId: string;
            applicationId?: string | undefined;
            uniquenessKey?: string | undefined;
            date: string;
            amount: number;
            platformFeeAmount?: number | undefined;
            platformFeeRate?: number | undefined;
            postId: string;
            publishedAt?: string | undefined;
            smmUserId: string;
            creatorId: string;
            brandId: string;
            publicationCommitment?: {
                token: string;
                mode: "server" | "server_schedule" | "extension" | "voyager_schedule";
                state: "prepared" | "publishing" | "updating" | "external_confirmed" | "external_rejected" | "reconciliation_required";
                preparedAt: string;
                publishingAt?: string | undefined;
                expectedPublishedAt?: string | undefined;
                pendingExpectedPublishedAt?: string | undefined;
                resourceKey?: string | undefined;
                confirmedLinkedinPostId?: string | undefined;
                confirmedAt?: string | undefined;
                rejectedAt?: string | undefined;
                contentFingerprint: string;
                expectedAuthorLinkedinNumId?: string | undefined;
                expectedMedia?: ({
                    kind: "none";
                } | {
                    kind: "document";
                    title: string;
                    assetUrn?: string | undefined;
                } | {
                    kind: "image";
                    assetUrn?: string | undefined;
                } | {
                    kind: "video";
                    assetUrn?: string | undefined;
                }) | undefined;
                frozenTerms: {
                    model: "fixed";
                    amount: number;
                    platformFeeRate: number;
                    currency: "EUR" | "USD";
                    currencyConversion: {
                        currency: "USD";
                        rateFromEUR: number;
                        lockedAt: string;
                    };
                } | {
                    model: "cpm";
                    cpm: number;
                    cap: number;
                    platformFeeRate: number;
                    currency: "EUR" | "USD";
                    currencyConversion: {
                        currency: "USD";
                        rateFromEUR: number;
                        lockedAt: string;
                    };
                };
            } | undefined;
            publicationIntegritySnapshot?: {
                commitmentToken: string;
                approvedAt: string;
                contentFingerprint: string;
                expectedMedia: {
                    kind: "none";
                } | {
                    kind: "document";
                    title: string;
                    assetUrn: string;
                } | {
                    kind: "image";
                    assetUrn: string;
                } | {
                    kind: "video";
                    assetUrn: string;
                };
                expectedAuthorLinkedinNumId?: string | undefined;
                verifiedPostShareUrn: string;
            } | undefined;
            pricingSnapshot?: ({
                model: "fixed";
                applicationId: string;
                amount: number;
                platformFeeRate: number;
                currency: "EUR" | "USD";
                currencyConversion: {
                    currency: "USD";
                    rateFromEUR: number;
                    lockedAt: string;
                };
                publishedAt: string;
                paymentBatchDate: string;
            } | {
                model: "cpm";
                applicationId: string;
                cpm: number;
                cap: number;
                platformFeeRate: number;
                currency: "EUR" | "USD";
                currencyConversion: {
                    currency: "USD";
                    rateFromEUR: number;
                    lockedAt: string;
                };
                publishedAt: string;
                settlementDate: string;
                paymentBatchDate: string;
                settlementScheduleVersion?: "utc_elapsed_14d_v1" | undefined;
            }) | undefined;
            paypalPayout?: {
                payout_item_status?: ("DENIED" | "PENDING" | "UNCLAIMED" | "PROCESSING" | "SUCCESS" | "CANCELED" | "FAILED" | "HELD" | "REFUNDED" | "BLOCKED" | "RETURNED") | undefined;
                payout_batch_status: "PENDING" | "PROCESSING" | "SUCCESS" | "DENIED";
                payout_batch_id: string;
                payout_item_id?: string | undefined;
                payout_initiated_at: string;
            } | undefined;
            status: "waiting_for_publication";
        } | {
            campaignId: string;
            applicationId?: string | undefined;
            uniquenessKey?: string | undefined;
            date: string;
            amount: number;
            platformFeeAmount?: number | undefined;
            platformFeeRate?: number | undefined;
            postId: string;
            publishedAt?: string | undefined;
            smmUserId: string;
            creatorId: string;
            brandId: string;
            publicationCommitment?: {
                token: string;
                mode: "server" | "server_schedule" | "extension" | "voyager_schedule";
                state: "prepared" | "publishing" | "updating" | "external_confirmed" | "external_rejected" | "reconciliation_required";
                preparedAt: string;
                publishingAt?: string | undefined;
                expectedPublishedAt?: string | undefined;
                pendingExpectedPublishedAt?: string | undefined;
                resourceKey?: string | undefined;
                confirmedLinkedinPostId?: string | undefined;
                confirmedAt?: string | undefined;
                rejectedAt?: string | undefined;
                contentFingerprint: string;
                expectedAuthorLinkedinNumId?: string | undefined;
                expectedMedia?: ({
                    kind: "none";
                } | {
                    kind: "document";
                    title: string;
                    assetUrn?: string | undefined;
                } | {
                    kind: "image";
                    assetUrn?: string | undefined;
                } | {
                    kind: "video";
                    assetUrn?: string | undefined;
                }) | undefined;
                frozenTerms: {
                    model: "fixed";
                    amount: number;
                    platformFeeRate: number;
                    currency: "EUR" | "USD";
                    currencyConversion: {
                        currency: "USD";
                        rateFromEUR: number;
                        lockedAt: string;
                    };
                } | {
                    model: "cpm";
                    cpm: number;
                    cap: number;
                    platformFeeRate: number;
                    currency: "EUR" | "USD";
                    currencyConversion: {
                        currency: "USD";
                        rateFromEUR: number;
                        lockedAt: string;
                    };
                };
            } | undefined;
            publicationIntegritySnapshot?: {
                commitmentToken: string;
                approvedAt: string;
                contentFingerprint: string;
                expectedMedia: {
                    kind: "none";
                } | {
                    kind: "document";
                    title: string;
                    assetUrn: string;
                } | {
                    kind: "image";
                    assetUrn: string;
                } | {
                    kind: "video";
                    assetUrn: string;
                };
                expectedAuthorLinkedinNumId?: string | undefined;
                verifiedPostShareUrn: string;
            } | undefined;
            pricingSnapshot?: ({
                model: "fixed";
                applicationId: string;
                amount: number;
                platformFeeRate: number;
                currency: "EUR" | "USD";
                currencyConversion: {
                    currency: "USD";
                    rateFromEUR: number;
                    lockedAt: string;
                };
                publishedAt: string;
                paymentBatchDate: string;
            } | {
                model: "cpm";
                applicationId: string;
                cpm: number;
                cap: number;
                platformFeeRate: number;
                currency: "EUR" | "USD";
                currencyConversion: {
                    currency: "USD";
                    rateFromEUR: number;
                    lockedAt: string;
                };
                publishedAt: string;
                settlementDate: string;
                paymentBatchDate: string;
                settlementScheduleVersion?: "utc_elapsed_14d_v1" | undefined;
            }) | undefined;
            paypalPayout?: {
                payout_item_status?: ("DENIED" | "PENDING" | "UNCLAIMED" | "PROCESSING" | "SUCCESS" | "CANCELED" | "FAILED" | "HELD" | "REFUNDED" | "BLOCKED" | "RETURNED") | undefined;
                payout_batch_status: "PENDING" | "PROCESSING" | "SUCCESS" | "DENIED";
                payout_batch_id: string;
                payout_item_id?: string | undefined;
                payout_initiated_at: string;
            } | undefined;
            status: "waiting_for_settlement";
            settlementDate: string;
            cpm: number;
            cap: number;
            postShareUrn?: string | undefined;
            lastExtensionReminderAt?: string | undefined;
            extensionReminderCount?: number | undefined;
            impressionsMeasurementRequiredAfter?: string | undefined;
        } | {
            campaignId: string;
            applicationId?: string | undefined;
            uniquenessKey?: string | undefined;
            date: string;
            amount: number;
            platformFeeAmount?: number | undefined;
            platformFeeRate?: number | undefined;
            postId: string;
            publishedAt?: string | undefined;
            smmUserId: string;
            creatorId: string;
            brandId: string;
            publicationCommitment?: {
                token: string;
                mode: "server" | "server_schedule" | "extension" | "voyager_schedule";
                state: "prepared" | "publishing" | "updating" | "external_confirmed" | "external_rejected" | "reconciliation_required";
                preparedAt: string;
                publishingAt?: string | undefined;
                expectedPublishedAt?: string | undefined;
                pendingExpectedPublishedAt?: string | undefined;
                resourceKey?: string | undefined;
                confirmedLinkedinPostId?: string | undefined;
                confirmedAt?: string | undefined;
                rejectedAt?: string | undefined;
                contentFingerprint: string;
                expectedAuthorLinkedinNumId?: string | undefined;
                expectedMedia?: ({
                    kind: "none";
                } | {
                    kind: "document";
                    title: string;
                    assetUrn?: string | undefined;
                } | {
                    kind: "image";
                    assetUrn?: string | undefined;
                } | {
                    kind: "video";
                    assetUrn?: string | undefined;
                }) | undefined;
                frozenTerms: {
                    model: "fixed";
                    amount: number;
                    platformFeeRate: number;
                    currency: "EUR" | "USD";
                    currencyConversion: {
                        currency: "USD";
                        rateFromEUR: number;
                        lockedAt: string;
                    };
                } | {
                    model: "cpm";
                    cpm: number;
                    cap: number;
                    platformFeeRate: number;
                    currency: "EUR" | "USD";
                    currencyConversion: {
                        currency: "USD";
                        rateFromEUR: number;
                        lockedAt: string;
                    };
                };
            } | undefined;
            publicationIntegritySnapshot?: {
                commitmentToken: string;
                approvedAt: string;
                contentFingerprint: string;
                expectedMedia: {
                    kind: "none";
                } | {
                    kind: "document";
                    title: string;
                    assetUrn: string;
                } | {
                    kind: "image";
                    assetUrn: string;
                } | {
                    kind: "video";
                    assetUrn: string;
                };
                expectedAuthorLinkedinNumId?: string | undefined;
                verifiedPostShareUrn: string;
            } | undefined;
            pricingSnapshot?: ({
                model: "fixed";
                applicationId: string;
                amount: number;
                platformFeeRate: number;
                currency: "EUR" | "USD";
                currencyConversion: {
                    currency: "USD";
                    rateFromEUR: number;
                    lockedAt: string;
                };
                publishedAt: string;
                paymentBatchDate: string;
            } | {
                model: "cpm";
                applicationId: string;
                cpm: number;
                cap: number;
                platformFeeRate: number;
                currency: "EUR" | "USD";
                currencyConversion: {
                    currency: "USD";
                    rateFromEUR: number;
                    lockedAt: string;
                };
                publishedAt: string;
                settlementDate: string;
                paymentBatchDate: string;
                settlementScheduleVersion?: "utc_elapsed_14d_v1" | undefined;
            }) | undefined;
            paypalPayout?: {
                payout_item_status?: ("DENIED" | "PENDING" | "UNCLAIMED" | "PROCESSING" | "SUCCESS" | "CANCELED" | "FAILED" | "HELD" | "REFUNDED" | "BLOCKED" | "RETURNED") | undefined;
                payout_batch_status: "PENDING" | "PROCESSING" | "SUCCESS" | "DENIED";
                payout_batch_id: string;
                payout_item_id?: string | undefined;
                payout_initiated_at: string;
            } | undefined;
            cpm?: number | undefined;
            cap?: number | undefined;
            impressionsAtSettlement?: number | undefined;
            settledAt?: string | undefined;
            impressionsMeasurementRequiredAfter?: string | undefined;
            budgetReconciliationPendingAt?: string | undefined;
            budgetReconciledAt?: string | undefined;
            status: "paid_by_brand";
            paidByBrandAt?: string | undefined;
            postShareUrn?: string | undefined;
        }) & {
            _id: string;
        }) & {
            campaign: {
                _id: string;
                name: string;
                currencyConversion: {
                    currency: "USD";
                    rateFromEUR: number;
                    lockedAt: string;
                };
            };
            creator: {
                _id: string;
                name?: string | undefined;
                picture?: (string | null) | undefined;
            };
        })[];
    };
};

/** get /v1/prv/payments/payouts */
interface GetV1PrvPaymentsPayoutsPositiveResponseVariants {
    200: GetV1PrvPaymentsPayoutsPositiveVariant1;
}

/** get /v1/prv/payments/payouts */
type GetV1PrvPaymentsPayoutsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/payments/payouts */
interface GetV1PrvPaymentsPayoutsNegativeResponseVariants {
    400: GetV1PrvPaymentsPayoutsNegativeVariant1;
}

/** get /v1/prv/payments/portal-session */
type GetV1PrvPaymentsPortalSessionInput = {
    returnTo?: "account" | undefined;
};

/** get /v1/prv/payments/portal-session */
type GetV1PrvPaymentsPortalSessionPositiveVariant1 = {
    status: "success";
    data: {
        url: string;
    };
};

/** get /v1/prv/payments/portal-session */
interface GetV1PrvPaymentsPortalSessionPositiveResponseVariants {
    200: GetV1PrvPaymentsPortalSessionPositiveVariant1;
}

/** get /v1/prv/payments/portal-session */
type GetV1PrvPaymentsPortalSessionNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/payments/portal-session */
interface GetV1PrvPaymentsPortalSessionNegativeResponseVariants {
    400: GetV1PrvPaymentsPortalSessionNegativeVariant1;
}

/** get /v1/prv/payments/customer */
type GetV1PrvPaymentsCustomerInput = {};

/** get /v1/prv/payments/customer */
type GetV1PrvPaymentsCustomerPositiveVariant1 = {
    status: "success";
    data: {
        customer?: any | undefined;
        invoices?: any | undefined;
    };
};

/** get /v1/prv/payments/customer */
interface GetV1PrvPaymentsCustomerPositiveResponseVariants {
    200: GetV1PrvPaymentsCustomerPositiveVariant1;
}

/** get /v1/prv/payments/customer */
type GetV1PrvPaymentsCustomerNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/payments/customer */
interface GetV1PrvPaymentsCustomerNegativeResponseVariants {
    400: GetV1PrvPaymentsCustomerNegativeVariant1;
}

/** put /v1/prv/payments/customer */
type PutV1PrvPaymentsCustomerInput = {
    name: string;
    vatNumber?: string | undefined;
    billingEmail: string;
    address: {
        line1: string;
        line2?: string | undefined;
        postalCode: string;
        city: string;
        country: string;
    };
};

/** put /v1/prv/payments/customer */
type PutV1PrvPaymentsCustomerPositiveVariant1 = {
    status: "success";
    data: {
        success: true;
    };
};

/** put /v1/prv/payments/customer */
interface PutV1PrvPaymentsCustomerPositiveResponseVariants {
    200: PutV1PrvPaymentsCustomerPositiveVariant1;
}

/** put /v1/prv/payments/customer */
type PutV1PrvPaymentsCustomerNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** put /v1/prv/payments/customer */
interface PutV1PrvPaymentsCustomerNegativeResponseVariants {
    400: PutV1PrvPaymentsCustomerNegativeVariant1;
}

/** get /v1/prv/payments/campaign-quote */
type GetV1PrvPaymentsCampaignQuoteInput = {
    campaignId: string;
};

/** get /v1/prv/payments/campaign-quote */
type GetV1PrvPaymentsCampaignQuotePositiveVariant1 = {
    status: "success";
    data: {
        currency: "eur" | "usd";
        creatorsBudget: number;
        brandFee: number;
        brandFeeRatePercent: number;
        totalHt: number;
        dates?: {
            invoiceDueDate: string;
            start?: string | undefined;
            transferBy?: string | undefined;
        } | undefined;
    };
};

/** get /v1/prv/payments/campaign-quote */
interface GetV1PrvPaymentsCampaignQuotePositiveResponseVariants {
    200: GetV1PrvPaymentsCampaignQuotePositiveVariant1;
}

/** get /v1/prv/payments/campaign-quote */
type GetV1PrvPaymentsCampaignQuoteNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/payments/campaign-quote */
interface GetV1PrvPaymentsCampaignQuoteNegativeResponseVariants {
    400: GetV1PrvPaymentsCampaignQuoteNegativeVariant1;
}

/** get /v1/prv/payments/deposit-details */
type GetV1PrvPaymentsDepositDetailsInput = {
    campaignId: string;
};

/** get /v1/prv/payments/deposit-details */
type GetV1PrvPaymentsDepositDetailsPositiveVariant1 = {
    status: "success";
    data: {
        hostedInstructionsUrl: string;
        amountDue: number;
        currency: string;
        reference?: string | undefined;
        invoiceNumber?: string | undefined;
        billingEmail?: string | undefined;
        iban?: string | undefined;
        bic?: string | undefined;
        accountHolderName?: string | undefined;
        expiresAt?: string | undefined;
        sentAt?: string | undefined;
        startDate?: string | undefined;
        transferBy?: string | undefined;
        creatorsFoundCount?: number | undefined;
    };
};

/** get /v1/prv/payments/deposit-details */
interface GetV1PrvPaymentsDepositDetailsPositiveResponseVariants {
    200: GetV1PrvPaymentsDepositDetailsPositiveVariant1;
}

/** get /v1/prv/payments/deposit-details */
type GetV1PrvPaymentsDepositDetailsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/payments/deposit-details */
interface GetV1PrvPaymentsDepositDetailsNegativeResponseVariants {
    400: GetV1PrvPaymentsDepositDetailsNegativeVariant1;
}

/** get /v1/prv/payments/payouts-overview */
type GetV1PrvPaymentsPayoutsOverviewInput = {};

/** get /v1/prv/payments/payouts-overview */
type GetV1PrvPaymentsPayoutsOverviewPositiveVariant1 = {
    status: "success";
    data: {
        nbCreatorsPaid: number;
        nbPaymentsPaid: number;
        totalPaidAmount: number;
        availableAmount: number;
    };
};

/** get /v1/prv/payments/payouts-overview */
interface GetV1PrvPaymentsPayoutsOverviewPositiveResponseVariants {
    200: GetV1PrvPaymentsPayoutsOverviewPositiveVariant1;
}

/** get /v1/prv/payments/payouts-overview */
type GetV1PrvPaymentsPayoutsOverviewNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/payments/payouts-overview */
interface GetV1PrvPaymentsPayoutsOverviewNegativeResponseVariants {
    400: GetV1PrvPaymentsPayoutsOverviewNegativeVariant1;
}

/** get /v1/prv/payments/upcoming-settlements */
type GetV1PrvPaymentsUpcomingSettlementsInput = {
    campaignId: string;
    page?: number | undefined;
    size?: number | undefined;
};

/** get /v1/prv/payments/upcoming-settlements */
type GetV1PrvPaymentsUpcomingSettlementsPositiveVariant1 = {
    status: "success";
    data: {
        upcomingSettlements: {
            _id: string;
            postId: string;
            publishedAt: string;
            settlementDate: string;
            cpm: number;
            cap: number;
            estimatedAmount: number;
            postShareUrn?: string | undefined;
            creator: {
                _id: string;
                name?: string | undefined;
                picture?: (string | null) | undefined;
            };
        }[];
        total: number;
    };
};

/** get /v1/prv/payments/upcoming-settlements */
interface GetV1PrvPaymentsUpcomingSettlementsPositiveResponseVariants {
    200: GetV1PrvPaymentsUpcomingSettlementsPositiveVariant1;
}

/** get /v1/prv/payments/upcoming-settlements */
type GetV1PrvPaymentsUpcomingSettlementsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/payments/upcoming-settlements */
interface GetV1PrvPaymentsUpcomingSettlementsNegativeResponseVariants {
    400: GetV1PrvPaymentsUpcomingSettlementsNegativeVariant1;
}

/** get /v1/prv/payments/campaign-results */
type GetV1PrvPaymentsCampaignResultsInput = {
    campaignId: string;
};

/** get /v1/prv/payments/campaign-results */
type GetV1PrvPaymentsCampaignResultsPositiveVariant1 = {
    status: "success";
    data: {
        publishedPostsCount: number;
        settledPostsCount: number;
        views: number;
        dueAmount: number;
        estimatedAmount: number;
        averageCostPer1000Views: number | null;
    };
};

/** get /v1/prv/payments/campaign-results */
interface GetV1PrvPaymentsCampaignResultsPositiveResponseVariants {
    200: GetV1PrvPaymentsCampaignResultsPositiveVariant1;
}

/** get /v1/prv/payments/campaign-results */
type GetV1PrvPaymentsCampaignResultsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/payments/campaign-results */
interface GetV1PrvPaymentsCampaignResultsNegativeResponseVariants {
    400: GetV1PrvPaymentsCampaignResultsNegativeVariant1;
}

/** get /v1/prv/saved-replies */
type GetV1PrvSavedRepliesInput = {
    page: number;
    size: number;
    search?: string | undefined;
};

/** get /v1/prv/saved-replies */
type GetV1PrvSavedRepliesPositiveVariant1 = {
    status: "success";
    data: {
        totalCount: number;
        savedReplies: {
            userId: string;
            name: string;
            content: {
                text: string;
                attachments?: {
                    name: string;
                    size: number;
                    type: string;
                    fileKey: string;
                }[] | undefined;
                images?: {
                    type: "image";
                    src?: string | undefined;
                    metadata: {
                        name: string;
                        size: number;
                        type: string;
                        fileKey: string;
                    };
                }[] | undefined;
            };
            _id: string;
        }[];
    };
};

/** get /v1/prv/saved-replies */
interface GetV1PrvSavedRepliesPositiveResponseVariants {
    200: GetV1PrvSavedRepliesPositiveVariant1;
}

/** get /v1/prv/saved-replies */
type GetV1PrvSavedRepliesNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/saved-replies */
interface GetV1PrvSavedRepliesNegativeResponseVariants {
    400: GetV1PrvSavedRepliesNegativeVariant1;
}

/** post /v1/prv/saved-replies */
type PostV1PrvSavedRepliesInput = {
    savedReplyData: {
        name: string;
        content: {
            text: string;
            attachments?: {
                name: string;
                size: number;
                type: string;
                fileKey: string;
            }[] | undefined;
            images?: {
                type: "image";
                src?: string | undefined;
                metadata: {
                    name: string;
                    size: number;
                    type: string;
                    fileKey: string;
                };
            }[] | undefined;
        };
    };
};

/** post /v1/prv/saved-replies */
type PostV1PrvSavedRepliesPositiveVariant1 = {
    status: "success";
    data: {
        savedReply: {
            userId: string;
            name: string;
            content: {
                text: string;
                attachments?: {
                    name: string;
                    size: number;
                    type: string;
                    fileKey: string;
                }[] | undefined;
                images?: {
                    type: "image";
                    src?: string | undefined;
                    metadata: {
                        name: string;
                        size: number;
                        type: string;
                        fileKey: string;
                    };
                }[] | undefined;
            };
            _id: string;
        };
    };
};

/** post /v1/prv/saved-replies */
interface PostV1PrvSavedRepliesPositiveResponseVariants {
    200: PostV1PrvSavedRepliesPositiveVariant1;
}

/** post /v1/prv/saved-replies */
type PostV1PrvSavedRepliesNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/prv/saved-replies */
interface PostV1PrvSavedRepliesNegativeResponseVariants {
    400: PostV1PrvSavedRepliesNegativeVariant1;
}

/** delete /v1/prv/saved-replies/:savedReplyId */
type DeleteV1PrvSavedRepliesSavedReplyIdInput = {
    savedReplyId: string;
};

/** delete /v1/prv/saved-replies/:savedReplyId */
type DeleteV1PrvSavedRepliesSavedReplyIdPositiveVariant1 = {
    status: "success";
    data: {
        success: boolean;
    };
};

/** delete /v1/prv/saved-replies/:savedReplyId */
interface DeleteV1PrvSavedRepliesSavedReplyIdPositiveResponseVariants {
    200: DeleteV1PrvSavedRepliesSavedReplyIdPositiveVariant1;
}

/** delete /v1/prv/saved-replies/:savedReplyId */
type DeleteV1PrvSavedRepliesSavedReplyIdNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** delete /v1/prv/saved-replies/:savedReplyId */
interface DeleteV1PrvSavedRepliesSavedReplyIdNegativeResponseVariants {
    400: DeleteV1PrvSavedRepliesSavedReplyIdNegativeVariant1;
}

/** put /v1/prv/saved-replies/:savedReplyId */
type PutV1PrvSavedRepliesSavedReplyIdInput = {
    savedReplyId: string;
    savedReplyData: {
        name: string;
        content: {
            text: string;
            attachments?: {
                name: string;
                size: number;
                type: string;
                fileKey: string;
            }[] | undefined;
            images?: {
                type: "image";
                src?: string | undefined;
                metadata: {
                    name: string;
                    size: number;
                    type: string;
                    fileKey: string;
                };
            }[] | undefined;
        };
    };
};

/** put /v1/prv/saved-replies/:savedReplyId */
type PutV1PrvSavedRepliesSavedReplyIdPositiveVariant1 = {
    status: "success";
    data: {
        savedReply: {
            userId: string;
            name: string;
            content: {
                text: string;
                attachments?: {
                    name: string;
                    size: number;
                    type: string;
                    fileKey: string;
                }[] | undefined;
                images?: {
                    type: "image";
                    src?: string | undefined;
                    metadata: {
                        name: string;
                        size: number;
                        type: string;
                        fileKey: string;
                    };
                }[] | undefined;
            };
            _id: string;
        };
    };
};

/** put /v1/prv/saved-replies/:savedReplyId */
interface PutV1PrvSavedRepliesSavedReplyIdPositiveResponseVariants {
    200: PutV1PrvSavedRepliesSavedReplyIdPositiveVariant1;
}

/** put /v1/prv/saved-replies/:savedReplyId */
type PutV1PrvSavedRepliesSavedReplyIdNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** put /v1/prv/saved-replies/:savedReplyId */
interface PutV1PrvSavedRepliesSavedReplyIdNegativeResponseVariants {
    400: PutV1PrvSavedRepliesSavedReplyIdNegativeVariant1;
}

/** post /v1/prv/pusher/auth */
type PostV1PrvPusherAuthInput = {
    socket_id: string;
    channel_name: string;
};

/** post /v1/prv/pusher/auth */
type PostV1PrvPusherAuthPositiveVariant1 = {
    status: "success";
    data: {
        auth: string;
    };
};

/** post /v1/prv/pusher/auth */
interface PostV1PrvPusherAuthPositiveResponseVariants {
    200: PostV1PrvPusherAuthPositiveVariant1;
}

/** post /v1/prv/pusher/auth */
type PostV1PrvPusherAuthNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/prv/pusher/auth */
interface PostV1PrvPusherAuthNegativeResponseVariants {
    400: PostV1PrvPusherAuthNegativeVariant1;
}

/** get /v1/prv/linkedin-sender */
type GetV1PrvLinkedinSenderInput = {};

/** get /v1/prv/linkedin-sender */
type GetV1PrvLinkedinSenderPositiveVariant1 = {
    status: "success";
    data: {
        enabled: boolean;
        connected: boolean;
        status: "disabled" | "disconnected" | "pending" | "connected" | "paused" | "too_few_connections";
        profile?: {
            name: string;
            headline?: string | undefined;
            avatarUrl?: string | undefined;
            connections?: number | undefined;
        } | undefined;
        weeklyQuota: number;
        dailyInvites: number;
        sentThisWeek: number;
        sendHour: number;
        sendingSchedule: {
            timeZone: string;
            startHour: number;
            endHour: number;
            days: ("Mon" | "Tue" | "Wed" | "Thu" | "Fri" | "Sat" | "Sun")[];
        };
        pausedUntil?: string | undefined;
        login?: "cloud" | undefined;
    };
};

/** get /v1/prv/linkedin-sender */
interface GetV1PrvLinkedinSenderPositiveResponseVariants {
    200: GetV1PrvLinkedinSenderPositiveVariant1;
}

/** get /v1/prv/linkedin-sender */
type GetV1PrvLinkedinSenderNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/linkedin-sender */
interface GetV1PrvLinkedinSenderNegativeResponseVariants {
    400: GetV1PrvLinkedinSenderNegativeVariant1;
}

/** delete /v1/prv/linkedin-sender */
type DeleteV1PrvLinkedinSenderInput = {};

/** delete /v1/prv/linkedin-sender */
type DeleteV1PrvLinkedinSenderPositiveVariant1 = {
    status: "success";
    data: {
        enabled: boolean;
        connected: boolean;
        status: "disabled" | "disconnected" | "pending" | "connected" | "paused" | "too_few_connections";
        profile?: {
            name: string;
            headline?: string | undefined;
            avatarUrl?: string | undefined;
            connections?: number | undefined;
        } | undefined;
        weeklyQuota: number;
        dailyInvites: number;
        sentThisWeek: number;
        sendHour: number;
        sendingSchedule: {
            timeZone: string;
            startHour: number;
            endHour: number;
            days: ("Mon" | "Tue" | "Wed" | "Thu" | "Fri" | "Sat" | "Sun")[];
        };
        pausedUntil?: string | undefined;
        login?: "cloud" | undefined;
    };
};

/** delete /v1/prv/linkedin-sender */
interface DeleteV1PrvLinkedinSenderPositiveResponseVariants {
    200: DeleteV1PrvLinkedinSenderPositiveVariant1;
}

/** delete /v1/prv/linkedin-sender */
type DeleteV1PrvLinkedinSenderNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** delete /v1/prv/linkedin-sender */
interface DeleteV1PrvLinkedinSenderNegativeResponseVariants {
    400: DeleteV1PrvLinkedinSenderNegativeVariant1;
}

/** put /v1/prv/linkedin-sender/schedule */
type PutV1PrvLinkedinSenderScheduleInput = {
    timeZone: string;
    startHour: number;
    endHour: number;
    days: ("Mon" | "Tue" | "Wed" | "Thu" | "Fri" | "Sat" | "Sun")[];
};

/** put /v1/prv/linkedin-sender/schedule */
type PutV1PrvLinkedinSenderSchedulePositiveVariant1 = {
    status: "success";
    data: {
        enabled: boolean;
        connected: boolean;
        status: "disabled" | "disconnected" | "pending" | "connected" | "paused" | "too_few_connections";
        profile?: {
            name: string;
            headline?: string | undefined;
            avatarUrl?: string | undefined;
            connections?: number | undefined;
        } | undefined;
        weeklyQuota: number;
        dailyInvites: number;
        sentThisWeek: number;
        sendHour: number;
        sendingSchedule: {
            timeZone: string;
            startHour: number;
            endHour: number;
            days: ("Mon" | "Tue" | "Wed" | "Thu" | "Fri" | "Sat" | "Sun")[];
        };
        pausedUntil?: string | undefined;
        login?: "cloud" | undefined;
    };
};

/** put /v1/prv/linkedin-sender/schedule */
interface PutV1PrvLinkedinSenderSchedulePositiveResponseVariants {
    200: PutV1PrvLinkedinSenderSchedulePositiveVariant1;
}

/** put /v1/prv/linkedin-sender/schedule */
type PutV1PrvLinkedinSenderScheduleNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** put /v1/prv/linkedin-sender/schedule */
interface PutV1PrvLinkedinSenderScheduleNegativeResponseVariants {
    400: PutV1PrvLinkedinSenderScheduleNegativeVariant1;
}

/** post /v1/prv/linkedin-sender/cloud-login */
type PostV1PrvLinkedinSenderCloudLoginInput = {
    email: string;
    password: string;
    countryCode: string;
    totpSecret?: string | undefined;
};

/** post /v1/prv/linkedin-sender/cloud-login */
type PostV1PrvLinkedinSenderCloudLoginPositiveVariant1 = {
    status: "success";
    data: {
        jobId: string;
        status: "queued" | "accepted" | "needs_user_input" | "succeeded" | "failed";
        inputKind?: string | undefined;
        failureCode?: string | undefined;
    };
};

/** post /v1/prv/linkedin-sender/cloud-login */
interface PostV1PrvLinkedinSenderCloudLoginPositiveResponseVariants {
    200: PostV1PrvLinkedinSenderCloudLoginPositiveVariant1;
}

/** post /v1/prv/linkedin-sender/cloud-login */
type PostV1PrvLinkedinSenderCloudLoginNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/prv/linkedin-sender/cloud-login */
interface PostV1PrvLinkedinSenderCloudLoginNegativeResponseVariants {
    400: PostV1PrvLinkedinSenderCloudLoginNegativeVariant1;
}

/** get /v1/prv/linkedin-sender/cloud-login */
type GetV1PrvLinkedinSenderCloudLoginInput = {
    jobId: string;
};

/** get /v1/prv/linkedin-sender/cloud-login */
type GetV1PrvLinkedinSenderCloudLoginPositiveVariant1 = {
    status: "success";
    data: {
        jobId: string;
        status: "queued" | "accepted" | "needs_user_input" | "succeeded" | "failed";
        inputKind?: string | undefined;
        failureCode?: string | undefined;
    };
};

/** get /v1/prv/linkedin-sender/cloud-login */
interface GetV1PrvLinkedinSenderCloudLoginPositiveResponseVariants {
    200: GetV1PrvLinkedinSenderCloudLoginPositiveVariant1;
}

/** get /v1/prv/linkedin-sender/cloud-login */
type GetV1PrvLinkedinSenderCloudLoginNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/prv/linkedin-sender/cloud-login */
interface GetV1PrvLinkedinSenderCloudLoginNegativeResponseVariants {
    400: GetV1PrvLinkedinSenderCloudLoginNegativeVariant1;
}

/** post /v1/prv/linkedin-sender/cloud-login/resume */
type PostV1PrvLinkedinSenderCloudLoginResumeInput = {
    jobId: string;
    code: string;
};

/** post /v1/prv/linkedin-sender/cloud-login/resume */
type PostV1PrvLinkedinSenderCloudLoginResumePositiveVariant1 = {
    status: "success";
    data: {
        jobId: string;
        status: "queued" | "accepted" | "needs_user_input" | "succeeded" | "failed";
        inputKind?: string | undefined;
        failureCode?: string | undefined;
    };
};

/** post /v1/prv/linkedin-sender/cloud-login/resume */
interface PostV1PrvLinkedinSenderCloudLoginResumePositiveResponseVariants {
    200: PostV1PrvLinkedinSenderCloudLoginResumePositiveVariant1;
}

/** post /v1/prv/linkedin-sender/cloud-login/resume */
type PostV1PrvLinkedinSenderCloudLoginResumeNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/prv/linkedin-sender/cloud-login/resume */
interface PostV1PrvLinkedinSenderCloudLoginResumeNegativeResponseVariants {
    400: PostV1PrvLinkedinSenderCloudLoginResumeNegativeVariant1;
}

/** get /v1/smm-prv/campaigns */
type GetV1SmmPrvCampaignsInput = {
    searchQuery?: string | undefined;
    page?: number | undefined;
    size?: number | undefined;
    eligibleOnly: boolean;
};

/** get /v1/smm-prv/campaigns */
type GetV1SmmPrvCampaignsPositiveVariant1 = {
    status: "success";
    data: {
        campaigns: {
            _id: string;
            userId: string;
            name: string;
            description: string;
            status: "DRAFT" | "PENDING_PAYMENT" | "ACTIVE" | "PAUSED" | "FINISHED";
            paymentStatus: "PENDING" | "PAID" | "FAILED";
            paymentDeclineCode?: string | undefined;
            targets: {
                minFollowers?: (number | null) | undefined;
                minViews?: (number | null) | undefined;
                minViewsLast28Days?: (number | null) | undefined;
                language?: (string | null) | undefined;
                audienceLocation?: string[] | undefined;
                hierarchyLevel?: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | undefined;
                industry?: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | undefined;
                companySize?: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | undefined;
                occupation?: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | undefined;
            };
            framing: {
                startDate: string;
                endDate?: string | undefined;
                publicationStartDate?: string | undefined;
                publicationEndDate?: string | undefined;
                maxBudgetPerPost?: number | undefined;
                cpm?: number | undefined;
                totalBudget: number;
                totalUsedBudget?: number | undefined;
                autoValidateContent: boolean;
                autoAcceptCreators: boolean;
                autonomousCpmCeilingMultiplier?: (1 | 1.1 | 1.2) | undefined;
                capMode?: ("auto" | "fixed") | undefined;
                fixedCap?: number | undefined;
            };
            objective?: ("awareness" | "traffic" | "demos") | undefined;
            brief?: {
                keyMessage?: string | undefined;
                tones?: ("concrete" | "educational" | "personal" | "light_humour")[] | undefined;
                do?: string[] | undefined;
                avoid?: string[] | undefined;
            } | undefined;
            regions?: string[] | undefined;
            rules?: {
                minTargetAudienceShare?: number | undefined;
                askIfMostlyAbroad?: boolean | undefined;
            } | undefined;
            invitationTemplate?: string | undefined;
            sender?: {
                kind: "own_profile" | "kawaak_managed";
            } | undefined;
            postAcceptanceMode?: ("agent_auto" | "review_24h" | "manual") | undefined;
            draftStep?: ("brand" | "proposal" | "budget" | "launch") | undefined;
            suggestedTargets?: {
                label: string;
                targets: {
                    minFollowers?: (number | null) | undefined;
                    minViews?: (number | null) | undefined;
                    minViewsLast28Days?: (number | null) | undefined;
                    language?: (string | null) | undefined;
                    audienceLocation?: string[] | undefined;
                    hierarchyLevel?: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | undefined;
                    industry?: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | undefined;
                    companySize?: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | undefined;
                    occupation?: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | undefined;
                };
                eligibleCount: number | null;
                reason?: string | undefined;
                audienceReached?: string[] | undefined;
            }[] | undefined;
            agentInstructions?: string[] | undefined;
            budgetReservationTrigger?: ("acceptance" | "post_submission") | undefined;
            nbPostsToReview: number;
            utmLink?: string | undefined;
            promoCode?: string | undefined;
            stripePaymentIntentId?: string | undefined;
            stripeInvoiceId?: string | undefined;
            stripeCheckoutSessionId?: string | undefined;
            stripeRefundId?: string | undefined;
            stripeCreditNoteId?: string | undefined;
            stripeDeferredClosePaymentIntentId?: string | undefined;
            stripeDeferredCloseInvoiceId?: string | undefined;
            paymentSnapshot?: {
                source: "stripe_checkout" | "stripe_payment_intent" | "out_of_band";
                currency: "eur" | "usd";
                conversionRateFromEUR: number;
                budgetAmountInCents: number;
                platformFeeAmountInCents: number;
                taxAmountInCents: number;
                totalAmountInCents: number;
                paidAt: string;
                stripePaymentIntentId?: string | undefined;
                stripeInvoiceId?: string | undefined;
                stripeCheckoutSessionId?: string | undefined;
                externalReference?: string | undefined;
                outOfBandProof?: {
                    proofDocumentKey: string;
                    proofDocumentSha256: string;
                    proofDocumentEtag: string;
                    proofDocumentSizeBytes: number;
                    proofDocumentLastModified: string;
                    proofDocumentContentType: string;
                    proofDocumentVersionId?: string | undefined;
                    bankTransactionReference: string;
                    invoiceReference: string;
                    submittedAt: string;
                    submittedByStaffId: string;
                    approvedAt: string;
                    approvedByStaffId: string;
                } | undefined;
            } | undefined;
            paymentAttempt?: {
                attemptId: string;
                version: number;
                purpose: "INITIAL_DEPOSIT" | "DEFERRED_USAGE";
                state: "creating" | "awaiting_payment" | "paid" | "failed" | "canceled";
                currency: "eur" | "usd";
                conversionRateFromEUR: number;
                budgetAmountInCents: number;
                platformFeeAmountInCents: number;
                customerId: string;
                createdAt: string;
                updatedAt: string;
                cardCheckout?: {
                    expiresAt: number;
                    successUrl: string;
                    cancelUrl: string;
                } | undefined;
                checkoutSessionId?: string | undefined;
                stripeInvoiceId?: string | undefined;
                stripePaymentIntentId?: string | undefined;
                failureCode?: string | undefined;
            } | undefined;
            paymentAttemptHistory?: {
                attemptId: string;
                version: number;
                purpose: "INITIAL_DEPOSIT" | "DEFERRED_USAGE";
                state: "creating" | "awaiting_payment" | "paid" | "failed" | "canceled";
                currency: "eur" | "usd";
                conversionRateFromEUR: number;
                budgetAmountInCents: number;
                platformFeeAmountInCents: number;
                customerId: string;
                createdAt: string;
                updatedAt: string;
                cardCheckout?: {
                    expiresAt: number;
                    successUrl: string;
                    cancelUrl: string;
                } | undefined;
                checkoutSessionId?: string | undefined;
                stripeInvoiceId?: string | undefined;
                stripePaymentIntentId?: string | undefined;
                failureCode?: string | undefined;
            }[] | undefined;
            paymentReconciliationIssues?: {
                attemptId: string;
                stripePaymentIntentId: string;
                amountInCents: number;
                currency: string;
                reason: string;
                detectedAt: string;
            }[] | undefined;
            financialClose?: {
                state: "closing" | "awaiting_deferred_payment" | "manual_refund_required" | "manual_refund_awaiting_approval" | "manual_refund_confirmed" | "refund_pending" | "refund_failed";
                requestedAt: string;
                projectedUsedBudgetInEuros: number;
                ownerId?: string | undefined;
                leaseId?: string | undefined;
                leaseExpiresAt?: string | undefined;
                refundAmountInCents?: number | undefined;
                currency?: ("eur" | "usd") | undefined;
                error?: string | undefined;
                refundFailedAlertedAt?: string | undefined;
            } | undefined;
            agent?: {
                enabled: boolean;
                autonomyLevel?: ("assisted" | "review" | "autonomous") | undefined;
                pausedAt?: string | undefined;
                autonomyStats?: {
                    firstMessagesSent?: number | undefined;
                    firstMessagesApprovedStreak?: number | undefined;
                    repliesSent?: number | undefined;
                    repliesApprovedStreak?: number | undefined;
                } | undefined;
                autonomyProposal?: {
                    status: "proposed" | "accepted" | "refused";
                    trigger: "first_messages_sent" | "first_messages_approved" | "replies_sent" | "replies_approved";
                    proposedAt: string;
                    refusals: number;
                    firstRefusedAt?: string | undefined;
                    nextProposalAt?: string | undefined;
                } | undefined;
                poolExhaustedAt?: {
                    in_app?: string | undefined;
                    linkedin?: string | undefined;
                } | undefined;
                linkedinSourcing?: {
                    nextRunAfter?: string | undefined;
                    lastRunAt?: string | undefined;
                    lastOutcome?: string | undefined;
                    keywords?: string[] | undefined;
                    searchKey?: string | undefined;
                    nextPage?: number | undefined;
                } | undefined;
            } | undefined;
            payoutCreationLocks?: string[] | undefined;
            scheduledPayoutClaims?: string[] | undefined;
            refundedAt?: string | undefined;
            refundedBudgetInCents?: number | undefined;
            refundedFeeInCents?: number | undefined;
            refundedTaxInCents?: number | undefined;
            refundMethod?: ("stripe" | "manual") | undefined;
            manualRefundReference?: string | undefined;
            manualRefundedByStaffId?: string | undefined;
            manualRefundProof?: {
                reference: string;
                amountInCents: number;
                currency: "eur" | "usd";
                executedAt: string;
                proofDocumentKey: string;
                proofDocumentEtag: string;
                proofDocumentSizeBytes: number;
                proofDocumentLastModified: string;
                proofDocumentContentType: string;
                submittedAt: string;
                submittedByStaffId: string;
                confirmedAt?: string | undefined;
                confirmedByStaffId?: string | undefined;
            } | undefined;
            depositedAt?: string | undefined;
            firstMessagesToAcceptedCreators?: ({
                type: "text";
                text: string;
                priceEUR?: number | undefined;
                cpmEUR?: number | undefined;
            } | {
                type: "image";
                src?: string | undefined;
                metadata: {
                    name: string;
                    size: number;
                    type: string;
                    fileKey: string;
                };
            } | {
                type: "file";
                src?: string | undefined;
                metadata: {
                    name: string;
                    size: number;
                    type: string;
                    fileKey: string;
                };
            })[] | undefined;
            closedByStaffAt?: string | undefined;
            deletedAt?: string | undefined;
            currencyConversion: {
                currency: "USD";
                rateFromEUR: number;
                lockedAt: string;
            };
            initialBudgetQuote?: {
                currency: "eur" | "usd";
                budgetAmountInCents: number;
                budgetAmountInEurCents: number;
                conversionRateFromEUR: number;
                quotedAt: string;
            } | undefined;
            budgetDepositStatus?: ("PENDING" | "DEPOSITED") | undefined;
            creatorsPaidByBrand?: boolean | undefined;
            createdAt?: string | undefined;
            brand: {
                _id: string;
                name: string;
                websiteUrl?: string | undefined;
                country?: string | undefined;
                language?: string | undefined;
                description?: string | undefined;
                logoKey?: string | undefined;
                filesKeys?: string[] | undefined;
                keyFeatures?: string | undefined;
                linkedinUrl?: string | undefined;
                socialProofs?: ({
                    type: "metric";
                    value: number;
                    name: string;
                } | {
                    type: "rating";
                    rating: number;
                    maxRating?: number | undefined;
                    plateform: string;
                })[] | undefined;
                targetAudience?: {
                    occupations: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | null;
                    occupationSeniority: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | null;
                    companySize: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | null;
                    industries: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | null;
                    locations: string[] | null;
                } | undefined;
                targetCustomers?: string | undefined;
                analyzedAt?: string | undefined;
                logoSource?: string | undefined;
            };
            isEligible: boolean;
            ineligibilityReasons?: ("CAMPAIGN_NOT_ACTIVE" | "PENDING_INVITE" | "ALREADY_APPLIED" | "ALREADY_ACCEPTED" | "ALREADY_REJECTED" | "ALREADY_EXCLUDED" | "MIN_FOLLOWERS" | "MIN_VIEWS" | "MIN_VIEWS_LAST_28_DAYS" | "LANGUAGE" | "AUDIENCE_NOT_MATCHING" | "BUDGET_EXCEEDED" | "NO_MEASURED_VIEWS")[] | undefined;
            creatorApplicationState?: string | undefined;
        }[];
        total: number;
    };
};

/** get /v1/smm-prv/campaigns */
interface GetV1SmmPrvCampaignsPositiveResponseVariants {
    200: GetV1SmmPrvCampaignsPositiveVariant1;
}

/** get /v1/smm-prv/campaigns */
type GetV1SmmPrvCampaignsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/smm-prv/campaigns */
interface GetV1SmmPrvCampaignsNegativeResponseVariants {
    400: GetV1SmmPrvCampaignsNegativeVariant1;
}

/** post /v1/smm-prv/campaigns/apply */
type PostV1SmmPrvCampaignsApplyInput = {
    campaignId: string;
    price?: number | undefined;
    cpm?: number | undefined;
    maxAmount?: number | undefined;
    reason: string;
    isUserOfBrand: boolean;
};

/** post /v1/smm-prv/campaigns/apply */
type PostV1SmmPrvCampaignsApplyPositiveVariant1 = {
    status: "success";
    data: {
        creatorApplication: {
            _id: string;
            uniquenessKey?: string | undefined;
            sideEffectOutboxVersion?: number | undefined;
            inviteSideEffectsEnqueuedAt?: string | undefined;
            price: number;
            cpm?: number | undefined;
            maxAmount?: number | undefined;
            campaignId: string;
            state: "pending" | "accepted" | "rejected" | "excluded" | "invited";
            reason: string;
            rejectionReason?: string | undefined;
            exclusionReason?: string | undefined;
            isUserOfBrand: boolean;
            creatorId: string;
            smmUserId: string;
            expectedAuthorLinkedinNumId?: string | undefined;
            linkedinIdentityFrozenAt?: string | undefined;
            brandId: string;
            createdAt: string;
            updatedAt: string;
            acceptedAt?: string | undefined;
            budgetReservedAt?: string | undefined;
            capacityExcludedAt?: string | undefined;
            lastPublishReminderAt?: string | undefined;
            publishReminderCount?: number | undefined;
            publishReminderExhausted?: boolean | undefined;
            changesRequestedAt?: string | undefined;
            changesRequestReason?: string | undefined;
            lastNegotiation?: {
                price: number;
                cpm?: number | undefined;
                maxAmount?: number | undefined;
                proposedBy: "creator" | "campaign";
                proposedAt: string;
                reason?: string | undefined;
            } | undefined;
        };
    };
};

/** post /v1/smm-prv/campaigns/apply */
interface PostV1SmmPrvCampaignsApplyPositiveResponseVariants {
    200: PostV1SmmPrvCampaignsApplyPositiveVariant1;
}

/** post /v1/smm-prv/campaigns/apply */
type PostV1SmmPrvCampaignsApplyNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/smm-prv/campaigns/apply */
interface PostV1SmmPrvCampaignsApplyNegativeResponseVariants {
    400: PostV1SmmPrvCampaignsApplyNegativeVariant1;
}

/** get /v1/smm-prv/campaigns/applied */
type GetV1SmmPrvCampaignsAppliedInput = {};

/** get /v1/smm-prv/campaigns/applied */
type GetV1SmmPrvCampaignsAppliedPositiveVariant1 = {
    status: "success";
    data: {
        campaigns: {
            _id: string;
            userId: string;
            brandId: string;
            name: string;
            description: string;
            status: "DRAFT" | "PENDING_PAYMENT" | "ACTIVE" | "PAUSED" | "FINISHED";
            paymentStatus: "PENDING" | "PAID" | "FAILED";
            paymentDeclineCode?: string | undefined;
            targets: {
                minFollowers?: (number | null) | undefined;
                minViews?: (number | null) | undefined;
                minViewsLast28Days?: (number | null) | undefined;
                language?: (string | null) | undefined;
                audienceLocation?: string[] | undefined;
                hierarchyLevel?: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | undefined;
                industry?: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | undefined;
                companySize?: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | undefined;
                occupation?: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | undefined;
            };
            framing: {
                startDate: string;
                endDate?: string | undefined;
                publicationStartDate?: string | undefined;
                publicationEndDate?: string | undefined;
                maxBudgetPerPost?: number | undefined;
                cpm?: number | undefined;
                totalBudget: number;
                totalUsedBudget?: number | undefined;
                autoValidateContent: boolean;
                autoAcceptCreators: boolean;
                autonomousCpmCeilingMultiplier?: (1 | 1.1 | 1.2) | undefined;
                capMode?: ("auto" | "fixed") | undefined;
                fixedCap?: number | undefined;
            };
            objective?: ("awareness" | "traffic" | "demos") | undefined;
            brief?: {
                keyMessage?: string | undefined;
                tones?: ("concrete" | "educational" | "personal" | "light_humour")[] | undefined;
                do?: string[] | undefined;
                avoid?: string[] | undefined;
            } | undefined;
            regions?: string[] | undefined;
            rules?: {
                minTargetAudienceShare?: number | undefined;
                askIfMostlyAbroad?: boolean | undefined;
            } | undefined;
            invitationTemplate?: string | undefined;
            sender?: {
                kind: "own_profile" | "kawaak_managed";
            } | undefined;
            postAcceptanceMode?: ("agent_auto" | "review_24h" | "manual") | undefined;
            draftStep?: ("brand" | "proposal" | "budget" | "launch") | undefined;
            suggestedTargets?: {
                label: string;
                targets: {
                    minFollowers?: (number | null) | undefined;
                    minViews?: (number | null) | undefined;
                    minViewsLast28Days?: (number | null) | undefined;
                    language?: (string | null) | undefined;
                    audienceLocation?: string[] | undefined;
                    hierarchyLevel?: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | undefined;
                    industry?: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | undefined;
                    companySize?: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | undefined;
                    occupation?: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | undefined;
                };
                eligibleCount: number | null;
                reason?: string | undefined;
                audienceReached?: string[] | undefined;
            }[] | undefined;
            agentInstructions?: string[] | undefined;
            budgetReservationTrigger?: ("acceptance" | "post_submission") | undefined;
            nbPostsToReview: number;
            utmLink?: string | undefined;
            promoCode?: string | undefined;
            stripePaymentIntentId?: string | undefined;
            stripeInvoiceId?: string | undefined;
            stripeCheckoutSessionId?: string | undefined;
            stripeRefundId?: string | undefined;
            stripeCreditNoteId?: string | undefined;
            stripeDeferredClosePaymentIntentId?: string | undefined;
            stripeDeferredCloseInvoiceId?: string | undefined;
            paymentSnapshot?: {
                source: "stripe_checkout" | "stripe_payment_intent" | "out_of_band";
                currency: "eur" | "usd";
                conversionRateFromEUR: number;
                budgetAmountInCents: number;
                platformFeeAmountInCents: number;
                taxAmountInCents: number;
                totalAmountInCents: number;
                paidAt: string;
                stripePaymentIntentId?: string | undefined;
                stripeInvoiceId?: string | undefined;
                stripeCheckoutSessionId?: string | undefined;
                externalReference?: string | undefined;
                outOfBandProof?: {
                    proofDocumentKey: string;
                    proofDocumentSha256: string;
                    proofDocumentEtag: string;
                    proofDocumentSizeBytes: number;
                    proofDocumentLastModified: string;
                    proofDocumentContentType: string;
                    proofDocumentVersionId?: string | undefined;
                    bankTransactionReference: string;
                    invoiceReference: string;
                    submittedAt: string;
                    submittedByStaffId: string;
                    approvedAt: string;
                    approvedByStaffId: string;
                } | undefined;
            } | undefined;
            paymentAttempt?: {
                attemptId: string;
                version: number;
                purpose: "INITIAL_DEPOSIT" | "DEFERRED_USAGE";
                state: "creating" | "awaiting_payment" | "paid" | "failed" | "canceled";
                currency: "eur" | "usd";
                conversionRateFromEUR: number;
                budgetAmountInCents: number;
                platformFeeAmountInCents: number;
                customerId: string;
                createdAt: string;
                updatedAt: string;
                cardCheckout?: {
                    expiresAt: number;
                    successUrl: string;
                    cancelUrl: string;
                } | undefined;
                checkoutSessionId?: string | undefined;
                stripeInvoiceId?: string | undefined;
                stripePaymentIntentId?: string | undefined;
                failureCode?: string | undefined;
            } | undefined;
            paymentAttemptHistory?: {
                attemptId: string;
                version: number;
                purpose: "INITIAL_DEPOSIT" | "DEFERRED_USAGE";
                state: "creating" | "awaiting_payment" | "paid" | "failed" | "canceled";
                currency: "eur" | "usd";
                conversionRateFromEUR: number;
                budgetAmountInCents: number;
                platformFeeAmountInCents: number;
                customerId: string;
                createdAt: string;
                updatedAt: string;
                cardCheckout?: {
                    expiresAt: number;
                    successUrl: string;
                    cancelUrl: string;
                } | undefined;
                checkoutSessionId?: string | undefined;
                stripeInvoiceId?: string | undefined;
                stripePaymentIntentId?: string | undefined;
                failureCode?: string | undefined;
            }[] | undefined;
            paymentReconciliationIssues?: {
                attemptId: string;
                stripePaymentIntentId: string;
                amountInCents: number;
                currency: string;
                reason: string;
                detectedAt: string;
            }[] | undefined;
            financialClose?: {
                state: "closing" | "awaiting_deferred_payment" | "manual_refund_required" | "manual_refund_awaiting_approval" | "manual_refund_confirmed" | "refund_pending" | "refund_failed";
                requestedAt: string;
                projectedUsedBudgetInEuros: number;
                ownerId?: string | undefined;
                leaseId?: string | undefined;
                leaseExpiresAt?: string | undefined;
                refundAmountInCents?: number | undefined;
                currency?: ("eur" | "usd") | undefined;
                error?: string | undefined;
                refundFailedAlertedAt?: string | undefined;
            } | undefined;
            agent?: {
                enabled: boolean;
                autonomyLevel?: ("assisted" | "review" | "autonomous") | undefined;
                pausedAt?: string | undefined;
                autonomyStats?: {
                    firstMessagesSent?: number | undefined;
                    firstMessagesApprovedStreak?: number | undefined;
                    repliesSent?: number | undefined;
                    repliesApprovedStreak?: number | undefined;
                } | undefined;
                autonomyProposal?: {
                    status: "proposed" | "accepted" | "refused";
                    trigger: "first_messages_sent" | "first_messages_approved" | "replies_sent" | "replies_approved";
                    proposedAt: string;
                    refusals: number;
                    firstRefusedAt?: string | undefined;
                    nextProposalAt?: string | undefined;
                } | undefined;
                poolExhaustedAt?: {
                    in_app?: string | undefined;
                    linkedin?: string | undefined;
                } | undefined;
                linkedinSourcing?: {
                    nextRunAfter?: string | undefined;
                    lastRunAt?: string | undefined;
                    lastOutcome?: string | undefined;
                    keywords?: string[] | undefined;
                    searchKey?: string | undefined;
                    nextPage?: number | undefined;
                } | undefined;
            } | undefined;
            payoutCreationLocks?: string[] | undefined;
            scheduledPayoutClaims?: string[] | undefined;
            refundedAt?: string | undefined;
            refundedBudgetInCents?: number | undefined;
            refundedFeeInCents?: number | undefined;
            refundedTaxInCents?: number | undefined;
            refundMethod?: ("stripe" | "manual") | undefined;
            manualRefundReference?: string | undefined;
            manualRefundedByStaffId?: string | undefined;
            manualRefundProof?: {
                reference: string;
                amountInCents: number;
                currency: "eur" | "usd";
                executedAt: string;
                proofDocumentKey: string;
                proofDocumentEtag: string;
                proofDocumentSizeBytes: number;
                proofDocumentLastModified: string;
                proofDocumentContentType: string;
                submittedAt: string;
                submittedByStaffId: string;
                confirmedAt?: string | undefined;
                confirmedByStaffId?: string | undefined;
            } | undefined;
            depositedAt?: string | undefined;
            firstMessagesToAcceptedCreators?: ({
                type: "text";
                text: string;
                priceEUR?: number | undefined;
                cpmEUR?: number | undefined;
            } | {
                type: "image";
                src?: string | undefined;
                metadata: {
                    name: string;
                    size: number;
                    type: string;
                    fileKey: string;
                };
            } | {
                type: "file";
                src?: string | undefined;
                metadata: {
                    name: string;
                    size: number;
                    type: string;
                    fileKey: string;
                };
            })[] | undefined;
            closedByStaffAt?: string | undefined;
            deletedAt?: string | undefined;
            currencyConversion: {
                currency: "USD";
                rateFromEUR: number;
                lockedAt: string;
            };
            initialBudgetQuote?: {
                currency: "eur" | "usd";
                budgetAmountInCents: number;
                budgetAmountInEurCents: number;
                conversionRateFromEUR: number;
                quotedAt: string;
            } | undefined;
            budgetDepositStatus?: ("PENDING" | "DEPOSITED") | undefined;
            creatorsPaidByBrand?: boolean | undefined;
            createdAt?: string | undefined;
        }[];
    };
};

/** get /v1/smm-prv/campaigns/applied */
interface GetV1SmmPrvCampaignsAppliedPositiveResponseVariants {
    200: GetV1SmmPrvCampaignsAppliedPositiveVariant1;
}

/** get /v1/smm-prv/campaigns/applied */
type GetV1SmmPrvCampaignsAppliedNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/smm-prv/campaigns/applied */
interface GetV1SmmPrvCampaignsAppliedNegativeResponseVariants {
    400: GetV1SmmPrvCampaignsAppliedNegativeVariant1;
}

/** get /v1/smm-prv/campaigns/:campaignId */
type GetV1SmmPrvCampaignsCampaignIdInput = {
    campaignId: string;
};

/** get /v1/smm-prv/campaigns/:campaignId */
type GetV1SmmPrvCampaignsCampaignIdPositiveVariant1 = {
    status: "success";
    data: {
        campaign: {
            _id: string;
            userId: string;
            name: string;
            description: string;
            status: "DRAFT" | "PENDING_PAYMENT" | "ACTIVE" | "PAUSED" | "FINISHED";
            paymentStatus: "PENDING" | "PAID" | "FAILED";
            paymentDeclineCode?: string | undefined;
            targets: {
                minFollowers?: (number | null) | undefined;
                minViews?: (number | null) | undefined;
                minViewsLast28Days?: (number | null) | undefined;
                language?: (string | null) | undefined;
                audienceLocation?: string[] | undefined;
                hierarchyLevel?: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | undefined;
                industry?: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | undefined;
                companySize?: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | undefined;
                occupation?: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | undefined;
            };
            framing: {
                startDate: string;
                endDate?: string | undefined;
                publicationStartDate?: string | undefined;
                publicationEndDate?: string | undefined;
                maxBudgetPerPost?: number | undefined;
                cpm?: number | undefined;
                totalBudget: number;
                totalUsedBudget?: number | undefined;
                autoValidateContent: boolean;
                autoAcceptCreators: boolean;
                autonomousCpmCeilingMultiplier?: (1 | 1.1 | 1.2) | undefined;
                capMode?: ("auto" | "fixed") | undefined;
                fixedCap?: number | undefined;
            };
            objective?: ("awareness" | "traffic" | "demos") | undefined;
            brief?: {
                keyMessage?: string | undefined;
                tones?: ("concrete" | "educational" | "personal" | "light_humour")[] | undefined;
                do?: string[] | undefined;
                avoid?: string[] | undefined;
            } | undefined;
            regions?: string[] | undefined;
            rules?: {
                minTargetAudienceShare?: number | undefined;
                askIfMostlyAbroad?: boolean | undefined;
            } | undefined;
            invitationTemplate?: string | undefined;
            sender?: {
                kind: "own_profile" | "kawaak_managed";
            } | undefined;
            postAcceptanceMode?: ("agent_auto" | "review_24h" | "manual") | undefined;
            draftStep?: ("brand" | "proposal" | "budget" | "launch") | undefined;
            suggestedTargets?: {
                label: string;
                targets: {
                    minFollowers?: (number | null) | undefined;
                    minViews?: (number | null) | undefined;
                    minViewsLast28Days?: (number | null) | undefined;
                    language?: (string | null) | undefined;
                    audienceLocation?: string[] | undefined;
                    hierarchyLevel?: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | undefined;
                    industry?: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | undefined;
                    companySize?: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | undefined;
                    occupation?: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | undefined;
                };
                eligibleCount: number | null;
                reason?: string | undefined;
                audienceReached?: string[] | undefined;
            }[] | undefined;
            agentInstructions?: string[] | undefined;
            budgetReservationTrigger?: ("acceptance" | "post_submission") | undefined;
            nbPostsToReview: number;
            utmLink?: string | undefined;
            promoCode?: string | undefined;
            stripePaymentIntentId?: string | undefined;
            stripeInvoiceId?: string | undefined;
            stripeCheckoutSessionId?: string | undefined;
            stripeRefundId?: string | undefined;
            stripeCreditNoteId?: string | undefined;
            stripeDeferredClosePaymentIntentId?: string | undefined;
            stripeDeferredCloseInvoiceId?: string | undefined;
            paymentSnapshot?: {
                source: "stripe_checkout" | "stripe_payment_intent" | "out_of_band";
                currency: "eur" | "usd";
                conversionRateFromEUR: number;
                budgetAmountInCents: number;
                platformFeeAmountInCents: number;
                taxAmountInCents: number;
                totalAmountInCents: number;
                paidAt: string;
                stripePaymentIntentId?: string | undefined;
                stripeInvoiceId?: string | undefined;
                stripeCheckoutSessionId?: string | undefined;
                externalReference?: string | undefined;
                outOfBandProof?: {
                    proofDocumentKey: string;
                    proofDocumentSha256: string;
                    proofDocumentEtag: string;
                    proofDocumentSizeBytes: number;
                    proofDocumentLastModified: string;
                    proofDocumentContentType: string;
                    proofDocumentVersionId?: string | undefined;
                    bankTransactionReference: string;
                    invoiceReference: string;
                    submittedAt: string;
                    submittedByStaffId: string;
                    approvedAt: string;
                    approvedByStaffId: string;
                } | undefined;
            } | undefined;
            paymentAttempt?: {
                attemptId: string;
                version: number;
                purpose: "INITIAL_DEPOSIT" | "DEFERRED_USAGE";
                state: "creating" | "awaiting_payment" | "paid" | "failed" | "canceled";
                currency: "eur" | "usd";
                conversionRateFromEUR: number;
                budgetAmountInCents: number;
                platformFeeAmountInCents: number;
                customerId: string;
                createdAt: string;
                updatedAt: string;
                cardCheckout?: {
                    expiresAt: number;
                    successUrl: string;
                    cancelUrl: string;
                } | undefined;
                checkoutSessionId?: string | undefined;
                stripeInvoiceId?: string | undefined;
                stripePaymentIntentId?: string | undefined;
                failureCode?: string | undefined;
            } | undefined;
            paymentAttemptHistory?: {
                attemptId: string;
                version: number;
                purpose: "INITIAL_DEPOSIT" | "DEFERRED_USAGE";
                state: "creating" | "awaiting_payment" | "paid" | "failed" | "canceled";
                currency: "eur" | "usd";
                conversionRateFromEUR: number;
                budgetAmountInCents: number;
                platformFeeAmountInCents: number;
                customerId: string;
                createdAt: string;
                updatedAt: string;
                cardCheckout?: {
                    expiresAt: number;
                    successUrl: string;
                    cancelUrl: string;
                } | undefined;
                checkoutSessionId?: string | undefined;
                stripeInvoiceId?: string | undefined;
                stripePaymentIntentId?: string | undefined;
                failureCode?: string | undefined;
            }[] | undefined;
            paymentReconciliationIssues?: {
                attemptId: string;
                stripePaymentIntentId: string;
                amountInCents: number;
                currency: string;
                reason: string;
                detectedAt: string;
            }[] | undefined;
            financialClose?: {
                state: "closing" | "awaiting_deferred_payment" | "manual_refund_required" | "manual_refund_awaiting_approval" | "manual_refund_confirmed" | "refund_pending" | "refund_failed";
                requestedAt: string;
                projectedUsedBudgetInEuros: number;
                ownerId?: string | undefined;
                leaseId?: string | undefined;
                leaseExpiresAt?: string | undefined;
                refundAmountInCents?: number | undefined;
                currency?: ("eur" | "usd") | undefined;
                error?: string | undefined;
                refundFailedAlertedAt?: string | undefined;
            } | undefined;
            agent?: {
                enabled: boolean;
                autonomyLevel?: ("assisted" | "review" | "autonomous") | undefined;
                pausedAt?: string | undefined;
                autonomyStats?: {
                    firstMessagesSent?: number | undefined;
                    firstMessagesApprovedStreak?: number | undefined;
                    repliesSent?: number | undefined;
                    repliesApprovedStreak?: number | undefined;
                } | undefined;
                autonomyProposal?: {
                    status: "proposed" | "accepted" | "refused";
                    trigger: "first_messages_sent" | "first_messages_approved" | "replies_sent" | "replies_approved";
                    proposedAt: string;
                    refusals: number;
                    firstRefusedAt?: string | undefined;
                    nextProposalAt?: string | undefined;
                } | undefined;
                poolExhaustedAt?: {
                    in_app?: string | undefined;
                    linkedin?: string | undefined;
                } | undefined;
                linkedinSourcing?: {
                    nextRunAfter?: string | undefined;
                    lastRunAt?: string | undefined;
                    lastOutcome?: string | undefined;
                    keywords?: string[] | undefined;
                    searchKey?: string | undefined;
                    nextPage?: number | undefined;
                } | undefined;
            } | undefined;
            payoutCreationLocks?: string[] | undefined;
            scheduledPayoutClaims?: string[] | undefined;
            refundedAt?: string | undefined;
            refundedBudgetInCents?: number | undefined;
            refundedFeeInCents?: number | undefined;
            refundedTaxInCents?: number | undefined;
            refundMethod?: ("stripe" | "manual") | undefined;
            manualRefundReference?: string | undefined;
            manualRefundedByStaffId?: string | undefined;
            manualRefundProof?: {
                reference: string;
                amountInCents: number;
                currency: "eur" | "usd";
                executedAt: string;
                proofDocumentKey: string;
                proofDocumentEtag: string;
                proofDocumentSizeBytes: number;
                proofDocumentLastModified: string;
                proofDocumentContentType: string;
                submittedAt: string;
                submittedByStaffId: string;
                confirmedAt?: string | undefined;
                confirmedByStaffId?: string | undefined;
            } | undefined;
            depositedAt?: string | undefined;
            firstMessagesToAcceptedCreators?: ({
                type: "text";
                text: string;
                priceEUR?: number | undefined;
                cpmEUR?: number | undefined;
            } | {
                type: "image";
                src?: string | undefined;
                metadata: {
                    name: string;
                    size: number;
                    type: string;
                    fileKey: string;
                };
            } | {
                type: "file";
                src?: string | undefined;
                metadata: {
                    name: string;
                    size: number;
                    type: string;
                    fileKey: string;
                };
            })[] | undefined;
            closedByStaffAt?: string | undefined;
            deletedAt?: string | undefined;
            currencyConversion: {
                currency: "USD";
                rateFromEUR: number;
                lockedAt: string;
            };
            initialBudgetQuote?: {
                currency: "eur" | "usd";
                budgetAmountInCents: number;
                budgetAmountInEurCents: number;
                conversionRateFromEUR: number;
                quotedAt: string;
            } | undefined;
            budgetDepositStatus?: ("PENDING" | "DEPOSITED") | undefined;
            creatorsPaidByBrand?: boolean | undefined;
            createdAt?: string | undefined;
            brand: {
                _id: string;
                name: string;
                websiteUrl?: string | undefined;
                country?: string | undefined;
                language?: string | undefined;
                description?: string | undefined;
                logoKey?: string | undefined;
                filesKeys?: string[] | undefined;
                keyFeatures?: string | undefined;
                linkedinUrl?: string | undefined;
                socialProofs?: ({
                    type: "metric";
                    value: number;
                    name: string;
                } | {
                    type: "rating";
                    rating: number;
                    maxRating?: number | undefined;
                    plateform: string;
                })[] | undefined;
                targetAudience?: {
                    occupations: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | null;
                    occupationSeniority: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | null;
                    companySize: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | null;
                    industries: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | null;
                    locations: string[] | null;
                } | undefined;
                targetCustomers?: string | undefined;
                analyzedAt?: string | undefined;
                logoSource?: string | undefined;
            };
            isEligible: boolean;
            ineligibilityReasons?: ("CAMPAIGN_NOT_ACTIVE" | "PENDING_INVITE" | "ALREADY_APPLIED" | "ALREADY_ACCEPTED" | "ALREADY_REJECTED" | "ALREADY_EXCLUDED" | "MIN_FOLLOWERS" | "MIN_VIEWS" | "MIN_VIEWS_LAST_28_DAYS" | "LANGUAGE" | "AUDIENCE_NOT_MATCHING" | "BUDGET_EXCEEDED" | "NO_MEASURED_VIEWS")[] | undefined;
            creatorApplicationState?: string | undefined;
        };
        trackedLinkUrl?: string | undefined;
    };
};

/** get /v1/smm-prv/campaigns/:campaignId */
interface GetV1SmmPrvCampaignsCampaignIdPositiveResponseVariants {
    200: GetV1SmmPrvCampaignsCampaignIdPositiveVariant1;
}

/** get /v1/smm-prv/campaigns/:campaignId */
type GetV1SmmPrvCampaignsCampaignIdNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/smm-prv/campaigns/:campaignId */
interface GetV1SmmPrvCampaignsCampaignIdNegativeResponseVariants {
    400: GetV1SmmPrvCampaignsCampaignIdNegativeVariant1;
}

/** get /v1/smm-prv/creator-applications */
type GetV1SmmPrvCreatorApplicationsInput = {
    brandIds?: string | undefined;
    searchQuery?: string | undefined;
    applicationStatus?: ("all" | "counterOfferSent" | "pending" | "accepted" | "rejected" | "excluded" | "invited") | undefined;
    campaignStatus?: (("ACTIVE" | "PAUSED" | "FINISHED") | "all") | undefined;
    page?: number | undefined;
    size?: number | undefined;
};

/** get /v1/smm-prv/creator-applications */
type GetV1SmmPrvCreatorApplicationsPositiveVariant1 = {
    status: "success";
    data: {
        creatorApplications: {
            _id: string;
            uniquenessKey?: string | undefined;
            sideEffectOutboxVersion?: number | undefined;
            inviteSideEffectsEnqueuedAt?: string | undefined;
            price: number;
            cpm?: number | undefined;
            maxAmount?: number | undefined;
            state: "pending" | "accepted" | "rejected" | "excluded" | "invited";
            reason: string;
            rejectionReason?: string | undefined;
            exclusionReason?: string | undefined;
            isUserOfBrand: boolean;
            smmUserId: string;
            expectedAuthorLinkedinNumId?: string | undefined;
            linkedinIdentityFrozenAt?: string | undefined;
            createdAt: string;
            updatedAt: string;
            acceptedAt?: string | undefined;
            budgetReservedAt?: string | undefined;
            capacityExcludedAt?: string | undefined;
            lastPublishReminderAt?: string | undefined;
            publishReminderCount?: number | undefined;
            publishReminderExhausted?: boolean | undefined;
            changesRequestedAt?: string | undefined;
            changesRequestReason?: string | undefined;
            lastNegotiation?: {
                price: number;
                cpm?: number | undefined;
                maxAmount?: number | undefined;
                proposedBy: "creator" | "campaign";
                proposedAt: string;
                reason?: string | undefined;
            } | undefined;
            campaign: {
                _id: string;
                userId: string;
                brandId: string;
                name: string;
                description: string;
                status: "DRAFT" | "PENDING_PAYMENT" | "ACTIVE" | "PAUSED" | "FINISHED";
                paymentStatus: "PENDING" | "PAID" | "FAILED";
                paymentDeclineCode?: string | undefined;
                targets: {
                    minFollowers?: (number | null) | undefined;
                    minViews?: (number | null) | undefined;
                    minViewsLast28Days?: (number | null) | undefined;
                    language?: (string | null) | undefined;
                    audienceLocation?: string[] | undefined;
                    hierarchyLevel?: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | undefined;
                    industry?: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | undefined;
                    companySize?: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | undefined;
                    occupation?: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | undefined;
                };
                framing: {
                    startDate: string;
                    endDate?: string | undefined;
                    publicationStartDate?: string | undefined;
                    publicationEndDate?: string | undefined;
                    maxBudgetPerPost?: number | undefined;
                    cpm?: number | undefined;
                    totalBudget: number;
                    totalUsedBudget?: number | undefined;
                    autoValidateContent: boolean;
                    autoAcceptCreators: boolean;
                    autonomousCpmCeilingMultiplier?: (1 | 1.1 | 1.2) | undefined;
                    capMode?: ("auto" | "fixed") | undefined;
                    fixedCap?: number | undefined;
                };
                objective?: ("awareness" | "traffic" | "demos") | undefined;
                brief?: {
                    keyMessage?: string | undefined;
                    tones?: ("concrete" | "educational" | "personal" | "light_humour")[] | undefined;
                    do?: string[] | undefined;
                    avoid?: string[] | undefined;
                } | undefined;
                regions?: string[] | undefined;
                rules?: {
                    minTargetAudienceShare?: number | undefined;
                    askIfMostlyAbroad?: boolean | undefined;
                } | undefined;
                invitationTemplate?: string | undefined;
                sender?: {
                    kind: "own_profile" | "kawaak_managed";
                } | undefined;
                postAcceptanceMode?: ("agent_auto" | "review_24h" | "manual") | undefined;
                draftStep?: ("brand" | "proposal" | "budget" | "launch") | undefined;
                suggestedTargets?: {
                    label: string;
                    targets: {
                        minFollowers?: (number | null) | undefined;
                        minViews?: (number | null) | undefined;
                        minViewsLast28Days?: (number | null) | undefined;
                        language?: (string | null) | undefined;
                        audienceLocation?: string[] | undefined;
                        hierarchyLevel?: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | undefined;
                        industry?: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | undefined;
                        companySize?: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | undefined;
                        occupation?: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | undefined;
                    };
                    eligibleCount: number | null;
                    reason?: string | undefined;
                    audienceReached?: string[] | undefined;
                }[] | undefined;
                agentInstructions?: string[] | undefined;
                budgetReservationTrigger?: ("acceptance" | "post_submission") | undefined;
                nbPostsToReview: number;
                utmLink?: string | undefined;
                promoCode?: string | undefined;
                stripePaymentIntentId?: string | undefined;
                stripeInvoiceId?: string | undefined;
                stripeCheckoutSessionId?: string | undefined;
                stripeRefundId?: string | undefined;
                stripeCreditNoteId?: string | undefined;
                stripeDeferredClosePaymentIntentId?: string | undefined;
                stripeDeferredCloseInvoiceId?: string | undefined;
                paymentSnapshot?: {
                    source: "stripe_checkout" | "stripe_payment_intent" | "out_of_band";
                    currency: "eur" | "usd";
                    conversionRateFromEUR: number;
                    budgetAmountInCents: number;
                    platformFeeAmountInCents: number;
                    taxAmountInCents: number;
                    totalAmountInCents: number;
                    paidAt: string;
                    stripePaymentIntentId?: string | undefined;
                    stripeInvoiceId?: string | undefined;
                    stripeCheckoutSessionId?: string | undefined;
                    externalReference?: string | undefined;
                    outOfBandProof?: {
                        proofDocumentKey: string;
                        proofDocumentSha256: string;
                        proofDocumentEtag: string;
                        proofDocumentSizeBytes: number;
                        proofDocumentLastModified: string;
                        proofDocumentContentType: string;
                        proofDocumentVersionId?: string | undefined;
                        bankTransactionReference: string;
                        invoiceReference: string;
                        submittedAt: string;
                        submittedByStaffId: string;
                        approvedAt: string;
                        approvedByStaffId: string;
                    } | undefined;
                } | undefined;
                paymentAttempt?: {
                    attemptId: string;
                    version: number;
                    purpose: "INITIAL_DEPOSIT" | "DEFERRED_USAGE";
                    state: "creating" | "awaiting_payment" | "paid" | "failed" | "canceled";
                    currency: "eur" | "usd";
                    conversionRateFromEUR: number;
                    budgetAmountInCents: number;
                    platformFeeAmountInCents: number;
                    customerId: string;
                    createdAt: string;
                    updatedAt: string;
                    cardCheckout?: {
                        expiresAt: number;
                        successUrl: string;
                        cancelUrl: string;
                    } | undefined;
                    checkoutSessionId?: string | undefined;
                    stripeInvoiceId?: string | undefined;
                    stripePaymentIntentId?: string | undefined;
                    failureCode?: string | undefined;
                } | undefined;
                paymentAttemptHistory?: {
                    attemptId: string;
                    version: number;
                    purpose: "INITIAL_DEPOSIT" | "DEFERRED_USAGE";
                    state: "creating" | "awaiting_payment" | "paid" | "failed" | "canceled";
                    currency: "eur" | "usd";
                    conversionRateFromEUR: number;
                    budgetAmountInCents: number;
                    platformFeeAmountInCents: number;
                    customerId: string;
                    createdAt: string;
                    updatedAt: string;
                    cardCheckout?: {
                        expiresAt: number;
                        successUrl: string;
                        cancelUrl: string;
                    } | undefined;
                    checkoutSessionId?: string | undefined;
                    stripeInvoiceId?: string | undefined;
                    stripePaymentIntentId?: string | undefined;
                    failureCode?: string | undefined;
                }[] | undefined;
                paymentReconciliationIssues?: {
                    attemptId: string;
                    stripePaymentIntentId: string;
                    amountInCents: number;
                    currency: string;
                    reason: string;
                    detectedAt: string;
                }[] | undefined;
                financialClose?: {
                    state: "closing" | "awaiting_deferred_payment" | "manual_refund_required" | "manual_refund_awaiting_approval" | "manual_refund_confirmed" | "refund_pending" | "refund_failed";
                    requestedAt: string;
                    projectedUsedBudgetInEuros: number;
                    ownerId?: string | undefined;
                    leaseId?: string | undefined;
                    leaseExpiresAt?: string | undefined;
                    refundAmountInCents?: number | undefined;
                    currency?: ("eur" | "usd") | undefined;
                    error?: string | undefined;
                    refundFailedAlertedAt?: string | undefined;
                } | undefined;
                agent?: {
                    enabled: boolean;
                    autonomyLevel?: ("assisted" | "review" | "autonomous") | undefined;
                    pausedAt?: string | undefined;
                    autonomyStats?: {
                        firstMessagesSent?: number | undefined;
                        firstMessagesApprovedStreak?: number | undefined;
                        repliesSent?: number | undefined;
                        repliesApprovedStreak?: number | undefined;
                    } | undefined;
                    autonomyProposal?: {
                        status: "proposed" | "accepted" | "refused";
                        trigger: "first_messages_sent" | "first_messages_approved" | "replies_sent" | "replies_approved";
                        proposedAt: string;
                        refusals: number;
                        firstRefusedAt?: string | undefined;
                        nextProposalAt?: string | undefined;
                    } | undefined;
                    poolExhaustedAt?: {
                        in_app?: string | undefined;
                        linkedin?: string | undefined;
                    } | undefined;
                    linkedinSourcing?: {
                        nextRunAfter?: string | undefined;
                        lastRunAt?: string | undefined;
                        lastOutcome?: string | undefined;
                        keywords?: string[] | undefined;
                        searchKey?: string | undefined;
                        nextPage?: number | undefined;
                    } | undefined;
                } | undefined;
                payoutCreationLocks?: string[] | undefined;
                scheduledPayoutClaims?: string[] | undefined;
                refundedAt?: string | undefined;
                refundedBudgetInCents?: number | undefined;
                refundedFeeInCents?: number | undefined;
                refundedTaxInCents?: number | undefined;
                refundMethod?: ("stripe" | "manual") | undefined;
                manualRefundReference?: string | undefined;
                manualRefundedByStaffId?: string | undefined;
                manualRefundProof?: {
                    reference: string;
                    amountInCents: number;
                    currency: "eur" | "usd";
                    executedAt: string;
                    proofDocumentKey: string;
                    proofDocumentEtag: string;
                    proofDocumentSizeBytes: number;
                    proofDocumentLastModified: string;
                    proofDocumentContentType: string;
                    submittedAt: string;
                    submittedByStaffId: string;
                    confirmedAt?: string | undefined;
                    confirmedByStaffId?: string | undefined;
                } | undefined;
                depositedAt?: string | undefined;
                firstMessagesToAcceptedCreators?: ({
                    type: "text";
                    text: string;
                    priceEUR?: number | undefined;
                    cpmEUR?: number | undefined;
                } | {
                    type: "image";
                    src?: string | undefined;
                    metadata: {
                        name: string;
                        size: number;
                        type: string;
                        fileKey: string;
                    };
                } | {
                    type: "file";
                    src?: string | undefined;
                    metadata: {
                        name: string;
                        size: number;
                        type: string;
                        fileKey: string;
                    };
                })[] | undefined;
                closedByStaffAt?: string | undefined;
                deletedAt?: string | undefined;
                currencyConversion: {
                    currency: "USD";
                    rateFromEUR: number;
                    lockedAt: string;
                };
                initialBudgetQuote?: {
                    currency: "eur" | "usd";
                    budgetAmountInCents: number;
                    budgetAmountInEurCents: number;
                    conversionRateFromEUR: number;
                    quotedAt: string;
                } | undefined;
                budgetDepositStatus?: ("PENDING" | "DEPOSITED") | undefined;
                creatorsPaidByBrand?: boolean | undefined;
                createdAt?: string | undefined;
            };
            brand: {
                _id: string;
                name: string;
                websiteUrl?: string | undefined;
                country?: string | undefined;
                language?: string | undefined;
                description?: string | undefined;
                logoKey?: string | undefined;
                filesKeys?: string[] | undefined;
                keyFeatures?: string | undefined;
                linkedinUrl?: string | undefined;
                socialProofs?: ({
                    type: "metric";
                    value: number;
                    name: string;
                } | {
                    type: "rating";
                    rating: number;
                    maxRating?: number | undefined;
                    plateform: string;
                })[] | undefined;
                targetAudience?: {
                    occupations: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | null;
                    occupationSeniority: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | null;
                    companySize: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | null;
                    industries: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | null;
                    locations: string[] | null;
                } | undefined;
                targetCustomers?: string | undefined;
                analyzedAt?: string | undefined;
                logoSource?: string | undefined;
            };
            creator: {
                _id: string;
                smmUserId?: string | undefined;
                name?: string | undefined;
                givenName: string;
                familyName: string;
                linkedinId?: string | undefined;
                linkedinUrl?: string | undefined;
                title?: string | undefined;
                picture?: (string | null) | undefined;
                language?: string | undefined;
                avgViewsPerPost?: (number | null) | undefined;
                medianViewsPerPost?: (number | null) | undefined;
                followers?: number | undefined;
                membersReached?: number | undefined;
                sector?: string | undefined;
                pricePerPost?: (number | null) | undefined;
                defaultCap?: (number | null) | undefined;
                impressions?: ({
                    timeRange: "past_7_days" | "past_14_days" | "past_28_days" | "past_90_days" | "past_365_days" | "custom_timerange";
                    data: {
                        totalValue?: (number | null) | undefined;
                        percentageChange?: (number | null) | undefined;
                        series: {
                            value?: (number | null) | undefined;
                            date?: (string | null) | undefined;
                        }[];
                        impressions: {
                            value?: (string | null) | undefined;
                            percentageChange?: (number | null) | undefined;
                        };
                        reached: {
                            value?: (string | null) | undefined;
                            percentageChange?: (number | null) | undefined;
                        };
                        topPosts?: {
                            urn: string;
                            reactions?: (number | null) | undefined;
                            comments?: (number | null) | undefined;
                            shares?: (number | null) | undefined;
                            text?: string | undefined;
                            impressions?: string | undefined;
                            date?: string | undefined;
                        }[] | undefined;
                    };
                }[] | null) | undefined;
                followersDemographics?: ({
                    category: "occupation_title" | "location" | "industry" | "occupation_seniority" | "company_size" | "company_name";
                    data: {
                        label: string;
                        value: number;
                        normalizedLabel?: (string | null) | undefined;
                    }[];
                }[] | null) | undefined;
                updatedAt?: string | undefined;
                isPrivate?: boolean | undefined;
            };
            postForCampaign?: {
                _id: string;
                linkedinPostId?: string | undefined;
                scheduledDate?: string | undefined;
                sponsoredPostStatus?: ("pending_validation" | "validated" | "rejected") | undefined;
            } | undefined;
        }[];
    };
};

/** get /v1/smm-prv/creator-applications */
interface GetV1SmmPrvCreatorApplicationsPositiveResponseVariants {
    200: GetV1SmmPrvCreatorApplicationsPositiveVariant1;
}

/** get /v1/smm-prv/creator-applications */
type GetV1SmmPrvCreatorApplicationsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/smm-prv/creator-applications */
interface GetV1SmmPrvCreatorApplicationsNegativeResponseVariants {
    400: GetV1SmmPrvCreatorApplicationsNegativeVariant1;
}

/** put /v1/smm-prv/creator-applications */
type PutV1SmmPrvCreatorApplicationsInput = {
    applicationId: string;
    status: "accepted" | "rejected";
};

/** put /v1/smm-prv/creator-applications */
type PutV1SmmPrvCreatorApplicationsPositiveVariant1 = {
    status: "success";
    data: {
        application: {
            _id: string;
            uniquenessKey?: string | undefined;
            sideEffectOutboxVersion?: number | undefined;
            inviteSideEffectsEnqueuedAt?: string | undefined;
            price: number;
            cpm?: number | undefined;
            maxAmount?: number | undefined;
            campaignId: string;
            state: "pending" | "accepted" | "rejected" | "excluded" | "invited";
            reason: string;
            rejectionReason?: string | undefined;
            exclusionReason?: string | undefined;
            isUserOfBrand: boolean;
            creatorId: string;
            smmUserId: string;
            expectedAuthorLinkedinNumId?: string | undefined;
            linkedinIdentityFrozenAt?: string | undefined;
            brandId: string;
            createdAt: string;
            updatedAt: string;
            acceptedAt?: string | undefined;
            budgetReservedAt?: string | undefined;
            capacityExcludedAt?: string | undefined;
            lastPublishReminderAt?: string | undefined;
            publishReminderCount?: number | undefined;
            publishReminderExhausted?: boolean | undefined;
            changesRequestedAt?: string | undefined;
            changesRequestReason?: string | undefined;
            lastNegotiation?: {
                price: number;
                cpm?: number | undefined;
                maxAmount?: number | undefined;
                proposedBy: "creator" | "campaign";
                proposedAt: string;
                reason?: string | undefined;
            } | undefined;
        };
    };
};

/** put /v1/smm-prv/creator-applications */
interface PutV1SmmPrvCreatorApplicationsPositiveResponseVariants {
    200: PutV1SmmPrvCreatorApplicationsPositiveVariant1;
}

/** put /v1/smm-prv/creator-applications */
type PutV1SmmPrvCreatorApplicationsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** put /v1/smm-prv/creator-applications */
interface PutV1SmmPrvCreatorApplicationsNegativeResponseVariants {
    400: PutV1SmmPrvCreatorApplicationsNegativeVariant1;
}

/** get /v1/smm-prv/creator-applications/overview */
type GetV1SmmPrvCreatorApplicationsOverviewInput = {
    campaignStatus: "ACTIVE" | "PAUSED" | "FINISHED";
};

/** get /v1/smm-prv/creator-applications/overview */
type GetV1SmmPrvCreatorApplicationsOverviewPositiveVariant1 = {
    status: "success";
    data: {
        accepted: number;
        rejected: number;
        pending: number;
        invited: number;
        excluded: number;
        counterOfferSent: number;
        total: number;
    };
};

/** get /v1/smm-prv/creator-applications/overview */
interface GetV1SmmPrvCreatorApplicationsOverviewPositiveResponseVariants {
    200: GetV1SmmPrvCreatorApplicationsOverviewPositiveVariant1;
}

/** get /v1/smm-prv/creator-applications/overview */
type GetV1SmmPrvCreatorApplicationsOverviewNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/smm-prv/creator-applications/overview */
interface GetV1SmmPrvCreatorApplicationsOverviewNegativeResponseVariants {
    400: GetV1SmmPrvCreatorApplicationsOverviewNegativeVariant1;
}

/** get /v1/smm-prv/creator-applications/count */
type GetV1SmmPrvCreatorApplicationsCountInput = {
    after: string;
    before: string;
};

/** get /v1/smm-prv/creator-applications/count */
type GetV1SmmPrvCreatorApplicationsCountPositiveVariant1 = {
    status: "success";
    data: {
        sent: number;
        accepted: number;
    };
};

/** get /v1/smm-prv/creator-applications/count */
interface GetV1SmmPrvCreatorApplicationsCountPositiveResponseVariants {
    200: GetV1SmmPrvCreatorApplicationsCountPositiveVariant1;
}

/** get /v1/smm-prv/creator-applications/count */
type GetV1SmmPrvCreatorApplicationsCountNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/smm-prv/creator-applications/count */
interface GetV1SmmPrvCreatorApplicationsCountNegativeResponseVariants {
    400: GetV1SmmPrvCreatorApplicationsCountNegativeVariant1;
}

/** get /v1/smm-prv/creator-applications/has-any */
type GetV1SmmPrvCreatorApplicationsHasAnyInput = {};

/** get /v1/smm-prv/creator-applications/has-any */
type GetV1SmmPrvCreatorApplicationsHasAnyPositiveVariant1 = {
    status: "success";
    data: {
        hasAny: boolean;
    };
};

/** get /v1/smm-prv/creator-applications/has-any */
interface GetV1SmmPrvCreatorApplicationsHasAnyPositiveResponseVariants {
    200: GetV1SmmPrvCreatorApplicationsHasAnyPositiveVariant1;
}

/** get /v1/smm-prv/creator-applications/has-any */
type GetV1SmmPrvCreatorApplicationsHasAnyNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/smm-prv/creator-applications/has-any */
interface GetV1SmmPrvCreatorApplicationsHasAnyNegativeResponseVariants {
    400: GetV1SmmPrvCreatorApplicationsHasAnyNegativeVariant1;
}

/** get /v1/smm-prv/creator-applications/by-id/:creatorApplicationId */
type GetV1SmmPrvCreatorApplicationsByIdCreatorApplicationIdInput = {
    creatorApplicationId: string;
};

/** get /v1/smm-prv/creator-applications/by-id/:creatorApplicationId */
type GetV1SmmPrvCreatorApplicationsByIdCreatorApplicationIdPositiveVariant1 = {
    status: "success";
    data: {
        creatorApplication: {
            _id: string;
            uniquenessKey?: string | undefined;
            sideEffectOutboxVersion?: number | undefined;
            inviteSideEffectsEnqueuedAt?: string | undefined;
            price: number;
            cpm?: number | undefined;
            maxAmount?: number | undefined;
            state: "pending" | "accepted" | "rejected" | "excluded" | "invited";
            reason: string;
            rejectionReason?: string | undefined;
            exclusionReason?: string | undefined;
            isUserOfBrand: boolean;
            smmUserId: string;
            expectedAuthorLinkedinNumId?: string | undefined;
            linkedinIdentityFrozenAt?: string | undefined;
            createdAt: string;
            updatedAt: string;
            acceptedAt?: string | undefined;
            budgetReservedAt?: string | undefined;
            capacityExcludedAt?: string | undefined;
            lastPublishReminderAt?: string | undefined;
            publishReminderCount?: number | undefined;
            publishReminderExhausted?: boolean | undefined;
            changesRequestedAt?: string | undefined;
            changesRequestReason?: string | undefined;
            lastNegotiation?: {
                price: number;
                cpm?: number | undefined;
                maxAmount?: number | undefined;
                proposedBy: "creator" | "campaign";
                proposedAt: string;
                reason?: string | undefined;
            } | undefined;
            campaign: {
                _id: string;
                userId: string;
                brandId: string;
                name: string;
                description: string;
                status: "DRAFT" | "PENDING_PAYMENT" | "ACTIVE" | "PAUSED" | "FINISHED";
                paymentStatus: "PENDING" | "PAID" | "FAILED";
                paymentDeclineCode?: string | undefined;
                targets: {
                    minFollowers?: (number | null) | undefined;
                    minViews?: (number | null) | undefined;
                    minViewsLast28Days?: (number | null) | undefined;
                    language?: (string | null) | undefined;
                    audienceLocation?: string[] | undefined;
                    hierarchyLevel?: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | undefined;
                    industry?: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | undefined;
                    companySize?: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | undefined;
                    occupation?: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | undefined;
                };
                framing: {
                    startDate: string;
                    endDate?: string | undefined;
                    publicationStartDate?: string | undefined;
                    publicationEndDate?: string | undefined;
                    maxBudgetPerPost?: number | undefined;
                    cpm?: number | undefined;
                    totalBudget: number;
                    totalUsedBudget?: number | undefined;
                    autoValidateContent: boolean;
                    autoAcceptCreators: boolean;
                    autonomousCpmCeilingMultiplier?: (1 | 1.1 | 1.2) | undefined;
                    capMode?: ("auto" | "fixed") | undefined;
                    fixedCap?: number | undefined;
                };
                objective?: ("awareness" | "traffic" | "demos") | undefined;
                brief?: {
                    keyMessage?: string | undefined;
                    tones?: ("concrete" | "educational" | "personal" | "light_humour")[] | undefined;
                    do?: string[] | undefined;
                    avoid?: string[] | undefined;
                } | undefined;
                regions?: string[] | undefined;
                rules?: {
                    minTargetAudienceShare?: number | undefined;
                    askIfMostlyAbroad?: boolean | undefined;
                } | undefined;
                invitationTemplate?: string | undefined;
                sender?: {
                    kind: "own_profile" | "kawaak_managed";
                } | undefined;
                postAcceptanceMode?: ("agent_auto" | "review_24h" | "manual") | undefined;
                draftStep?: ("brand" | "proposal" | "budget" | "launch") | undefined;
                suggestedTargets?: {
                    label: string;
                    targets: {
                        minFollowers?: (number | null) | undefined;
                        minViews?: (number | null) | undefined;
                        minViewsLast28Days?: (number | null) | undefined;
                        language?: (string | null) | undefined;
                        audienceLocation?: string[] | undefined;
                        hierarchyLevel?: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | undefined;
                        industry?: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | undefined;
                        companySize?: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | undefined;
                        occupation?: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | undefined;
                    };
                    eligibleCount: number | null;
                    reason?: string | undefined;
                    audienceReached?: string[] | undefined;
                }[] | undefined;
                agentInstructions?: string[] | undefined;
                budgetReservationTrigger?: ("acceptance" | "post_submission") | undefined;
                nbPostsToReview: number;
                utmLink?: string | undefined;
                promoCode?: string | undefined;
                stripePaymentIntentId?: string | undefined;
                stripeInvoiceId?: string | undefined;
                stripeCheckoutSessionId?: string | undefined;
                stripeRefundId?: string | undefined;
                stripeCreditNoteId?: string | undefined;
                stripeDeferredClosePaymentIntentId?: string | undefined;
                stripeDeferredCloseInvoiceId?: string | undefined;
                paymentSnapshot?: {
                    source: "stripe_checkout" | "stripe_payment_intent" | "out_of_band";
                    currency: "eur" | "usd";
                    conversionRateFromEUR: number;
                    budgetAmountInCents: number;
                    platformFeeAmountInCents: number;
                    taxAmountInCents: number;
                    totalAmountInCents: number;
                    paidAt: string;
                    stripePaymentIntentId?: string | undefined;
                    stripeInvoiceId?: string | undefined;
                    stripeCheckoutSessionId?: string | undefined;
                    externalReference?: string | undefined;
                    outOfBandProof?: {
                        proofDocumentKey: string;
                        proofDocumentSha256: string;
                        proofDocumentEtag: string;
                        proofDocumentSizeBytes: number;
                        proofDocumentLastModified: string;
                        proofDocumentContentType: string;
                        proofDocumentVersionId?: string | undefined;
                        bankTransactionReference: string;
                        invoiceReference: string;
                        submittedAt: string;
                        submittedByStaffId: string;
                        approvedAt: string;
                        approvedByStaffId: string;
                    } | undefined;
                } | undefined;
                paymentAttempt?: {
                    attemptId: string;
                    version: number;
                    purpose: "INITIAL_DEPOSIT" | "DEFERRED_USAGE";
                    state: "creating" | "awaiting_payment" | "paid" | "failed" | "canceled";
                    currency: "eur" | "usd";
                    conversionRateFromEUR: number;
                    budgetAmountInCents: number;
                    platformFeeAmountInCents: number;
                    customerId: string;
                    createdAt: string;
                    updatedAt: string;
                    cardCheckout?: {
                        expiresAt: number;
                        successUrl: string;
                        cancelUrl: string;
                    } | undefined;
                    checkoutSessionId?: string | undefined;
                    stripeInvoiceId?: string | undefined;
                    stripePaymentIntentId?: string | undefined;
                    failureCode?: string | undefined;
                } | undefined;
                paymentAttemptHistory?: {
                    attemptId: string;
                    version: number;
                    purpose: "INITIAL_DEPOSIT" | "DEFERRED_USAGE";
                    state: "creating" | "awaiting_payment" | "paid" | "failed" | "canceled";
                    currency: "eur" | "usd";
                    conversionRateFromEUR: number;
                    budgetAmountInCents: number;
                    platformFeeAmountInCents: number;
                    customerId: string;
                    createdAt: string;
                    updatedAt: string;
                    cardCheckout?: {
                        expiresAt: number;
                        successUrl: string;
                        cancelUrl: string;
                    } | undefined;
                    checkoutSessionId?: string | undefined;
                    stripeInvoiceId?: string | undefined;
                    stripePaymentIntentId?: string | undefined;
                    failureCode?: string | undefined;
                }[] | undefined;
                paymentReconciliationIssues?: {
                    attemptId: string;
                    stripePaymentIntentId: string;
                    amountInCents: number;
                    currency: string;
                    reason: string;
                    detectedAt: string;
                }[] | undefined;
                financialClose?: {
                    state: "closing" | "awaiting_deferred_payment" | "manual_refund_required" | "manual_refund_awaiting_approval" | "manual_refund_confirmed" | "refund_pending" | "refund_failed";
                    requestedAt: string;
                    projectedUsedBudgetInEuros: number;
                    ownerId?: string | undefined;
                    leaseId?: string | undefined;
                    leaseExpiresAt?: string | undefined;
                    refundAmountInCents?: number | undefined;
                    currency?: ("eur" | "usd") | undefined;
                    error?: string | undefined;
                    refundFailedAlertedAt?: string | undefined;
                } | undefined;
                agent?: {
                    enabled: boolean;
                    autonomyLevel?: ("assisted" | "review" | "autonomous") | undefined;
                    pausedAt?: string | undefined;
                    autonomyStats?: {
                        firstMessagesSent?: number | undefined;
                        firstMessagesApprovedStreak?: number | undefined;
                        repliesSent?: number | undefined;
                        repliesApprovedStreak?: number | undefined;
                    } | undefined;
                    autonomyProposal?: {
                        status: "proposed" | "accepted" | "refused";
                        trigger: "first_messages_sent" | "first_messages_approved" | "replies_sent" | "replies_approved";
                        proposedAt: string;
                        refusals: number;
                        firstRefusedAt?: string | undefined;
                        nextProposalAt?: string | undefined;
                    } | undefined;
                    poolExhaustedAt?: {
                        in_app?: string | undefined;
                        linkedin?: string | undefined;
                    } | undefined;
                    linkedinSourcing?: {
                        nextRunAfter?: string | undefined;
                        lastRunAt?: string | undefined;
                        lastOutcome?: string | undefined;
                        keywords?: string[] | undefined;
                        searchKey?: string | undefined;
                        nextPage?: number | undefined;
                    } | undefined;
                } | undefined;
                payoutCreationLocks?: string[] | undefined;
                scheduledPayoutClaims?: string[] | undefined;
                refundedAt?: string | undefined;
                refundedBudgetInCents?: number | undefined;
                refundedFeeInCents?: number | undefined;
                refundedTaxInCents?: number | undefined;
                refundMethod?: ("stripe" | "manual") | undefined;
                manualRefundReference?: string | undefined;
                manualRefundedByStaffId?: string | undefined;
                manualRefundProof?: {
                    reference: string;
                    amountInCents: number;
                    currency: "eur" | "usd";
                    executedAt: string;
                    proofDocumentKey: string;
                    proofDocumentEtag: string;
                    proofDocumentSizeBytes: number;
                    proofDocumentLastModified: string;
                    proofDocumentContentType: string;
                    submittedAt: string;
                    submittedByStaffId: string;
                    confirmedAt?: string | undefined;
                    confirmedByStaffId?: string | undefined;
                } | undefined;
                depositedAt?: string | undefined;
                firstMessagesToAcceptedCreators?: ({
                    type: "text";
                    text: string;
                    priceEUR?: number | undefined;
                    cpmEUR?: number | undefined;
                } | {
                    type: "image";
                    src?: string | undefined;
                    metadata: {
                        name: string;
                        size: number;
                        type: string;
                        fileKey: string;
                    };
                } | {
                    type: "file";
                    src?: string | undefined;
                    metadata: {
                        name: string;
                        size: number;
                        type: string;
                        fileKey: string;
                    };
                })[] | undefined;
                closedByStaffAt?: string | undefined;
                deletedAt?: string | undefined;
                currencyConversion: {
                    currency: "USD";
                    rateFromEUR: number;
                    lockedAt: string;
                };
                initialBudgetQuote?: {
                    currency: "eur" | "usd";
                    budgetAmountInCents: number;
                    budgetAmountInEurCents: number;
                    conversionRateFromEUR: number;
                    quotedAt: string;
                } | undefined;
                budgetDepositStatus?: ("PENDING" | "DEPOSITED") | undefined;
                creatorsPaidByBrand?: boolean | undefined;
                createdAt?: string | undefined;
            };
            brand: {
                _id: string;
                name: string;
                websiteUrl?: string | undefined;
                country?: string | undefined;
                language?: string | undefined;
                description?: string | undefined;
                logoKey?: string | undefined;
                filesKeys?: string[] | undefined;
                keyFeatures?: string | undefined;
                linkedinUrl?: string | undefined;
                socialProofs?: ({
                    type: "metric";
                    value: number;
                    name: string;
                } | {
                    type: "rating";
                    rating: number;
                    maxRating?: number | undefined;
                    plateform: string;
                })[] | undefined;
                targetAudience?: {
                    occupations: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | null;
                    occupationSeniority: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | null;
                    companySize: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | null;
                    industries: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | null;
                    locations: string[] | null;
                } | undefined;
                targetCustomers?: string | undefined;
                analyzedAt?: string | undefined;
                logoSource?: string | undefined;
            };
            creator: {
                _id: string;
                smmUserId?: string | undefined;
                name?: string | undefined;
                givenName: string;
                familyName: string;
                linkedinId?: string | undefined;
                linkedinUrl?: string | undefined;
                title?: string | undefined;
                picture?: (string | null) | undefined;
                language?: string | undefined;
                avgViewsPerPost?: (number | null) | undefined;
                medianViewsPerPost?: (number | null) | undefined;
                followers?: number | undefined;
                membersReached?: number | undefined;
                sector?: string | undefined;
                pricePerPost?: (number | null) | undefined;
                defaultCap?: (number | null) | undefined;
                impressions?: ({
                    timeRange: "past_7_days" | "past_14_days" | "past_28_days" | "past_90_days" | "past_365_days" | "custom_timerange";
                    data: {
                        totalValue?: (number | null) | undefined;
                        percentageChange?: (number | null) | undefined;
                        series: {
                            value?: (number | null) | undefined;
                            date?: (string | null) | undefined;
                        }[];
                        impressions: {
                            value?: (string | null) | undefined;
                            percentageChange?: (number | null) | undefined;
                        };
                        reached: {
                            value?: (string | null) | undefined;
                            percentageChange?: (number | null) | undefined;
                        };
                        topPosts?: {
                            urn: string;
                            reactions?: (number | null) | undefined;
                            comments?: (number | null) | undefined;
                            shares?: (number | null) | undefined;
                            text?: string | undefined;
                            impressions?: string | undefined;
                            date?: string | undefined;
                        }[] | undefined;
                    };
                }[] | null) | undefined;
                followersDemographics?: ({
                    category: "occupation_title" | "location" | "industry" | "occupation_seniority" | "company_size" | "company_name";
                    data: {
                        label: string;
                        value: number;
                        normalizedLabel?: (string | null) | undefined;
                    }[];
                }[] | null) | undefined;
                updatedAt?: string | undefined;
                isPrivate?: boolean | undefined;
            };
            postForCampaign?: {
                _id: string;
                linkedinPostId?: string | undefined;
                scheduledDate?: string | undefined;
                sponsoredPostStatus?: ("pending_validation" | "validated" | "rejected") | undefined;
            } | undefined;
        };
    };
};

/** get /v1/smm-prv/creator-applications/by-id/:creatorApplicationId */
interface GetV1SmmPrvCreatorApplicationsByIdCreatorApplicationIdPositiveResponseVariants {
    200: GetV1SmmPrvCreatorApplicationsByIdCreatorApplicationIdPositiveVariant1;
}

/** get /v1/smm-prv/creator-applications/by-id/:creatorApplicationId */
type GetV1SmmPrvCreatorApplicationsByIdCreatorApplicationIdNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/smm-prv/creator-applications/by-id/:creatorApplicationId */
interface GetV1SmmPrvCreatorApplicationsByIdCreatorApplicationIdNegativeResponseVariants {
    400: GetV1SmmPrvCreatorApplicationsByIdCreatorApplicationIdNegativeVariant1;
}

/** get /v1/smm-prv/creator-applications/:campaignId */
type GetV1SmmPrvCreatorApplicationsCampaignIdInput = {
    campaignId: string;
};

/** get /v1/smm-prv/creator-applications/:campaignId */
type GetV1SmmPrvCreatorApplicationsCampaignIdPositiveVariant1 = {
    status: "success";
    data: {
        creatorApplication: {
            _id: string;
            uniquenessKey?: string | undefined;
            sideEffectOutboxVersion?: number | undefined;
            inviteSideEffectsEnqueuedAt?: string | undefined;
            price: number;
            cpm?: number | undefined;
            maxAmount?: number | undefined;
            campaignId: string;
            state: "pending" | "accepted" | "rejected" | "excluded" | "invited";
            reason: string;
            rejectionReason?: string | undefined;
            exclusionReason?: string | undefined;
            isUserOfBrand: boolean;
            creatorId: string;
            smmUserId: string;
            expectedAuthorLinkedinNumId?: string | undefined;
            linkedinIdentityFrozenAt?: string | undefined;
            brandId: string;
            createdAt: string;
            updatedAt: string;
            acceptedAt?: string | undefined;
            budgetReservedAt?: string | undefined;
            capacityExcludedAt?: string | undefined;
            lastPublishReminderAt?: string | undefined;
            publishReminderCount?: number | undefined;
            publishReminderExhausted?: boolean | undefined;
            changesRequestedAt?: string | undefined;
            changesRequestReason?: string | undefined;
            lastNegotiation?: {
                price: number;
                cpm?: number | undefined;
                maxAmount?: number | undefined;
                proposedBy: "creator" | "campaign";
                proposedAt: string;
                reason?: string | undefined;
            } | undefined;
        };
        campaign: {
            currencyConversion: {
                currency: "USD";
                rateFromEUR: number;
                lockedAt: string;
            };
            framing?: {
                maxBudgetPerPost?: number | undefined;
            } | undefined;
        };
    };
};

/** get /v1/smm-prv/creator-applications/:campaignId */
interface GetV1SmmPrvCreatorApplicationsCampaignIdPositiveResponseVariants {
    200: GetV1SmmPrvCreatorApplicationsCampaignIdPositiveVariant1;
}

/** get /v1/smm-prv/creator-applications/:campaignId */
type GetV1SmmPrvCreatorApplicationsCampaignIdNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/smm-prv/creator-applications/:campaignId */
interface GetV1SmmPrvCreatorApplicationsCampaignIdNegativeResponseVariants {
    400: GetV1SmmPrvCreatorApplicationsCampaignIdNegativeVariant1;
}

/** post /v1/smm-prv/creator-applications/negociate */
type PostV1SmmPrvCreatorApplicationsNegociateInput = {
    applicationIds: string[];
    campaignId: string;
    price: number;
    cpm?: number | undefined;
    maxAmount: number;
    reason?: string | undefined;
};

/** post /v1/smm-prv/creator-applications/negociate */
type PostV1SmmPrvCreatorApplicationsNegociatePositiveVariant1 = {
    status: "success";
    data: {
        applications: {
            _id: string;
            uniquenessKey?: string | undefined;
            sideEffectOutboxVersion?: number | undefined;
            inviteSideEffectsEnqueuedAt?: string | undefined;
            price: number;
            cpm?: number | undefined;
            maxAmount?: number | undefined;
            campaignId: string;
            state: "pending" | "accepted" | "rejected" | "excluded" | "invited";
            reason: string;
            rejectionReason?: string | undefined;
            exclusionReason?: string | undefined;
            isUserOfBrand: boolean;
            creatorId: string;
            smmUserId: string;
            expectedAuthorLinkedinNumId?: string | undefined;
            linkedinIdentityFrozenAt?: string | undefined;
            brandId: string;
            createdAt: string;
            updatedAt: string;
            acceptedAt?: string | undefined;
            budgetReservedAt?: string | undefined;
            capacityExcludedAt?: string | undefined;
            lastPublishReminderAt?: string | undefined;
            publishReminderCount?: number | undefined;
            publishReminderExhausted?: boolean | undefined;
            changesRequestedAt?: string | undefined;
            changesRequestReason?: string | undefined;
            lastNegotiation?: {
                price: number;
                cpm?: number | undefined;
                maxAmount?: number | undefined;
                proposedBy: "creator" | "campaign";
                proposedAt: string;
                reason?: string | undefined;
            } | undefined;
        }[];
    };
};

/** post /v1/smm-prv/creator-applications/negociate */
interface PostV1SmmPrvCreatorApplicationsNegociatePositiveResponseVariants {
    200: PostV1SmmPrvCreatorApplicationsNegociatePositiveVariant1;
}

/** post /v1/smm-prv/creator-applications/negociate */
type PostV1SmmPrvCreatorApplicationsNegociateNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/smm-prv/creator-applications/negociate */
interface PostV1SmmPrvCreatorApplicationsNegociateNegativeResponseVariants {
    400: PostV1SmmPrvCreatorApplicationsNegociateNegativeVariant1;
}

/** get /v1/smm-prv/brands/applied-to */
type GetV1SmmPrvBrandsAppliedToInput = {};

/** get /v1/smm-prv/brands/applied-to */
type GetV1SmmPrvBrandsAppliedToPositiveVariant1 = {
    status: "success";
    data: {
        brands: {
            _id: string;
            name: string;
            websiteUrl?: string | undefined;
            country?: string | undefined;
            language?: string | undefined;
            description?: string | undefined;
            logoKey?: string | undefined;
            filesKeys?: string[] | undefined;
            keyFeatures?: string | undefined;
            linkedinUrl?: string | undefined;
            socialProofs?: ({
                type: "metric";
                value: number;
                name: string;
            } | {
                type: "rating";
                rating: number;
                maxRating?: number | undefined;
                plateform: string;
            })[] | undefined;
            targetAudience?: {
                occupations: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | null;
                occupationSeniority: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | null;
                companySize: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | null;
                industries: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | null;
                locations: string[] | null;
            } | undefined;
            targetCustomers?: string | undefined;
            analyzedAt?: string | undefined;
            logoSource?: string | undefined;
        }[];
    };
};

/** get /v1/smm-prv/brands/applied-to */
interface GetV1SmmPrvBrandsAppliedToPositiveResponseVariants {
    200: GetV1SmmPrvBrandsAppliedToPositiveVariant1;
}

/** get /v1/smm-prv/brands/applied-to */
type GetV1SmmPrvBrandsAppliedToNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/smm-prv/brands/applied-to */
interface GetV1SmmPrvBrandsAppliedToNegativeResponseVariants {
    400: GetV1SmmPrvBrandsAppliedToNegativeVariant1;
}

/** get /v1/smm-prv/brands/:brandId */
type GetV1SmmPrvBrandsBrandIdInput = {
    brandId: string;
};

/** get /v1/smm-prv/brands/:brandId */
type GetV1SmmPrvBrandsBrandIdPositiveVariant1 = {
    status: "success";
    data: {
        brand: {
            _id: string;
            name: string;
            websiteUrl?: string | undefined;
            country?: string | undefined;
            language?: string | undefined;
            description?: string | undefined;
            logoKey?: string | undefined;
            filesKeys?: string[] | undefined;
            keyFeatures?: string | undefined;
            linkedinUrl?: string | undefined;
            socialProofs?: ({
                type: "metric";
                value: number;
                name: string;
            } | {
                type: "rating";
                rating: number;
                maxRating?: number | undefined;
                plateform: string;
            })[] | undefined;
            targetAudience?: {
                occupations: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | null;
                occupationSeniority: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | null;
                companySize: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | null;
                industries: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | null;
                locations: string[] | null;
            } | undefined;
            targetCustomers?: string | undefined;
            analyzedAt?: string | undefined;
            logoSource?: string | undefined;
            filesMetadatas?: {
                fileName: string;
                fileSizeBytes?: number | undefined;
                lastModified?: string | undefined;
            }[] | undefined;
        };
    };
};

/** get /v1/smm-prv/brands/:brandId */
interface GetV1SmmPrvBrandsBrandIdPositiveResponseVariants {
    200: GetV1SmmPrvBrandsBrandIdPositiveVariant1;
}

/** get /v1/smm-prv/brands/:brandId */
type GetV1SmmPrvBrandsBrandIdNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/smm-prv/brands/:brandId */
interface GetV1SmmPrvBrandsBrandIdNegativeResponseVariants {
    400: GetV1SmmPrvBrandsBrandIdNegativeVariant1;
}

/** get /v1/smm-prv/creators/me */
type GetV1SmmPrvCreatorsMeInput = {};

/** get /v1/smm-prv/creators/me */
type GetV1SmmPrvCreatorsMePositiveVariant1 = {
    status: "success";
    data: {
        creator: {
            _id: string;
            smmUserId?: string | undefined;
            name?: string | undefined;
            givenName: string;
            familyName: string;
            linkedinId?: string | undefined;
            linkedinUrl?: string | undefined;
            title?: string | undefined;
            picture?: (string | null) | undefined;
            language?: string | undefined;
            avgViewsPerPost?: (number | null) | undefined;
            medianViewsPerPost?: (number | null) | undefined;
            followers?: number | undefined;
            membersReached?: number | undefined;
            sector?: string | undefined;
            pricePerPost?: (number | null) | undefined;
            defaultCap?: (number | null) | undefined;
            impressions?: ({
                timeRange: "past_7_days" | "past_14_days" | "past_28_days" | "past_90_days" | "past_365_days" | "custom_timerange";
                data: {
                    totalValue?: (number | null) | undefined;
                    percentageChange?: (number | null) | undefined;
                    series: {
                        value?: (number | null) | undefined;
                        date?: (string | null) | undefined;
                    }[];
                    impressions: {
                        value?: (string | null) | undefined;
                        percentageChange?: (number | null) | undefined;
                    };
                    reached: {
                        value?: (string | null) | undefined;
                        percentageChange?: (number | null) | undefined;
                    };
                    topPosts?: {
                        urn: string;
                        reactions?: (number | null) | undefined;
                        comments?: (number | null) | undefined;
                        shares?: (number | null) | undefined;
                        text?: string | undefined;
                        impressions?: string | undefined;
                        date?: string | undefined;
                    }[] | undefined;
                };
            }[] | null) | undefined;
            followersDemographics?: ({
                category: "occupation_title" | "location" | "industry" | "occupation_seniority" | "company_size" | "company_name";
                data: {
                    label: string;
                    value: number;
                    normalizedLabel?: (string | null) | undefined;
                }[];
            }[] | null) | undefined;
            updatedAt?: string | undefined;
            isPrivate?: boolean | undefined;
        };
    };
};

/** get /v1/smm-prv/creators/me */
interface GetV1SmmPrvCreatorsMePositiveResponseVariants {
    200: GetV1SmmPrvCreatorsMePositiveVariant1;
}

/** get /v1/smm-prv/creators/me */
type GetV1SmmPrvCreatorsMeNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/smm-prv/creators/me */
interface GetV1SmmPrvCreatorsMeNegativeResponseVariants {
    400: GetV1SmmPrvCreatorsMeNegativeVariant1;
}

/** post /v1/smm-prv/creators/adopt-sourced */
type PostV1SmmPrvCreatorsAdoptSourcedInput = {
    token: string;
};

/** post /v1/smm-prv/creators/adopt-sourced */
type PostV1SmmPrvCreatorsAdoptSourcedPositiveVariant1 = {
    status: "success";
    data: {
        status: "adopted" | "already_adopted" | "adopted_by_another_account" | "account_has_creator" | "not_found";
    };
};

/** post /v1/smm-prv/creators/adopt-sourced */
interface PostV1SmmPrvCreatorsAdoptSourcedPositiveResponseVariants {
    200: PostV1SmmPrvCreatorsAdoptSourcedPositiveVariant1;
}

/** post /v1/smm-prv/creators/adopt-sourced */
type PostV1SmmPrvCreatorsAdoptSourcedNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/smm-prv/creators/adopt-sourced */
interface PostV1SmmPrvCreatorsAdoptSourcedNegativeResponseVariants {
    400: PostV1SmmPrvCreatorsAdoptSourcedNegativeVariant1;
}

/** post /v1/smm-prv/creators/populate */
type PostV1SmmPrvCreatorsPopulateInput = {};

/** post /v1/smm-prv/creators/populate */
type PostV1SmmPrvCreatorsPopulatePositiveVariant1 = {
    status: "success";
    data: {
        success: boolean;
    };
};

/** post /v1/smm-prv/creators/populate */
interface PostV1SmmPrvCreatorsPopulatePositiveResponseVariants {
    200: PostV1SmmPrvCreatorsPopulatePositiveVariant1;
}

/** post /v1/smm-prv/creators/populate */
type PostV1SmmPrvCreatorsPopulateNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/smm-prv/creators/populate */
interface PostV1SmmPrvCreatorsPopulateNegativeResponseVariants {
    400: PostV1SmmPrvCreatorsPopulateNegativeVariant1;
}

/** put /v1/smm-prv/creators/privacy */
type PutV1SmmPrvCreatorsPrivacyInput = {
    isPrivate: boolean;
};

/** put /v1/smm-prv/creators/privacy */
type PutV1SmmPrvCreatorsPrivacyPositiveVariant1 = {
    status: "success";
    data: {
        success: boolean;
    };
};

/** put /v1/smm-prv/creators/privacy */
interface PutV1SmmPrvCreatorsPrivacyPositiveResponseVariants {
    200: PutV1SmmPrvCreatorsPrivacyPositiveVariant1;
}

/** put /v1/smm-prv/creators/privacy */
type PutV1SmmPrvCreatorsPrivacyNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** put /v1/smm-prv/creators/privacy */
interface PutV1SmmPrvCreatorsPrivacyNegativeResponseVariants {
    400: PutV1SmmPrvCreatorsPrivacyNegativeVariant1;
}

/** get /v1/smm-prv/conversations */
type GetV1SmmPrvConversationsInput = {
    filters?: any | undefined;
    page?: number | undefined;
    size?: number | undefined;
};

/** get /v1/smm-prv/conversations */
type GetV1SmmPrvConversationsPositiveVariant1 = {
    status: "success";
    data: {
        conversations: {
            _id: string;
            brandInbox?: {
                pinned?: boolean | undefined;
                reminderAt?: (string | null) | undefined;
                needsReply?: boolean | undefined;
            } | undefined;
            smmUserId: string;
            brandId: string;
            campaignId: string;
            creatorId: string;
            applicationId: string;
            influenceUserId: string;
            hasUnreadMessages: boolean;
            needsReply?: boolean | undefined;
            lastMessage?: ({
                _id: string;
                idempotencyKey?: string | undefined;
                conversationId: string;
                authorId: string;
                type: "user";
                content: {
                    type: "text";
                    text: string;
                    priceEUR?: number | undefined;
                    cpmEUR?: number | undefined;
                } | {
                    type: "image";
                    src?: string | undefined;
                    metadata: {
                        name: string;
                        size: number;
                        type: string;
                        fileKey: string;
                    };
                } | {
                    type: "file";
                    src?: string | undefined;
                    metadata: {
                        name: string;
                        size: number;
                        type: string;
                        fileKey: string;
                    };
                };
                createdAt: string;
            } | {
                _id: string;
                idempotencyKey?: string | undefined;
                conversationId: string;
                type: "automatic";
                content: {
                    notificationType: "creator_offer_submitted";
                    price: number;
                    cpm?: number | undefined;
                    maxAmount?: number | undefined;
                } | {
                    notificationType: "creator_offer_accepted";
                    utmLink?: string | undefined;
                    promoCode?: string | undefined;
                    creatorsPaidByBrand?: boolean | undefined;
                } | {
                    notificationType: "creator_offer_rejected";
                    rejectionReason: string;
                } | {
                    notificationType: "creator_counter_offer";
                    price: number;
                    cpm?: number | undefined;
                    maxAmount?: number | undefined;
                    reason?: string | undefined;
                } | {
                    notificationType: "creator_excluded_from_campaign";
                    exclusionReason: string;
                } | {
                    notificationType: "campaign_offer_submitted";
                    price: number;
                    cpm?: number | undefined;
                    maxAmount?: number | undefined;
                } | {
                    notificationType: "campaign_offer_accepted";
                    utmLink?: string | undefined;
                    promoCode?: string | undefined;
                    creatorsPaidByBrand?: boolean | undefined;
                } | {
                    notificationType: "campaign_offer_rejected";
                } | {
                    notificationType: "campaign_counter_offer";
                    price: number;
                    cpm?: number | undefined;
                    maxAmount?: number | undefined;
                    reason?: string | undefined;
                } | {
                    notificationType: "post_to_review";
                    postId: string;
                    campaignId: string;
                } | {
                    notificationType: "post_scheduled";
                    postId: string;
                    campaignId: string;
                } | {
                    notificationType: "post_published";
                    postId: string;
                    linkedinPostId?: string | undefined;
                } | {
                    notificationType: "post_rejected";
                    postId: string;
                    campaignId: string;
                    rejectionReason: string;
                } | {
                    notificationType: "post_validated";
                    postId: string;
                    campaignId: string;
                } | {
                    notificationType: "post_comment_added";
                    postId: string;
                    campaignId: string;
                    commentId: string;
                } | {
                    notificationType: "post_comment_updated";
                    postId: string;
                    campaignId: string;
                    commentId: string;
                } | {
                    notificationType: "post_comment_removed";
                    postId: string;
                    campaignId: string;
                    commentId: string;
                } | {
                    notificationType: "post_attachment_added";
                    postId: string;
                    campaignId: string;
                    attachmentName: string;
                } | {
                    notificationType: "post_attachment_updated";
                    postId: string;
                    campaignId: string;
                    attachmentName: string;
                } | {
                    notificationType: "post_attachment_removed";
                    postId: string;
                    campaignId: string;
                    attachmentName: string;
                } | {
                    notificationType: "sponsored_post_payment_received";
                    linkedinPostId?: string | undefined;
                    campaignId: string;
                    campaignName: string;
                    amount: number;
                    currency?: ("EUR" | "USD") | undefined;
                } | {
                    notificationType: "sponsored_post_payment_failed";
                    linkedinPostId?: string | undefined;
                    campaignId: string;
                    campaignName: string;
                    amount: number;
                    currency?: ("EUR" | "USD") | undefined;
                } | {
                    notificationType: "campaign_closed";
                    campaignId: string;
                    campaignName: string;
                };
                createdAt: string;
            }) | undefined;
            participant: {
                id: string;
                type: "campaign" | "creator";
                avatarSrc: string;
                name: string;
                givenName?: string | undefined;
                familyName?: string | undefined;
            };
            currencyConversion: {
                currency: "USD";
                rateFromEUR: number;
                lockedAt: string;
            };
        }[];
        totalCount: number;
        hasMore: boolean;
    };
};

/** get /v1/smm-prv/conversations */
interface GetV1SmmPrvConversationsPositiveResponseVariants {
    200: GetV1SmmPrvConversationsPositiveVariant1;
}

/** get /v1/smm-prv/conversations */
type GetV1SmmPrvConversationsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/smm-prv/conversations */
interface GetV1SmmPrvConversationsNegativeResponseVariants {
    400: GetV1SmmPrvConversationsNegativeVariant1;
}

/** get /v1/smm-prv/conversations/unread-count */
type GetV1SmmPrvConversationsUnreadCountInput = {};

/** get /v1/smm-prv/conversations/unread-count */
type GetV1SmmPrvConversationsUnreadCountPositiveVariant1 = {
    status: "success";
    data: {
        count: number;
    };
};

/** get /v1/smm-prv/conversations/unread-count */
interface GetV1SmmPrvConversationsUnreadCountPositiveResponseVariants {
    200: GetV1SmmPrvConversationsUnreadCountPositiveVariant1;
}

/** get /v1/smm-prv/conversations/unread-count */
type GetV1SmmPrvConversationsUnreadCountNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/smm-prv/conversations/unread-count */
interface GetV1SmmPrvConversationsUnreadCountNegativeResponseVariants {
    400: GetV1SmmPrvConversationsUnreadCountNegativeVariant1;
}

/** post /v1/smm-prv/conversations/messages */
type PostV1SmmPrvConversationsMessagesInput = {
    data: {
        conversationId: string;
        content: {
            type: "text";
            text: string;
            priceEUR?: number | undefined;
            cpmEUR?: number | undefined;
        } | {
            type: "image";
            src?: string | undefined;
            metadata: {
                name: string;
                size: number;
                type: string;
                fileKey: string;
            };
        } | {
            type: "file";
            src?: string | undefined;
            metadata: {
                name: string;
                size: number;
                type: string;
                fileKey: string;
            };
        };
    };
};

/** post /v1/smm-prv/conversations/messages */
type PostV1SmmPrvConversationsMessagesPositiveVariant1 = {
    status: "success";
    data: {
        message: {
            _id: string;
            idempotencyKey?: string | undefined;
            conversationId: string;
            authorId: string;
            type: "user";
            content: {
                type: "text";
                text: string;
                priceEUR?: number | undefined;
                cpmEUR?: number | undefined;
            } | {
                type: "image";
                src?: string | undefined;
                metadata: {
                    name: string;
                    size: number;
                    type: string;
                    fileKey: string;
                };
            } | {
                type: "file";
                src?: string | undefined;
                metadata: {
                    name: string;
                    size: number;
                    type: string;
                    fileKey: string;
                };
            };
            createdAt: string;
        } | {
            _id: string;
            idempotencyKey?: string | undefined;
            conversationId: string;
            type: "automatic";
            content: {
                notificationType: "creator_offer_submitted";
                price: number;
                cpm?: number | undefined;
                maxAmount?: number | undefined;
            } | {
                notificationType: "creator_offer_accepted";
                utmLink?: string | undefined;
                promoCode?: string | undefined;
                creatorsPaidByBrand?: boolean | undefined;
            } | {
                notificationType: "creator_offer_rejected";
                rejectionReason: string;
            } | {
                notificationType: "creator_counter_offer";
                price: number;
                cpm?: number | undefined;
                maxAmount?: number | undefined;
                reason?: string | undefined;
            } | {
                notificationType: "creator_excluded_from_campaign";
                exclusionReason: string;
            } | {
                notificationType: "campaign_offer_submitted";
                price: number;
                cpm?: number | undefined;
                maxAmount?: number | undefined;
            } | {
                notificationType: "campaign_offer_accepted";
                utmLink?: string | undefined;
                promoCode?: string | undefined;
                creatorsPaidByBrand?: boolean | undefined;
            } | {
                notificationType: "campaign_offer_rejected";
            } | {
                notificationType: "campaign_counter_offer";
                price: number;
                cpm?: number | undefined;
                maxAmount?: number | undefined;
                reason?: string | undefined;
            } | {
                notificationType: "post_to_review";
                postId: string;
                campaignId: string;
            } | {
                notificationType: "post_scheduled";
                postId: string;
                campaignId: string;
            } | {
                notificationType: "post_published";
                postId: string;
                linkedinPostId?: string | undefined;
            } | {
                notificationType: "post_rejected";
                postId: string;
                campaignId: string;
                rejectionReason: string;
            } | {
                notificationType: "post_validated";
                postId: string;
                campaignId: string;
            } | {
                notificationType: "post_comment_added";
                postId: string;
                campaignId: string;
                commentId: string;
            } | {
                notificationType: "post_comment_updated";
                postId: string;
                campaignId: string;
                commentId: string;
            } | {
                notificationType: "post_comment_removed";
                postId: string;
                campaignId: string;
                commentId: string;
            } | {
                notificationType: "post_attachment_added";
                postId: string;
                campaignId: string;
                attachmentName: string;
            } | {
                notificationType: "post_attachment_updated";
                postId: string;
                campaignId: string;
                attachmentName: string;
            } | {
                notificationType: "post_attachment_removed";
                postId: string;
                campaignId: string;
                attachmentName: string;
            } | {
                notificationType: "sponsored_post_payment_received";
                linkedinPostId?: string | undefined;
                campaignId: string;
                campaignName: string;
                amount: number;
                currency?: ("EUR" | "USD") | undefined;
            } | {
                notificationType: "sponsored_post_payment_failed";
                linkedinPostId?: string | undefined;
                campaignId: string;
                campaignName: string;
                amount: number;
                currency?: ("EUR" | "USD") | undefined;
            } | {
                notificationType: "campaign_closed";
                campaignId: string;
                campaignName: string;
            };
            createdAt: string;
        };
    };
};

/** post /v1/smm-prv/conversations/messages */
interface PostV1SmmPrvConversationsMessagesPositiveResponseVariants {
    200: PostV1SmmPrvConversationsMessagesPositiveVariant1;
}

/** post /v1/smm-prv/conversations/messages */
type PostV1SmmPrvConversationsMessagesNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/smm-prv/conversations/messages */
interface PostV1SmmPrvConversationsMessagesNegativeResponseVariants {
    400: PostV1SmmPrvConversationsMessagesNegativeVariant1;
}

/** get /v1/smm-prv/conversations/:conversationId/messages */
type GetV1SmmPrvConversationsConversationIdMessagesInput = {
    conversationId: string;
    lastMessageId?: string | undefined;
    size?: number | undefined;
};

/** get /v1/smm-prv/conversations/:conversationId/messages */
type GetV1SmmPrvConversationsConversationIdMessagesPositiveVariant1 = {
    status: "success";
    data: any;
};

/** get /v1/smm-prv/conversations/:conversationId/messages */
interface GetV1SmmPrvConversationsConversationIdMessagesPositiveResponseVariants {
    200: GetV1SmmPrvConversationsConversationIdMessagesPositiveVariant1;
}

/** get /v1/smm-prv/conversations/:conversationId/messages */
type GetV1SmmPrvConversationsConversationIdMessagesNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/smm-prv/conversations/:conversationId/messages */
interface GetV1SmmPrvConversationsConversationIdMessagesNegativeResponseVariants {
    400: GetV1SmmPrvConversationsConversationIdMessagesNegativeVariant1;
}

/** put /v1/smm-prv/conversations/:conversationId/read */
type PutV1SmmPrvConversationsConversationIdReadInput = {
    conversationId: string;
};

/** put /v1/smm-prv/conversations/:conversationId/read */
type PutV1SmmPrvConversationsConversationIdReadPositiveVariant1 = {
    status: "success";
    data: {
        success: boolean;
        modifiedCount: number;
    };
};

/** put /v1/smm-prv/conversations/:conversationId/read */
interface PutV1SmmPrvConversationsConversationIdReadPositiveResponseVariants {
    200: PutV1SmmPrvConversationsConversationIdReadPositiveVariant1;
}

/** put /v1/smm-prv/conversations/:conversationId/read */
type PutV1SmmPrvConversationsConversationIdReadNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** put /v1/smm-prv/conversations/:conversationId/read */
interface PutV1SmmPrvConversationsConversationIdReadNegativeResponseVariants {
    400: PutV1SmmPrvConversationsConversationIdReadNegativeVariant1;
}

/** put /v1/smm-prv/conversations/:conversationId/unread */
type PutV1SmmPrvConversationsConversationIdUnreadInput = {
    conversationId: string;
};

/** put /v1/smm-prv/conversations/:conversationId/unread */
type PutV1SmmPrvConversationsConversationIdUnreadPositiveVariant1 = {
    status: "success";
    data: {
        success: boolean;
        modifiedCount: number;
    };
};

/** put /v1/smm-prv/conversations/:conversationId/unread */
interface PutV1SmmPrvConversationsConversationIdUnreadPositiveResponseVariants {
    200: PutV1SmmPrvConversationsConversationIdUnreadPositiveVariant1;
}

/** put /v1/smm-prv/conversations/:conversationId/unread */
type PutV1SmmPrvConversationsConversationIdUnreadNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** put /v1/smm-prv/conversations/:conversationId/unread */
interface PutV1SmmPrvConversationsConversationIdUnreadNegativeResponseVariants {
    400: PutV1SmmPrvConversationsConversationIdUnreadNegativeVariant1;
}

/** post /v1/smm-prv/conversations/:conversationId/upload */
type PostV1SmmPrvConversationsConversationIdUploadInput = {
    conversationId: string;
    file: any;
};

/** post /v1/smm-prv/conversations/:conversationId/upload */
type PostV1SmmPrvConversationsConversationIdUploadPositiveVariant1 = {
    status: "success";
    data: {
        message: {
            _id: string;
            idempotencyKey?: string | undefined;
            conversationId: string;
            authorId: string;
            type: "user";
            content: {
                type: "text";
                text: string;
                priceEUR?: number | undefined;
                cpmEUR?: number | undefined;
            } | {
                type: "image";
                src?: string | undefined;
                metadata: {
                    name: string;
                    size: number;
                    type: string;
                    fileKey: string;
                };
            } | {
                type: "file";
                src?: string | undefined;
                metadata: {
                    name: string;
                    size: number;
                    type: string;
                    fileKey: string;
                };
            };
            createdAt: string;
        } | {
            _id: string;
            idempotencyKey?: string | undefined;
            conversationId: string;
            type: "automatic";
            content: {
                notificationType: "creator_offer_submitted";
                price: number;
                cpm?: number | undefined;
                maxAmount?: number | undefined;
            } | {
                notificationType: "creator_offer_accepted";
                utmLink?: string | undefined;
                promoCode?: string | undefined;
                creatorsPaidByBrand?: boolean | undefined;
            } | {
                notificationType: "creator_offer_rejected";
                rejectionReason: string;
            } | {
                notificationType: "creator_counter_offer";
                price: number;
                cpm?: number | undefined;
                maxAmount?: number | undefined;
                reason?: string | undefined;
            } | {
                notificationType: "creator_excluded_from_campaign";
                exclusionReason: string;
            } | {
                notificationType: "campaign_offer_submitted";
                price: number;
                cpm?: number | undefined;
                maxAmount?: number | undefined;
            } | {
                notificationType: "campaign_offer_accepted";
                utmLink?: string | undefined;
                promoCode?: string | undefined;
                creatorsPaidByBrand?: boolean | undefined;
            } | {
                notificationType: "campaign_offer_rejected";
            } | {
                notificationType: "campaign_counter_offer";
                price: number;
                cpm?: number | undefined;
                maxAmount?: number | undefined;
                reason?: string | undefined;
            } | {
                notificationType: "post_to_review";
                postId: string;
                campaignId: string;
            } | {
                notificationType: "post_scheduled";
                postId: string;
                campaignId: string;
            } | {
                notificationType: "post_published";
                postId: string;
                linkedinPostId?: string | undefined;
            } | {
                notificationType: "post_rejected";
                postId: string;
                campaignId: string;
                rejectionReason: string;
            } | {
                notificationType: "post_validated";
                postId: string;
                campaignId: string;
            } | {
                notificationType: "post_comment_added";
                postId: string;
                campaignId: string;
                commentId: string;
            } | {
                notificationType: "post_comment_updated";
                postId: string;
                campaignId: string;
                commentId: string;
            } | {
                notificationType: "post_comment_removed";
                postId: string;
                campaignId: string;
                commentId: string;
            } | {
                notificationType: "post_attachment_added";
                postId: string;
                campaignId: string;
                attachmentName: string;
            } | {
                notificationType: "post_attachment_updated";
                postId: string;
                campaignId: string;
                attachmentName: string;
            } | {
                notificationType: "post_attachment_removed";
                postId: string;
                campaignId: string;
                attachmentName: string;
            } | {
                notificationType: "sponsored_post_payment_received";
                linkedinPostId?: string | undefined;
                campaignId: string;
                campaignName: string;
                amount: number;
                currency?: ("EUR" | "USD") | undefined;
            } | {
                notificationType: "sponsored_post_payment_failed";
                linkedinPostId?: string | undefined;
                campaignId: string;
                campaignName: string;
                amount: number;
                currency?: ("EUR" | "USD") | undefined;
            } | {
                notificationType: "campaign_closed";
                campaignId: string;
                campaignName: string;
            };
            createdAt: string;
        };
        fileKey: string;
    };
};

/** post /v1/smm-prv/conversations/:conversationId/upload */
interface PostV1SmmPrvConversationsConversationIdUploadPositiveResponseVariants {
    200: PostV1SmmPrvConversationsConversationIdUploadPositiveVariant1;
}

/** post /v1/smm-prv/conversations/:conversationId/upload */
type PostV1SmmPrvConversationsConversationIdUploadNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/smm-prv/conversations/:conversationId/upload */
interface PostV1SmmPrvConversationsConversationIdUploadNegativeResponseVariants {
    400: PostV1SmmPrvConversationsConversationIdUploadNegativeVariant1;
}

/** get /v1/smm-prv/nps */
type GetV1SmmPrvNpsInput = {};

/** get /v1/smm-prv/nps */
type GetV1SmmPrvNpsPositiveVariant1 = {
    status: "success";
    data: {
        npsRating?: {
            rating: number;
            comment?: string | undefined;
            _id: string;
            source: "smm" | "influence";
            userId: string;
            month: string;
            email?: string | undefined;
            name?: string | undefined;
            createdAt: string;
            updatedAt: string;
        } | undefined;
    };
};

/** get /v1/smm-prv/nps */
interface GetV1SmmPrvNpsPositiveResponseVariants {
    200: GetV1SmmPrvNpsPositiveVariant1;
}

/** get /v1/smm-prv/nps */
type GetV1SmmPrvNpsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/smm-prv/nps */
interface GetV1SmmPrvNpsNegativeResponseVariants {
    400: GetV1SmmPrvNpsNegativeVariant1;
}

/** post /v1/smm-prv/nps */
type PostV1SmmPrvNpsInput = {
    rating: number;
    comment?: string | undefined;
};

/** post /v1/smm-prv/nps */
type PostV1SmmPrvNpsPositiveVariant1 = {
    status: "success";
    data: {
        npsRating: {
            rating: number;
            comment?: string | undefined;
            _id: string;
            source: "smm" | "influence";
            userId: string;
            month: string;
            email?: string | undefined;
            name?: string | undefined;
            createdAt: string;
            updatedAt: string;
        };
    };
};

/** post /v1/smm-prv/nps */
interface PostV1SmmPrvNpsPositiveResponseVariants {
    200: PostV1SmmPrvNpsPositiveVariant1;
}

/** post /v1/smm-prv/nps */
type PostV1SmmPrvNpsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/smm-prv/nps */
interface PostV1SmmPrvNpsNegativeResponseVariants {
    400: PostV1SmmPrvNpsNegativeVariant1;
}

/** get /v1/smm-prv/payments/payouts */
type GetV1SmmPrvPaymentsPayoutsInput = {
    size?: number | undefined;
    page?: number | undefined;
};

/** get /v1/smm-prv/payments/payouts */
type GetV1SmmPrvPaymentsPayoutsPositiveVariant1 = {
    status: "success";
    data: {
        payouts: {
            post?: {
                userId: string;
                content: string;
                scheduledDate?: string | undefined;
                linkedinPostId?: string | undefined;
                changes?: {
                    id: number;
                    old: string;
                    new: string;
                }[] | undefined;
                publishDate?: string | undefined;
                publicationFailedAt?: string | undefined;
                publicationFailureReason?: string | undefined;
                index?: number | undefined;
                saved?: boolean | undefined;
                campaignId?: string | undefined;
                sponsoredApplicationId?: string | undefined;
                sponsoredPayoutScheduleToken?: string | undefined;
                sponsoredPayoutScheduleClaimedAt?: string | undefined;
                sponsoredPayoutUnscheduleToken?: string | undefined;
                sponsoredPayoutCancellationConfirmedToken?: string | undefined;
                sponsoredPayoutPublicationToken?: string | undefined;
                sponsoredPayoutPublicationClaimedAt?: string | undefined;
                sponsoredPayoutClaimRecovery?: {
                    token: string;
                    kind: "publication" | "scheduling";
                    recoveredAt: string;
                    campaignId: string;
                    applicationId: string;
                } | undefined;
                sponsoredPayoutClaimTimestampBackfill?: {
                    token: string;
                    kind: "publication" | "scheduling";
                    backfilledAt: string;
                    source: "reconciler_quarantine";
                } | undefined;
                externalPublicationIntent?: {
                    token: string;
                    intent: "publication" | "scheduling";
                    claimedAt: string;
                } | undefined;
                externalPublicationIntentResolution?: {
                    token: string;
                    outcome: "not_published" | "published" | "scheduled";
                    resolvedAt: string;
                    resolvedBy: string;
                    evidence: string;
                    linkedinPostId?: string | undefined;
                    publishDate?: string | undefined;
                    resourceKey?: string | undefined;
                    scheduledDate?: string | undefined;
                } | undefined;
                scheduledJobId?: string | undefined;
                sponsoredDeletionToken?: string | undefined;
                boost?: ("10_likes" | "25_likes" | "50_likes") | undefined;
                boosted?: boolean | undefined;
                boostDeliveryStatus?: ("delivered" | "failed") | undefined;
                resourceKey?: string | undefined;
                sponsoredPostStatus?: ("pending_validation" | "validated" | "rejected") | undefined;
                campaignExclusion?: {
                    campaignId: string;
                    applicationId: string;
                    excludedAt: string;
                    sponsoredPostStatus?: ("pending_validation" | "validated" | "rejected") | undefined;
                    scheduledDate?: string | undefined;
                    resourceKey?: string | undefined;
                    boost?: ("10_likes" | "25_likes" | "50_likes") | undefined;
                } | undefined;
                sponsoredReviewRevision?: number | undefined;
                autoAcceptAt?: string | undefined;
                modifiedSinceRejection?: boolean | undefined;
                comments?: {
                    id: string;
                    text: string;
                    mentions?: {
                        name: string;
                        trackingUrn: string;
                        entityUrn: string;
                        url: string;
                        picture?: string | undefined;
                        headline?: string | undefined;
                    }[] | undefined;
                    attachments?: {
                        name: string;
                        displayName?: string | undefined;
                        type: string;
                        size: number;
                        link?: string | undefined;
                    }[] | undefined;
                }[] | undefined;
                sponsoredCommentDeliveries?: {
                    commentId: string;
                    linkedinCommentUrn: string;
                    deliveredAt: string;
                }[] | undefined;
                origin?: {
                    source: string;
                    refId?: string | undefined;
                } | undefined;
                tagIds?: string[] | undefined;
                _id: string;
            } | undefined;
            campaign: {
                _id: string;
                userId: string;
                brandId: string;
                name: string;
                description: string;
                status: "DRAFT" | "PENDING_PAYMENT" | "ACTIVE" | "PAUSED" | "FINISHED";
                paymentStatus: "PENDING" | "PAID" | "FAILED";
                paymentDeclineCode?: string | undefined;
                targets: {
                    minFollowers?: (number | null) | undefined;
                    minViews?: (number | null) | undefined;
                    minViewsLast28Days?: (number | null) | undefined;
                    language?: (string | null) | undefined;
                    audienceLocation?: string[] | undefined;
                    hierarchyLevel?: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | undefined;
                    industry?: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | undefined;
                    companySize?: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | undefined;
                    occupation?: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | undefined;
                };
                framing: {
                    startDate: string;
                    endDate?: string | undefined;
                    publicationStartDate?: string | undefined;
                    publicationEndDate?: string | undefined;
                    maxBudgetPerPost?: number | undefined;
                    cpm?: number | undefined;
                    totalBudget: number;
                    totalUsedBudget?: number | undefined;
                    autoValidateContent: boolean;
                    autoAcceptCreators: boolean;
                    autonomousCpmCeilingMultiplier?: (1 | 1.1 | 1.2) | undefined;
                    capMode?: ("auto" | "fixed") | undefined;
                    fixedCap?: number | undefined;
                };
                objective?: ("awareness" | "traffic" | "demos") | undefined;
                brief?: {
                    keyMessage?: string | undefined;
                    tones?: ("concrete" | "educational" | "personal" | "light_humour")[] | undefined;
                    do?: string[] | undefined;
                    avoid?: string[] | undefined;
                } | undefined;
                regions?: string[] | undefined;
                rules?: {
                    minTargetAudienceShare?: number | undefined;
                    askIfMostlyAbroad?: boolean | undefined;
                } | undefined;
                invitationTemplate?: string | undefined;
                sender?: {
                    kind: "own_profile" | "kawaak_managed";
                } | undefined;
                postAcceptanceMode?: ("agent_auto" | "review_24h" | "manual") | undefined;
                draftStep?: ("brand" | "proposal" | "budget" | "launch") | undefined;
                suggestedTargets?: {
                    label: string;
                    targets: {
                        minFollowers?: (number | null) | undefined;
                        minViews?: (number | null) | undefined;
                        minViewsLast28Days?: (number | null) | undefined;
                        language?: (string | null) | undefined;
                        audienceLocation?: string[] | undefined;
                        hierarchyLevel?: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | undefined;
                        industry?: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | undefined;
                        companySize?: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | undefined;
                        occupation?: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | undefined;
                    };
                    eligibleCount: number | null;
                    reason?: string | undefined;
                    audienceReached?: string[] | undefined;
                }[] | undefined;
                agentInstructions?: string[] | undefined;
                budgetReservationTrigger?: ("acceptance" | "post_submission") | undefined;
                nbPostsToReview: number;
                utmLink?: string | undefined;
                promoCode?: string | undefined;
                stripePaymentIntentId?: string | undefined;
                stripeInvoiceId?: string | undefined;
                stripeCheckoutSessionId?: string | undefined;
                stripeRefundId?: string | undefined;
                stripeCreditNoteId?: string | undefined;
                stripeDeferredClosePaymentIntentId?: string | undefined;
                stripeDeferredCloseInvoiceId?: string | undefined;
                paymentSnapshot?: {
                    source: "stripe_checkout" | "stripe_payment_intent" | "out_of_band";
                    currency: "eur" | "usd";
                    conversionRateFromEUR: number;
                    budgetAmountInCents: number;
                    platformFeeAmountInCents: number;
                    taxAmountInCents: number;
                    totalAmountInCents: number;
                    paidAt: string;
                    stripePaymentIntentId?: string | undefined;
                    stripeInvoiceId?: string | undefined;
                    stripeCheckoutSessionId?: string | undefined;
                    externalReference?: string | undefined;
                    outOfBandProof?: {
                        proofDocumentKey: string;
                        proofDocumentSha256: string;
                        proofDocumentEtag: string;
                        proofDocumentSizeBytes: number;
                        proofDocumentLastModified: string;
                        proofDocumentContentType: string;
                        proofDocumentVersionId?: string | undefined;
                        bankTransactionReference: string;
                        invoiceReference: string;
                        submittedAt: string;
                        submittedByStaffId: string;
                        approvedAt: string;
                        approvedByStaffId: string;
                    } | undefined;
                } | undefined;
                paymentAttempt?: {
                    attemptId: string;
                    version: number;
                    purpose: "INITIAL_DEPOSIT" | "DEFERRED_USAGE";
                    state: "creating" | "awaiting_payment" | "paid" | "failed" | "canceled";
                    currency: "eur" | "usd";
                    conversionRateFromEUR: number;
                    budgetAmountInCents: number;
                    platformFeeAmountInCents: number;
                    customerId: string;
                    createdAt: string;
                    updatedAt: string;
                    cardCheckout?: {
                        expiresAt: number;
                        successUrl: string;
                        cancelUrl: string;
                    } | undefined;
                    checkoutSessionId?: string | undefined;
                    stripeInvoiceId?: string | undefined;
                    stripePaymentIntentId?: string | undefined;
                    failureCode?: string | undefined;
                } | undefined;
                paymentAttemptHistory?: {
                    attemptId: string;
                    version: number;
                    purpose: "INITIAL_DEPOSIT" | "DEFERRED_USAGE";
                    state: "creating" | "awaiting_payment" | "paid" | "failed" | "canceled";
                    currency: "eur" | "usd";
                    conversionRateFromEUR: number;
                    budgetAmountInCents: number;
                    platformFeeAmountInCents: number;
                    customerId: string;
                    createdAt: string;
                    updatedAt: string;
                    cardCheckout?: {
                        expiresAt: number;
                        successUrl: string;
                        cancelUrl: string;
                    } | undefined;
                    checkoutSessionId?: string | undefined;
                    stripeInvoiceId?: string | undefined;
                    stripePaymentIntentId?: string | undefined;
                    failureCode?: string | undefined;
                }[] | undefined;
                paymentReconciliationIssues?: {
                    attemptId: string;
                    stripePaymentIntentId: string;
                    amountInCents: number;
                    currency: string;
                    reason: string;
                    detectedAt: string;
                }[] | undefined;
                financialClose?: {
                    state: "closing" | "awaiting_deferred_payment" | "manual_refund_required" | "manual_refund_awaiting_approval" | "manual_refund_confirmed" | "refund_pending" | "refund_failed";
                    requestedAt: string;
                    projectedUsedBudgetInEuros: number;
                    ownerId?: string | undefined;
                    leaseId?: string | undefined;
                    leaseExpiresAt?: string | undefined;
                    refundAmountInCents?: number | undefined;
                    currency?: ("eur" | "usd") | undefined;
                    error?: string | undefined;
                    refundFailedAlertedAt?: string | undefined;
                } | undefined;
                agent?: {
                    enabled: boolean;
                    autonomyLevel?: ("assisted" | "review" | "autonomous") | undefined;
                    pausedAt?: string | undefined;
                    autonomyStats?: {
                        firstMessagesSent?: number | undefined;
                        firstMessagesApprovedStreak?: number | undefined;
                        repliesSent?: number | undefined;
                        repliesApprovedStreak?: number | undefined;
                    } | undefined;
                    autonomyProposal?: {
                        status: "proposed" | "accepted" | "refused";
                        trigger: "first_messages_sent" | "first_messages_approved" | "replies_sent" | "replies_approved";
                        proposedAt: string;
                        refusals: number;
                        firstRefusedAt?: string | undefined;
                        nextProposalAt?: string | undefined;
                    } | undefined;
                    poolExhaustedAt?: {
                        in_app?: string | undefined;
                        linkedin?: string | undefined;
                    } | undefined;
                    linkedinSourcing?: {
                        nextRunAfter?: string | undefined;
                        lastRunAt?: string | undefined;
                        lastOutcome?: string | undefined;
                        keywords?: string[] | undefined;
                        searchKey?: string | undefined;
                        nextPage?: number | undefined;
                    } | undefined;
                } | undefined;
                payoutCreationLocks?: string[] | undefined;
                scheduledPayoutClaims?: string[] | undefined;
                refundedAt?: string | undefined;
                refundedBudgetInCents?: number | undefined;
                refundedFeeInCents?: number | undefined;
                refundedTaxInCents?: number | undefined;
                refundMethod?: ("stripe" | "manual") | undefined;
                manualRefundReference?: string | undefined;
                manualRefundedByStaffId?: string | undefined;
                manualRefundProof?: {
                    reference: string;
                    amountInCents: number;
                    currency: "eur" | "usd";
                    executedAt: string;
                    proofDocumentKey: string;
                    proofDocumentEtag: string;
                    proofDocumentSizeBytes: number;
                    proofDocumentLastModified: string;
                    proofDocumentContentType: string;
                    submittedAt: string;
                    submittedByStaffId: string;
                    confirmedAt?: string | undefined;
                    confirmedByStaffId?: string | undefined;
                } | undefined;
                depositedAt?: string | undefined;
                firstMessagesToAcceptedCreators?: ({
                    type: "text";
                    text: string;
                    priceEUR?: number | undefined;
                    cpmEUR?: number | undefined;
                } | {
                    type: "image";
                    src?: string | undefined;
                    metadata: {
                        name: string;
                        size: number;
                        type: string;
                        fileKey: string;
                    };
                } | {
                    type: "file";
                    src?: string | undefined;
                    metadata: {
                        name: string;
                        size: number;
                        type: string;
                        fileKey: string;
                    };
                })[] | undefined;
                closedByStaffAt?: string | undefined;
                deletedAt?: string | undefined;
                currencyConversion: {
                    currency: "USD";
                    rateFromEUR: number;
                    lockedAt: string;
                };
                initialBudgetQuote?: {
                    currency: "eur" | "usd";
                    budgetAmountInCents: number;
                    budgetAmountInEurCents: number;
                    conversionRateFromEUR: number;
                    quotedAt: string;
                } | undefined;
                budgetDepositStatus?: ("PENDING" | "DEPOSITED") | undefined;
                creatorsPaidByBrand?: boolean | undefined;
                createdAt?: string | undefined;
            };
            payout: ({
                campaignId: string;
                applicationId?: string | undefined;
                uniquenessKey?: string | undefined;
                date: string;
                amount: number;
                platformFeeAmount?: number | undefined;
                platformFeeRate?: number | undefined;
                postId: string;
                publishedAt?: string | undefined;
                smmUserId: string;
                creatorId: string;
                brandId: string;
                publicationCommitment?: {
                    token: string;
                    mode: "server" | "server_schedule" | "extension" | "voyager_schedule";
                    state: "prepared" | "publishing" | "updating" | "external_confirmed" | "external_rejected" | "reconciliation_required";
                    preparedAt: string;
                    publishingAt?: string | undefined;
                    expectedPublishedAt?: string | undefined;
                    pendingExpectedPublishedAt?: string | undefined;
                    resourceKey?: string | undefined;
                    confirmedLinkedinPostId?: string | undefined;
                    confirmedAt?: string | undefined;
                    rejectedAt?: string | undefined;
                    contentFingerprint: string;
                    expectedAuthorLinkedinNumId?: string | undefined;
                    expectedMedia?: ({
                        kind: "none";
                    } | {
                        kind: "document";
                        title: string;
                        assetUrn?: string | undefined;
                    } | {
                        kind: "image";
                        assetUrn?: string | undefined;
                    } | {
                        kind: "video";
                        assetUrn?: string | undefined;
                    }) | undefined;
                    frozenTerms: {
                        model: "fixed";
                        amount: number;
                        platformFeeRate: number;
                        currency: "EUR" | "USD";
                        currencyConversion: {
                            currency: "USD";
                            rateFromEUR: number;
                            lockedAt: string;
                        };
                    } | {
                        model: "cpm";
                        cpm: number;
                        cap: number;
                        platformFeeRate: number;
                        currency: "EUR" | "USD";
                        currencyConversion: {
                            currency: "USD";
                            rateFromEUR: number;
                            lockedAt: string;
                        };
                    };
                } | undefined;
                publicationIntegritySnapshot?: {
                    commitmentToken: string;
                    approvedAt: string;
                    contentFingerprint: string;
                    expectedMedia: {
                        kind: "none";
                    } | {
                        kind: "document";
                        title: string;
                        assetUrn: string;
                    } | {
                        kind: "image";
                        assetUrn: string;
                    } | {
                        kind: "video";
                        assetUrn: string;
                    };
                    expectedAuthorLinkedinNumId?: string | undefined;
                    verifiedPostShareUrn: string;
                } | undefined;
                pricingSnapshot?: ({
                    model: "fixed";
                    applicationId: string;
                    amount: number;
                    platformFeeRate: number;
                    currency: "EUR" | "USD";
                    currencyConversion: {
                        currency: "USD";
                        rateFromEUR: number;
                        lockedAt: string;
                    };
                    publishedAt: string;
                    paymentBatchDate: string;
                } | {
                    model: "cpm";
                    applicationId: string;
                    cpm: number;
                    cap: number;
                    platformFeeRate: number;
                    currency: "EUR" | "USD";
                    currencyConversion: {
                        currency: "USD";
                        rateFromEUR: number;
                        lockedAt: string;
                    };
                    publishedAt: string;
                    settlementDate: string;
                    paymentBatchDate: string;
                    settlementScheduleVersion?: "utc_elapsed_14d_v1" | undefined;
                }) | undefined;
                paypalPayout?: {
                    payout_item_status?: ("DENIED" | "PENDING" | "UNCLAIMED" | "PROCESSING" | "SUCCESS" | "CANCELED" | "FAILED" | "HELD" | "REFUNDED" | "BLOCKED" | "RETURNED") | undefined;
                    payout_batch_status: "PENDING" | "PROCESSING" | "SUCCESS" | "DENIED";
                    payout_batch_id: string;
                    payout_item_id?: string | undefined;
                    payout_initiated_at: string;
                } | undefined;
                cpm?: number | undefined;
                cap?: number | undefined;
                impressionsAtSettlement?: number | undefined;
                settledAt?: string | undefined;
                impressionsMeasurementRequiredAfter?: string | undefined;
                budgetReconciliationPendingAt?: string | undefined;
                budgetReconciledAt?: string | undefined;
                paidAt?: string | undefined;
                paidByStaffId?: string | undefined;
                paymentBatchReference?: string | undefined;
                paymentRail?: ("SEPA" | "INTERNATIONAL") | undefined;
                paymentNotificationEventKey?: string | undefined;
                paymentNotificationState?: ("pending" | "delivering" | "sent") | undefined;
                paymentNotificationAttemptedAt?: string | undefined;
                paymentNotificationSentAt?: string | undefined;
                paymentNotificationAttempts?: number | undefined;
                paymentNotificationLastError?: string | undefined;
                invoiceRevocationPendingAt?: string | undefined;
                invoiceOrphanedS3Key?: string | undefined;
                invoiceGenerationErrorCode?: string | undefined;
                status: "paid";
                invoice?: {
                    id: string;
                    key: string;
                    url?: string | undefined;
                    totalWithTax?: number | undefined;
                    currency?: string | undefined;
                    invoiceNumber?: string | undefined;
                    invoiceSequence?: number | undefined;
                    issueDate?: string | undefined;
                    serviceDate?: string | undefined;
                    dueDate?: string | undefined;
                    grossAmount?: number | undefined;
                    platformFeeAmount?: number | undefined;
                    netAmount?: number | undefined;
                    vatRate?: number | undefined;
                    vatAmount?: number | undefined;
                    taxTreatment?: ("domestic_vat" | "franchise_exemption" | "eu_reverse_charge" | "non_eu_reverse_charge" | "supplier_declared_exempt") | undefined;
                    taxDeclaration?: {
                        country: string;
                        vatStatus: "vat_registered" | "fr_franchise_293_b" | "vat_exempt";
                        vatNumber?: string | undefined;
                        vatNumberVerification?: ("format_valid_unverified" | "vies_verified" | "manually_verified" | "not_applicable") | undefined;
                        vatNumberVerificationEvidence?: ({
                            method: "vies";
                            country: string;
                            vatNumber: string;
                            verifiedAt: string;
                            reference: string;
                        } | {
                            method: "manual";
                            country: string;
                            vatNumber: string;
                            verifiedAt: string;
                            reference: string;
                            verifiedBy: string;
                        }) | undefined;
                        vatVerificationRemediatedAt?: string | undefined;
                        vatVerificationRemediatedBy?: string | undefined;
                        taxExemptionReason?: string | undefined;
                    } | undefined;
                    selfBillingMandate?: {
                        version: string;
                        acceptedAt: string;
                    } | undefined;
                    paymentDetails?: {
                        rail: "SEPA" | "INTERNATIONAL";
                        beneficiaryName: string;
                        iban?: string | undefined;
                        bic?: string | undefined;
                        internationalDetails?: string | undefined;
                    } | undefined;
                } | undefined;
                postShareUrn: string;
            } | {
                campaignId: string;
                applicationId?: string | undefined;
                uniquenessKey?: string | undefined;
                date: string;
                amount: number;
                platformFeeAmount?: number | undefined;
                platformFeeRate?: number | undefined;
                postId: string;
                publishedAt?: string | undefined;
                smmUserId: string;
                creatorId: string;
                brandId: string;
                publicationCommitment?: {
                    token: string;
                    mode: "server" | "server_schedule" | "extension" | "voyager_schedule";
                    state: "prepared" | "publishing" | "updating" | "external_confirmed" | "external_rejected" | "reconciliation_required";
                    preparedAt: string;
                    publishingAt?: string | undefined;
                    expectedPublishedAt?: string | undefined;
                    pendingExpectedPublishedAt?: string | undefined;
                    resourceKey?: string | undefined;
                    confirmedLinkedinPostId?: string | undefined;
                    confirmedAt?: string | undefined;
                    rejectedAt?: string | undefined;
                    contentFingerprint: string;
                    expectedAuthorLinkedinNumId?: string | undefined;
                    expectedMedia?: ({
                        kind: "none";
                    } | {
                        kind: "document";
                        title: string;
                        assetUrn?: string | undefined;
                    } | {
                        kind: "image";
                        assetUrn?: string | undefined;
                    } | {
                        kind: "video";
                        assetUrn?: string | undefined;
                    }) | undefined;
                    frozenTerms: {
                        model: "fixed";
                        amount: number;
                        platformFeeRate: number;
                        currency: "EUR" | "USD";
                        currencyConversion: {
                            currency: "USD";
                            rateFromEUR: number;
                            lockedAt: string;
                        };
                    } | {
                        model: "cpm";
                        cpm: number;
                        cap: number;
                        platformFeeRate: number;
                        currency: "EUR" | "USD";
                        currencyConversion: {
                            currency: "USD";
                            rateFromEUR: number;
                            lockedAt: string;
                        };
                    };
                } | undefined;
                publicationIntegritySnapshot?: {
                    commitmentToken: string;
                    approvedAt: string;
                    contentFingerprint: string;
                    expectedMedia: {
                        kind: "none";
                    } | {
                        kind: "document";
                        title: string;
                        assetUrn: string;
                    } | {
                        kind: "image";
                        assetUrn: string;
                    } | {
                        kind: "video";
                        assetUrn: string;
                    };
                    expectedAuthorLinkedinNumId?: string | undefined;
                    verifiedPostShareUrn: string;
                } | undefined;
                pricingSnapshot?: ({
                    model: "fixed";
                    applicationId: string;
                    amount: number;
                    platformFeeRate: number;
                    currency: "EUR" | "USD";
                    currencyConversion: {
                        currency: "USD";
                        rateFromEUR: number;
                        lockedAt: string;
                    };
                    publishedAt: string;
                    paymentBatchDate: string;
                } | {
                    model: "cpm";
                    applicationId: string;
                    cpm: number;
                    cap: number;
                    platformFeeRate: number;
                    currency: "EUR" | "USD";
                    currencyConversion: {
                        currency: "USD";
                        rateFromEUR: number;
                        lockedAt: string;
                    };
                    publishedAt: string;
                    settlementDate: string;
                    paymentBatchDate: string;
                    settlementScheduleVersion?: "utc_elapsed_14d_v1" | undefined;
                }) | undefined;
                paypalPayout?: {
                    payout_item_status?: ("DENIED" | "PENDING" | "UNCLAIMED" | "PROCESSING" | "SUCCESS" | "CANCELED" | "FAILED" | "HELD" | "REFUNDED" | "BLOCKED" | "RETURNED") | undefined;
                    payout_batch_status: "PENDING" | "PROCESSING" | "SUCCESS" | "DENIED";
                    payout_batch_id: string;
                    payout_item_id?: string | undefined;
                    payout_initiated_at: string;
                } | undefined;
                cpm?: number | undefined;
                cap?: number | undefined;
                impressionsAtSettlement?: number | undefined;
                settledAt?: string | undefined;
                impressionsMeasurementRequiredAfter?: string | undefined;
                budgetReconciliationPendingAt?: string | undefined;
                budgetReconciledAt?: string | undefined;
                invoiceRevocationPendingAt?: string | undefined;
                invoiceOrphanedS3Key?: string | undefined;
                invoiceGenerationErrorCode?: string | undefined;
                status: "pending";
                invoice?: {
                    id: string;
                    key: string;
                    url?: string | undefined;
                    totalWithTax?: number | undefined;
                    currency?: string | undefined;
                    invoiceNumber?: string | undefined;
                    invoiceSequence?: number | undefined;
                    issueDate?: string | undefined;
                    serviceDate?: string | undefined;
                    dueDate?: string | undefined;
                    grossAmount?: number | undefined;
                    platformFeeAmount?: number | undefined;
                    netAmount?: number | undefined;
                    vatRate?: number | undefined;
                    vatAmount?: number | undefined;
                    taxTreatment?: ("domestic_vat" | "franchise_exemption" | "eu_reverse_charge" | "non_eu_reverse_charge" | "supplier_declared_exempt") | undefined;
                    taxDeclaration?: {
                        country: string;
                        vatStatus: "vat_registered" | "fr_franchise_293_b" | "vat_exempt";
                        vatNumber?: string | undefined;
                        vatNumberVerification?: ("format_valid_unverified" | "vies_verified" | "manually_verified" | "not_applicable") | undefined;
                        vatNumberVerificationEvidence?: ({
                            method: "vies";
                            country: string;
                            vatNumber: string;
                            verifiedAt: string;
                            reference: string;
                        } | {
                            method: "manual";
                            country: string;
                            vatNumber: string;
                            verifiedAt: string;
                            reference: string;
                            verifiedBy: string;
                        }) | undefined;
                        vatVerificationRemediatedAt?: string | undefined;
                        vatVerificationRemediatedBy?: string | undefined;
                        taxExemptionReason?: string | undefined;
                    } | undefined;
                    selfBillingMandate?: {
                        version: string;
                        acceptedAt: string;
                    } | undefined;
                    paymentDetails?: {
                        rail: "SEPA" | "INTERNATIONAL";
                        beneficiaryName: string;
                        iban?: string | undefined;
                        bic?: string | undefined;
                        internationalDetails?: string | undefined;
                    } | undefined;
                } | undefined;
                invoiceMintingToken?: string | undefined;
                invoiceMintingAt?: string | undefined;
                postShareUrn: string;
            } | {
                campaignId: string;
                applicationId?: string | undefined;
                uniquenessKey?: string | undefined;
                date: string;
                amount: number;
                platformFeeAmount?: number | undefined;
                platformFeeRate?: number | undefined;
                postId: string;
                publishedAt?: string | undefined;
                smmUserId: string;
                creatorId: string;
                brandId: string;
                publicationCommitment?: {
                    token: string;
                    mode: "server" | "server_schedule" | "extension" | "voyager_schedule";
                    state: "prepared" | "publishing" | "updating" | "external_confirmed" | "external_rejected" | "reconciliation_required";
                    preparedAt: string;
                    publishingAt?: string | undefined;
                    expectedPublishedAt?: string | undefined;
                    pendingExpectedPublishedAt?: string | undefined;
                    resourceKey?: string | undefined;
                    confirmedLinkedinPostId?: string | undefined;
                    confirmedAt?: string | undefined;
                    rejectedAt?: string | undefined;
                    contentFingerprint: string;
                    expectedAuthorLinkedinNumId?: string | undefined;
                    expectedMedia?: ({
                        kind: "none";
                    } | {
                        kind: "document";
                        title: string;
                        assetUrn?: string | undefined;
                    } | {
                        kind: "image";
                        assetUrn?: string | undefined;
                    } | {
                        kind: "video";
                        assetUrn?: string | undefined;
                    }) | undefined;
                    frozenTerms: {
                        model: "fixed";
                        amount: number;
                        platformFeeRate: number;
                        currency: "EUR" | "USD";
                        currencyConversion: {
                            currency: "USD";
                            rateFromEUR: number;
                            lockedAt: string;
                        };
                    } | {
                        model: "cpm";
                        cpm: number;
                        cap: number;
                        platformFeeRate: number;
                        currency: "EUR" | "USD";
                        currencyConversion: {
                            currency: "USD";
                            rateFromEUR: number;
                            lockedAt: string;
                        };
                    };
                } | undefined;
                publicationIntegritySnapshot?: {
                    commitmentToken: string;
                    approvedAt: string;
                    contentFingerprint: string;
                    expectedMedia: {
                        kind: "none";
                    } | {
                        kind: "document";
                        title: string;
                        assetUrn: string;
                    } | {
                        kind: "image";
                        assetUrn: string;
                    } | {
                        kind: "video";
                        assetUrn: string;
                    };
                    expectedAuthorLinkedinNumId?: string | undefined;
                    verifiedPostShareUrn: string;
                } | undefined;
                pricingSnapshot?: ({
                    model: "fixed";
                    applicationId: string;
                    amount: number;
                    platformFeeRate: number;
                    currency: "EUR" | "USD";
                    currencyConversion: {
                        currency: "USD";
                        rateFromEUR: number;
                        lockedAt: string;
                    };
                    publishedAt: string;
                    paymentBatchDate: string;
                } | {
                    model: "cpm";
                    applicationId: string;
                    cpm: number;
                    cap: number;
                    platformFeeRate: number;
                    currency: "EUR" | "USD";
                    currencyConversion: {
                        currency: "USD";
                        rateFromEUR: number;
                        lockedAt: string;
                    };
                    publishedAt: string;
                    settlementDate: string;
                    paymentBatchDate: string;
                    settlementScheduleVersion?: "utc_elapsed_14d_v1" | undefined;
                }) | undefined;
                paypalPayout?: {
                    payout_item_status?: ("DENIED" | "PENDING" | "UNCLAIMED" | "PROCESSING" | "SUCCESS" | "CANCELED" | "FAILED" | "HELD" | "REFUNDED" | "BLOCKED" | "RETURNED") | undefined;
                    payout_batch_status: "PENDING" | "PROCESSING" | "SUCCESS" | "DENIED";
                    payout_batch_id: string;
                    payout_item_id?: string | undefined;
                    payout_initiated_at: string;
                } | undefined;
                invoiceRevocationPendingAt?: string | undefined;
                invoiceOrphanedS3Key?: string | undefined;
                invoiceGenerationErrorCode?: string | undefined;
                status: "blocked";
                failureReason: "smm_user_not_found" | "payout_informations_invalid" | "campaign_budget_not_enough" | "campaign_not_paid" | "extension_not_active" | "payout_invoice_stale" | "data_integrity_invalid" | "invoice_generation_failed";
                postShareUrn: string;
            } | {
                campaignId: string;
                applicationId?: string | undefined;
                uniquenessKey?: string | undefined;
                date: string;
                amount: number;
                platformFeeAmount?: number | undefined;
                platformFeeRate?: number | undefined;
                postId: string;
                publishedAt?: string | undefined;
                smmUserId: string;
                creatorId: string;
                brandId: string;
                publicationCommitment?: {
                    token: string;
                    mode: "server" | "server_schedule" | "extension" | "voyager_schedule";
                    state: "prepared" | "publishing" | "updating" | "external_confirmed" | "external_rejected" | "reconciliation_required";
                    preparedAt: string;
                    publishingAt?: string | undefined;
                    expectedPublishedAt?: string | undefined;
                    pendingExpectedPublishedAt?: string | undefined;
                    resourceKey?: string | undefined;
                    confirmedLinkedinPostId?: string | undefined;
                    confirmedAt?: string | undefined;
                    rejectedAt?: string | undefined;
                    contentFingerprint: string;
                    expectedAuthorLinkedinNumId?: string | undefined;
                    expectedMedia?: ({
                        kind: "none";
                    } | {
                        kind: "document";
                        title: string;
                        assetUrn?: string | undefined;
                    } | {
                        kind: "image";
                        assetUrn?: string | undefined;
                    } | {
                        kind: "video";
                        assetUrn?: string | undefined;
                    }) | undefined;
                    frozenTerms: {
                        model: "fixed";
                        amount: number;
                        platformFeeRate: number;
                        currency: "EUR" | "USD";
                        currencyConversion: {
                            currency: "USD";
                            rateFromEUR: number;
                            lockedAt: string;
                        };
                    } | {
                        model: "cpm";
                        cpm: number;
                        cap: number;
                        platformFeeRate: number;
                        currency: "EUR" | "USD";
                        currencyConversion: {
                            currency: "USD";
                            rateFromEUR: number;
                            lockedAt: string;
                        };
                    };
                } | undefined;
                publicationIntegritySnapshot?: {
                    commitmentToken: string;
                    approvedAt: string;
                    contentFingerprint: string;
                    expectedMedia: {
                        kind: "none";
                    } | {
                        kind: "document";
                        title: string;
                        assetUrn: string;
                    } | {
                        kind: "image";
                        assetUrn: string;
                    } | {
                        kind: "video";
                        assetUrn: string;
                    };
                    expectedAuthorLinkedinNumId?: string | undefined;
                    verifiedPostShareUrn: string;
                } | undefined;
                pricingSnapshot?: ({
                    model: "fixed";
                    applicationId: string;
                    amount: number;
                    platformFeeRate: number;
                    currency: "EUR" | "USD";
                    currencyConversion: {
                        currency: "USD";
                        rateFromEUR: number;
                        lockedAt: string;
                    };
                    publishedAt: string;
                    paymentBatchDate: string;
                } | {
                    model: "cpm";
                    applicationId: string;
                    cpm: number;
                    cap: number;
                    platformFeeRate: number;
                    currency: "EUR" | "USD";
                    currencyConversion: {
                        currency: "USD";
                        rateFromEUR: number;
                        lockedAt: string;
                    };
                    publishedAt: string;
                    settlementDate: string;
                    paymentBatchDate: string;
                    settlementScheduleVersion?: "utc_elapsed_14d_v1" | undefined;
                }) | undefined;
                paypalPayout?: {
                    payout_item_status?: ("DENIED" | "PENDING" | "UNCLAIMED" | "PROCESSING" | "SUCCESS" | "CANCELED" | "FAILED" | "HELD" | "REFUNDED" | "BLOCKED" | "RETURNED") | undefined;
                    payout_batch_status: "PENDING" | "PROCESSING" | "SUCCESS" | "DENIED";
                    payout_batch_id: string;
                    payout_item_id?: string | undefined;
                    payout_initiated_at: string;
                } | undefined;
                status: "waiting_for_publication";
            } | {
                campaignId: string;
                applicationId?: string | undefined;
                uniquenessKey?: string | undefined;
                date: string;
                amount: number;
                platformFeeAmount?: number | undefined;
                platformFeeRate?: number | undefined;
                postId: string;
                publishedAt?: string | undefined;
                smmUserId: string;
                creatorId: string;
                brandId: string;
                publicationCommitment?: {
                    token: string;
                    mode: "server" | "server_schedule" | "extension" | "voyager_schedule";
                    state: "prepared" | "publishing" | "updating" | "external_confirmed" | "external_rejected" | "reconciliation_required";
                    preparedAt: string;
                    publishingAt?: string | undefined;
                    expectedPublishedAt?: string | undefined;
                    pendingExpectedPublishedAt?: string | undefined;
                    resourceKey?: string | undefined;
                    confirmedLinkedinPostId?: string | undefined;
                    confirmedAt?: string | undefined;
                    rejectedAt?: string | undefined;
                    contentFingerprint: string;
                    expectedAuthorLinkedinNumId?: string | undefined;
                    expectedMedia?: ({
                        kind: "none";
                    } | {
                        kind: "document";
                        title: string;
                        assetUrn?: string | undefined;
                    } | {
                        kind: "image";
                        assetUrn?: string | undefined;
                    } | {
                        kind: "video";
                        assetUrn?: string | undefined;
                    }) | undefined;
                    frozenTerms: {
                        model: "fixed";
                        amount: number;
                        platformFeeRate: number;
                        currency: "EUR" | "USD";
                        currencyConversion: {
                            currency: "USD";
                            rateFromEUR: number;
                            lockedAt: string;
                        };
                    } | {
                        model: "cpm";
                        cpm: number;
                        cap: number;
                        platformFeeRate: number;
                        currency: "EUR" | "USD";
                        currencyConversion: {
                            currency: "USD";
                            rateFromEUR: number;
                            lockedAt: string;
                        };
                    };
                } | undefined;
                publicationIntegritySnapshot?: {
                    commitmentToken: string;
                    approvedAt: string;
                    contentFingerprint: string;
                    expectedMedia: {
                        kind: "none";
                    } | {
                        kind: "document";
                        title: string;
                        assetUrn: string;
                    } | {
                        kind: "image";
                        assetUrn: string;
                    } | {
                        kind: "video";
                        assetUrn: string;
                    };
                    expectedAuthorLinkedinNumId?: string | undefined;
                    verifiedPostShareUrn: string;
                } | undefined;
                pricingSnapshot?: ({
                    model: "fixed";
                    applicationId: string;
                    amount: number;
                    platformFeeRate: number;
                    currency: "EUR" | "USD";
                    currencyConversion: {
                        currency: "USD";
                        rateFromEUR: number;
                        lockedAt: string;
                    };
                    publishedAt: string;
                    paymentBatchDate: string;
                } | {
                    model: "cpm";
                    applicationId: string;
                    cpm: number;
                    cap: number;
                    platformFeeRate: number;
                    currency: "EUR" | "USD";
                    currencyConversion: {
                        currency: "USD";
                        rateFromEUR: number;
                        lockedAt: string;
                    };
                    publishedAt: string;
                    settlementDate: string;
                    paymentBatchDate: string;
                    settlementScheduleVersion?: "utc_elapsed_14d_v1" | undefined;
                }) | undefined;
                paypalPayout?: {
                    payout_item_status?: ("DENIED" | "PENDING" | "UNCLAIMED" | "PROCESSING" | "SUCCESS" | "CANCELED" | "FAILED" | "HELD" | "REFUNDED" | "BLOCKED" | "RETURNED") | undefined;
                    payout_batch_status: "PENDING" | "PROCESSING" | "SUCCESS" | "DENIED";
                    payout_batch_id: string;
                    payout_item_id?: string | undefined;
                    payout_initiated_at: string;
                } | undefined;
                status: "waiting_for_settlement";
                settlementDate: string;
                cpm: number;
                cap: number;
                postShareUrn?: string | undefined;
                lastExtensionReminderAt?: string | undefined;
                extensionReminderCount?: number | undefined;
                impressionsMeasurementRequiredAfter?: string | undefined;
            } | {
                campaignId: string;
                applicationId?: string | undefined;
                uniquenessKey?: string | undefined;
                date: string;
                amount: number;
                platformFeeAmount?: number | undefined;
                platformFeeRate?: number | undefined;
                postId: string;
                publishedAt?: string | undefined;
                smmUserId: string;
                creatorId: string;
                brandId: string;
                publicationCommitment?: {
                    token: string;
                    mode: "server" | "server_schedule" | "extension" | "voyager_schedule";
                    state: "prepared" | "publishing" | "updating" | "external_confirmed" | "external_rejected" | "reconciliation_required";
                    preparedAt: string;
                    publishingAt?: string | undefined;
                    expectedPublishedAt?: string | undefined;
                    pendingExpectedPublishedAt?: string | undefined;
                    resourceKey?: string | undefined;
                    confirmedLinkedinPostId?: string | undefined;
                    confirmedAt?: string | undefined;
                    rejectedAt?: string | undefined;
                    contentFingerprint: string;
                    expectedAuthorLinkedinNumId?: string | undefined;
                    expectedMedia?: ({
                        kind: "none";
                    } | {
                        kind: "document";
                        title: string;
                        assetUrn?: string | undefined;
                    } | {
                        kind: "image";
                        assetUrn?: string | undefined;
                    } | {
                        kind: "video";
                        assetUrn?: string | undefined;
                    }) | undefined;
                    frozenTerms: {
                        model: "fixed";
                        amount: number;
                        platformFeeRate: number;
                        currency: "EUR" | "USD";
                        currencyConversion: {
                            currency: "USD";
                            rateFromEUR: number;
                            lockedAt: string;
                        };
                    } | {
                        model: "cpm";
                        cpm: number;
                        cap: number;
                        platformFeeRate: number;
                        currency: "EUR" | "USD";
                        currencyConversion: {
                            currency: "USD";
                            rateFromEUR: number;
                            lockedAt: string;
                        };
                    };
                } | undefined;
                publicationIntegritySnapshot?: {
                    commitmentToken: string;
                    approvedAt: string;
                    contentFingerprint: string;
                    expectedMedia: {
                        kind: "none";
                    } | {
                        kind: "document";
                        title: string;
                        assetUrn: string;
                    } | {
                        kind: "image";
                        assetUrn: string;
                    } | {
                        kind: "video";
                        assetUrn: string;
                    };
                    expectedAuthorLinkedinNumId?: string | undefined;
                    verifiedPostShareUrn: string;
                } | undefined;
                pricingSnapshot?: ({
                    model: "fixed";
                    applicationId: string;
                    amount: number;
                    platformFeeRate: number;
                    currency: "EUR" | "USD";
                    currencyConversion: {
                        currency: "USD";
                        rateFromEUR: number;
                        lockedAt: string;
                    };
                    publishedAt: string;
                    paymentBatchDate: string;
                } | {
                    model: "cpm";
                    applicationId: string;
                    cpm: number;
                    cap: number;
                    platformFeeRate: number;
                    currency: "EUR" | "USD";
                    currencyConversion: {
                        currency: "USD";
                        rateFromEUR: number;
                        lockedAt: string;
                    };
                    publishedAt: string;
                    settlementDate: string;
                    paymentBatchDate: string;
                    settlementScheduleVersion?: "utc_elapsed_14d_v1" | undefined;
                }) | undefined;
                paypalPayout?: {
                    payout_item_status?: ("DENIED" | "PENDING" | "UNCLAIMED" | "PROCESSING" | "SUCCESS" | "CANCELED" | "FAILED" | "HELD" | "REFUNDED" | "BLOCKED" | "RETURNED") | undefined;
                    payout_batch_status: "PENDING" | "PROCESSING" | "SUCCESS" | "DENIED";
                    payout_batch_id: string;
                    payout_item_id?: string | undefined;
                    payout_initiated_at: string;
                } | undefined;
                cpm?: number | undefined;
                cap?: number | undefined;
                impressionsAtSettlement?: number | undefined;
                settledAt?: string | undefined;
                impressionsMeasurementRequiredAfter?: string | undefined;
                budgetReconciliationPendingAt?: string | undefined;
                budgetReconciledAt?: string | undefined;
                status: "paid_by_brand";
                paidByBrandAt?: string | undefined;
                postShareUrn?: string | undefined;
            }) & {
                _id: string;
            };
            application?: {
                _id: string;
                uniquenessKey?: string | undefined;
                sideEffectOutboxVersion?: number | undefined;
                inviteSideEffectsEnqueuedAt?: string | undefined;
                price: number;
                cpm?: number | undefined;
                maxAmount?: number | undefined;
                campaignId: string;
                state: "pending" | "accepted" | "rejected" | "excluded" | "invited";
                reason: string;
                rejectionReason?: string | undefined;
                exclusionReason?: string | undefined;
                isUserOfBrand: boolean;
                creatorId: string;
                smmUserId: string;
                expectedAuthorLinkedinNumId?: string | undefined;
                linkedinIdentityFrozenAt?: string | undefined;
                brandId: string;
                createdAt: string;
                updatedAt: string;
                acceptedAt?: string | undefined;
                budgetReservedAt?: string | undefined;
                capacityExcludedAt?: string | undefined;
                lastPublishReminderAt?: string | undefined;
                publishReminderCount?: number | undefined;
                publishReminderExhausted?: boolean | undefined;
                changesRequestedAt?: string | undefined;
                changesRequestReason?: string | undefined;
                lastNegotiation?: {
                    price: number;
                    cpm?: number | undefined;
                    maxAmount?: number | undefined;
                    proposedBy: "creator" | "campaign";
                    proposedAt: string;
                    reason?: string | undefined;
                } | undefined;
            } | undefined;
        }[];
    };
};

/** get /v1/smm-prv/payments/payouts */
interface GetV1SmmPrvPaymentsPayoutsPositiveResponseVariants {
    200: GetV1SmmPrvPaymentsPayoutsPositiveVariant1;
}

/** get /v1/smm-prv/payments/payouts */
type GetV1SmmPrvPaymentsPayoutsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/smm-prv/payments/payouts */
interface GetV1SmmPrvPaymentsPayoutsNegativeResponseVariants {
    400: GetV1SmmPrvPaymentsPayoutsNegativeVariant1;
}

/** get /v1/smm-prv/payments/earnings */
type GetV1SmmPrvPaymentsEarningsInput = {};

/** get /v1/smm-prv/payments/earnings */
type GetV1SmmPrvPaymentsEarningsPositiveVariant1 = {
    status: "success";
    data: {
        totalEarningsAmount: number;
        monthlyEarningsAmount: number;
        averageMonthlyEarningsAmount: number;
    };
};

/** get /v1/smm-prv/payments/earnings */
interface GetV1SmmPrvPaymentsEarningsPositiveResponseVariants {
    200: GetV1SmmPrvPaymentsEarningsPositiveVariant1;
}

/** get /v1/smm-prv/payments/earnings */
type GetV1SmmPrvPaymentsEarningsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/smm-prv/payments/earnings */
interface GetV1SmmPrvPaymentsEarningsNegativeResponseVariants {
    400: GetV1SmmPrvPaymentsEarningsNegativeVariant1;
}

/** get /v1/smm-prv/payments/recent-payouts */
type GetV1SmmPrvPaymentsRecentPayoutsInput = {};

/** get /v1/smm-prv/payments/recent-payouts */
type GetV1SmmPrvPaymentsRecentPayoutsPositiveVariant1 = {
    status: "success";
    data: {
        payouts: {
            payoutId: string;
            creatorLabel: string;
            amount: number;
            date: string;
        }[];
    };
};

/** get /v1/smm-prv/payments/recent-payouts */
interface GetV1SmmPrvPaymentsRecentPayoutsPositiveResponseVariants {
    200: GetV1SmmPrvPaymentsRecentPayoutsPositiveVariant1;
}

/** get /v1/smm-prv/payments/recent-payouts */
type GetV1SmmPrvPaymentsRecentPayoutsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/smm-prv/payments/recent-payouts */
interface GetV1SmmPrvPaymentsRecentPayoutsNegativeResponseVariants {
    400: GetV1SmmPrvPaymentsRecentPayoutsNegativeVariant1;
}

/** get /v1/smm-prv/saved-replies */
type GetV1SmmPrvSavedRepliesInput = {
    page: number;
    size: number;
    search?: string | undefined;
};

/** get /v1/smm-prv/saved-replies */
type GetV1SmmPrvSavedRepliesPositiveVariant1 = {
    status: "success";
    data: {
        totalCount: number;
        savedReplies: {
            userId: string;
            name: string;
            content: {
                text: string;
                attachments?: {
                    name: string;
                    size: number;
                    type: string;
                    fileKey: string;
                }[] | undefined;
                images?: {
                    type: "image";
                    src?: string | undefined;
                    metadata: {
                        name: string;
                        size: number;
                        type: string;
                        fileKey: string;
                    };
                }[] | undefined;
            };
            _id: string;
        }[];
    };
};

/** get /v1/smm-prv/saved-replies */
interface GetV1SmmPrvSavedRepliesPositiveResponseVariants {
    200: GetV1SmmPrvSavedRepliesPositiveVariant1;
}

/** get /v1/smm-prv/saved-replies */
type GetV1SmmPrvSavedRepliesNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/smm-prv/saved-replies */
interface GetV1SmmPrvSavedRepliesNegativeResponseVariants {
    400: GetV1SmmPrvSavedRepliesNegativeVariant1;
}

/** post /v1/smm-prv/saved-replies */
type PostV1SmmPrvSavedRepliesInput = {
    savedReplyData: {
        name: string;
        content: {
            text: string;
            attachments?: {
                name: string;
                size: number;
                type: string;
                fileKey: string;
            }[] | undefined;
            images?: {
                type: "image";
                src?: string | undefined;
                metadata: {
                    name: string;
                    size: number;
                    type: string;
                    fileKey: string;
                };
            }[] | undefined;
        };
    };
};

/** post /v1/smm-prv/saved-replies */
type PostV1SmmPrvSavedRepliesPositiveVariant1 = {
    status: "success";
    data: {
        savedReply: {
            userId: string;
            name: string;
            content: {
                text: string;
                attachments?: {
                    name: string;
                    size: number;
                    type: string;
                    fileKey: string;
                }[] | undefined;
                images?: {
                    type: "image";
                    src?: string | undefined;
                    metadata: {
                        name: string;
                        size: number;
                        type: string;
                        fileKey: string;
                    };
                }[] | undefined;
            };
            _id: string;
        };
    };
};

/** post /v1/smm-prv/saved-replies */
interface PostV1SmmPrvSavedRepliesPositiveResponseVariants {
    200: PostV1SmmPrvSavedRepliesPositiveVariant1;
}

/** post /v1/smm-prv/saved-replies */
type PostV1SmmPrvSavedRepliesNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/smm-prv/saved-replies */
interface PostV1SmmPrvSavedRepliesNegativeResponseVariants {
    400: PostV1SmmPrvSavedRepliesNegativeVariant1;
}

/** delete /v1/smm-prv/saved-replies/:savedReplyId */
type DeleteV1SmmPrvSavedRepliesSavedReplyIdInput = {
    savedReplyId: string;
};

/** delete /v1/smm-prv/saved-replies/:savedReplyId */
type DeleteV1SmmPrvSavedRepliesSavedReplyIdPositiveVariant1 = {
    status: "success";
    data: {
        success: boolean;
    };
};

/** delete /v1/smm-prv/saved-replies/:savedReplyId */
interface DeleteV1SmmPrvSavedRepliesSavedReplyIdPositiveResponseVariants {
    200: DeleteV1SmmPrvSavedRepliesSavedReplyIdPositiveVariant1;
}

/** delete /v1/smm-prv/saved-replies/:savedReplyId */
type DeleteV1SmmPrvSavedRepliesSavedReplyIdNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** delete /v1/smm-prv/saved-replies/:savedReplyId */
interface DeleteV1SmmPrvSavedRepliesSavedReplyIdNegativeResponseVariants {
    400: DeleteV1SmmPrvSavedRepliesSavedReplyIdNegativeVariant1;
}

/** put /v1/smm-prv/saved-replies/:savedReplyId */
type PutV1SmmPrvSavedRepliesSavedReplyIdInput = {
    savedReplyId: string;
    savedReplyData: {
        name: string;
        content: {
            text: string;
            attachments?: {
                name: string;
                size: number;
                type: string;
                fileKey: string;
            }[] | undefined;
            images?: {
                type: "image";
                src?: string | undefined;
                metadata: {
                    name: string;
                    size: number;
                    type: string;
                    fileKey: string;
                };
            }[] | undefined;
        };
    };
};

/** put /v1/smm-prv/saved-replies/:savedReplyId */
type PutV1SmmPrvSavedRepliesSavedReplyIdPositiveVariant1 = {
    status: "success";
    data: {
        savedReply: {
            userId: string;
            name: string;
            content: {
                text: string;
                attachments?: {
                    name: string;
                    size: number;
                    type: string;
                    fileKey: string;
                }[] | undefined;
                images?: {
                    type: "image";
                    src?: string | undefined;
                    metadata: {
                        name: string;
                        size: number;
                        type: string;
                        fileKey: string;
                    };
                }[] | undefined;
            };
            _id: string;
        };
    };
};

/** put /v1/smm-prv/saved-replies/:savedReplyId */
interface PutV1SmmPrvSavedRepliesSavedReplyIdPositiveResponseVariants {
    200: PutV1SmmPrvSavedRepliesSavedReplyIdPositiveVariant1;
}

/** put /v1/smm-prv/saved-replies/:savedReplyId */
type PutV1SmmPrvSavedRepliesSavedReplyIdNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** put /v1/smm-prv/saved-replies/:savedReplyId */
interface PutV1SmmPrvSavedRepliesSavedReplyIdNegativeResponseVariants {
    400: PutV1SmmPrvSavedRepliesSavedReplyIdNegativeVariant1;
}

/** get /v1/smm-prv/sponsors */
type GetV1SmmPrvSponsorsInput = {
    search?: string | undefined;
    tags?: string | undefined;
    page?: number | undefined;
    size?: number | undefined;
};

/** get /v1/smm-prv/sponsors */
type GetV1SmmPrvSponsorsPositiveVariant1 = {
    status: "success";
    data: {
        sponsors: {
            _id: string;
            name: string;
            contactEmail?: (string | null) | undefined;
            contactName?: string | undefined;
            websiteUrl?: string | undefined;
            logoUrl?: string | undefined;
            sector?: string | undefined;
            contentTypes: string[];
            description?: string | undefined;
            creatorsCount?: (number | null) | undefined;
            mentionsCount?: (number | null) | undefined;
            mentionsSince?: (string | null) | undefined;
            mentionsOverTime?: ({
                date: string;
                count: number;
            }[] | null) | undefined;
            topCategories?: ({
                name: string;
                count: number;
            }[] | null) | undefined;
            sponsorshipCategories?: ({
                name: string;
                path: string;
                rank?: (number | null) | undefined;
                mentionsCount?: (number | null) | undefined;
                creatorsCount?: (number | null) | undefined;
                sponsorshipUuid?: string | undefined;
            }[] | null) | undefined;
            sponsorshipSourceCategory?: (string | null) | undefined;
            sponsorshipSourceUuid?: (string | null) | undefined;
            sponsorshipSourceUrl?: (string | null) | undefined;
            sponsorshipSourceUpdatedAt?: (string | null) | undefined;
            sponsorshipInsightsScrapedAt?: (string | null) | undefined;
            medianSubscribers?: (number | null) | undefined;
            medianVideoViews?: (number | null) | undefined;
            firstSponsoredAt?: (string | null) | undefined;
            similarBrands?: (string[] | null) | undefined;
            source?: string | undefined;
            keyContacts?: {
                fullName: string;
                firstName?: string | undefined;
                lastName?: string | undefined;
                title?: string | undefined;
                location?: string | undefined;
                email?: string | undefined;
                emailVerified?: boolean | undefined;
                linkedinUrl?: string | undefined;
            }[] | undefined;
            createdAt?: string | undefined;
            updatedAt?: string | undefined;
            contact?: {
                _id: string;
                smmUserId: string;
                sponsorId: string;
                status?: ("to_contact" | "contacted" | "in_discussion" | "deal") | undefined;
                contactedAt?: string | undefined;
                favorite?: boolean | undefined;
                dismissed?: boolean | undefined;
                note?: string | undefined;
                createdAt?: string | undefined;
                updatedAt?: string | undefined;
            } | undefined;
        }[];
        total: number;
    };
};

/** get /v1/smm-prv/sponsors */
interface GetV1SmmPrvSponsorsPositiveResponseVariants {
    200: GetV1SmmPrvSponsorsPositiveVariant1;
}

/** get /v1/smm-prv/sponsors */
type GetV1SmmPrvSponsorsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/smm-prv/sponsors */
interface GetV1SmmPrvSponsorsNegativeResponseVariants {
    400: GetV1SmmPrvSponsorsNegativeVariant1;
}

/** get /v1/smm-prv/sponsors/tags */
type GetV1SmmPrvSponsorsTagsInput = {};

/** get /v1/smm-prv/sponsors/tags */
type GetV1SmmPrvSponsorsTagsPositiveVariant1 = {
    status: "success";
    data: {
        tags: {
            tag: string;
            count: number;
        }[];
    };
};

/** get /v1/smm-prv/sponsors/tags */
interface GetV1SmmPrvSponsorsTagsPositiveResponseVariants {
    200: GetV1SmmPrvSponsorsTagsPositiveVariant1;
}

/** get /v1/smm-prv/sponsors/tags */
type GetV1SmmPrvSponsorsTagsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/smm-prv/sponsors/tags */
interface GetV1SmmPrvSponsorsTagsNegativeResponseVariants {
    400: GetV1SmmPrvSponsorsTagsNegativeVariant1;
}

/** get /v1/smm-prv/sponsors/contacts */
type GetV1SmmPrvSponsorsContactsInput = {};

/** get /v1/smm-prv/sponsors/contacts */
type GetV1SmmPrvSponsorsContactsPositiveVariant1 = {
    status: "success";
    data: {
        sponsors: {
            _id: string;
            name: string;
            contactEmail?: (string | null) | undefined;
            contactName?: string | undefined;
            websiteUrl?: string | undefined;
            logoUrl?: string | undefined;
            sector?: string | undefined;
            contentTypes: string[];
            description?: string | undefined;
            creatorsCount?: (number | null) | undefined;
            mentionsCount?: (number | null) | undefined;
            mentionsSince?: (string | null) | undefined;
            mentionsOverTime?: ({
                date: string;
                count: number;
            }[] | null) | undefined;
            topCategories?: ({
                name: string;
                count: number;
            }[] | null) | undefined;
            sponsorshipCategories?: ({
                name: string;
                path: string;
                rank?: (number | null) | undefined;
                mentionsCount?: (number | null) | undefined;
                creatorsCount?: (number | null) | undefined;
                sponsorshipUuid?: string | undefined;
            }[] | null) | undefined;
            sponsorshipSourceCategory?: (string | null) | undefined;
            sponsorshipSourceUuid?: (string | null) | undefined;
            sponsorshipSourceUrl?: (string | null) | undefined;
            sponsorshipSourceUpdatedAt?: (string | null) | undefined;
            sponsorshipInsightsScrapedAt?: (string | null) | undefined;
            medianSubscribers?: (number | null) | undefined;
            medianVideoViews?: (number | null) | undefined;
            firstSponsoredAt?: (string | null) | undefined;
            similarBrands?: (string[] | null) | undefined;
            source?: string | undefined;
            keyContacts?: {
                fullName: string;
                firstName?: string | undefined;
                lastName?: string | undefined;
                title?: string | undefined;
                location?: string | undefined;
                email?: string | undefined;
                emailVerified?: boolean | undefined;
                linkedinUrl?: string | undefined;
            }[] | undefined;
            createdAt?: string | undefined;
            updatedAt?: string | undefined;
            contact?: {
                _id: string;
                smmUserId: string;
                sponsorId: string;
                status?: ("to_contact" | "contacted" | "in_discussion" | "deal") | undefined;
                contactedAt?: string | undefined;
                favorite?: boolean | undefined;
                dismissed?: boolean | undefined;
                note?: string | undefined;
                createdAt?: string | undefined;
                updatedAt?: string | undefined;
            } | undefined;
        }[];
    };
};

/** get /v1/smm-prv/sponsors/contacts */
interface GetV1SmmPrvSponsorsContactsPositiveResponseVariants {
    200: GetV1SmmPrvSponsorsContactsPositiveVariant1;
}

/** get /v1/smm-prv/sponsors/contacts */
type GetV1SmmPrvSponsorsContactsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/smm-prv/sponsors/contacts */
interface GetV1SmmPrvSponsorsContactsNegativeResponseVariants {
    400: GetV1SmmPrvSponsorsContactsNegativeVariant1;
}

/** put /v1/smm-prv/sponsors/contact */
type PutV1SmmPrvSponsorsContactInput = {
    sponsorId: string;
    status?: ("to_contact" | "contacted" | "in_discussion" | "deal") | undefined;
    favorite?: boolean | undefined;
    dismissed?: boolean | undefined;
    note?: string | undefined;
};

/** put /v1/smm-prv/sponsors/contact */
type PutV1SmmPrvSponsorsContactPositiveVariant1 = {
    status: "success";
    data: {
        contact: {
            _id: string;
            smmUserId: string;
            sponsorId: string;
            status?: ("to_contact" | "contacted" | "in_discussion" | "deal") | undefined;
            contactedAt?: string | undefined;
            favorite?: boolean | undefined;
            dismissed?: boolean | undefined;
            note?: string | undefined;
            createdAt?: string | undefined;
            updatedAt?: string | undefined;
        };
    };
};

/** put /v1/smm-prv/sponsors/contact */
interface PutV1SmmPrvSponsorsContactPositiveResponseVariants {
    200: PutV1SmmPrvSponsorsContactPositiveVariant1;
}

/** put /v1/smm-prv/sponsors/contact */
type PutV1SmmPrvSponsorsContactNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** put /v1/smm-prv/sponsors/contact */
interface PutV1SmmPrvSponsorsContactNegativeResponseVariants {
    400: PutV1SmmPrvSponsorsContactNegativeVariant1;
}

/** delete /v1/smm-prv/sponsors/contact */
type DeleteV1SmmPrvSponsorsContactInput = {
    sponsorId: string;
};

/** delete /v1/smm-prv/sponsors/contact */
type DeleteV1SmmPrvSponsorsContactPositiveVariant1 = {
    status: "success";
    data: {
        removed: boolean;
    };
};

/** delete /v1/smm-prv/sponsors/contact */
interface DeleteV1SmmPrvSponsorsContactPositiveResponseVariants {
    200: DeleteV1SmmPrvSponsorsContactPositiveVariant1;
}

/** delete /v1/smm-prv/sponsors/contact */
type DeleteV1SmmPrvSponsorsContactNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** delete /v1/smm-prv/sponsors/contact */
interface DeleteV1SmmPrvSponsorsContactNegativeResponseVariants {
    400: DeleteV1SmmPrvSponsorsContactNegativeVariant1;
}

/** get /v1/smm-prv/sponsors/:sponsorId */
type GetV1SmmPrvSponsorsSponsorIdInput = {
    sponsorId: string;
};

/** get /v1/smm-prv/sponsors/:sponsorId */
type GetV1SmmPrvSponsorsSponsorIdPositiveVariant1 = {
    status: "success";
    data: {
        sponsor: {
            _id: string;
            name: string;
            contactEmail?: (string | null) | undefined;
            contactName?: string | undefined;
            websiteUrl?: string | undefined;
            logoUrl?: string | undefined;
            sector?: string | undefined;
            contentTypes: string[];
            description?: string | undefined;
            creatorsCount?: (number | null) | undefined;
            mentionsCount?: (number | null) | undefined;
            mentionsSince?: (string | null) | undefined;
            mentionsOverTime?: ({
                date: string;
                count: number;
            }[] | null) | undefined;
            topCategories?: ({
                name: string;
                count: number;
            }[] | null) | undefined;
            sponsorshipCategories?: ({
                name: string;
                path: string;
                rank?: (number | null) | undefined;
                mentionsCount?: (number | null) | undefined;
                creatorsCount?: (number | null) | undefined;
                sponsorshipUuid?: string | undefined;
            }[] | null) | undefined;
            sponsorshipSourceCategory?: (string | null) | undefined;
            sponsorshipSourceUuid?: (string | null) | undefined;
            sponsorshipSourceUrl?: (string | null) | undefined;
            sponsorshipSourceUpdatedAt?: (string | null) | undefined;
            sponsorshipInsightsScrapedAt?: (string | null) | undefined;
            medianSubscribers?: (number | null) | undefined;
            medianVideoViews?: (number | null) | undefined;
            firstSponsoredAt?: (string | null) | undefined;
            similarBrands?: (string[] | null) | undefined;
            source?: string | undefined;
            keyContacts?: {
                fullName: string;
                firstName?: string | undefined;
                lastName?: string | undefined;
                title?: string | undefined;
                location?: string | undefined;
                email?: string | undefined;
                emailVerified?: boolean | undefined;
                linkedinUrl?: string | undefined;
            }[] | undefined;
            createdAt?: string | undefined;
            updatedAt?: string | undefined;
            contact?: {
                _id: string;
                smmUserId: string;
                sponsorId: string;
                status?: ("to_contact" | "contacted" | "in_discussion" | "deal") | undefined;
                contactedAt?: string | undefined;
                favorite?: boolean | undefined;
                dismissed?: boolean | undefined;
                note?: string | undefined;
                createdAt?: string | undefined;
                updatedAt?: string | undefined;
            } | undefined;
        };
    };
};

/** get /v1/smm-prv/sponsors/:sponsorId */
interface GetV1SmmPrvSponsorsSponsorIdPositiveResponseVariants {
    200: GetV1SmmPrvSponsorsSponsorIdPositiveVariant1;
}

/** get /v1/smm-prv/sponsors/:sponsorId */
type GetV1SmmPrvSponsorsSponsorIdNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/smm-prv/sponsors/:sponsorId */
interface GetV1SmmPrvSponsorsSponsorIdNegativeResponseVariants {
    400: GetV1SmmPrvSponsorsSponsorIdNegativeVariant1;
}

/** get /v1/open/me */
type GetV1OpenMeInput = {};

/** get /v1/open/me */
type GetV1OpenMePositiveVariant1 = {
    status: "success";
    data: {
        creator: {
            _id: string;
            smmUserId?: string | undefined;
            name?: string | undefined;
            givenName: string;
            familyName: string;
            linkedinId?: string | undefined;
            linkedinUrl?: string | undefined;
            title?: string | undefined;
            picture?: (string | null) | undefined;
            language?: string | undefined;
            avgViewsPerPost?: (number | null) | undefined;
            medianViewsPerPost?: (number | null) | undefined;
            followers?: number | undefined;
            membersReached?: number | undefined;
            sector?: string | undefined;
            pricePerPost?: (number | null) | undefined;
            defaultCap?: (number | null) | undefined;
            impressions?: ({
                timeRange: "past_7_days" | "past_14_days" | "past_28_days" | "past_90_days" | "past_365_days" | "custom_timerange";
                data: {
                    totalValue?: (number | null) | undefined;
                    percentageChange?: (number | null) | undefined;
                    series: {
                        value?: (number | null) | undefined;
                        date?: (string | null) | undefined;
                    }[];
                    impressions: {
                        value?: (string | null) | undefined;
                        percentageChange?: (number | null) | undefined;
                    };
                    reached: {
                        value?: (string | null) | undefined;
                        percentageChange?: (number | null) | undefined;
                    };
                    topPosts?: {
                        urn: string;
                        reactions?: (number | null) | undefined;
                        comments?: (number | null) | undefined;
                        shares?: (number | null) | undefined;
                        text?: string | undefined;
                        impressions?: string | undefined;
                        date?: string | undefined;
                    }[] | undefined;
                };
            }[] | null) | undefined;
            followersDemographics?: ({
                category: "occupation_title" | "location" | "industry" | "occupation_seniority" | "company_size" | "company_name";
                data: {
                    label: string;
                    value: number;
                    normalizedLabel?: (string | null) | undefined;
                }[];
            }[] | null) | undefined;
            updatedAt?: string | undefined;
            isPrivate?: boolean | undefined;
        };
        profileUrl: string;
    };
};

/** get /v1/open/me */
interface GetV1OpenMePositiveResponseVariants {
    200: GetV1OpenMePositiveVariant1;
}

/** get /v1/open/me */
type GetV1OpenMeNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/open/me */
interface GetV1OpenMeNegativeResponseVariants {
    400: GetV1OpenMeNegativeVariant1;
}

/** get /v1/open/sponsors */
type GetV1OpenSponsorsInput = {
    search?: string | undefined;
    tags?: string | undefined;
    page?: number | undefined;
    size?: number | undefined;
};

/** get /v1/open/sponsors */
type GetV1OpenSponsorsPositiveVariant1 = {
    status: "success";
    data: {
        sponsors: {
            _id: string;
            name: string;
            contactEmail?: (string | null) | undefined;
            contactName?: string | undefined;
            websiteUrl?: string | undefined;
            logoUrl?: string | undefined;
            sector?: string | undefined;
            contentTypes: string[];
            description?: string | undefined;
            creatorsCount?: (number | null) | undefined;
            mentionsCount?: (number | null) | undefined;
            mentionsSince?: (string | null) | undefined;
            mentionsOverTime?: ({
                date: string;
                count: number;
            }[] | null) | undefined;
            topCategories?: ({
                name: string;
                count: number;
            }[] | null) | undefined;
            sponsorshipCategories?: ({
                name: string;
                path: string;
                rank?: (number | null) | undefined;
                mentionsCount?: (number | null) | undefined;
                creatorsCount?: (number | null) | undefined;
                sponsorshipUuid?: string | undefined;
            }[] | null) | undefined;
            sponsorshipSourceCategory?: (string | null) | undefined;
            sponsorshipSourceUuid?: (string | null) | undefined;
            sponsorshipSourceUrl?: (string | null) | undefined;
            sponsorshipSourceUpdatedAt?: (string | null) | undefined;
            sponsorshipInsightsScrapedAt?: (string | null) | undefined;
            medianSubscribers?: (number | null) | undefined;
            medianVideoViews?: (number | null) | undefined;
            firstSponsoredAt?: (string | null) | undefined;
            similarBrands?: (string[] | null) | undefined;
            source?: string | undefined;
            keyContacts?: {
                fullName: string;
                firstName?: string | undefined;
                lastName?: string | undefined;
                title?: string | undefined;
                location?: string | undefined;
                email?: string | undefined;
                emailVerified?: boolean | undefined;
                linkedinUrl?: string | undefined;
            }[] | undefined;
            createdAt?: string | undefined;
            updatedAt?: string | undefined;
            contact?: {
                _id: string;
                smmUserId: string;
                sponsorId: string;
                status?: ("to_contact" | "contacted" | "in_discussion" | "deal") | undefined;
                contactedAt?: string | undefined;
                favorite?: boolean | undefined;
                dismissed?: boolean | undefined;
                note?: string | undefined;
                createdAt?: string | undefined;
                updatedAt?: string | undefined;
            } | undefined;
        }[];
        total: number;
    };
};

/** get /v1/open/sponsors */
interface GetV1OpenSponsorsPositiveResponseVariants {
    200: GetV1OpenSponsorsPositiveVariant1;
}

/** get /v1/open/sponsors */
type GetV1OpenSponsorsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/open/sponsors */
interface GetV1OpenSponsorsNegativeResponseVariants {
    400: GetV1OpenSponsorsNegativeVariant1;
}

/** get /v1/open/sponsors/tags */
type GetV1OpenSponsorsTagsInput = {};

/** get /v1/open/sponsors/tags */
type GetV1OpenSponsorsTagsPositiveVariant1 = {
    status: "success";
    data: {
        tags: {
            tag: string;
            count: number;
        }[];
    };
};

/** get /v1/open/sponsors/tags */
interface GetV1OpenSponsorsTagsPositiveResponseVariants {
    200: GetV1OpenSponsorsTagsPositiveVariant1;
}

/** get /v1/open/sponsors/tags */
type GetV1OpenSponsorsTagsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/open/sponsors/tags */
interface GetV1OpenSponsorsTagsNegativeResponseVariants {
    400: GetV1OpenSponsorsTagsNegativeVariant1;
}

/** get /v1/open/sponsors/tracked */
type GetV1OpenSponsorsTrackedInput = {};

/** get /v1/open/sponsors/tracked */
type GetV1OpenSponsorsTrackedPositiveVariant1 = {
    status: "success";
    data: {
        sponsors: {
            _id: string;
            name: string;
            contactEmail?: (string | null) | undefined;
            contactName?: string | undefined;
            websiteUrl?: string | undefined;
            logoUrl?: string | undefined;
            sector?: string | undefined;
            contentTypes: string[];
            description?: string | undefined;
            creatorsCount?: (number | null) | undefined;
            mentionsCount?: (number | null) | undefined;
            mentionsSince?: (string | null) | undefined;
            mentionsOverTime?: ({
                date: string;
                count: number;
            }[] | null) | undefined;
            topCategories?: ({
                name: string;
                count: number;
            }[] | null) | undefined;
            sponsorshipCategories?: ({
                name: string;
                path: string;
                rank?: (number | null) | undefined;
                mentionsCount?: (number | null) | undefined;
                creatorsCount?: (number | null) | undefined;
                sponsorshipUuid?: string | undefined;
            }[] | null) | undefined;
            sponsorshipSourceCategory?: (string | null) | undefined;
            sponsorshipSourceUuid?: (string | null) | undefined;
            sponsorshipSourceUrl?: (string | null) | undefined;
            sponsorshipSourceUpdatedAt?: (string | null) | undefined;
            sponsorshipInsightsScrapedAt?: (string | null) | undefined;
            medianSubscribers?: (number | null) | undefined;
            medianVideoViews?: (number | null) | undefined;
            firstSponsoredAt?: (string | null) | undefined;
            similarBrands?: (string[] | null) | undefined;
            source?: string | undefined;
            keyContacts?: {
                fullName: string;
                firstName?: string | undefined;
                lastName?: string | undefined;
                title?: string | undefined;
                location?: string | undefined;
                email?: string | undefined;
                emailVerified?: boolean | undefined;
                linkedinUrl?: string | undefined;
            }[] | undefined;
            createdAt?: string | undefined;
            updatedAt?: string | undefined;
            contact?: {
                _id: string;
                smmUserId: string;
                sponsorId: string;
                status?: ("to_contact" | "contacted" | "in_discussion" | "deal") | undefined;
                contactedAt?: string | undefined;
                favorite?: boolean | undefined;
                dismissed?: boolean | undefined;
                note?: string | undefined;
                createdAt?: string | undefined;
                updatedAt?: string | undefined;
            } | undefined;
        }[];
    };
};

/** get /v1/open/sponsors/tracked */
interface GetV1OpenSponsorsTrackedPositiveResponseVariants {
    200: GetV1OpenSponsorsTrackedPositiveVariant1;
}

/** get /v1/open/sponsors/tracked */
type GetV1OpenSponsorsTrackedNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/open/sponsors/tracked */
interface GetV1OpenSponsorsTrackedNegativeResponseVariants {
    400: GetV1OpenSponsorsTrackedNegativeVariant1;
}

/** put /v1/open/sponsors/contact */
type PutV1OpenSponsorsContactInput = {
    sponsorId: string;
    status?: ("to_contact" | "contacted" | "in_discussion" | "deal") | undefined;
    note?: string | undefined;
};

/** put /v1/open/sponsors/contact */
type PutV1OpenSponsorsContactPositiveVariant1 = {
    status: "success";
    data: {
        contact: {
            _id: string;
            smmUserId: string;
            sponsorId: string;
            status?: ("to_contact" | "contacted" | "in_discussion" | "deal") | undefined;
            contactedAt?: string | undefined;
            favorite?: boolean | undefined;
            dismissed?: boolean | undefined;
            note?: string | undefined;
            createdAt?: string | undefined;
            updatedAt?: string | undefined;
        };
    };
};

/** put /v1/open/sponsors/contact */
interface PutV1OpenSponsorsContactPositiveResponseVariants {
    200: PutV1OpenSponsorsContactPositiveVariant1;
}

/** put /v1/open/sponsors/contact */
type PutV1OpenSponsorsContactNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** put /v1/open/sponsors/contact */
interface PutV1OpenSponsorsContactNegativeResponseVariants {
    400: PutV1OpenSponsorsContactNegativeVariant1;
}

/** get /v1/open/sponsors/:sponsorId */
type GetV1OpenSponsorsSponsorIdInput = {
    sponsorId: string;
};

/** get /v1/open/sponsors/:sponsorId */
type GetV1OpenSponsorsSponsorIdPositiveVariant1 = {
    status: "success";
    data: {
        sponsor: {
            _id: string;
            name: string;
            contactEmail?: (string | null) | undefined;
            contactName?: string | undefined;
            websiteUrl?: string | undefined;
            logoUrl?: string | undefined;
            sector?: string | undefined;
            contentTypes: string[];
            description?: string | undefined;
            creatorsCount?: (number | null) | undefined;
            mentionsCount?: (number | null) | undefined;
            mentionsSince?: (string | null) | undefined;
            mentionsOverTime?: ({
                date: string;
                count: number;
            }[] | null) | undefined;
            topCategories?: ({
                name: string;
                count: number;
            }[] | null) | undefined;
            sponsorshipCategories?: ({
                name: string;
                path: string;
                rank?: (number | null) | undefined;
                mentionsCount?: (number | null) | undefined;
                creatorsCount?: (number | null) | undefined;
                sponsorshipUuid?: string | undefined;
            }[] | null) | undefined;
            sponsorshipSourceCategory?: (string | null) | undefined;
            sponsorshipSourceUuid?: (string | null) | undefined;
            sponsorshipSourceUrl?: (string | null) | undefined;
            sponsorshipSourceUpdatedAt?: (string | null) | undefined;
            sponsorshipInsightsScrapedAt?: (string | null) | undefined;
            medianSubscribers?: (number | null) | undefined;
            medianVideoViews?: (number | null) | undefined;
            firstSponsoredAt?: (string | null) | undefined;
            similarBrands?: (string[] | null) | undefined;
            source?: string | undefined;
            keyContacts?: {
                fullName: string;
                firstName?: string | undefined;
                lastName?: string | undefined;
                title?: string | undefined;
                location?: string | undefined;
                email?: string | undefined;
                emailVerified?: boolean | undefined;
                linkedinUrl?: string | undefined;
            }[] | undefined;
            createdAt?: string | undefined;
            updatedAt?: string | undefined;
            contact?: {
                _id: string;
                smmUserId: string;
                sponsorId: string;
                status?: ("to_contact" | "contacted" | "in_discussion" | "deal") | undefined;
                contactedAt?: string | undefined;
                favorite?: boolean | undefined;
                dismissed?: boolean | undefined;
                note?: string | undefined;
                createdAt?: string | undefined;
                updatedAt?: string | undefined;
            } | undefined;
        };
    };
};

/** get /v1/open/sponsors/:sponsorId */
interface GetV1OpenSponsorsSponsorIdPositiveResponseVariants {
    200: GetV1OpenSponsorsSponsorIdPositiveVariant1;
}

/** get /v1/open/sponsors/:sponsorId */
type GetV1OpenSponsorsSponsorIdNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/open/sponsors/:sponsorId */
interface GetV1OpenSponsorsSponsorIdNegativeResponseVariants {
    400: GetV1OpenSponsorsSponsorIdNegativeVariant1;
}

/** get /v1/open/sponsors/:sponsorId/outreach-context */
type GetV1OpenSponsorsSponsorIdOutreachContextInput = {
    sponsorId: string;
};

/** get /v1/open/sponsors/:sponsorId/outreach-context */
type GetV1OpenSponsorsSponsorIdOutreachContextPositiveVariant1 = {
    status: "success";
    data: {
        creator: {
            id: string;
            name?: string | undefined;
            title?: string | undefined;
            followers?: number | undefined;
            medianViewsPerPost?: number | undefined;
        };
        profileUrl: string;
        signupUrl: string;
        sponsor: {
            _id: string;
            name: string;
            contactEmail?: string | undefined;
            contactName?: string | undefined;
            websiteUrl?: string | undefined;
            sector?: string | undefined;
            contentTypes: string[];
            description?: string | undefined;
            creatorsCount?: (number | null) | undefined;
            mentionsCount?: (number | null) | undefined;
            medianSubscribers?: (number | null) | undefined;
            medianVideoViews?: (number | null) | undefined;
        };
        keyContacts: {
            fullName: string;
            firstName?: string | undefined;
            lastName?: string | undefined;
            title?: string | undefined;
            location?: string | undefined;
            email?: string | undefined;
            emailVerified?: boolean | undefined;
            linkedinUrl?: string | undefined;
        }[];
        contactStatus?: ("to_contact" | "contacted" | "in_discussion" | "deal") | undefined;
    };
};

/** get /v1/open/sponsors/:sponsorId/outreach-context */
interface GetV1OpenSponsorsSponsorIdOutreachContextPositiveResponseVariants {
    200: GetV1OpenSponsorsSponsorIdOutreachContextPositiveVariant1;
}

/** get /v1/open/sponsors/:sponsorId/outreach-context */
type GetV1OpenSponsorsSponsorIdOutreachContextNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/open/sponsors/:sponsorId/outreach-context */
interface GetV1OpenSponsorsSponsorIdOutreachContextNegativeResponseVariants {
    400: GetV1OpenSponsorsSponsorIdOutreachContextNegativeVariant1;
}

/** get /v1/open/brand/brands */
type GetV1OpenBrandBrandsInput = {};

/** get /v1/open/brand/brands */
type GetV1OpenBrandBrandsPositiveVariant1 = {
    status: "success";
    data: {
        brands: {
            _id: string;
            name: string;
            websiteUrl?: string | undefined;
            description?: string | undefined;
            numberOfActiveCampaigns: number;
        }[];
    };
};

/** get /v1/open/brand/brands */
interface GetV1OpenBrandBrandsPositiveResponseVariants {
    200: GetV1OpenBrandBrandsPositiveVariant1;
}

/** get /v1/open/brand/brands */
type GetV1OpenBrandBrandsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/open/brand/brands */
interface GetV1OpenBrandBrandsNegativeResponseVariants {
    400: GetV1OpenBrandBrandsNegativeVariant1;
}

/** post /v1/open/brand/brands */
type PostV1OpenBrandBrandsInput = {
    name: string;
    websiteUrl?: undefined | undefined;
    country?: string | undefined;
    language?: string | undefined;
    description?: undefined | undefined;
    logoKey?: string | undefined;
    filesKeys?: string[] | undefined;
    keyFeatures?: string | undefined;
    linkedinUrl?: undefined | undefined;
    socialProofs?: ({
        type: "metric";
        value: number;
        name: string;
    } | {
        type: "rating";
        rating: number;
        maxRating?: number | undefined;
        plateform: string;
    })[] | undefined;
    targetAudience?: {
        occupations: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | null;
        occupationSeniority: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | null;
        companySize: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | null;
        industries: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | null;
        locations: string[] | null;
    } | undefined;
    targetCustomers?: undefined | undefined;
};

/** post /v1/open/brand/brands */
type PostV1OpenBrandBrandsPositiveVariant1 = {
    status: "success";
    data: {
        brand: {
            _id: string;
            name: string;
            websiteUrl?: string | undefined;
            description?: string | undefined;
        };
    };
};

/** post /v1/open/brand/brands */
interface PostV1OpenBrandBrandsPositiveResponseVariants {
    200: PostV1OpenBrandBrandsPositiveVariant1;
}

/** post /v1/open/brand/brands */
type PostV1OpenBrandBrandsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/open/brand/brands */
interface PostV1OpenBrandBrandsNegativeResponseVariants {
    400: PostV1OpenBrandBrandsNegativeVariant1;
}

/** get /v1/open/brand/creators */
type GetV1OpenBrandCreatorsInput = {
    ids?: undefined | undefined;
    excludedIds?: undefined | undefined;
    creatorListId?: string | undefined;
    searchQuery?: string | undefined;
    followers?: number | undefined;
    language?: string | undefined;
    viewsPeriod?: ("past_7_days" | "past_14_days" | "past_28_days" | "past_90_days" | "past_365_days" | "custom_timerange") | undefined;
    viewsCountForPeriod?: number | undefined;
    viewsPerPost?: number | undefined;
    industry?: undefined | undefined;
    occupationSeniority?: undefined | undefined;
    occupation?: undefined | undefined;
    location?: undefined | undefined;
    companySize?: undefined | undefined;
    pricePerPost?: number | undefined;
    postKeyword?: string | undefined;
    postKeywordDays?: number | undefined;
    page?: number | undefined;
    size?: number | undefined;
    sort?: any | undefined;
};

/** get /v1/open/brand/creators */
type GetV1OpenBrandCreatorsPositiveVariant1 = {
    status: "success";
    data: {
        total: number;
        creators: {
            _id: string;
            smmUserId?: string | undefined;
            name?: string | undefined;
            givenName: string;
            familyName: string;
            linkedinId?: string | undefined;
            linkedinUrl?: string | undefined;
            title?: string | undefined;
            picture?: (string | null) | undefined;
            language?: string | undefined;
            avgViewsPerPost?: (number | null) | undefined;
            medianViewsPerPost?: (number | null) | undefined;
            followers?: number | undefined;
            membersReached?: number | undefined;
            sector?: string | undefined;
            pricePerPost?: (number | null) | undefined;
            defaultCap?: (number | null) | undefined;
            impressions?: ({
                timeRange: "past_7_days" | "past_14_days" | "past_28_days" | "past_90_days" | "past_365_days" | "custom_timerange";
                data: {
                    totalValue?: (number | null) | undefined;
                    percentageChange?: (number | null) | undefined;
                    series: {
                        value?: (number | null) | undefined;
                        date?: (string | null) | undefined;
                    }[];
                    impressions: {
                        value?: (string | null) | undefined;
                        percentageChange?: (number | null) | undefined;
                    };
                    reached: {
                        value?: (string | null) | undefined;
                        percentageChange?: (number | null) | undefined;
                    };
                    topPosts?: {
                        urn: string;
                        reactions?: (number | null) | undefined;
                        comments?: (number | null) | undefined;
                        shares?: (number | null) | undefined;
                        text?: string | undefined;
                        impressions?: string | undefined;
                        date?: string | undefined;
                    }[] | undefined;
                };
            }[] | null) | undefined;
            followersDemographics?: ({
                category: "occupation_title" | "location" | "industry" | "occupation_seniority" | "company_size" | "company_name";
                data: {
                    label: string;
                    value: number;
                    normalizedLabel?: (string | null) | undefined;
                }[];
            }[] | null) | undefined;
            updatedAt?: string | undefined;
            isPrivate?: boolean | undefined;
        }[];
    };
};

/** get /v1/open/brand/creators */
interface GetV1OpenBrandCreatorsPositiveResponseVariants {
    200: GetV1OpenBrandCreatorsPositiveVariant1;
}

/** get /v1/open/brand/creators */
type GetV1OpenBrandCreatorsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/open/brand/creators */
interface GetV1OpenBrandCreatorsNegativeResponseVariants {
    400: GetV1OpenBrandCreatorsNegativeVariant1;
}

/** post /v1/open/brand/campaigns */
type PostV1OpenBrandCampaignsInput = {
    campaignData: {
        name: string;
        description: string;
        brandId: string;
        targets: {
            minFollowers?: (number | null) | undefined;
            minViews?: (number | null) | undefined;
            minViewsLast28Days?: (number | null) | undefined;
            language?: (string | null) | undefined;
            audienceLocation?: string[] | undefined;
            hierarchyLevel?: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | undefined;
            industry?: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | undefined;
            companySize?: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | undefined;
            occupation?: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | undefined;
        };
        framing: {
            startDate: string;
            endDate?: string | undefined;
            publicationStartDate?: string | undefined;
            publicationEndDate?: string | undefined;
            maxBudgetPerPost?: number | undefined;
            cpm?: number | undefined;
            totalBudget: number;
            totalUsedBudget?: number | undefined;
            autoValidateContent: boolean;
            autoAcceptCreators: boolean;
        };
        utmLink?: string | undefined;
        promoCode?: string | undefined;
        firstMessagesToAcceptedCreators?: ({
            type: "text";
            text: string;
            priceEUR?: number | undefined;
            cpmEUR?: number | undefined;
        } | {
            type: "image";
            src?: string | undefined;
            metadata: {
                name: string;
                size: number;
                type: string;
                fileKey: string;
            };
        } | {
            type: "file";
            src?: string | undefined;
            metadata: {
                name: string;
                size: number;
                type: string;
                fileKey: string;
            };
        })[] | undefined;
    };
};

/** post /v1/open/brand/campaigns */
type PostV1OpenBrandCampaignsPositiveVariant1 = {
    status: "success";
    data: {
        campaignId: string;
        status: string;
        paymentUrl: string;
    };
};

/** post /v1/open/brand/campaigns */
interface PostV1OpenBrandCampaignsPositiveResponseVariants {
    200: PostV1OpenBrandCampaignsPositiveVariant1;
}

/** post /v1/open/brand/campaigns */
type PostV1OpenBrandCampaignsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/open/brand/campaigns */
interface PostV1OpenBrandCampaignsNegativeResponseVariants {
    400: PostV1OpenBrandCampaignsNegativeVariant1;
}

/** post /v1/open/brand/campaigns/invite */
type PostV1OpenBrandCampaignsInviteInput = {
    campaignId: string;
    creatorIds: string[];
    reason: string;
    price?: number | undefined;
    cpm?: number | undefined;
    maxAmount?: number | undefined;
    useAutoPrice?: boolean | undefined;
};

/** post /v1/open/brand/campaigns/invite */
type PostV1OpenBrandCampaignsInvitePositiveVariant1 = {
    status: "success";
    data: {
        invited: number;
        ignored: number;
    };
};

/** post /v1/open/brand/campaigns/invite */
interface PostV1OpenBrandCampaignsInvitePositiveResponseVariants {
    200: PostV1OpenBrandCampaignsInvitePositiveVariant1;
}

/** post /v1/open/brand/campaigns/invite */
type PostV1OpenBrandCampaignsInviteNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/open/brand/campaigns/invite */
interface PostV1OpenBrandCampaignsInviteNegativeResponseVariants {
    400: PostV1OpenBrandCampaignsInviteNegativeVariant1;
}

/** post /v1/adm/conversations/send-automatic-message */
type PostV1AdmConversationsSendAutomaticMessageInput = {
    campaignId: string;
    automaticNotificationContentData: {
        notificationType: "creator_offer_submitted";
        price: number;
        cpm?: number | undefined;
        maxAmount?: number | undefined;
    } | {
        notificationType: "creator_offer_accepted";
        utmLink?: string | undefined;
        promoCode?: string | undefined;
        creatorsPaidByBrand?: boolean | undefined;
    } | {
        notificationType: "creator_offer_rejected";
        rejectionReason: string;
    } | {
        notificationType: "creator_counter_offer";
        price: number;
        cpm?: number | undefined;
        maxAmount?: number | undefined;
        reason?: string | undefined;
    } | {
        notificationType: "creator_excluded_from_campaign";
        exclusionReason: string;
    } | {
        notificationType: "campaign_offer_submitted";
        price: number;
        cpm?: number | undefined;
        maxAmount?: number | undefined;
    } | {
        notificationType: "campaign_offer_accepted";
        utmLink?: string | undefined;
        promoCode?: string | undefined;
        creatorsPaidByBrand?: boolean | undefined;
    } | {
        notificationType: "campaign_offer_rejected";
    } | {
        notificationType: "campaign_counter_offer";
        price: number;
        cpm?: number | undefined;
        maxAmount?: number | undefined;
        reason?: string | undefined;
    } | {
        notificationType: "post_to_review";
        postId: string;
        campaignId: string;
    } | {
        notificationType: "post_scheduled";
        postId: string;
        campaignId: string;
    } | {
        notificationType: "post_published";
        postId: string;
        linkedinPostId?: string | undefined;
    } | {
        notificationType: "post_rejected";
        postId: string;
        campaignId: string;
        rejectionReason: string;
    } | {
        notificationType: "post_validated";
        postId: string;
        campaignId: string;
    } | {
        notificationType: "post_comment_added";
        postId: string;
        campaignId: string;
        commentId: string;
    } | {
        notificationType: "post_comment_updated";
        postId: string;
        campaignId: string;
        commentId: string;
    } | {
        notificationType: "post_comment_removed";
        postId: string;
        campaignId: string;
        commentId: string;
    } | {
        notificationType: "post_attachment_added";
        postId: string;
        campaignId: string;
        attachmentName: string;
    } | {
        notificationType: "post_attachment_updated";
        postId: string;
        campaignId: string;
        attachmentName: string;
    } | {
        notificationType: "post_attachment_removed";
        postId: string;
        campaignId: string;
        attachmentName: string;
    } | {
        notificationType: "sponsored_post_payment_received";
        linkedinPostId?: string | undefined;
        campaignId: string;
        campaignName: string;
        amount: number;
        currency?: ("EUR" | "USD") | undefined;
    } | {
        notificationType: "sponsored_post_payment_failed";
        linkedinPostId?: string | undefined;
        campaignId: string;
        campaignName: string;
        amount: number;
        currency?: ("EUR" | "USD") | undefined;
    } | {
        notificationType: "campaign_closed";
        campaignId: string;
        campaignName: string;
    };
    smmUserId: string;
};

/** post /v1/adm/conversations/send-automatic-message */
type PostV1AdmConversationsSendAutomaticMessagePositiveVariant1 = {
    status: "success";
    data: {
        message: {
            _id: string;
            idempotencyKey?: string | undefined;
            conversationId: string;
            authorId: string;
            type: "user";
            content: {
                type: "text";
                text: string;
                priceEUR?: number | undefined;
                cpmEUR?: number | undefined;
            } | {
                type: "image";
                src?: string | undefined;
                metadata: {
                    name: string;
                    size: number;
                    type: string;
                    fileKey: string;
                };
            } | {
                type: "file";
                src?: string | undefined;
                metadata: {
                    name: string;
                    size: number;
                    type: string;
                    fileKey: string;
                };
            };
            createdAt: string;
        } | {
            _id: string;
            idempotencyKey?: string | undefined;
            conversationId: string;
            type: "automatic";
            content: {
                notificationType: "creator_offer_submitted";
                price: number;
                cpm?: number | undefined;
                maxAmount?: number | undefined;
            } | {
                notificationType: "creator_offer_accepted";
                utmLink?: string | undefined;
                promoCode?: string | undefined;
                creatorsPaidByBrand?: boolean | undefined;
            } | {
                notificationType: "creator_offer_rejected";
                rejectionReason: string;
            } | {
                notificationType: "creator_counter_offer";
                price: number;
                cpm?: number | undefined;
                maxAmount?: number | undefined;
                reason?: string | undefined;
            } | {
                notificationType: "creator_excluded_from_campaign";
                exclusionReason: string;
            } | {
                notificationType: "campaign_offer_submitted";
                price: number;
                cpm?: number | undefined;
                maxAmount?: number | undefined;
            } | {
                notificationType: "campaign_offer_accepted";
                utmLink?: string | undefined;
                promoCode?: string | undefined;
                creatorsPaidByBrand?: boolean | undefined;
            } | {
                notificationType: "campaign_offer_rejected";
            } | {
                notificationType: "campaign_counter_offer";
                price: number;
                cpm?: number | undefined;
                maxAmount?: number | undefined;
                reason?: string | undefined;
            } | {
                notificationType: "post_to_review";
                postId: string;
                campaignId: string;
            } | {
                notificationType: "post_scheduled";
                postId: string;
                campaignId: string;
            } | {
                notificationType: "post_published";
                postId: string;
                linkedinPostId?: string | undefined;
            } | {
                notificationType: "post_rejected";
                postId: string;
                campaignId: string;
                rejectionReason: string;
            } | {
                notificationType: "post_validated";
                postId: string;
                campaignId: string;
            } | {
                notificationType: "post_comment_added";
                postId: string;
                campaignId: string;
                commentId: string;
            } | {
                notificationType: "post_comment_updated";
                postId: string;
                campaignId: string;
                commentId: string;
            } | {
                notificationType: "post_comment_removed";
                postId: string;
                campaignId: string;
                commentId: string;
            } | {
                notificationType: "post_attachment_added";
                postId: string;
                campaignId: string;
                attachmentName: string;
            } | {
                notificationType: "post_attachment_updated";
                postId: string;
                campaignId: string;
                attachmentName: string;
            } | {
                notificationType: "post_attachment_removed";
                postId: string;
                campaignId: string;
                attachmentName: string;
            } | {
                notificationType: "sponsored_post_payment_received";
                linkedinPostId?: string | undefined;
                campaignId: string;
                campaignName: string;
                amount: number;
                currency?: ("EUR" | "USD") | undefined;
            } | {
                notificationType: "sponsored_post_payment_failed";
                linkedinPostId?: string | undefined;
                campaignId: string;
                campaignName: string;
                amount: number;
                currency?: ("EUR" | "USD") | undefined;
            } | {
                notificationType: "campaign_closed";
                campaignId: string;
                campaignName: string;
            };
            createdAt: string;
        };
    };
};

/** post /v1/adm/conversations/send-automatic-message */
interface PostV1AdmConversationsSendAutomaticMessagePositiveResponseVariants {
    200: PostV1AdmConversationsSendAutomaticMessagePositiveVariant1;
}

/** post /v1/adm/conversations/send-automatic-message */
type PostV1AdmConversationsSendAutomaticMessageNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/adm/conversations/send-automatic-message */
interface PostV1AdmConversationsSendAutomaticMessageNegativeResponseVariants {
    400: PostV1AdmConversationsSendAutomaticMessageNegativeVariant1;
}

/** post /v1/adm/populateOneCreator */
type PostV1AdmPopulateOneCreatorInput = {
    smmUserId: string;
    linkedinNumId: string;
};

/** post /v1/adm/populateOneCreator */
type PostV1AdmPopulateOneCreatorPositiveVariant1 = {
    status: "success";
    data: {};
};

/** post /v1/adm/populateOneCreator */
interface PostV1AdmPopulateOneCreatorPositiveResponseVariants {
    200: PostV1AdmPopulateOneCreatorPositiveVariant1;
}

/** post /v1/adm/populateOneCreator */
type PostV1AdmPopulateOneCreatorNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/adm/populateOneCreator */
interface PostV1AdmPopulateOneCreatorNegativeResponseVariants {
    400: PostV1AdmPopulateOneCreatorNegativeVariant1;
}

/** post /v1/adm/populateAllCreators */
type PostV1AdmPopulateAllCreatorsInput = {};

/** post /v1/adm/populateAllCreators */
type PostV1AdmPopulateAllCreatorsPositiveVariant1 = {
    status: "success";
    data: {};
};

/** post /v1/adm/populateAllCreators */
interface PostV1AdmPopulateAllCreatorsPositiveResponseVariants {
    200: PostV1AdmPopulateAllCreatorsPositiveVariant1;
}

/** post /v1/adm/populateAllCreators */
type PostV1AdmPopulateAllCreatorsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/adm/populateAllCreators */
interface PostV1AdmPopulateAllCreatorsNegativeResponseVariants {
    400: PostV1AdmPopulateAllCreatorsNegativeVariant1;
}

/** post /v1/adm/excludeCreator */
type PostV1AdmExcludeCreatorInput = {
    creatorId: string;
    creatorApplicationId: string;
    exclusionReason: string;
    influenceUserId: string;
};

/** post /v1/adm/excludeCreator */
type PostV1AdmExcludeCreatorPositiveVariant1 = {
    status: "success";
    data: {
        success: boolean;
    };
};

/** post /v1/adm/excludeCreator */
interface PostV1AdmExcludeCreatorPositiveResponseVariants {
    200: PostV1AdmExcludeCreatorPositiveVariant1;
}

/** post /v1/adm/excludeCreator */
type PostV1AdmExcludeCreatorNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/adm/excludeCreator */
interface PostV1AdmExcludeCreatorNegativeResponseVariants {
    400: PostV1AdmExcludeCreatorNegativeVariant1;
}

/** post /v1/adm/runPostChecks */
type PostV1AdmRunPostChecksInput = {
    postId: string;
};

/** post /v1/adm/runPostChecks */
type PostV1AdmRunPostChecksPositiveVariant1 = {
    status: "success";
    data: {};
};

/** post /v1/adm/runPostChecks */
interface PostV1AdmRunPostChecksPositiveResponseVariants {
    200: PostV1AdmRunPostChecksPositiveVariant1;
}

/** post /v1/adm/runPostChecks */
type PostV1AdmRunPostChecksNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/adm/runPostChecks */
interface PostV1AdmRunPostChecksNegativeResponseVariants {
    400: PostV1AdmRunPostChecksNegativeVariant1;
}

/** get /v1/stf/linkedin-message-recovery */
type GetV1StfLinkedinMessageRecoveryInput = {};

/** get /v1/stf/linkedin-message-recovery */
type GetV1StfLinkedinMessageRecoveryPositiveVariant1 = {
    status: "success";
    data: {
        messages: {
            claimId: string;
            campaignId: string;
            threadId: string;
            claimedAt: string;
            status: "dispatching" | "uncertain" | "sent" | "rejected";
        }[];
    };
};

/** get /v1/stf/linkedin-message-recovery */
interface GetV1StfLinkedinMessageRecoveryPositiveResponseVariants {
    200: GetV1StfLinkedinMessageRecoveryPositiveVariant1;
}

/** get /v1/stf/linkedin-message-recovery */
type GetV1StfLinkedinMessageRecoveryNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/stf/linkedin-message-recovery */
interface GetV1StfLinkedinMessageRecoveryNegativeResponseVariants {
    400: GetV1StfLinkedinMessageRecoveryNegativeVariant1;
}

/** post /v1/stf/linkedin-message-recovery/confirm-not-sent */
type PostV1StfLinkedinMessageRecoveryConfirmNotSentInput = {
    claimId: string;
    expectedClaimedAt: string;
    evidence: string;
};

/** post /v1/stf/linkedin-message-recovery/confirm-not-sent */
type PostV1StfLinkedinMessageRecoveryConfirmNotSentPositiveVariant1 = {
    status: "success";
    data: {
        resolved: boolean;
    };
};

/** post /v1/stf/linkedin-message-recovery/confirm-not-sent */
interface PostV1StfLinkedinMessageRecoveryConfirmNotSentPositiveResponseVariants {
    200: PostV1StfLinkedinMessageRecoveryConfirmNotSentPositiveVariant1;
}

/** post /v1/stf/linkedin-message-recovery/confirm-not-sent */
type PostV1StfLinkedinMessageRecoveryConfirmNotSentNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/stf/linkedin-message-recovery/confirm-not-sent */
interface PostV1StfLinkedinMessageRecoveryConfirmNotSentNegativeResponseVariants {
    400: PostV1StfLinkedinMessageRecoveryConfirmNotSentNegativeVariant1;
}

/** get /v1/stf/linkedin-pool */
type GetV1StfLinkedinPoolInput = {};

/** get /v1/stf/linkedin-pool */
type GetV1StfLinkedinPoolPositiveVariant1 = {
    status: "success";
    data: {
        sendingEnabled: boolean;
        accounts: {
            accountId: string;
            label: string;
            enabled: boolean;
            status: "disabled" | "disconnected" | "pending" | "connected" | "paused" | "too_few_connections";
            profileName?: string | undefined;
            weeklyQuota: number;
            sentThisWeek: number;
            sentToday: number;
            invited: number;
            accepted: number;
            replied: number;
            recruited: number;
            pauseReason?: string | undefined;
            pausedUntil?: string | undefined;
            loginJobId?: string | undefined;
            campaigns: {
                campaignId: string;
                name: string;
            }[];
        }[];
        capacity: {
            weeklyCapacity: number;
            remainingThisWeek: number;
            committedCampaigns: number;
            additionalCampaigns: number;
        };
        history: {
            id: string;
            actorId: string;
            action: "created" | "enabled" | "paused" | "login_started" | "disconnected" | "reserved" | "restriction";
            accountId?: string | undefined;
            campaignId?: string | undefined;
            at: string;
        }[];
    };
};

/** get /v1/stf/linkedin-pool */
interface GetV1StfLinkedinPoolPositiveResponseVariants {
    200: GetV1StfLinkedinPoolPositiveVariant1;
}

/** get /v1/stf/linkedin-pool */
type GetV1StfLinkedinPoolNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/stf/linkedin-pool */
interface GetV1StfLinkedinPoolNegativeResponseVariants {
    400: GetV1StfLinkedinPoolNegativeVariant1;
}

/** post /v1/stf/linkedin-pool */
type PostV1StfLinkedinPoolInput = {
    label: string;
};

/** post /v1/stf/linkedin-pool */
type PostV1StfLinkedinPoolPositiveVariant1 = {
    status: "success";
    data: {
        accountId: string;
    };
};

/** post /v1/stf/linkedin-pool */
interface PostV1StfLinkedinPoolPositiveResponseVariants {
    200: PostV1StfLinkedinPoolPositiveVariant1;
}

/** post /v1/stf/linkedin-pool */
type PostV1StfLinkedinPoolNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/stf/linkedin-pool */
interface PostV1StfLinkedinPoolNegativeResponseVariants {
    400: PostV1StfLinkedinPoolNegativeVariant1;
}

/** patch /v1/stf/linkedin-pool/:accountId */
type PatchV1StfLinkedinPoolAccountIdInput = {
    accountId: string;
    enabled: boolean;
};

/** patch /v1/stf/linkedin-pool/:accountId */
type PatchV1StfLinkedinPoolAccountIdPositiveVariant1 = {
    status: "success";
    data: {};
};

/** patch /v1/stf/linkedin-pool/:accountId */
interface PatchV1StfLinkedinPoolAccountIdPositiveResponseVariants {
    200: PatchV1StfLinkedinPoolAccountIdPositiveVariant1;
}

/** patch /v1/stf/linkedin-pool/:accountId */
type PatchV1StfLinkedinPoolAccountIdNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** patch /v1/stf/linkedin-pool/:accountId */
interface PatchV1StfLinkedinPoolAccountIdNegativeResponseVariants {
    400: PatchV1StfLinkedinPoolAccountIdNegativeVariant1;
}

/** delete /v1/stf/linkedin-pool/:accountId */
type DeleteV1StfLinkedinPoolAccountIdInput = {
    accountId: string;
};

/** delete /v1/stf/linkedin-pool/:accountId */
type DeleteV1StfLinkedinPoolAccountIdPositiveVariant1 = {
    status: "success";
    data: {};
};

/** delete /v1/stf/linkedin-pool/:accountId */
interface DeleteV1StfLinkedinPoolAccountIdPositiveResponseVariants {
    200: DeleteV1StfLinkedinPoolAccountIdPositiveVariant1;
}

/** delete /v1/stf/linkedin-pool/:accountId */
type DeleteV1StfLinkedinPoolAccountIdNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** delete /v1/stf/linkedin-pool/:accountId */
interface DeleteV1StfLinkedinPoolAccountIdNegativeResponseVariants {
    400: DeleteV1StfLinkedinPoolAccountIdNegativeVariant1;
}

/** post /v1/stf/linkedin-pool/:accountId/cloud-login */
type PostV1StfLinkedinPoolAccountIdCloudLoginInput = {
    email: string;
    password: string;
    countryCode: string;
    totpSecret?: string | undefined;
    accountId: string;
};

/** post /v1/stf/linkedin-pool/:accountId/cloud-login */
type PostV1StfLinkedinPoolAccountIdCloudLoginPositiveVariant1 = {
    status: "success";
    data: {
        jobId: string;
        status: "queued" | "accepted" | "needs_user_input" | "succeeded" | "failed";
        inputKind?: string | undefined;
        failureCode?: string | undefined;
    };
};

/** post /v1/stf/linkedin-pool/:accountId/cloud-login */
interface PostV1StfLinkedinPoolAccountIdCloudLoginPositiveResponseVariants {
    200: PostV1StfLinkedinPoolAccountIdCloudLoginPositiveVariant1;
}

/** post /v1/stf/linkedin-pool/:accountId/cloud-login */
type PostV1StfLinkedinPoolAccountIdCloudLoginNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/stf/linkedin-pool/:accountId/cloud-login */
interface PostV1StfLinkedinPoolAccountIdCloudLoginNegativeResponseVariants {
    400: PostV1StfLinkedinPoolAccountIdCloudLoginNegativeVariant1;
}

/** get /v1/stf/linkedin-pool/:accountId/cloud-login */
type GetV1StfLinkedinPoolAccountIdCloudLoginInput = {
    jobId: string;
    accountId: string;
};

/** get /v1/stf/linkedin-pool/:accountId/cloud-login */
type GetV1StfLinkedinPoolAccountIdCloudLoginPositiveVariant1 = {
    status: "success";
    data: {
        jobId: string;
        status: "queued" | "accepted" | "needs_user_input" | "succeeded" | "failed";
        inputKind?: string | undefined;
        failureCode?: string | undefined;
    };
};

/** get /v1/stf/linkedin-pool/:accountId/cloud-login */
interface GetV1StfLinkedinPoolAccountIdCloudLoginPositiveResponseVariants {
    200: GetV1StfLinkedinPoolAccountIdCloudLoginPositiveVariant1;
}

/** get /v1/stf/linkedin-pool/:accountId/cloud-login */
type GetV1StfLinkedinPoolAccountIdCloudLoginNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/stf/linkedin-pool/:accountId/cloud-login */
interface GetV1StfLinkedinPoolAccountIdCloudLoginNegativeResponseVariants {
    400: GetV1StfLinkedinPoolAccountIdCloudLoginNegativeVariant1;
}

/** post /v1/stf/linkedin-pool/:accountId/cloud-login/resume */
type PostV1StfLinkedinPoolAccountIdCloudLoginResumeInput = {
    jobId: string;
    code: string;
    accountId: string;
};

/** post /v1/stf/linkedin-pool/:accountId/cloud-login/resume */
type PostV1StfLinkedinPoolAccountIdCloudLoginResumePositiveVariant1 = {
    status: "success";
    data: {
        jobId: string;
        status: "queued" | "accepted" | "needs_user_input" | "succeeded" | "failed";
        inputKind?: string | undefined;
        failureCode?: string | undefined;
    };
};

/** post /v1/stf/linkedin-pool/:accountId/cloud-login/resume */
interface PostV1StfLinkedinPoolAccountIdCloudLoginResumePositiveResponseVariants {
    200: PostV1StfLinkedinPoolAccountIdCloudLoginResumePositiveVariant1;
}

/** post /v1/stf/linkedin-pool/:accountId/cloud-login/resume */
type PostV1StfLinkedinPoolAccountIdCloudLoginResumeNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/stf/linkedin-pool/:accountId/cloud-login/resume */
interface PostV1StfLinkedinPoolAccountIdCloudLoginResumeNegativeResponseVariants {
    400: PostV1StfLinkedinPoolAccountIdCloudLoginResumeNegativeVariant1;
}

/** get /v1/stf/users */
type GetV1StfUsersInput = {
    page?: number | undefined;
    size?: number | undefined;
    search?: string | undefined;
};

/** get /v1/stf/users */
type GetV1StfUsersPositiveVariant1 = {
    status: "success";
    data: {
        users: {
            _id: string;
            first_name: string;
            last_name: string;
            email: string;
            image_url: string | null;
            id: string;
        }[];
    };
};

/** get /v1/stf/users */
interface GetV1StfUsersPositiveResponseVariants {
    200: GetV1StfUsersPositiveVariant1;
}

/** get /v1/stf/users */
type GetV1StfUsersNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/stf/users */
interface GetV1StfUsersNegativeResponseVariants {
    400: GetV1StfUsersNegativeVariant1;
}

/** get /v1/stf/campaigns */
type GetV1StfCampaignsInput = {
    page?: number | undefined;
    size?: number | undefined;
    search?: string | undefined;
    sortDir?: ("asc" | "desc") | undefined;
};

/** get /v1/stf/campaigns */
type GetV1StfCampaignsPositiveVariant1 = {
    status: "success";
    data: {
        campaigns: {
            _id: string;
            userId: string;
            name: string;
            description: string;
            status: "DRAFT" | "PENDING_PAYMENT" | "ACTIVE" | "PAUSED" | "FINISHED";
            paymentStatus: "PENDING" | "PAID" | "FAILED";
            paymentDeclineCode?: string | undefined;
            targets: {
                minFollowers?: (number | null) | undefined;
                minViews?: (number | null) | undefined;
                minViewsLast28Days?: (number | null) | undefined;
                language?: (string | null) | undefined;
                audienceLocation?: string[] | undefined;
                hierarchyLevel?: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | undefined;
                industry?: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | undefined;
                companySize?: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | undefined;
                occupation?: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | undefined;
            };
            framing: {
                startDate: string;
                endDate?: string | undefined;
                publicationStartDate?: string | undefined;
                publicationEndDate?: string | undefined;
                maxBudgetPerPost?: number | undefined;
                cpm?: number | undefined;
                totalBudget: number;
                totalUsedBudget?: number | undefined;
                autoValidateContent: boolean;
                autoAcceptCreators: boolean;
                autonomousCpmCeilingMultiplier?: (1 | 1.1 | 1.2) | undefined;
                capMode?: ("auto" | "fixed") | undefined;
                fixedCap?: number | undefined;
            };
            objective?: ("awareness" | "traffic" | "demos") | undefined;
            brief?: {
                keyMessage?: string | undefined;
                tones?: ("concrete" | "educational" | "personal" | "light_humour")[] | undefined;
                do?: string[] | undefined;
                avoid?: string[] | undefined;
            } | undefined;
            regions?: string[] | undefined;
            rules?: {
                minTargetAudienceShare?: number | undefined;
                askIfMostlyAbroad?: boolean | undefined;
            } | undefined;
            invitationTemplate?: string | undefined;
            sender?: {
                kind: "own_profile" | "kawaak_managed";
            } | undefined;
            postAcceptanceMode?: ("agent_auto" | "review_24h" | "manual") | undefined;
            draftStep?: ("brand" | "proposal" | "budget" | "launch") | undefined;
            suggestedTargets?: {
                label: string;
                targets: {
                    minFollowers?: (number | null) | undefined;
                    minViews?: (number | null) | undefined;
                    minViewsLast28Days?: (number | null) | undefined;
                    language?: (string | null) | undefined;
                    audienceLocation?: string[] | undefined;
                    hierarchyLevel?: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | undefined;
                    industry?: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | undefined;
                    companySize?: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | undefined;
                    occupation?: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | undefined;
                };
                eligibleCount: number | null;
                reason?: string | undefined;
                audienceReached?: string[] | undefined;
            }[] | undefined;
            agentInstructions?: string[] | undefined;
            budgetReservationTrigger?: ("acceptance" | "post_submission") | undefined;
            nbPostsToReview: number;
            utmLink?: string | undefined;
            promoCode?: string | undefined;
            stripePaymentIntentId?: string | undefined;
            stripeInvoiceId?: string | undefined;
            stripeCheckoutSessionId?: string | undefined;
            stripeRefundId?: string | undefined;
            stripeCreditNoteId?: string | undefined;
            stripeDeferredClosePaymentIntentId?: string | undefined;
            stripeDeferredCloseInvoiceId?: string | undefined;
            paymentSnapshot?: {
                source: "stripe_checkout" | "stripe_payment_intent" | "out_of_band";
                currency: "eur" | "usd";
                conversionRateFromEUR: number;
                budgetAmountInCents: number;
                platformFeeAmountInCents: number;
                taxAmountInCents: number;
                totalAmountInCents: number;
                paidAt: string;
                stripePaymentIntentId?: string | undefined;
                stripeInvoiceId?: string | undefined;
                stripeCheckoutSessionId?: string | undefined;
                externalReference?: string | undefined;
                outOfBandProof?: {
                    proofDocumentKey: string;
                    proofDocumentSha256: string;
                    proofDocumentEtag: string;
                    proofDocumentSizeBytes: number;
                    proofDocumentLastModified: string;
                    proofDocumentContentType: string;
                    proofDocumentVersionId?: string | undefined;
                    bankTransactionReference: string;
                    invoiceReference: string;
                    submittedAt: string;
                    submittedByStaffId: string;
                    approvedAt: string;
                    approvedByStaffId: string;
                } | undefined;
            } | undefined;
            paymentAttempt?: {
                attemptId: string;
                version: number;
                purpose: "INITIAL_DEPOSIT" | "DEFERRED_USAGE";
                state: "creating" | "awaiting_payment" | "paid" | "failed" | "canceled";
                currency: "eur" | "usd";
                conversionRateFromEUR: number;
                budgetAmountInCents: number;
                platformFeeAmountInCents: number;
                customerId: string;
                createdAt: string;
                updatedAt: string;
                cardCheckout?: {
                    expiresAt: number;
                    successUrl: string;
                    cancelUrl: string;
                } | undefined;
                checkoutSessionId?: string | undefined;
                stripeInvoiceId?: string | undefined;
                stripePaymentIntentId?: string | undefined;
                failureCode?: string | undefined;
            } | undefined;
            paymentAttemptHistory?: {
                attemptId: string;
                version: number;
                purpose: "INITIAL_DEPOSIT" | "DEFERRED_USAGE";
                state: "creating" | "awaiting_payment" | "paid" | "failed" | "canceled";
                currency: "eur" | "usd";
                conversionRateFromEUR: number;
                budgetAmountInCents: number;
                platformFeeAmountInCents: number;
                customerId: string;
                createdAt: string;
                updatedAt: string;
                cardCheckout?: {
                    expiresAt: number;
                    successUrl: string;
                    cancelUrl: string;
                } | undefined;
                checkoutSessionId?: string | undefined;
                stripeInvoiceId?: string | undefined;
                stripePaymentIntentId?: string | undefined;
                failureCode?: string | undefined;
            }[] | undefined;
            paymentReconciliationIssues?: {
                attemptId: string;
                stripePaymentIntentId: string;
                amountInCents: number;
                currency: string;
                reason: string;
                detectedAt: string;
            }[] | undefined;
            financialClose?: {
                state: "closing" | "awaiting_deferred_payment" | "manual_refund_required" | "manual_refund_awaiting_approval" | "manual_refund_confirmed" | "refund_pending" | "refund_failed";
                requestedAt: string;
                projectedUsedBudgetInEuros: number;
                ownerId?: string | undefined;
                leaseId?: string | undefined;
                leaseExpiresAt?: string | undefined;
                refundAmountInCents?: number | undefined;
                currency?: ("eur" | "usd") | undefined;
                error?: string | undefined;
                refundFailedAlertedAt?: string | undefined;
            } | undefined;
            agent?: {
                enabled: boolean;
                autonomyLevel?: ("assisted" | "review" | "autonomous") | undefined;
                pausedAt?: string | undefined;
                autonomyStats?: {
                    firstMessagesSent?: number | undefined;
                    firstMessagesApprovedStreak?: number | undefined;
                    repliesSent?: number | undefined;
                    repliesApprovedStreak?: number | undefined;
                } | undefined;
                autonomyProposal?: {
                    status: "proposed" | "accepted" | "refused";
                    trigger: "first_messages_sent" | "first_messages_approved" | "replies_sent" | "replies_approved";
                    proposedAt: string;
                    refusals: number;
                    firstRefusedAt?: string | undefined;
                    nextProposalAt?: string | undefined;
                } | undefined;
                poolExhaustedAt?: {
                    in_app?: string | undefined;
                    linkedin?: string | undefined;
                } | undefined;
                linkedinSourcing?: {
                    nextRunAfter?: string | undefined;
                    lastRunAt?: string | undefined;
                    lastOutcome?: string | undefined;
                    keywords?: string[] | undefined;
                    searchKey?: string | undefined;
                    nextPage?: number | undefined;
                } | undefined;
            } | undefined;
            payoutCreationLocks?: string[] | undefined;
            scheduledPayoutClaims?: string[] | undefined;
            refundedAt?: string | undefined;
            refundedBudgetInCents?: number | undefined;
            refundedFeeInCents?: number | undefined;
            refundedTaxInCents?: number | undefined;
            refundMethod?: ("stripe" | "manual") | undefined;
            manualRefundReference?: string | undefined;
            manualRefundedByStaffId?: string | undefined;
            manualRefundProof?: {
                reference: string;
                amountInCents: number;
                currency: "eur" | "usd";
                executedAt: string;
                proofDocumentKey: string;
                proofDocumentEtag: string;
                proofDocumentSizeBytes: number;
                proofDocumentLastModified: string;
                proofDocumentContentType: string;
                submittedAt: string;
                submittedByStaffId: string;
                confirmedAt?: string | undefined;
                confirmedByStaffId?: string | undefined;
            } | undefined;
            depositedAt?: string | undefined;
            firstMessagesToAcceptedCreators?: ({
                type: "text";
                text: string;
                priceEUR?: number | undefined;
                cpmEUR?: number | undefined;
            } | {
                type: "image";
                src?: string | undefined;
                metadata: {
                    name: string;
                    size: number;
                    type: string;
                    fileKey: string;
                };
            } | {
                type: "file";
                src?: string | undefined;
                metadata: {
                    name: string;
                    size: number;
                    type: string;
                    fileKey: string;
                };
            })[] | undefined;
            closedByStaffAt?: string | undefined;
            deletedAt?: string | undefined;
            currencyConversion: {
                currency: "USD";
                rateFromEUR: number;
                lockedAt: string;
            };
            initialBudgetQuote?: {
                currency: "eur" | "usd";
                budgetAmountInCents: number;
                budgetAmountInEurCents: number;
                conversionRateFromEUR: number;
                quotedAt: string;
            } | undefined;
            budgetDepositStatus?: ("PENDING" | "DEPOSITED") | undefined;
            creatorsPaidByBrand?: boolean | undefined;
            createdAt?: string | undefined;
            brand: {
                _id: string;
                name: string;
                websiteUrl?: string | undefined;
                country?: string | undefined;
                language?: string | undefined;
                description?: string | undefined;
                logoKey?: string | undefined;
                filesKeys?: string[] | undefined;
                keyFeatures?: string | undefined;
                linkedinUrl?: string | undefined;
                socialProofs?: ({
                    type: "metric";
                    value: number;
                    name: string;
                } | {
                    type: "rating";
                    rating: number;
                    maxRating?: number | undefined;
                    plateform: string;
                })[] | undefined;
                targetAudience?: {
                    occupations: ("Marketing" | "Management" | "Accounting" | "Administrative" | "Arts & Design" | "Business Development" | "Community & Social Services" | "Consulting" | "Education" | "Engineering" | "Finance" | "Founder/Owner" | "Healthcare" | "Human Resources" | "Legal" | "Media & Communication" | "Operations" | "Product Management" | "Program & Project Management" | "Purchasing" | "Quality Assurance" | "Real Estate" | "Research" | "Sales" | "Customer Success & Support" | "Freelance" | "Data" | "Other")[] | null;
                    occupationSeniority: ("First job" | "Director" | "Intern" | "Experienced manager" | "Owner / Partner" | "Entry-level manager" | "Executive committee" | "Vice President" | "Strategic" | "Experienced" | "Other")[] | null;
                    companySize: ("1-10" | "11-50" | "51-200" | "201-500" | "501-1000" | "1001-5000" | "5001-10000" | "10000+")[] | null;
                    industries: ("Software & IT" | "Internet & Platforms" | "Hardware & Electronics" | "Finance" | "Insurance" | "Healthcare & Pharma" | "Biotechnology" | "Education" | "Legal & Compliance" | "Marketing & Advertising" | "Media & Entertainment" | "Consulting & Strategy" | "Human Resources" | "Real Estate" | "Retail & Consumer Goods" | "Manufacturing" | "Energy & Utilities" | "Transportation & Logistics" | "Public & Government" | "Non-Profit & Associations" | "Other")[] | null;
                    locations: string[] | null;
                } | undefined;
                targetCustomers?: string | undefined;
                analyzedAt?: string | undefined;
                logoSource?: string | undefined;
            };
        }[];
        total: number;
    };
};

/** get /v1/stf/campaigns */
interface GetV1StfCampaignsPositiveResponseVariants {
    200: GetV1StfCampaignsPositiveVariant1;
}

/** get /v1/stf/campaigns */
type GetV1StfCampaignsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/stf/campaigns */
interface GetV1StfCampaignsNegativeResponseVariants {
    400: GetV1StfCampaignsNegativeVariant1;
}

/** post /v1/stf/campaigns/force-close */
type PostV1StfCampaignsForceCloseInput = {
    campaignId: string;
};

/** post /v1/stf/campaigns/force-close */
type PostV1StfCampaignsForceClosePositiveVariant1 = {
    status: "success";
    data: {
        success: boolean;
        requiresPayment?: boolean | undefined;
        hostedInstructionsUrl?: string | undefined;
        requiresManualRefund?: boolean | undefined;
        manualRefundAmountInCents?: number | undefined;
        manualRefundCurrency?: ("eur" | "usd") | undefined;
    };
};

/** post /v1/stf/campaigns/force-close */
interface PostV1StfCampaignsForceClosePositiveResponseVariants {
    200: PostV1StfCampaignsForceClosePositiveVariant1;
}

/** post /v1/stf/campaigns/force-close */
type PostV1StfCampaignsForceCloseNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/stf/campaigns/force-close */
interface PostV1StfCampaignsForceCloseNegativeResponseVariants {
    400: PostV1StfCampaignsForceCloseNegativeVariant1;
}

/** post /v1/stf/campaigns/confirm-manual-refund */
type PostV1StfCampaignsConfirmManualRefundInput = {
    campaignId: string;
    reference: string;
    amountInCents: number;
    currency: "eur" | "usd";
    executedAt: string;
    proofDocumentKey: string;
};

/** post /v1/stf/campaigns/confirm-manual-refund */
type PostV1StfCampaignsConfirmManualRefundPositiveVariant1 = {
    status: "success";
    data: {
        success: boolean;
        requiresSecondApproval: boolean;
    };
};

/** post /v1/stf/campaigns/confirm-manual-refund */
interface PostV1StfCampaignsConfirmManualRefundPositiveResponseVariants {
    200: PostV1StfCampaignsConfirmManualRefundPositiveVariant1;
}

/** post /v1/stf/campaigns/confirm-manual-refund */
type PostV1StfCampaignsConfirmManualRefundNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/stf/campaigns/confirm-manual-refund */
interface PostV1StfCampaignsConfirmManualRefundNegativeResponseVariants {
    400: PostV1StfCampaignsConfirmManualRefundNegativeVariant1;
}

/** post /v1/stf/campaigns/confirm-out-of-band-payment */
type PostV1StfCampaignsConfirmOutOfBandPaymentInput = {
    campaignId: string;
    proofDocumentKey: string;
    bankTransactionReference: string;
    invoiceReference: string;
};

/** post /v1/stf/campaigns/confirm-out-of-band-payment */
type PostV1StfCampaignsConfirmOutOfBandPaymentPositiveVariant1 = {
    status: "success";
    data: {
        approved: boolean;
        requiresSecondApproval: boolean;
    };
};

/** post /v1/stf/campaigns/confirm-out-of-band-payment */
interface PostV1StfCampaignsConfirmOutOfBandPaymentPositiveResponseVariants {
    200: PostV1StfCampaignsConfirmOutOfBandPaymentPositiveVariant1;
}

/** post /v1/stf/campaigns/confirm-out-of-band-payment */
type PostV1StfCampaignsConfirmOutOfBandPaymentNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/stf/campaigns/confirm-out-of-band-payment */
interface PostV1StfCampaignsConfirmOutOfBandPaymentNegativeResponseVariants {
    400: PostV1StfCampaignsConfirmOutOfBandPaymentNegativeVariant1;
}

/** post /v1/stf/campaigns/delete */
type PostV1StfCampaignsDeleteInput = {
    campaignId: string;
};

/** post /v1/stf/campaigns/delete */
type PostV1StfCampaignsDeletePositiveVariant1 = {
    status: "success";
    data: {
        success: boolean;
    };
};

/** post /v1/stf/campaigns/delete */
interface PostV1StfCampaignsDeletePositiveResponseVariants {
    200: PostV1StfCampaignsDeletePositiveVariant1;
}

/** post /v1/stf/campaigns/delete */
type PostV1StfCampaignsDeleteNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/stf/campaigns/delete */
interface PostV1StfCampaignsDeleteNegativeResponseVariants {
    400: PostV1StfCampaignsDeleteNegativeVariant1;
}

/** post /v1/stf/creator-applications/reinstate */
type PostV1StfCreatorApplicationsReinstateInput = {
    campaignId: string;
    applicationId: string;
    dryRun?: boolean | undefined;
};

/** post /v1/stf/creator-applications/reinstate */
type PostV1StfCreatorApplicationsReinstatePositiveVariant1 = {
    status: "success";
    data: {
        reinstated: boolean;
        state: string;
        campaignName: string;
        campaignStatus: string;
        creatorName?: string | undefined;
        exclusionReason?: string | undefined;
        cap?: number | undefined;
        availableBudget: number;
        capExceedsAvailableBudget: boolean;
    };
};

/** post /v1/stf/creator-applications/reinstate */
interface PostV1StfCreatorApplicationsReinstatePositiveResponseVariants {
    200: PostV1StfCreatorApplicationsReinstatePositiveVariant1;
}

/** post /v1/stf/creator-applications/reinstate */
type PostV1StfCreatorApplicationsReinstateNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/stf/creator-applications/reinstate */
interface PostV1StfCreatorApplicationsReinstateNegativeResponseVariants {
    400: PostV1StfCreatorApplicationsReinstateNegativeVariant1;
}

/** post /v1/stf/generate-actor-token */
type PostV1StfGenerateActorTokenInput = {
    userId: string;
};

/** post /v1/stf/generate-actor-token */
type PostV1StfGenerateActorTokenPositiveVariant1 = {
    status: "success";
    data: {
        token: string;
        url: string;
    };
};

/** post /v1/stf/generate-actor-token */
interface PostV1StfGenerateActorTokenPositiveResponseVariants {
    200: PostV1StfGenerateActorTokenPositiveVariant1;
}

/** post /v1/stf/generate-actor-token */
type PostV1StfGenerateActorTokenNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/stf/generate-actor-token */
interface PostV1StfGenerateActorTokenNegativeResponseVariants {
    400: PostV1StfGenerateActorTokenNegativeVariant1;
}

/** get /v1/stf/nps-ratings */
type GetV1StfNpsRatingsInput = {};

/** get /v1/stf/nps-ratings */
type GetV1StfNpsRatingsPositiveVariant1 = {
    status: "success";
    data: {
        npsRatings: {
            rating: number;
            comment?: string | undefined;
            _id: string;
            source: "smm" | "influence";
            userId: string;
            month: string;
            email?: string | undefined;
            name?: string | undefined;
            createdAt: string;
            updatedAt: string;
        }[];
    };
};

/** get /v1/stf/nps-ratings */
interface GetV1StfNpsRatingsPositiveResponseVariants {
    200: GetV1StfNpsRatingsPositiveVariant1;
}

/** get /v1/stf/nps-ratings */
type GetV1StfNpsRatingsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/stf/nps-ratings */
interface GetV1StfNpsRatingsNegativeResponseVariants {
    400: GetV1StfNpsRatingsNegativeVariant1;
}

/** post /v1/stf/trigger-pay-sponsored-posts */
type PostV1StfTriggerPaySponsoredPostsInput = {
    smmUserId: string;
};

/** post /v1/stf/trigger-pay-sponsored-posts */
type PostV1StfTriggerPaySponsoredPostsPositiveVariant1 = {
    status: "success";
    data: {
        success: boolean;
    };
};

/** post /v1/stf/trigger-pay-sponsored-posts */
interface PostV1StfTriggerPaySponsoredPostsPositiveResponseVariants {
    200: PostV1StfTriggerPaySponsoredPostsPositiveVariant1;
}

/** post /v1/stf/trigger-pay-sponsored-posts */
type PostV1StfTriggerPaySponsoredPostsNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/stf/trigger-pay-sponsored-posts */
interface PostV1StfTriggerPaySponsoredPostsNegativeResponseVariants {
    400: PostV1StfTriggerPaySponsoredPostsNegativeVariant1;
}

/** get /v1/stf/payouts-to-pay */
type GetV1StfPayoutsToPayInput = {};

/** get /v1/stf/payouts-to-pay */
type GetV1StfPayoutsToPayPositiveVariant1 = {
    status: "success";
    data: {
        payouts: {
            payoutId: string;
            creatorName: string;
            accountHolderName?: string | undefined;
            iban?: string | undefined;
            bic?: string | undefined;
            internationalDetails?: string | undefined;
            country?: string | undefined;
            amount: number;
            currency: string;
            invoiceNumber?: string | undefined;
            invoiceUrl?: string | undefined;
            campaignName: string;
            campaignOwnerEmail?: string | undefined;
            publishedAt?: string | undefined;
            isSepaEligible: boolean;
            isTransferable: boolean;
            paymentRail?: ("SEPA" | "INTERNATIONAL") | undefined;
            validationError?: string | undefined;
            transferExportId?: string | undefined;
            transferExportState?: ("reserved" | "confirmation_pending" | "cancellation_pending") | undefined;
        }[];
    };
};

/** get /v1/stf/payouts-to-pay */
interface GetV1StfPayoutsToPayPositiveResponseVariants {
    200: GetV1StfPayoutsToPayPositiveVariant1;
}

/** get /v1/stf/payouts-to-pay */
type GetV1StfPayoutsToPayNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/stf/payouts-to-pay */
interface GetV1StfPayoutsToPayNegativeResponseVariants {
    400: GetV1StfPayoutsToPayNegativeVariant1;
}

/** get /v1/stf/payouts-paid */
type GetV1StfPayoutsPaidInput = {};

/** get /v1/stf/payouts-paid */
type GetV1StfPayoutsPaidPositiveVariant1 = {
    status: "success";
    data: {
        payouts: {
            payoutId: string;
            creatorName: string;
            campaignName: string;
            amount: number;
            currency: string;
            paidAt?: string | undefined;
            paidByName?: string | undefined;
            paymentBatchReference?: string | undefined;
            invoiceNumber?: string | undefined;
            invoiceUrl?: string | undefined;
        }[];
    };
};

/** get /v1/stf/payouts-paid */
interface GetV1StfPayoutsPaidPositiveResponseVariants {
    200: GetV1StfPayoutsPaidPositiveVariant1;
}

/** get /v1/stf/payouts-paid */
type GetV1StfPayoutsPaidNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/stf/payouts-paid */
interface GetV1StfPayoutsPaidNegativeResponseVariants {
    400: GetV1StfPayoutsPaidNegativeVariant1;
}

/** get /v1/stf/payouts-blocked */
type GetV1StfPayoutsBlockedInput = {};

/** get /v1/stf/payouts-blocked */
type GetV1StfPayoutsBlockedPositiveVariant1 = {
    status: "success";
    data: {
        payouts: {
            payoutId: string;
            creatorName: string;
            creatorEmail?: string | undefined;
            campaignName: string;
            amount: number;
            currency: string;
            failureReason?: ("smm_user_not_found" | "payout_informations_invalid" | "campaign_budget_not_enough" | "campaign_not_paid" | "extension_not_active" | "payout_invoice_stale" | "data_integrity_invalid" | "invoice_generation_failed") | undefined;
            date?: string | undefined;
        }[];
    };
};

/** get /v1/stf/payouts-blocked */
interface GetV1StfPayoutsBlockedPositiveResponseVariants {
    200: GetV1StfPayoutsBlockedPositiveVariant1;
}

/** get /v1/stf/payouts-blocked */
type GetV1StfPayoutsBlockedNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** get /v1/stf/payouts-blocked */
interface GetV1StfPayoutsBlockedNegativeResponseVariants {
    400: GetV1StfPayoutsBlockedNegativeVariant1;
}

/** post /v1/stf/payouts/cancel-export */
type PostV1StfPayoutsCancelExportInput = {
    exportId: string;
    reason: string;
    attestedNotSubmittedToBank: true;
};

/** post /v1/stf/payouts/cancel-export */
type PostV1StfPayoutsCancelExportPositiveVariant1 = {
    status: "success";
    data: {
        cancelledCount: number;
        requiresSecondApproval: boolean;
    };
};

/** post /v1/stf/payouts/cancel-export */
interface PostV1StfPayoutsCancelExportPositiveResponseVariants {
    200: PostV1StfPayoutsCancelExportPositiveVariant1;
}

/** post /v1/stf/payouts/cancel-export */
type PostV1StfPayoutsCancelExportNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/stf/payouts/cancel-export */
interface PostV1StfPayoutsCancelExportNegativeResponseVariants {
    400: PostV1StfPayoutsCancelExportNegativeVariant1;
}

/** post /v1/stf/payouts/create-export */
type PostV1StfPayoutsCreateExportInput = {
    payoutIds: string[];
};

/** post /v1/stf/payouts/create-export */
type PostV1StfPayoutsCreateExportPositiveVariant1 = {
    status: "success";
    data: {
        exportId: string;
        csvContent: string;
        csvSha256: string;
        filename: string;
    };
};

/** post /v1/stf/payouts/create-export */
interface PostV1StfPayoutsCreateExportPositiveResponseVariants {
    200: PostV1StfPayoutsCreateExportPositiveVariant1;
}

/** post /v1/stf/payouts/create-export */
type PostV1StfPayoutsCreateExportNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/stf/payouts/create-export */
interface PostV1StfPayoutsCreateExportNegativeResponseVariants {
    400: PostV1StfPayoutsCreateExportNegativeVariant1;
}

/** post /v1/stf/payouts/get-export */
type PostV1StfPayoutsGetExportInput = {
    exportId: string;
};

/** post /v1/stf/payouts/get-export */
type PostV1StfPayoutsGetExportPositiveVariant1 = {
    status: "success";
    data: {
        exportId: string;
        state: "reserved" | "confirmation_pending" | "cancellation_pending";
        payoutIds: string[];
        csvContent: string;
        csvSha256: string;
        filename: string;
        totalAmount: number;
        confirmation?: {
            bankReference: string;
            proofDocumentKey: string;
            proofDocumentUrl: string;
            proofDocumentSha256: string;
            submittedAt: string;
            submittedByStaffId: string;
        } | undefined;
        cancellation?: {
            reason: string;
            attestedNotSubmittedToBank: true;
            submittedAt: string;
            submittedByStaffId: string;
        } | undefined;
    };
};

/** post /v1/stf/payouts/get-export */
interface PostV1StfPayoutsGetExportPositiveResponseVariants {
    200: PostV1StfPayoutsGetExportPositiveVariant1;
}

/** post /v1/stf/payouts/get-export */
type PostV1StfPayoutsGetExportNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/stf/payouts/get-export */
interface PostV1StfPayoutsGetExportNegativeResponseVariants {
    400: PostV1StfPayoutsGetExportNegativeVariant1;
}

/** post /v1/stf/payouts/mark-paid */
type PostV1StfPayoutsMarkPaidInput = {
    payoutIds: string[];
    batchReference: string;
};

/** post /v1/stf/payouts/mark-paid */
type PostV1StfPayoutsMarkPaidPositiveVariant1 = {
    status: "success";
    data: {
        markedCount: number;
    };
};

/** post /v1/stf/payouts/mark-paid */
interface PostV1StfPayoutsMarkPaidPositiveResponseVariants {
    200: PostV1StfPayoutsMarkPaidPositiveVariant1;
}

/** post /v1/stf/payouts/mark-paid */
type PostV1StfPayoutsMarkPaidNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/stf/payouts/mark-paid */
interface PostV1StfPayoutsMarkPaidNegativeResponseVariants {
    400: PostV1StfPayoutsMarkPaidNegativeVariant1;
}

/** post /v1/stf/payouts/upload-transfer-proof */
type PostV1StfPayoutsUploadTransferProofInput = {
    exportId: string;
    proof: any;
};

/** post /v1/stf/payouts/upload-transfer-proof */
type PostV1StfPayoutsUploadTransferProofPositiveVariant1 = {
    status: "success";
    data: {
        proofDocumentKey: string;
    };
};

/** post /v1/stf/payouts/upload-transfer-proof */
interface PostV1StfPayoutsUploadTransferProofPositiveResponseVariants {
    200: PostV1StfPayoutsUploadTransferProofPositiveVariant1;
}

/** post /v1/stf/payouts/upload-transfer-proof */
type PostV1StfPayoutsUploadTransferProofNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/stf/payouts/upload-transfer-proof */
interface PostV1StfPayoutsUploadTransferProofNegativeResponseVariants {
    400: PostV1StfPayoutsUploadTransferProofNegativeVariant1;
}

/** post /v1/stf/payouts/verify-vat */
type PostV1StfPayoutsVerifyVatInput = {
    smmUserId: string;
    reference: string;
};

/** post /v1/stf/payouts/verify-vat */
type PostV1StfPayoutsVerifyVatPositiveVariant1 = {
    status: "success";
    data: {
        verification: {
            method: "vies";
            country: string;
            vatNumber: string;
            verifiedAt: string;
            reference: string;
        } | {
            method: "manual";
            country: string;
            vatNumber: string;
            verifiedAt: string;
            reference: string;
            verifiedBy: string;
        };
    };
};

/** post /v1/stf/payouts/verify-vat */
interface PostV1StfPayoutsVerifyVatPositiveResponseVariants {
    200: PostV1StfPayoutsVerifyVatPositiveVariant1;
}

/** post /v1/stf/payouts/verify-vat */
type PostV1StfPayoutsVerifyVatNegativeVariant1 = {
    status: "error";
    error: {
        message: string;
    };
};

/** post /v1/stf/payouts/verify-vat */
interface PostV1StfPayoutsVerifyVatNegativeResponseVariants {
    400: PostV1StfPayoutsVerifyVatNegativeVariant1;
}

export type Path = "/v1/pub/clerk/webhook" | "/v1/pub/login" | "/v1/pub/campaigns" | "/v1/pub/campaign-invitations/:token" | "/v1/pub/campaign-invitations/:token/accept" | "/v1/pub/campaign-invitations/:token/decline" | "/v1/pub/creator-signup/:token" | "/v1/pub/webhook/stripe" | "/v1/pub/creators" | "/v1/pub/creators/dashboard" | "/v1/pub/creators/posts" | "/v1/pub/creators/sitemap" | "/v1/pub/health" | "/v1/pub/sponsoring/stats" | "/v1/pub/translations/:language" | "/v1/prv/lists" | "/v1/prv/lists/delete" | "/v1/prv/lists/all" | "/v1/prv/lists/creators/add" | "/v1/prv/lists/creators/remove" | "/v1/prv/lists/creators/empty" | "/v1/prv/brands" | "/v1/prv/brands/analyze" | "/v1/prv/brands/analyze/:analysisId" | "/v1/prv/brands/:brandId" | "/v1/prv/brands/:brandId/subscription" | "/v1/prv/brands/:brandId/subscription/checkout" | "/v1/prv/brands/:brandId/subscription/portal" | "/v1/prv/brands/:brandId/subscription/cancel" | "/v1/prv/brands/upload/logo" | "/v1/prv/brands/upload/file" | "/v1/prv/brands/download/file" | "/v1/prv/brands/download/files" | "/v1/prv/creators" | "/v1/prv/creators/exclude" | "/v1/prv/creators/checkCanExclude" | "/v1/prv/creators/all" | "/v1/prv/creators/with-published-campaign-post" | "/v1/prv/creators/dormant" | "/v1/prv/creators/relaunch" | "/v1/prv/campaigns" | "/v1/prv/campaigns/open-to-offer" | "/v1/prv/campaigns/total" | "/v1/prv/campaigns/has-enough-creators" | "/v1/prv/campaigns/failed-payment" | "/v1/prv/campaigns/draft" | "/v1/prv/campaigns/audience-locations" | "/v1/prv/campaigns/overview" | "/v1/prv/campaigns/:campaignId" | "/v1/prv/campaigns/:campaignId/draft" | "/v1/prv/campaigns/:campaignId/estimate" | "/v1/prv/campaigns/:campaignId/invitation-preview" | "/v1/prv/campaigns/:campaignId/key-message-suggestion" | "/v1/prv/campaigns/:campaignId/can-close" | "/v1/prv/campaigns/:campaignId/close" | "/v1/prv/campaigns/:campaignId/invite" | "/v1/prv/campaigns/:campaignId/upload" | "/v1/prv/campaigns/:campaignId/agent" | "/v1/prv/campaigns/:campaignId/agent/creators" | "/v1/prv/campaigns/:campaignId/agent/creators/:creatorId/timeline" | "/v1/prv/campaigns/:campaignId/agent/decisions" | "/v1/prv/campaigns/:campaignId/agent/decisions/:decisionId" | "/v1/prv/campaigns/:campaignId/agent/follow-up-now" | "/v1/prv/campaigns/:campaignId/agent/events" | "/v1/prv/campaigns/:campaignId/agent/threads/:threadId/take-over" | "/v1/prv/campaigns/:campaignId/agent/threads/:threadId/hand-back" | "/v1/prv/campaigns/:campaignId/agent/threads/:threadId/draft" | "/v1/prv/campaigns/:campaignId/agent/threads/:threadId/send" | "/v1/prv/campaigns/:campaignId/posts/:postId/checks" | "/v1/prv/campaigns/:campaignId/posts/:postId/reminder" | "/v1/prv/campaigns/:campaignId/posts/:postId/refusal-draft" | "/v1/prv/campaigns/:campaignId/applications/:applicationId/rejection-draft" | "/v1/prv/campaigns/:campaignId/agent-instructions" | "/v1/prv/campaigns/:campaignId/tracked-links/clicks" | "/v1/prv/conversations/:conversationId/inbox" | "/v1/prv/conversations/:conversationId/suggest-reply" | "/v1/prv/conversations" | "/v1/prv/conversations/unread-count" | "/v1/prv/conversations/bulk-message" | "/v1/prv/conversations/file/:campaignId/:creatorIds" | "/v1/prv/conversations/:conversationId/messages" | "/v1/prv/conversations/:conversationId/read" | "/v1/prv/conversations/:conversationId/unread" | "/v1/prv/conversations/:conversationId/upload" | "/v1/prv/creator-applications" | "/v1/prv/creator-applications/:creatorApplicationId" | "/v1/prv/creator-applications/overview/:campaignId" | "/v1/prv/creator-applications/:creatorApplicationId/reinstate" | "/v1/prv/creator-applications/:campaignId/:creatorId" | "/v1/prv/creator-applications/negociate" | "/v1/prv/user" | "/v1/prv/user/readonly-token" | "/v1/prv/user/country" | "/v1/prv/user/api-key" | "/v1/prv/user/generate-api-key" | "/v1/prv/campaign-analytics/:campaignId" | "/v1/prv/campaign-analytics/:campaignId/engagement-profiles" | "/v1/prv/campaign-analytics/:campaignId/engagement-counts" | "/v1/prv/campaign-analytics/:campaignId/engagement-profiles-export" | "/v1/prv/nps" | "/v1/prv/payments/campaign-session" | "/v1/prv/payments/retry-payment" | "/v1/prv/payments/deposit-budget" | "/v1/prv/payments/checkout-session" | "/v1/prv/payments/campaign-wallet" | "/v1/prv/payments/payouts" | "/v1/prv/payments/portal-session" | "/v1/prv/payments/customer" | "/v1/prv/payments/campaign-quote" | "/v1/prv/payments/deposit-details" | "/v1/prv/payments/payouts-overview" | "/v1/prv/payments/upcoming-settlements" | "/v1/prv/payments/campaign-results" | "/v1/prv/saved-replies" | "/v1/prv/saved-replies/:savedReplyId" | "/v1/prv/pusher/auth" | "/v1/prv/linkedin-sender" | "/v1/prv/linkedin-sender/schedule" | "/v1/prv/linkedin-sender/cloud-login" | "/v1/prv/linkedin-sender/cloud-login/resume" | "/v1/smm-prv/campaigns" | "/v1/smm-prv/campaigns/apply" | "/v1/smm-prv/campaigns/applied" | "/v1/smm-prv/campaigns/:campaignId" | "/v1/smm-prv/creator-applications" | "/v1/smm-prv/creator-applications/overview" | "/v1/smm-prv/creator-applications/count" | "/v1/smm-prv/creator-applications/has-any" | "/v1/smm-prv/creator-applications/by-id/:creatorApplicationId" | "/v1/smm-prv/creator-applications/:campaignId" | "/v1/smm-prv/creator-applications/negociate" | "/v1/smm-prv/brands/applied-to" | "/v1/smm-prv/brands/:brandId" | "/v1/smm-prv/creators/me" | "/v1/smm-prv/creators/adopt-sourced" | "/v1/smm-prv/creators/populate" | "/v1/smm-prv/creators/privacy" | "/v1/smm-prv/conversations" | "/v1/smm-prv/conversations/unread-count" | "/v1/smm-prv/conversations/messages" | "/v1/smm-prv/conversations/:conversationId/messages" | "/v1/smm-prv/conversations/:conversationId/read" | "/v1/smm-prv/conversations/:conversationId/unread" | "/v1/smm-prv/conversations/:conversationId/upload" | "/v1/smm-prv/nps" | "/v1/smm-prv/payments/payouts" | "/v1/smm-prv/payments/earnings" | "/v1/smm-prv/payments/recent-payouts" | "/v1/smm-prv/saved-replies" | "/v1/smm-prv/saved-replies/:savedReplyId" | "/v1/smm-prv/sponsors" | "/v1/smm-prv/sponsors/tags" | "/v1/smm-prv/sponsors/contacts" | "/v1/smm-prv/sponsors/contact" | "/v1/smm-prv/sponsors/:sponsorId" | "/v1/open/me" | "/v1/open/sponsors" | "/v1/open/sponsors/tags" | "/v1/open/sponsors/tracked" | "/v1/open/sponsors/contact" | "/v1/open/sponsors/:sponsorId" | "/v1/open/sponsors/:sponsorId/outreach-context" | "/v1/open/brand/brands" | "/v1/open/brand/creators" | "/v1/open/brand/campaigns" | "/v1/open/brand/campaigns/invite" | "/v1/adm/conversations/send-automatic-message" | "/v1/adm/populateOneCreator" | "/v1/adm/populateAllCreators" | "/v1/adm/excludeCreator" | "/v1/adm/runPostChecks" | "/v1/stf/linkedin-message-recovery" | "/v1/stf/linkedin-message-recovery/confirm-not-sent" | "/v1/stf/linkedin-pool" | "/v1/stf/linkedin-pool/:accountId" | "/v1/stf/linkedin-pool/:accountId/cloud-login" | "/v1/stf/linkedin-pool/:accountId/cloud-login/resume" | "/v1/stf/users" | "/v1/stf/campaigns" | "/v1/stf/campaigns/force-close" | "/v1/stf/campaigns/confirm-manual-refund" | "/v1/stf/campaigns/confirm-out-of-band-payment" | "/v1/stf/campaigns/delete" | "/v1/stf/creator-applications/reinstate" | "/v1/stf/generate-actor-token" | "/v1/stf/nps-ratings" | "/v1/stf/trigger-pay-sponsored-posts" | "/v1/stf/payouts-to-pay" | "/v1/stf/payouts-paid" | "/v1/stf/payouts-blocked" | "/v1/stf/payouts/cancel-export" | "/v1/stf/payouts/create-export" | "/v1/stf/payouts/get-export" | "/v1/stf/payouts/mark-paid" | "/v1/stf/payouts/upload-transfer-proof" | "/v1/stf/payouts/verify-vat";

export type Method = "get" | "post" | "put" | "delete" | "patch";

export interface Input {
    "post /v1/pub/clerk/webhook": PostV1PubClerkWebhookInput;
    "post /v1/pub/login": PostV1PubLoginInput;
    "get /v1/pub/campaigns": GetV1PubCampaignsInput;
    "get /v1/pub/campaign-invitations/:token": GetV1PubCampaignInvitationsTokenInput;
    "post /v1/pub/campaign-invitations/:token/accept": PostV1PubCampaignInvitationsTokenAcceptInput;
    "post /v1/pub/campaign-invitations/:token/decline": PostV1PubCampaignInvitationsTokenDeclineInput;
    "get /v1/pub/creator-signup/:token": GetV1PubCreatorSignupTokenInput;
    "post /v1/pub/webhook/stripe": PostV1PubWebhookStripeInput;
    "get /v1/pub/creators": GetV1PubCreatorsInput;
    "get /v1/pub/creators/dashboard": GetV1PubCreatorsDashboardInput;
    "get /v1/pub/creators/posts": GetV1PubCreatorsPostsInput;
    "get /v1/pub/creators/sitemap": GetV1PubCreatorsSitemapInput;
    "get /v1/pub/health": GetV1PubHealthInput;
    "get /v1/pub/sponsoring/stats": GetV1PubSponsoringStatsInput;
    "get /v1/pub/translations/:language": GetV1PubTranslationsLanguageInput;
    "get /v1/prv/lists": GetV1PrvListsInput;
    "post /v1/prv/lists": PostV1PrvListsInput;
    "put /v1/prv/lists": PutV1PrvListsInput;
    "post /v1/prv/lists/delete": PostV1PrvListsDeleteInput;
    "get /v1/prv/lists/all": GetV1PrvListsAllInput;
    "put /v1/prv/lists/creators/add": PutV1PrvListsCreatorsAddInput;
    "put /v1/prv/lists/creators/remove": PutV1PrvListsCreatorsRemoveInput;
    "put /v1/prv/lists/creators/empty": PutV1PrvListsCreatorsEmptyInput;
    "get /v1/prv/brands": GetV1PrvBrandsInput;
    "post /v1/prv/brands": PostV1PrvBrandsInput;
    "put /v1/prv/brands": PutV1PrvBrandsInput;
    "delete /v1/prv/brands": DeleteV1PrvBrandsInput;
    "post /v1/prv/brands/analyze": PostV1PrvBrandsAnalyzeInput;
    "get /v1/prv/brands/analyze/:analysisId": GetV1PrvBrandsAnalyzeAnalysisIdInput;
    "get /v1/prv/brands/:brandId": GetV1PrvBrandsBrandIdInput;
    "patch /v1/prv/brands/:brandId": PatchV1PrvBrandsBrandIdInput;
    "get /v1/prv/brands/:brandId/subscription": GetV1PrvBrandsBrandIdSubscriptionInput;
    "post /v1/prv/brands/:brandId/subscription/checkout": PostV1PrvBrandsBrandIdSubscriptionCheckoutInput;
    "post /v1/prv/brands/:brandId/subscription/portal": PostV1PrvBrandsBrandIdSubscriptionPortalInput;
    "post /v1/prv/brands/:brandId/subscription/cancel": PostV1PrvBrandsBrandIdSubscriptionCancelInput;
    "post /v1/prv/brands/upload/logo": PostV1PrvBrandsUploadLogoInput;
    "post /v1/prv/brands/upload/file": PostV1PrvBrandsUploadFileInput;
    "get /v1/prv/brands/download/file": GetV1PrvBrandsDownloadFileInput;
    "post /v1/prv/brands/download/files": PostV1PrvBrandsDownloadFilesInput;
    "get /v1/prv/creators": GetV1PrvCreatorsInput;
    "post /v1/prv/creators/exclude": PostV1PrvCreatorsExcludeInput;
    "get /v1/prv/creators/checkCanExclude": GetV1PrvCreatorsCheckCanExcludeInput;
    "get /v1/prv/creators/all": GetV1PrvCreatorsAllInput;
    "get /v1/prv/creators/with-published-campaign-post": GetV1PrvCreatorsWithPublishedCampaignPostInput;
    "get /v1/prv/creators/dormant": GetV1PrvCreatorsDormantInput;
    "post /v1/prv/creators/relaunch": PostV1PrvCreatorsRelaunchInput;
    "get /v1/prv/campaigns": GetV1PrvCampaignsInput;
    "post /v1/prv/campaigns": PostV1PrvCampaignsInput;
    "put /v1/prv/campaigns": PutV1PrvCampaignsInput;
    "get /v1/prv/campaigns/open-to-offer": GetV1PrvCampaignsOpenToOfferInput;
    "get /v1/prv/campaigns/total": GetV1PrvCampaignsTotalInput;
    "post /v1/prv/campaigns/has-enough-creators": PostV1PrvCampaignsHasEnoughCreatorsInput;
    "get /v1/prv/campaigns/failed-payment": GetV1PrvCampaignsFailedPaymentInput;
    "post /v1/prv/campaigns/draft": PostV1PrvCampaignsDraftInput;
    "get /v1/prv/campaigns/audience-locations": GetV1PrvCampaignsAudienceLocationsInput;
    "get /v1/prv/campaigns/overview": GetV1PrvCampaignsOverviewInput;
    "get /v1/prv/campaigns/:campaignId": GetV1PrvCampaignsCampaignIdInput;
    "put /v1/prv/campaigns/:campaignId": PutV1PrvCampaignsCampaignIdInput;
    "patch /v1/prv/campaigns/:campaignId/draft": PatchV1PrvCampaignsCampaignIdDraftInput;
    "delete /v1/prv/campaigns/:campaignId/draft": DeleteV1PrvCampaignsCampaignIdDraftInput;
    "post /v1/prv/campaigns/:campaignId/estimate": PostV1PrvCampaignsCampaignIdEstimateInput;
    "post /v1/prv/campaigns/:campaignId/invitation-preview": PostV1PrvCampaignsCampaignIdInvitationPreviewInput;
    "post /v1/prv/campaigns/:campaignId/key-message-suggestion": PostV1PrvCampaignsCampaignIdKeyMessageSuggestionInput;
    "get /v1/prv/campaigns/:campaignId/can-close": GetV1PrvCampaignsCampaignIdCanCloseInput;
    "post /v1/prv/campaigns/:campaignId/close": PostV1PrvCampaignsCampaignIdCloseInput;
    "post /v1/prv/campaigns/:campaignId/invite": PostV1PrvCampaignsCampaignIdInviteInput;
    "post /v1/prv/campaigns/:campaignId/upload": PostV1PrvCampaignsCampaignIdUploadInput;
    "get /v1/prv/campaigns/:campaignId/agent": GetV1PrvCampaignsCampaignIdAgentInput;
    "patch /v1/prv/campaigns/:campaignId/agent": PatchV1PrvCampaignsCampaignIdAgentInput;
    "get /v1/prv/campaigns/:campaignId/agent/creators": GetV1PrvCampaignsCampaignIdAgentCreatorsInput;
    "get /v1/prv/campaigns/:campaignId/agent/creators/:creatorId/timeline": GetV1PrvCampaignsCampaignIdAgentCreatorsCreatorIdTimelineInput;
    "get /v1/prv/campaigns/:campaignId/agent/decisions": GetV1PrvCampaignsCampaignIdAgentDecisionsInput;
    "post /v1/prv/campaigns/:campaignId/agent/decisions/:decisionId": PostV1PrvCampaignsCampaignIdAgentDecisionsDecisionIdInput;
    "post /v1/prv/campaigns/:campaignId/agent/follow-up-now": PostV1PrvCampaignsCampaignIdAgentFollowUpNowInput;
    "get /v1/prv/campaigns/:campaignId/agent/events": GetV1PrvCampaignsCampaignIdAgentEventsInput;
    "post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/take-over": PostV1PrvCampaignsCampaignIdAgentThreadsThreadIdTakeOverInput;
    "post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/hand-back": PostV1PrvCampaignsCampaignIdAgentThreadsThreadIdHandBackInput;
    "get /v1/prv/campaigns/:campaignId/agent/threads/:threadId/draft": GetV1PrvCampaignsCampaignIdAgentThreadsThreadIdDraftInput;
    "post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/draft": PostV1PrvCampaignsCampaignIdAgentThreadsThreadIdDraftInput;
    "put /v1/prv/campaigns/:campaignId/agent/threads/:threadId/draft": PutV1PrvCampaignsCampaignIdAgentThreadsThreadIdDraftInput;
    "post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/send": PostV1PrvCampaignsCampaignIdAgentThreadsThreadIdSendInput;
    "get /v1/prv/campaigns/:campaignId/posts/:postId/checks": GetV1PrvCampaignsCampaignIdPostsPostIdChecksInput;
    "get /v1/prv/campaigns/:campaignId/posts/:postId/reminder": GetV1PrvCampaignsCampaignIdPostsPostIdReminderInput;
    "get /v1/prv/campaigns/:campaignId/posts/:postId/refusal-draft": GetV1PrvCampaignsCampaignIdPostsPostIdRefusalDraftInput;
    "post /v1/prv/campaigns/:campaignId/applications/:applicationId/rejection-draft": PostV1PrvCampaignsCampaignIdApplicationsApplicationIdRejectionDraftInput;
    "put /v1/prv/campaigns/:campaignId/agent-instructions": PutV1PrvCampaignsCampaignIdAgentInstructionsInput;
    "get /v1/prv/campaigns/:campaignId/tracked-links/clicks": GetV1PrvCampaignsCampaignIdTrackedLinksClicksInput;
    "put /v1/prv/conversations/:conversationId/inbox": PutV1PrvConversationsConversationIdInboxInput;
    "post /v1/prv/conversations/:conversationId/suggest-reply": PostV1PrvConversationsConversationIdSuggestReplyInput;
    "get /v1/prv/conversations": GetV1PrvConversationsInput;
    "get /v1/prv/conversations/unread-count": GetV1PrvConversationsUnreadCountInput;
    "post /v1/prv/conversations/bulk-message": PostV1PrvConversationsBulkMessageInput;
    "post /v1/prv/conversations/file/:campaignId/:creatorIds": PostV1PrvConversationsFileCampaignIdCreatorIdsInput;
    "get /v1/prv/conversations/:conversationId/messages": GetV1PrvConversationsConversationIdMessagesInput;
    "post /v1/prv/conversations/:conversationId/messages": PostV1PrvConversationsConversationIdMessagesInput;
    "put /v1/prv/conversations/:conversationId/read": PutV1PrvConversationsConversationIdReadInput;
    "put /v1/prv/conversations/:conversationId/unread": PutV1PrvConversationsConversationIdUnreadInput;
    "post /v1/prv/conversations/:conversationId/upload": PostV1PrvConversationsConversationIdUploadInput;
    "get /v1/prv/creator-applications": GetV1PrvCreatorApplicationsInput;
    "put /v1/prv/creator-applications": PutV1PrvCreatorApplicationsInput;
    "get /v1/prv/creator-applications/:creatorApplicationId": GetV1PrvCreatorApplicationsCreatorApplicationIdInput;
    "get /v1/prv/creator-applications/overview/:campaignId": GetV1PrvCreatorApplicationsOverviewCampaignIdInput;
    "post /v1/prv/creator-applications/:creatorApplicationId/reinstate": PostV1PrvCreatorApplicationsCreatorApplicationIdReinstateInput;
    "get /v1/prv/creator-applications/:campaignId/:creatorId": GetV1PrvCreatorApplicationsCampaignIdCreatorIdInput;
    "post /v1/prv/creator-applications/negociate": PostV1PrvCreatorApplicationsNegociateInput;
    "get /v1/prv/user": GetV1PrvUserInput;
    "get /v1/prv/user/readonly-token": GetV1PrvUserReadonlyTokenInput;
    "post /v1/prv/user/country": PostV1PrvUserCountryInput;
    "get /v1/prv/user/api-key": GetV1PrvUserApiKeyInput;
    "post /v1/prv/user/generate-api-key": PostV1PrvUserGenerateApiKeyInput;
    "get /v1/prv/campaign-analytics/:campaignId": GetV1PrvCampaignAnalyticsCampaignIdInput;
    "get /v1/prv/campaign-analytics/:campaignId/engagement-profiles": GetV1PrvCampaignAnalyticsCampaignIdEngagementProfilesInput;
    "get /v1/prv/campaign-analytics/:campaignId/engagement-counts": GetV1PrvCampaignAnalyticsCampaignIdEngagementCountsInput;
    "post /v1/prv/campaign-analytics/:campaignId/engagement-profiles-export": PostV1PrvCampaignAnalyticsCampaignIdEngagementProfilesExportInput;
    "get /v1/prv/nps": GetV1PrvNpsInput;
    "post /v1/prv/nps": PostV1PrvNpsInput;
    "post /v1/prv/payments/campaign-session": PostV1PrvPaymentsCampaignSessionInput;
    "post /v1/prv/payments/retry-payment": PostV1PrvPaymentsRetryPaymentInput;
    "post /v1/prv/payments/deposit-budget": PostV1PrvPaymentsDepositBudgetInput;
    "post /v1/prv/payments/checkout-session": PostV1PrvPaymentsCheckoutSessionInput;
    "get /v1/prv/payments/campaign-wallet": GetV1PrvPaymentsCampaignWalletInput;
    "get /v1/prv/payments/payouts": GetV1PrvPaymentsPayoutsInput;
    "get /v1/prv/payments/portal-session": GetV1PrvPaymentsPortalSessionInput;
    "get /v1/prv/payments/customer": GetV1PrvPaymentsCustomerInput;
    "put /v1/prv/payments/customer": PutV1PrvPaymentsCustomerInput;
    "get /v1/prv/payments/campaign-quote": GetV1PrvPaymentsCampaignQuoteInput;
    "get /v1/prv/payments/deposit-details": GetV1PrvPaymentsDepositDetailsInput;
    "get /v1/prv/payments/payouts-overview": GetV1PrvPaymentsPayoutsOverviewInput;
    "get /v1/prv/payments/upcoming-settlements": GetV1PrvPaymentsUpcomingSettlementsInput;
    "get /v1/prv/payments/campaign-results": GetV1PrvPaymentsCampaignResultsInput;
    "get /v1/prv/saved-replies": GetV1PrvSavedRepliesInput;
    "post /v1/prv/saved-replies": PostV1PrvSavedRepliesInput;
    "delete /v1/prv/saved-replies/:savedReplyId": DeleteV1PrvSavedRepliesSavedReplyIdInput;
    "put /v1/prv/saved-replies/:savedReplyId": PutV1PrvSavedRepliesSavedReplyIdInput;
    "post /v1/prv/pusher/auth": PostV1PrvPusherAuthInput;
    "get /v1/prv/linkedin-sender": GetV1PrvLinkedinSenderInput;
    "delete /v1/prv/linkedin-sender": DeleteV1PrvLinkedinSenderInput;
    "put /v1/prv/linkedin-sender/schedule": PutV1PrvLinkedinSenderScheduleInput;
    "post /v1/prv/linkedin-sender/cloud-login": PostV1PrvLinkedinSenderCloudLoginInput;
    "get /v1/prv/linkedin-sender/cloud-login": GetV1PrvLinkedinSenderCloudLoginInput;
    "post /v1/prv/linkedin-sender/cloud-login/resume": PostV1PrvLinkedinSenderCloudLoginResumeInput;
    "get /v1/smm-prv/campaigns": GetV1SmmPrvCampaignsInput;
    "post /v1/smm-prv/campaigns/apply": PostV1SmmPrvCampaignsApplyInput;
    "get /v1/smm-prv/campaigns/applied": GetV1SmmPrvCampaignsAppliedInput;
    "get /v1/smm-prv/campaigns/:campaignId": GetV1SmmPrvCampaignsCampaignIdInput;
    "get /v1/smm-prv/creator-applications": GetV1SmmPrvCreatorApplicationsInput;
    "put /v1/smm-prv/creator-applications": PutV1SmmPrvCreatorApplicationsInput;
    "get /v1/smm-prv/creator-applications/overview": GetV1SmmPrvCreatorApplicationsOverviewInput;
    "get /v1/smm-prv/creator-applications/count": GetV1SmmPrvCreatorApplicationsCountInput;
    "get /v1/smm-prv/creator-applications/has-any": GetV1SmmPrvCreatorApplicationsHasAnyInput;
    "get /v1/smm-prv/creator-applications/by-id/:creatorApplicationId": GetV1SmmPrvCreatorApplicationsByIdCreatorApplicationIdInput;
    "get /v1/smm-prv/creator-applications/:campaignId": GetV1SmmPrvCreatorApplicationsCampaignIdInput;
    "post /v1/smm-prv/creator-applications/negociate": PostV1SmmPrvCreatorApplicationsNegociateInput;
    "get /v1/smm-prv/brands/applied-to": GetV1SmmPrvBrandsAppliedToInput;
    "get /v1/smm-prv/brands/:brandId": GetV1SmmPrvBrandsBrandIdInput;
    "get /v1/smm-prv/creators/me": GetV1SmmPrvCreatorsMeInput;
    "post /v1/smm-prv/creators/adopt-sourced": PostV1SmmPrvCreatorsAdoptSourcedInput;
    "post /v1/smm-prv/creators/populate": PostV1SmmPrvCreatorsPopulateInput;
    "put /v1/smm-prv/creators/privacy": PutV1SmmPrvCreatorsPrivacyInput;
    "get /v1/smm-prv/conversations": GetV1SmmPrvConversationsInput;
    "get /v1/smm-prv/conversations/unread-count": GetV1SmmPrvConversationsUnreadCountInput;
    "post /v1/smm-prv/conversations/messages": PostV1SmmPrvConversationsMessagesInput;
    "get /v1/smm-prv/conversations/:conversationId/messages": GetV1SmmPrvConversationsConversationIdMessagesInput;
    "put /v1/smm-prv/conversations/:conversationId/read": PutV1SmmPrvConversationsConversationIdReadInput;
    "put /v1/smm-prv/conversations/:conversationId/unread": PutV1SmmPrvConversationsConversationIdUnreadInput;
    "post /v1/smm-prv/conversations/:conversationId/upload": PostV1SmmPrvConversationsConversationIdUploadInput;
    "get /v1/smm-prv/nps": GetV1SmmPrvNpsInput;
    "post /v1/smm-prv/nps": PostV1SmmPrvNpsInput;
    "get /v1/smm-prv/payments/payouts": GetV1SmmPrvPaymentsPayoutsInput;
    "get /v1/smm-prv/payments/earnings": GetV1SmmPrvPaymentsEarningsInput;
    "get /v1/smm-prv/payments/recent-payouts": GetV1SmmPrvPaymentsRecentPayoutsInput;
    "get /v1/smm-prv/saved-replies": GetV1SmmPrvSavedRepliesInput;
    "post /v1/smm-prv/saved-replies": PostV1SmmPrvSavedRepliesInput;
    "delete /v1/smm-prv/saved-replies/:savedReplyId": DeleteV1SmmPrvSavedRepliesSavedReplyIdInput;
    "put /v1/smm-prv/saved-replies/:savedReplyId": PutV1SmmPrvSavedRepliesSavedReplyIdInput;
    "get /v1/smm-prv/sponsors": GetV1SmmPrvSponsorsInput;
    "get /v1/smm-prv/sponsors/tags": GetV1SmmPrvSponsorsTagsInput;
    "get /v1/smm-prv/sponsors/contacts": GetV1SmmPrvSponsorsContactsInput;
    "put /v1/smm-prv/sponsors/contact": PutV1SmmPrvSponsorsContactInput;
    "delete /v1/smm-prv/sponsors/contact": DeleteV1SmmPrvSponsorsContactInput;
    "get /v1/smm-prv/sponsors/:sponsorId": GetV1SmmPrvSponsorsSponsorIdInput;
    "get /v1/open/me": GetV1OpenMeInput;
    "get /v1/open/sponsors": GetV1OpenSponsorsInput;
    "get /v1/open/sponsors/tags": GetV1OpenSponsorsTagsInput;
    "get /v1/open/sponsors/tracked": GetV1OpenSponsorsTrackedInput;
    "put /v1/open/sponsors/contact": PutV1OpenSponsorsContactInput;
    "get /v1/open/sponsors/:sponsorId": GetV1OpenSponsorsSponsorIdInput;
    "get /v1/open/sponsors/:sponsorId/outreach-context": GetV1OpenSponsorsSponsorIdOutreachContextInput;
    "get /v1/open/brand/brands": GetV1OpenBrandBrandsInput;
    "post /v1/open/brand/brands": PostV1OpenBrandBrandsInput;
    "get /v1/open/brand/creators": GetV1OpenBrandCreatorsInput;
    "post /v1/open/brand/campaigns": PostV1OpenBrandCampaignsInput;
    "post /v1/open/brand/campaigns/invite": PostV1OpenBrandCampaignsInviteInput;
    "post /v1/adm/conversations/send-automatic-message": PostV1AdmConversationsSendAutomaticMessageInput;
    "post /v1/adm/populateOneCreator": PostV1AdmPopulateOneCreatorInput;
    "post /v1/adm/populateAllCreators": PostV1AdmPopulateAllCreatorsInput;
    "post /v1/adm/excludeCreator": PostV1AdmExcludeCreatorInput;
    "post /v1/adm/runPostChecks": PostV1AdmRunPostChecksInput;
    "get /v1/stf/linkedin-message-recovery": GetV1StfLinkedinMessageRecoveryInput;
    "post /v1/stf/linkedin-message-recovery/confirm-not-sent": PostV1StfLinkedinMessageRecoveryConfirmNotSentInput;
    "get /v1/stf/linkedin-pool": GetV1StfLinkedinPoolInput;
    "post /v1/stf/linkedin-pool": PostV1StfLinkedinPoolInput;
    "patch /v1/stf/linkedin-pool/:accountId": PatchV1StfLinkedinPoolAccountIdInput;
    "delete /v1/stf/linkedin-pool/:accountId": DeleteV1StfLinkedinPoolAccountIdInput;
    "post /v1/stf/linkedin-pool/:accountId/cloud-login": PostV1StfLinkedinPoolAccountIdCloudLoginInput;
    "get /v1/stf/linkedin-pool/:accountId/cloud-login": GetV1StfLinkedinPoolAccountIdCloudLoginInput;
    "post /v1/stf/linkedin-pool/:accountId/cloud-login/resume": PostV1StfLinkedinPoolAccountIdCloudLoginResumeInput;
    "get /v1/stf/users": GetV1StfUsersInput;
    "get /v1/stf/campaigns": GetV1StfCampaignsInput;
    "post /v1/stf/campaigns/force-close": PostV1StfCampaignsForceCloseInput;
    "post /v1/stf/campaigns/confirm-manual-refund": PostV1StfCampaignsConfirmManualRefundInput;
    "post /v1/stf/campaigns/confirm-out-of-band-payment": PostV1StfCampaignsConfirmOutOfBandPaymentInput;
    "post /v1/stf/campaigns/delete": PostV1StfCampaignsDeleteInput;
    "post /v1/stf/creator-applications/reinstate": PostV1StfCreatorApplicationsReinstateInput;
    "post /v1/stf/generate-actor-token": PostV1StfGenerateActorTokenInput;
    "get /v1/stf/nps-ratings": GetV1StfNpsRatingsInput;
    "post /v1/stf/trigger-pay-sponsored-posts": PostV1StfTriggerPaySponsoredPostsInput;
    "get /v1/stf/payouts-to-pay": GetV1StfPayoutsToPayInput;
    "get /v1/stf/payouts-paid": GetV1StfPayoutsPaidInput;
    "get /v1/stf/payouts-blocked": GetV1StfPayoutsBlockedInput;
    "post /v1/stf/payouts/cancel-export": PostV1StfPayoutsCancelExportInput;
    "post /v1/stf/payouts/create-export": PostV1StfPayoutsCreateExportInput;
    "post /v1/stf/payouts/get-export": PostV1StfPayoutsGetExportInput;
    "post /v1/stf/payouts/mark-paid": PostV1StfPayoutsMarkPaidInput;
    "post /v1/stf/payouts/upload-transfer-proof": PostV1StfPayoutsUploadTransferProofInput;
    "post /v1/stf/payouts/verify-vat": PostV1StfPayoutsVerifyVatInput;
}

export interface PositiveResponse {
    "post /v1/pub/clerk/webhook": SomeOf<PostV1PubClerkWebhookPositiveResponseVariants>;
    "post /v1/pub/login": SomeOf<PostV1PubLoginPositiveResponseVariants>;
    "get /v1/pub/campaigns": SomeOf<GetV1PubCampaignsPositiveResponseVariants>;
    "get /v1/pub/campaign-invitations/:token": SomeOf<GetV1PubCampaignInvitationsTokenPositiveResponseVariants>;
    "post /v1/pub/campaign-invitations/:token/accept": SomeOf<PostV1PubCampaignInvitationsTokenAcceptPositiveResponseVariants>;
    "post /v1/pub/campaign-invitations/:token/decline": SomeOf<PostV1PubCampaignInvitationsTokenDeclinePositiveResponseVariants>;
    "get /v1/pub/creator-signup/:token": SomeOf<GetV1PubCreatorSignupTokenPositiveResponseVariants>;
    "post /v1/pub/webhook/stripe": SomeOf<PostV1PubWebhookStripePositiveResponseVariants>;
    "get /v1/pub/creators": SomeOf<GetV1PubCreatorsPositiveResponseVariants>;
    "get /v1/pub/creators/dashboard": SomeOf<GetV1PubCreatorsDashboardPositiveResponseVariants>;
    "get /v1/pub/creators/posts": SomeOf<GetV1PubCreatorsPostsPositiveResponseVariants>;
    "get /v1/pub/creators/sitemap": SomeOf<GetV1PubCreatorsSitemapPositiveResponseVariants>;
    "get /v1/pub/health": SomeOf<GetV1PubHealthPositiveResponseVariants>;
    "get /v1/pub/sponsoring/stats": SomeOf<GetV1PubSponsoringStatsPositiveResponseVariants>;
    "get /v1/pub/translations/:language": SomeOf<GetV1PubTranslationsLanguagePositiveResponseVariants>;
    "get /v1/prv/lists": SomeOf<GetV1PrvListsPositiveResponseVariants>;
    "post /v1/prv/lists": SomeOf<PostV1PrvListsPositiveResponseVariants>;
    "put /v1/prv/lists": SomeOf<PutV1PrvListsPositiveResponseVariants>;
    "post /v1/prv/lists/delete": SomeOf<PostV1PrvListsDeletePositiveResponseVariants>;
    "get /v1/prv/lists/all": SomeOf<GetV1PrvListsAllPositiveResponseVariants>;
    "put /v1/prv/lists/creators/add": SomeOf<PutV1PrvListsCreatorsAddPositiveResponseVariants>;
    "put /v1/prv/lists/creators/remove": SomeOf<PutV1PrvListsCreatorsRemovePositiveResponseVariants>;
    "put /v1/prv/lists/creators/empty": SomeOf<PutV1PrvListsCreatorsEmptyPositiveResponseVariants>;
    "get /v1/prv/brands": SomeOf<GetV1PrvBrandsPositiveResponseVariants>;
    "post /v1/prv/brands": SomeOf<PostV1PrvBrandsPositiveResponseVariants>;
    "put /v1/prv/brands": SomeOf<PutV1PrvBrandsPositiveResponseVariants>;
    "delete /v1/prv/brands": SomeOf<DeleteV1PrvBrandsPositiveResponseVariants>;
    "post /v1/prv/brands/analyze": SomeOf<PostV1PrvBrandsAnalyzePositiveResponseVariants>;
    "get /v1/prv/brands/analyze/:analysisId": SomeOf<GetV1PrvBrandsAnalyzeAnalysisIdPositiveResponseVariants>;
    "get /v1/prv/brands/:brandId": SomeOf<GetV1PrvBrandsBrandIdPositiveResponseVariants>;
    "patch /v1/prv/brands/:brandId": SomeOf<PatchV1PrvBrandsBrandIdPositiveResponseVariants>;
    "get /v1/prv/brands/:brandId/subscription": SomeOf<GetV1PrvBrandsBrandIdSubscriptionPositiveResponseVariants>;
    "post /v1/prv/brands/:brandId/subscription/checkout": SomeOf<PostV1PrvBrandsBrandIdSubscriptionCheckoutPositiveResponseVariants>;
    "post /v1/prv/brands/:brandId/subscription/portal": SomeOf<PostV1PrvBrandsBrandIdSubscriptionPortalPositiveResponseVariants>;
    "post /v1/prv/brands/:brandId/subscription/cancel": SomeOf<PostV1PrvBrandsBrandIdSubscriptionCancelPositiveResponseVariants>;
    "post /v1/prv/brands/upload/logo": SomeOf<PostV1PrvBrandsUploadLogoPositiveResponseVariants>;
    "post /v1/prv/brands/upload/file": SomeOf<PostV1PrvBrandsUploadFilePositiveResponseVariants>;
    "get /v1/prv/brands/download/file": SomeOf<GetV1PrvBrandsDownloadFilePositiveResponseVariants>;
    "post /v1/prv/brands/download/files": SomeOf<PostV1PrvBrandsDownloadFilesPositiveResponseVariants>;
    "get /v1/prv/creators": SomeOf<GetV1PrvCreatorsPositiveResponseVariants>;
    "post /v1/prv/creators/exclude": SomeOf<PostV1PrvCreatorsExcludePositiveResponseVariants>;
    "get /v1/prv/creators/checkCanExclude": SomeOf<GetV1PrvCreatorsCheckCanExcludePositiveResponseVariants>;
    "get /v1/prv/creators/all": SomeOf<GetV1PrvCreatorsAllPositiveResponseVariants>;
    "get /v1/prv/creators/with-published-campaign-post": SomeOf<GetV1PrvCreatorsWithPublishedCampaignPostPositiveResponseVariants>;
    "get /v1/prv/creators/dormant": SomeOf<GetV1PrvCreatorsDormantPositiveResponseVariants>;
    "post /v1/prv/creators/relaunch": SomeOf<PostV1PrvCreatorsRelaunchPositiveResponseVariants>;
    "get /v1/prv/campaigns": SomeOf<GetV1PrvCampaignsPositiveResponseVariants>;
    "post /v1/prv/campaigns": SomeOf<PostV1PrvCampaignsPositiveResponseVariants>;
    "put /v1/prv/campaigns": SomeOf<PutV1PrvCampaignsPositiveResponseVariants>;
    "get /v1/prv/campaigns/open-to-offer": SomeOf<GetV1PrvCampaignsOpenToOfferPositiveResponseVariants>;
    "get /v1/prv/campaigns/total": SomeOf<GetV1PrvCampaignsTotalPositiveResponseVariants>;
    "post /v1/prv/campaigns/has-enough-creators": SomeOf<PostV1PrvCampaignsHasEnoughCreatorsPositiveResponseVariants>;
    "get /v1/prv/campaigns/failed-payment": SomeOf<GetV1PrvCampaignsFailedPaymentPositiveResponseVariants>;
    "post /v1/prv/campaigns/draft": SomeOf<PostV1PrvCampaignsDraftPositiveResponseVariants>;
    "get /v1/prv/campaigns/audience-locations": SomeOf<GetV1PrvCampaignsAudienceLocationsPositiveResponseVariants>;
    "get /v1/prv/campaigns/overview": SomeOf<GetV1PrvCampaignsOverviewPositiveResponseVariants>;
    "get /v1/prv/campaigns/:campaignId": SomeOf<GetV1PrvCampaignsCampaignIdPositiveResponseVariants>;
    "put /v1/prv/campaigns/:campaignId": SomeOf<PutV1PrvCampaignsCampaignIdPositiveResponseVariants>;
    "patch /v1/prv/campaigns/:campaignId/draft": SomeOf<PatchV1PrvCampaignsCampaignIdDraftPositiveResponseVariants>;
    "delete /v1/prv/campaigns/:campaignId/draft": SomeOf<DeleteV1PrvCampaignsCampaignIdDraftPositiveResponseVariants>;
    "post /v1/prv/campaigns/:campaignId/estimate": SomeOf<PostV1PrvCampaignsCampaignIdEstimatePositiveResponseVariants>;
    "post /v1/prv/campaigns/:campaignId/invitation-preview": SomeOf<PostV1PrvCampaignsCampaignIdInvitationPreviewPositiveResponseVariants>;
    "post /v1/prv/campaigns/:campaignId/key-message-suggestion": SomeOf<PostV1PrvCampaignsCampaignIdKeyMessageSuggestionPositiveResponseVariants>;
    "get /v1/prv/campaigns/:campaignId/can-close": SomeOf<GetV1PrvCampaignsCampaignIdCanClosePositiveResponseVariants>;
    "post /v1/prv/campaigns/:campaignId/close": SomeOf<PostV1PrvCampaignsCampaignIdClosePositiveResponseVariants>;
    "post /v1/prv/campaigns/:campaignId/invite": SomeOf<PostV1PrvCampaignsCampaignIdInvitePositiveResponseVariants>;
    "post /v1/prv/campaigns/:campaignId/upload": SomeOf<PostV1PrvCampaignsCampaignIdUploadPositiveResponseVariants>;
    "get /v1/prv/campaigns/:campaignId/agent": SomeOf<GetV1PrvCampaignsCampaignIdAgentPositiveResponseVariants>;
    "patch /v1/prv/campaigns/:campaignId/agent": SomeOf<PatchV1PrvCampaignsCampaignIdAgentPositiveResponseVariants>;
    "get /v1/prv/campaigns/:campaignId/agent/creators": SomeOf<GetV1PrvCampaignsCampaignIdAgentCreatorsPositiveResponseVariants>;
    "get /v1/prv/campaigns/:campaignId/agent/creators/:creatorId/timeline": SomeOf<GetV1PrvCampaignsCampaignIdAgentCreatorsCreatorIdTimelinePositiveResponseVariants>;
    "get /v1/prv/campaigns/:campaignId/agent/decisions": SomeOf<GetV1PrvCampaignsCampaignIdAgentDecisionsPositiveResponseVariants>;
    "post /v1/prv/campaigns/:campaignId/agent/decisions/:decisionId": SomeOf<PostV1PrvCampaignsCampaignIdAgentDecisionsDecisionIdPositiveResponseVariants>;
    "post /v1/prv/campaigns/:campaignId/agent/follow-up-now": SomeOf<PostV1PrvCampaignsCampaignIdAgentFollowUpNowPositiveResponseVariants>;
    "get /v1/prv/campaigns/:campaignId/agent/events": SomeOf<GetV1PrvCampaignsCampaignIdAgentEventsPositiveResponseVariants>;
    "post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/take-over": SomeOf<PostV1PrvCampaignsCampaignIdAgentThreadsThreadIdTakeOverPositiveResponseVariants>;
    "post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/hand-back": SomeOf<PostV1PrvCampaignsCampaignIdAgentThreadsThreadIdHandBackPositiveResponseVariants>;
    "get /v1/prv/campaigns/:campaignId/agent/threads/:threadId/draft": SomeOf<GetV1PrvCampaignsCampaignIdAgentThreadsThreadIdDraftPositiveResponseVariants>;
    "post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/draft": SomeOf<PostV1PrvCampaignsCampaignIdAgentThreadsThreadIdDraftPositiveResponseVariants>;
    "put /v1/prv/campaigns/:campaignId/agent/threads/:threadId/draft": SomeOf<PutV1PrvCampaignsCampaignIdAgentThreadsThreadIdDraftPositiveResponseVariants>;
    "post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/send": SomeOf<PostV1PrvCampaignsCampaignIdAgentThreadsThreadIdSendPositiveResponseVariants>;
    "get /v1/prv/campaigns/:campaignId/posts/:postId/checks": SomeOf<GetV1PrvCampaignsCampaignIdPostsPostIdChecksPositiveResponseVariants>;
    "get /v1/prv/campaigns/:campaignId/posts/:postId/reminder": SomeOf<GetV1PrvCampaignsCampaignIdPostsPostIdReminderPositiveResponseVariants>;
    "get /v1/prv/campaigns/:campaignId/posts/:postId/refusal-draft": SomeOf<GetV1PrvCampaignsCampaignIdPostsPostIdRefusalDraftPositiveResponseVariants>;
    "post /v1/prv/campaigns/:campaignId/applications/:applicationId/rejection-draft": SomeOf<PostV1PrvCampaignsCampaignIdApplicationsApplicationIdRejectionDraftPositiveResponseVariants>;
    "put /v1/prv/campaigns/:campaignId/agent-instructions": SomeOf<PutV1PrvCampaignsCampaignIdAgentInstructionsPositiveResponseVariants>;
    "get /v1/prv/campaigns/:campaignId/tracked-links/clicks": SomeOf<GetV1PrvCampaignsCampaignIdTrackedLinksClicksPositiveResponseVariants>;
    "put /v1/prv/conversations/:conversationId/inbox": SomeOf<PutV1PrvConversationsConversationIdInboxPositiveResponseVariants>;
    "post /v1/prv/conversations/:conversationId/suggest-reply": SomeOf<PostV1PrvConversationsConversationIdSuggestReplyPositiveResponseVariants>;
    "get /v1/prv/conversations": SomeOf<GetV1PrvConversationsPositiveResponseVariants>;
    "get /v1/prv/conversations/unread-count": SomeOf<GetV1PrvConversationsUnreadCountPositiveResponseVariants>;
    "post /v1/prv/conversations/bulk-message": SomeOf<PostV1PrvConversationsBulkMessagePositiveResponseVariants>;
    "post /v1/prv/conversations/file/:campaignId/:creatorIds": SomeOf<PostV1PrvConversationsFileCampaignIdCreatorIdsPositiveResponseVariants>;
    "get /v1/prv/conversations/:conversationId/messages": SomeOf<GetV1PrvConversationsConversationIdMessagesPositiveResponseVariants>;
    "post /v1/prv/conversations/:conversationId/messages": SomeOf<PostV1PrvConversationsConversationIdMessagesPositiveResponseVariants>;
    "put /v1/prv/conversations/:conversationId/read": SomeOf<PutV1PrvConversationsConversationIdReadPositiveResponseVariants>;
    "put /v1/prv/conversations/:conversationId/unread": SomeOf<PutV1PrvConversationsConversationIdUnreadPositiveResponseVariants>;
    "post /v1/prv/conversations/:conversationId/upload": SomeOf<PostV1PrvConversationsConversationIdUploadPositiveResponseVariants>;
    "get /v1/prv/creator-applications": SomeOf<GetV1PrvCreatorApplicationsPositiveResponseVariants>;
    "put /v1/prv/creator-applications": SomeOf<PutV1PrvCreatorApplicationsPositiveResponseVariants>;
    "get /v1/prv/creator-applications/:creatorApplicationId": SomeOf<GetV1PrvCreatorApplicationsCreatorApplicationIdPositiveResponseVariants>;
    "get /v1/prv/creator-applications/overview/:campaignId": SomeOf<GetV1PrvCreatorApplicationsOverviewCampaignIdPositiveResponseVariants>;
    "post /v1/prv/creator-applications/:creatorApplicationId/reinstate": SomeOf<PostV1PrvCreatorApplicationsCreatorApplicationIdReinstatePositiveResponseVariants>;
    "get /v1/prv/creator-applications/:campaignId/:creatorId": SomeOf<GetV1PrvCreatorApplicationsCampaignIdCreatorIdPositiveResponseVariants>;
    "post /v1/prv/creator-applications/negociate": SomeOf<PostV1PrvCreatorApplicationsNegociatePositiveResponseVariants>;
    "get /v1/prv/user": SomeOf<GetV1PrvUserPositiveResponseVariants>;
    "get /v1/prv/user/readonly-token": SomeOf<GetV1PrvUserReadonlyTokenPositiveResponseVariants>;
    "post /v1/prv/user/country": SomeOf<PostV1PrvUserCountryPositiveResponseVariants>;
    "get /v1/prv/user/api-key": SomeOf<GetV1PrvUserApiKeyPositiveResponseVariants>;
    "post /v1/prv/user/generate-api-key": SomeOf<PostV1PrvUserGenerateApiKeyPositiveResponseVariants>;
    "get /v1/prv/campaign-analytics/:campaignId": SomeOf<GetV1PrvCampaignAnalyticsCampaignIdPositiveResponseVariants>;
    "get /v1/prv/campaign-analytics/:campaignId/engagement-profiles": SomeOf<GetV1PrvCampaignAnalyticsCampaignIdEngagementProfilesPositiveResponseVariants>;
    "get /v1/prv/campaign-analytics/:campaignId/engagement-counts": SomeOf<GetV1PrvCampaignAnalyticsCampaignIdEngagementCountsPositiveResponseVariants>;
    "post /v1/prv/campaign-analytics/:campaignId/engagement-profiles-export": SomeOf<PostV1PrvCampaignAnalyticsCampaignIdEngagementProfilesExportPositiveResponseVariants>;
    "get /v1/prv/nps": SomeOf<GetV1PrvNpsPositiveResponseVariants>;
    "post /v1/prv/nps": SomeOf<PostV1PrvNpsPositiveResponseVariants>;
    "post /v1/prv/payments/campaign-session": SomeOf<PostV1PrvPaymentsCampaignSessionPositiveResponseVariants>;
    "post /v1/prv/payments/retry-payment": SomeOf<PostV1PrvPaymentsRetryPaymentPositiveResponseVariants>;
    "post /v1/prv/payments/deposit-budget": SomeOf<PostV1PrvPaymentsDepositBudgetPositiveResponseVariants>;
    "post /v1/prv/payments/checkout-session": SomeOf<PostV1PrvPaymentsCheckoutSessionPositiveResponseVariants>;
    "get /v1/prv/payments/campaign-wallet": SomeOf<GetV1PrvPaymentsCampaignWalletPositiveResponseVariants>;
    "get /v1/prv/payments/payouts": SomeOf<GetV1PrvPaymentsPayoutsPositiveResponseVariants>;
    "get /v1/prv/payments/portal-session": SomeOf<GetV1PrvPaymentsPortalSessionPositiveResponseVariants>;
    "get /v1/prv/payments/customer": SomeOf<GetV1PrvPaymentsCustomerPositiveResponseVariants>;
    "put /v1/prv/payments/customer": SomeOf<PutV1PrvPaymentsCustomerPositiveResponseVariants>;
    "get /v1/prv/payments/campaign-quote": SomeOf<GetV1PrvPaymentsCampaignQuotePositiveResponseVariants>;
    "get /v1/prv/payments/deposit-details": SomeOf<GetV1PrvPaymentsDepositDetailsPositiveResponseVariants>;
    "get /v1/prv/payments/payouts-overview": SomeOf<GetV1PrvPaymentsPayoutsOverviewPositiveResponseVariants>;
    "get /v1/prv/payments/upcoming-settlements": SomeOf<GetV1PrvPaymentsUpcomingSettlementsPositiveResponseVariants>;
    "get /v1/prv/payments/campaign-results": SomeOf<GetV1PrvPaymentsCampaignResultsPositiveResponseVariants>;
    "get /v1/prv/saved-replies": SomeOf<GetV1PrvSavedRepliesPositiveResponseVariants>;
    "post /v1/prv/saved-replies": SomeOf<PostV1PrvSavedRepliesPositiveResponseVariants>;
    "delete /v1/prv/saved-replies/:savedReplyId": SomeOf<DeleteV1PrvSavedRepliesSavedReplyIdPositiveResponseVariants>;
    "put /v1/prv/saved-replies/:savedReplyId": SomeOf<PutV1PrvSavedRepliesSavedReplyIdPositiveResponseVariants>;
    "post /v1/prv/pusher/auth": SomeOf<PostV1PrvPusherAuthPositiveResponseVariants>;
    "get /v1/prv/linkedin-sender": SomeOf<GetV1PrvLinkedinSenderPositiveResponseVariants>;
    "delete /v1/prv/linkedin-sender": SomeOf<DeleteV1PrvLinkedinSenderPositiveResponseVariants>;
    "put /v1/prv/linkedin-sender/schedule": SomeOf<PutV1PrvLinkedinSenderSchedulePositiveResponseVariants>;
    "post /v1/prv/linkedin-sender/cloud-login": SomeOf<PostV1PrvLinkedinSenderCloudLoginPositiveResponseVariants>;
    "get /v1/prv/linkedin-sender/cloud-login": SomeOf<GetV1PrvLinkedinSenderCloudLoginPositiveResponseVariants>;
    "post /v1/prv/linkedin-sender/cloud-login/resume": SomeOf<PostV1PrvLinkedinSenderCloudLoginResumePositiveResponseVariants>;
    "get /v1/smm-prv/campaigns": SomeOf<GetV1SmmPrvCampaignsPositiveResponseVariants>;
    "post /v1/smm-prv/campaigns/apply": SomeOf<PostV1SmmPrvCampaignsApplyPositiveResponseVariants>;
    "get /v1/smm-prv/campaigns/applied": SomeOf<GetV1SmmPrvCampaignsAppliedPositiveResponseVariants>;
    "get /v1/smm-prv/campaigns/:campaignId": SomeOf<GetV1SmmPrvCampaignsCampaignIdPositiveResponseVariants>;
    "get /v1/smm-prv/creator-applications": SomeOf<GetV1SmmPrvCreatorApplicationsPositiveResponseVariants>;
    "put /v1/smm-prv/creator-applications": SomeOf<PutV1SmmPrvCreatorApplicationsPositiveResponseVariants>;
    "get /v1/smm-prv/creator-applications/overview": SomeOf<GetV1SmmPrvCreatorApplicationsOverviewPositiveResponseVariants>;
    "get /v1/smm-prv/creator-applications/count": SomeOf<GetV1SmmPrvCreatorApplicationsCountPositiveResponseVariants>;
    "get /v1/smm-prv/creator-applications/has-any": SomeOf<GetV1SmmPrvCreatorApplicationsHasAnyPositiveResponseVariants>;
    "get /v1/smm-prv/creator-applications/by-id/:creatorApplicationId": SomeOf<GetV1SmmPrvCreatorApplicationsByIdCreatorApplicationIdPositiveResponseVariants>;
    "get /v1/smm-prv/creator-applications/:campaignId": SomeOf<GetV1SmmPrvCreatorApplicationsCampaignIdPositiveResponseVariants>;
    "post /v1/smm-prv/creator-applications/negociate": SomeOf<PostV1SmmPrvCreatorApplicationsNegociatePositiveResponseVariants>;
    "get /v1/smm-prv/brands/applied-to": SomeOf<GetV1SmmPrvBrandsAppliedToPositiveResponseVariants>;
    "get /v1/smm-prv/brands/:brandId": SomeOf<GetV1SmmPrvBrandsBrandIdPositiveResponseVariants>;
    "get /v1/smm-prv/creators/me": SomeOf<GetV1SmmPrvCreatorsMePositiveResponseVariants>;
    "post /v1/smm-prv/creators/adopt-sourced": SomeOf<PostV1SmmPrvCreatorsAdoptSourcedPositiveResponseVariants>;
    "post /v1/smm-prv/creators/populate": SomeOf<PostV1SmmPrvCreatorsPopulatePositiveResponseVariants>;
    "put /v1/smm-prv/creators/privacy": SomeOf<PutV1SmmPrvCreatorsPrivacyPositiveResponseVariants>;
    "get /v1/smm-prv/conversations": SomeOf<GetV1SmmPrvConversationsPositiveResponseVariants>;
    "get /v1/smm-prv/conversations/unread-count": SomeOf<GetV1SmmPrvConversationsUnreadCountPositiveResponseVariants>;
    "post /v1/smm-prv/conversations/messages": SomeOf<PostV1SmmPrvConversationsMessagesPositiveResponseVariants>;
    "get /v1/smm-prv/conversations/:conversationId/messages": SomeOf<GetV1SmmPrvConversationsConversationIdMessagesPositiveResponseVariants>;
    "put /v1/smm-prv/conversations/:conversationId/read": SomeOf<PutV1SmmPrvConversationsConversationIdReadPositiveResponseVariants>;
    "put /v1/smm-prv/conversations/:conversationId/unread": SomeOf<PutV1SmmPrvConversationsConversationIdUnreadPositiveResponseVariants>;
    "post /v1/smm-prv/conversations/:conversationId/upload": SomeOf<PostV1SmmPrvConversationsConversationIdUploadPositiveResponseVariants>;
    "get /v1/smm-prv/nps": SomeOf<GetV1SmmPrvNpsPositiveResponseVariants>;
    "post /v1/smm-prv/nps": SomeOf<PostV1SmmPrvNpsPositiveResponseVariants>;
    "get /v1/smm-prv/payments/payouts": SomeOf<GetV1SmmPrvPaymentsPayoutsPositiveResponseVariants>;
    "get /v1/smm-prv/payments/earnings": SomeOf<GetV1SmmPrvPaymentsEarningsPositiveResponseVariants>;
    "get /v1/smm-prv/payments/recent-payouts": SomeOf<GetV1SmmPrvPaymentsRecentPayoutsPositiveResponseVariants>;
    "get /v1/smm-prv/saved-replies": SomeOf<GetV1SmmPrvSavedRepliesPositiveResponseVariants>;
    "post /v1/smm-prv/saved-replies": SomeOf<PostV1SmmPrvSavedRepliesPositiveResponseVariants>;
    "delete /v1/smm-prv/saved-replies/:savedReplyId": SomeOf<DeleteV1SmmPrvSavedRepliesSavedReplyIdPositiveResponseVariants>;
    "put /v1/smm-prv/saved-replies/:savedReplyId": SomeOf<PutV1SmmPrvSavedRepliesSavedReplyIdPositiveResponseVariants>;
    "get /v1/smm-prv/sponsors": SomeOf<GetV1SmmPrvSponsorsPositiveResponseVariants>;
    "get /v1/smm-prv/sponsors/tags": SomeOf<GetV1SmmPrvSponsorsTagsPositiveResponseVariants>;
    "get /v1/smm-prv/sponsors/contacts": SomeOf<GetV1SmmPrvSponsorsContactsPositiveResponseVariants>;
    "put /v1/smm-prv/sponsors/contact": SomeOf<PutV1SmmPrvSponsorsContactPositiveResponseVariants>;
    "delete /v1/smm-prv/sponsors/contact": SomeOf<DeleteV1SmmPrvSponsorsContactPositiveResponseVariants>;
    "get /v1/smm-prv/sponsors/:sponsorId": SomeOf<GetV1SmmPrvSponsorsSponsorIdPositiveResponseVariants>;
    "get /v1/open/me": SomeOf<GetV1OpenMePositiveResponseVariants>;
    "get /v1/open/sponsors": SomeOf<GetV1OpenSponsorsPositiveResponseVariants>;
    "get /v1/open/sponsors/tags": SomeOf<GetV1OpenSponsorsTagsPositiveResponseVariants>;
    "get /v1/open/sponsors/tracked": SomeOf<GetV1OpenSponsorsTrackedPositiveResponseVariants>;
    "put /v1/open/sponsors/contact": SomeOf<PutV1OpenSponsorsContactPositiveResponseVariants>;
    "get /v1/open/sponsors/:sponsorId": SomeOf<GetV1OpenSponsorsSponsorIdPositiveResponseVariants>;
    "get /v1/open/sponsors/:sponsorId/outreach-context": SomeOf<GetV1OpenSponsorsSponsorIdOutreachContextPositiveResponseVariants>;
    "get /v1/open/brand/brands": SomeOf<GetV1OpenBrandBrandsPositiveResponseVariants>;
    "post /v1/open/brand/brands": SomeOf<PostV1OpenBrandBrandsPositiveResponseVariants>;
    "get /v1/open/brand/creators": SomeOf<GetV1OpenBrandCreatorsPositiveResponseVariants>;
    "post /v1/open/brand/campaigns": SomeOf<PostV1OpenBrandCampaignsPositiveResponseVariants>;
    "post /v1/open/brand/campaigns/invite": SomeOf<PostV1OpenBrandCampaignsInvitePositiveResponseVariants>;
    "post /v1/adm/conversations/send-automatic-message": SomeOf<PostV1AdmConversationsSendAutomaticMessagePositiveResponseVariants>;
    "post /v1/adm/populateOneCreator": SomeOf<PostV1AdmPopulateOneCreatorPositiveResponseVariants>;
    "post /v1/adm/populateAllCreators": SomeOf<PostV1AdmPopulateAllCreatorsPositiveResponseVariants>;
    "post /v1/adm/excludeCreator": SomeOf<PostV1AdmExcludeCreatorPositiveResponseVariants>;
    "post /v1/adm/runPostChecks": SomeOf<PostV1AdmRunPostChecksPositiveResponseVariants>;
    "get /v1/stf/linkedin-message-recovery": SomeOf<GetV1StfLinkedinMessageRecoveryPositiveResponseVariants>;
    "post /v1/stf/linkedin-message-recovery/confirm-not-sent": SomeOf<PostV1StfLinkedinMessageRecoveryConfirmNotSentPositiveResponseVariants>;
    "get /v1/stf/linkedin-pool": SomeOf<GetV1StfLinkedinPoolPositiveResponseVariants>;
    "post /v1/stf/linkedin-pool": SomeOf<PostV1StfLinkedinPoolPositiveResponseVariants>;
    "patch /v1/stf/linkedin-pool/:accountId": SomeOf<PatchV1StfLinkedinPoolAccountIdPositiveResponseVariants>;
    "delete /v1/stf/linkedin-pool/:accountId": SomeOf<DeleteV1StfLinkedinPoolAccountIdPositiveResponseVariants>;
    "post /v1/stf/linkedin-pool/:accountId/cloud-login": SomeOf<PostV1StfLinkedinPoolAccountIdCloudLoginPositiveResponseVariants>;
    "get /v1/stf/linkedin-pool/:accountId/cloud-login": SomeOf<GetV1StfLinkedinPoolAccountIdCloudLoginPositiveResponseVariants>;
    "post /v1/stf/linkedin-pool/:accountId/cloud-login/resume": SomeOf<PostV1StfLinkedinPoolAccountIdCloudLoginResumePositiveResponseVariants>;
    "get /v1/stf/users": SomeOf<GetV1StfUsersPositiveResponseVariants>;
    "get /v1/stf/campaigns": SomeOf<GetV1StfCampaignsPositiveResponseVariants>;
    "post /v1/stf/campaigns/force-close": SomeOf<PostV1StfCampaignsForceClosePositiveResponseVariants>;
    "post /v1/stf/campaigns/confirm-manual-refund": SomeOf<PostV1StfCampaignsConfirmManualRefundPositiveResponseVariants>;
    "post /v1/stf/campaigns/confirm-out-of-band-payment": SomeOf<PostV1StfCampaignsConfirmOutOfBandPaymentPositiveResponseVariants>;
    "post /v1/stf/campaigns/delete": SomeOf<PostV1StfCampaignsDeletePositiveResponseVariants>;
    "post /v1/stf/creator-applications/reinstate": SomeOf<PostV1StfCreatorApplicationsReinstatePositiveResponseVariants>;
    "post /v1/stf/generate-actor-token": SomeOf<PostV1StfGenerateActorTokenPositiveResponseVariants>;
    "get /v1/stf/nps-ratings": SomeOf<GetV1StfNpsRatingsPositiveResponseVariants>;
    "post /v1/stf/trigger-pay-sponsored-posts": SomeOf<PostV1StfTriggerPaySponsoredPostsPositiveResponseVariants>;
    "get /v1/stf/payouts-to-pay": SomeOf<GetV1StfPayoutsToPayPositiveResponseVariants>;
    "get /v1/stf/payouts-paid": SomeOf<GetV1StfPayoutsPaidPositiveResponseVariants>;
    "get /v1/stf/payouts-blocked": SomeOf<GetV1StfPayoutsBlockedPositiveResponseVariants>;
    "post /v1/stf/payouts/cancel-export": SomeOf<PostV1StfPayoutsCancelExportPositiveResponseVariants>;
    "post /v1/stf/payouts/create-export": SomeOf<PostV1StfPayoutsCreateExportPositiveResponseVariants>;
    "post /v1/stf/payouts/get-export": SomeOf<PostV1StfPayoutsGetExportPositiveResponseVariants>;
    "post /v1/stf/payouts/mark-paid": SomeOf<PostV1StfPayoutsMarkPaidPositiveResponseVariants>;
    "post /v1/stf/payouts/upload-transfer-proof": SomeOf<PostV1StfPayoutsUploadTransferProofPositiveResponseVariants>;
    "post /v1/stf/payouts/verify-vat": SomeOf<PostV1StfPayoutsVerifyVatPositiveResponseVariants>;
}

export interface NegativeResponse {
    "post /v1/pub/clerk/webhook": SomeOf<PostV1PubClerkWebhookNegativeResponseVariants>;
    "post /v1/pub/login": SomeOf<PostV1PubLoginNegativeResponseVariants>;
    "get /v1/pub/campaigns": SomeOf<GetV1PubCampaignsNegativeResponseVariants>;
    "get /v1/pub/campaign-invitations/:token": SomeOf<GetV1PubCampaignInvitationsTokenNegativeResponseVariants>;
    "post /v1/pub/campaign-invitations/:token/accept": SomeOf<PostV1PubCampaignInvitationsTokenAcceptNegativeResponseVariants>;
    "post /v1/pub/campaign-invitations/:token/decline": SomeOf<PostV1PubCampaignInvitationsTokenDeclineNegativeResponseVariants>;
    "get /v1/pub/creator-signup/:token": SomeOf<GetV1PubCreatorSignupTokenNegativeResponseVariants>;
    "post /v1/pub/webhook/stripe": SomeOf<PostV1PubWebhookStripeNegativeResponseVariants>;
    "get /v1/pub/creators": SomeOf<GetV1PubCreatorsNegativeResponseVariants>;
    "get /v1/pub/creators/dashboard": SomeOf<GetV1PubCreatorsDashboardNegativeResponseVariants>;
    "get /v1/pub/creators/posts": SomeOf<GetV1PubCreatorsPostsNegativeResponseVariants>;
    "get /v1/pub/creators/sitemap": SomeOf<GetV1PubCreatorsSitemapNegativeResponseVariants>;
    "get /v1/pub/health": SomeOf<GetV1PubHealthNegativeResponseVariants>;
    "get /v1/pub/sponsoring/stats": SomeOf<GetV1PubSponsoringStatsNegativeResponseVariants>;
    "get /v1/pub/translations/:language": SomeOf<GetV1PubTranslationsLanguageNegativeResponseVariants>;
    "get /v1/prv/lists": SomeOf<GetV1PrvListsNegativeResponseVariants>;
    "post /v1/prv/lists": SomeOf<PostV1PrvListsNegativeResponseVariants>;
    "put /v1/prv/lists": SomeOf<PutV1PrvListsNegativeResponseVariants>;
    "post /v1/prv/lists/delete": SomeOf<PostV1PrvListsDeleteNegativeResponseVariants>;
    "get /v1/prv/lists/all": SomeOf<GetV1PrvListsAllNegativeResponseVariants>;
    "put /v1/prv/lists/creators/add": SomeOf<PutV1PrvListsCreatorsAddNegativeResponseVariants>;
    "put /v1/prv/lists/creators/remove": SomeOf<PutV1PrvListsCreatorsRemoveNegativeResponseVariants>;
    "put /v1/prv/lists/creators/empty": SomeOf<PutV1PrvListsCreatorsEmptyNegativeResponseVariants>;
    "get /v1/prv/brands": SomeOf<GetV1PrvBrandsNegativeResponseVariants>;
    "post /v1/prv/brands": SomeOf<PostV1PrvBrandsNegativeResponseVariants>;
    "put /v1/prv/brands": SomeOf<PutV1PrvBrandsNegativeResponseVariants>;
    "delete /v1/prv/brands": SomeOf<DeleteV1PrvBrandsNegativeResponseVariants>;
    "post /v1/prv/brands/analyze": SomeOf<PostV1PrvBrandsAnalyzeNegativeResponseVariants>;
    "get /v1/prv/brands/analyze/:analysisId": SomeOf<GetV1PrvBrandsAnalyzeAnalysisIdNegativeResponseVariants>;
    "get /v1/prv/brands/:brandId": SomeOf<GetV1PrvBrandsBrandIdNegativeResponseVariants>;
    "patch /v1/prv/brands/:brandId": SomeOf<PatchV1PrvBrandsBrandIdNegativeResponseVariants>;
    "get /v1/prv/brands/:brandId/subscription": SomeOf<GetV1PrvBrandsBrandIdSubscriptionNegativeResponseVariants>;
    "post /v1/prv/brands/:brandId/subscription/checkout": SomeOf<PostV1PrvBrandsBrandIdSubscriptionCheckoutNegativeResponseVariants>;
    "post /v1/prv/brands/:brandId/subscription/portal": SomeOf<PostV1PrvBrandsBrandIdSubscriptionPortalNegativeResponseVariants>;
    "post /v1/prv/brands/:brandId/subscription/cancel": SomeOf<PostV1PrvBrandsBrandIdSubscriptionCancelNegativeResponseVariants>;
    "post /v1/prv/brands/upload/logo": SomeOf<PostV1PrvBrandsUploadLogoNegativeResponseVariants>;
    "post /v1/prv/brands/upload/file": SomeOf<PostV1PrvBrandsUploadFileNegativeResponseVariants>;
    "get /v1/prv/brands/download/file": SomeOf<GetV1PrvBrandsDownloadFileNegativeResponseVariants>;
    "post /v1/prv/brands/download/files": SomeOf<PostV1PrvBrandsDownloadFilesNegativeResponseVariants>;
    "get /v1/prv/creators": SomeOf<GetV1PrvCreatorsNegativeResponseVariants>;
    "post /v1/prv/creators/exclude": SomeOf<PostV1PrvCreatorsExcludeNegativeResponseVariants>;
    "get /v1/prv/creators/checkCanExclude": SomeOf<GetV1PrvCreatorsCheckCanExcludeNegativeResponseVariants>;
    "get /v1/prv/creators/all": SomeOf<GetV1PrvCreatorsAllNegativeResponseVariants>;
    "get /v1/prv/creators/with-published-campaign-post": SomeOf<GetV1PrvCreatorsWithPublishedCampaignPostNegativeResponseVariants>;
    "get /v1/prv/creators/dormant": SomeOf<GetV1PrvCreatorsDormantNegativeResponseVariants>;
    "post /v1/prv/creators/relaunch": SomeOf<PostV1PrvCreatorsRelaunchNegativeResponseVariants>;
    "get /v1/prv/campaigns": SomeOf<GetV1PrvCampaignsNegativeResponseVariants>;
    "post /v1/prv/campaigns": SomeOf<PostV1PrvCampaignsNegativeResponseVariants>;
    "put /v1/prv/campaigns": SomeOf<PutV1PrvCampaignsNegativeResponseVariants>;
    "get /v1/prv/campaigns/open-to-offer": SomeOf<GetV1PrvCampaignsOpenToOfferNegativeResponseVariants>;
    "get /v1/prv/campaigns/total": SomeOf<GetV1PrvCampaignsTotalNegativeResponseVariants>;
    "post /v1/prv/campaigns/has-enough-creators": SomeOf<PostV1PrvCampaignsHasEnoughCreatorsNegativeResponseVariants>;
    "get /v1/prv/campaigns/failed-payment": SomeOf<GetV1PrvCampaignsFailedPaymentNegativeResponseVariants>;
    "post /v1/prv/campaigns/draft": SomeOf<PostV1PrvCampaignsDraftNegativeResponseVariants>;
    "get /v1/prv/campaigns/audience-locations": SomeOf<GetV1PrvCampaignsAudienceLocationsNegativeResponseVariants>;
    "get /v1/prv/campaigns/overview": SomeOf<GetV1PrvCampaignsOverviewNegativeResponseVariants>;
    "get /v1/prv/campaigns/:campaignId": SomeOf<GetV1PrvCampaignsCampaignIdNegativeResponseVariants>;
    "put /v1/prv/campaigns/:campaignId": SomeOf<PutV1PrvCampaignsCampaignIdNegativeResponseVariants>;
    "patch /v1/prv/campaigns/:campaignId/draft": SomeOf<PatchV1PrvCampaignsCampaignIdDraftNegativeResponseVariants>;
    "delete /v1/prv/campaigns/:campaignId/draft": SomeOf<DeleteV1PrvCampaignsCampaignIdDraftNegativeResponseVariants>;
    "post /v1/prv/campaigns/:campaignId/estimate": SomeOf<PostV1PrvCampaignsCampaignIdEstimateNegativeResponseVariants>;
    "post /v1/prv/campaigns/:campaignId/invitation-preview": SomeOf<PostV1PrvCampaignsCampaignIdInvitationPreviewNegativeResponseVariants>;
    "post /v1/prv/campaigns/:campaignId/key-message-suggestion": SomeOf<PostV1PrvCampaignsCampaignIdKeyMessageSuggestionNegativeResponseVariants>;
    "get /v1/prv/campaigns/:campaignId/can-close": SomeOf<GetV1PrvCampaignsCampaignIdCanCloseNegativeResponseVariants>;
    "post /v1/prv/campaigns/:campaignId/close": SomeOf<PostV1PrvCampaignsCampaignIdCloseNegativeResponseVariants>;
    "post /v1/prv/campaigns/:campaignId/invite": SomeOf<PostV1PrvCampaignsCampaignIdInviteNegativeResponseVariants>;
    "post /v1/prv/campaigns/:campaignId/upload": SomeOf<PostV1PrvCampaignsCampaignIdUploadNegativeResponseVariants>;
    "get /v1/prv/campaigns/:campaignId/agent": SomeOf<GetV1PrvCampaignsCampaignIdAgentNegativeResponseVariants>;
    "patch /v1/prv/campaigns/:campaignId/agent": SomeOf<PatchV1PrvCampaignsCampaignIdAgentNegativeResponseVariants>;
    "get /v1/prv/campaigns/:campaignId/agent/creators": SomeOf<GetV1PrvCampaignsCampaignIdAgentCreatorsNegativeResponseVariants>;
    "get /v1/prv/campaigns/:campaignId/agent/creators/:creatorId/timeline": SomeOf<GetV1PrvCampaignsCampaignIdAgentCreatorsCreatorIdTimelineNegativeResponseVariants>;
    "get /v1/prv/campaigns/:campaignId/agent/decisions": SomeOf<GetV1PrvCampaignsCampaignIdAgentDecisionsNegativeResponseVariants>;
    "post /v1/prv/campaigns/:campaignId/agent/decisions/:decisionId": SomeOf<PostV1PrvCampaignsCampaignIdAgentDecisionsDecisionIdNegativeResponseVariants>;
    "post /v1/prv/campaigns/:campaignId/agent/follow-up-now": SomeOf<PostV1PrvCampaignsCampaignIdAgentFollowUpNowNegativeResponseVariants>;
    "get /v1/prv/campaigns/:campaignId/agent/events": SomeOf<GetV1PrvCampaignsCampaignIdAgentEventsNegativeResponseVariants>;
    "post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/take-over": SomeOf<PostV1PrvCampaignsCampaignIdAgentThreadsThreadIdTakeOverNegativeResponseVariants>;
    "post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/hand-back": SomeOf<PostV1PrvCampaignsCampaignIdAgentThreadsThreadIdHandBackNegativeResponseVariants>;
    "get /v1/prv/campaigns/:campaignId/agent/threads/:threadId/draft": SomeOf<GetV1PrvCampaignsCampaignIdAgentThreadsThreadIdDraftNegativeResponseVariants>;
    "post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/draft": SomeOf<PostV1PrvCampaignsCampaignIdAgentThreadsThreadIdDraftNegativeResponseVariants>;
    "put /v1/prv/campaigns/:campaignId/agent/threads/:threadId/draft": SomeOf<PutV1PrvCampaignsCampaignIdAgentThreadsThreadIdDraftNegativeResponseVariants>;
    "post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/send": SomeOf<PostV1PrvCampaignsCampaignIdAgentThreadsThreadIdSendNegativeResponseVariants>;
    "get /v1/prv/campaigns/:campaignId/posts/:postId/checks": SomeOf<GetV1PrvCampaignsCampaignIdPostsPostIdChecksNegativeResponseVariants>;
    "get /v1/prv/campaigns/:campaignId/posts/:postId/reminder": SomeOf<GetV1PrvCampaignsCampaignIdPostsPostIdReminderNegativeResponseVariants>;
    "get /v1/prv/campaigns/:campaignId/posts/:postId/refusal-draft": SomeOf<GetV1PrvCampaignsCampaignIdPostsPostIdRefusalDraftNegativeResponseVariants>;
    "post /v1/prv/campaigns/:campaignId/applications/:applicationId/rejection-draft": SomeOf<PostV1PrvCampaignsCampaignIdApplicationsApplicationIdRejectionDraftNegativeResponseVariants>;
    "put /v1/prv/campaigns/:campaignId/agent-instructions": SomeOf<PutV1PrvCampaignsCampaignIdAgentInstructionsNegativeResponseVariants>;
    "get /v1/prv/campaigns/:campaignId/tracked-links/clicks": SomeOf<GetV1PrvCampaignsCampaignIdTrackedLinksClicksNegativeResponseVariants>;
    "put /v1/prv/conversations/:conversationId/inbox": SomeOf<PutV1PrvConversationsConversationIdInboxNegativeResponseVariants>;
    "post /v1/prv/conversations/:conversationId/suggest-reply": SomeOf<PostV1PrvConversationsConversationIdSuggestReplyNegativeResponseVariants>;
    "get /v1/prv/conversations": SomeOf<GetV1PrvConversationsNegativeResponseVariants>;
    "get /v1/prv/conversations/unread-count": SomeOf<GetV1PrvConversationsUnreadCountNegativeResponseVariants>;
    "post /v1/prv/conversations/bulk-message": SomeOf<PostV1PrvConversationsBulkMessageNegativeResponseVariants>;
    "post /v1/prv/conversations/file/:campaignId/:creatorIds": SomeOf<PostV1PrvConversationsFileCampaignIdCreatorIdsNegativeResponseVariants>;
    "get /v1/prv/conversations/:conversationId/messages": SomeOf<GetV1PrvConversationsConversationIdMessagesNegativeResponseVariants>;
    "post /v1/prv/conversations/:conversationId/messages": SomeOf<PostV1PrvConversationsConversationIdMessagesNegativeResponseVariants>;
    "put /v1/prv/conversations/:conversationId/read": SomeOf<PutV1PrvConversationsConversationIdReadNegativeResponseVariants>;
    "put /v1/prv/conversations/:conversationId/unread": SomeOf<PutV1PrvConversationsConversationIdUnreadNegativeResponseVariants>;
    "post /v1/prv/conversations/:conversationId/upload": SomeOf<PostV1PrvConversationsConversationIdUploadNegativeResponseVariants>;
    "get /v1/prv/creator-applications": SomeOf<GetV1PrvCreatorApplicationsNegativeResponseVariants>;
    "put /v1/prv/creator-applications": SomeOf<PutV1PrvCreatorApplicationsNegativeResponseVariants>;
    "get /v1/prv/creator-applications/:creatorApplicationId": SomeOf<GetV1PrvCreatorApplicationsCreatorApplicationIdNegativeResponseVariants>;
    "get /v1/prv/creator-applications/overview/:campaignId": SomeOf<GetV1PrvCreatorApplicationsOverviewCampaignIdNegativeResponseVariants>;
    "post /v1/prv/creator-applications/:creatorApplicationId/reinstate": SomeOf<PostV1PrvCreatorApplicationsCreatorApplicationIdReinstateNegativeResponseVariants>;
    "get /v1/prv/creator-applications/:campaignId/:creatorId": SomeOf<GetV1PrvCreatorApplicationsCampaignIdCreatorIdNegativeResponseVariants>;
    "post /v1/prv/creator-applications/negociate": SomeOf<PostV1PrvCreatorApplicationsNegociateNegativeResponseVariants>;
    "get /v1/prv/user": SomeOf<GetV1PrvUserNegativeResponseVariants>;
    "get /v1/prv/user/readonly-token": SomeOf<GetV1PrvUserReadonlyTokenNegativeResponseVariants>;
    "post /v1/prv/user/country": SomeOf<PostV1PrvUserCountryNegativeResponseVariants>;
    "get /v1/prv/user/api-key": SomeOf<GetV1PrvUserApiKeyNegativeResponseVariants>;
    "post /v1/prv/user/generate-api-key": SomeOf<PostV1PrvUserGenerateApiKeyNegativeResponseVariants>;
    "get /v1/prv/campaign-analytics/:campaignId": SomeOf<GetV1PrvCampaignAnalyticsCampaignIdNegativeResponseVariants>;
    "get /v1/prv/campaign-analytics/:campaignId/engagement-profiles": SomeOf<GetV1PrvCampaignAnalyticsCampaignIdEngagementProfilesNegativeResponseVariants>;
    "get /v1/prv/campaign-analytics/:campaignId/engagement-counts": SomeOf<GetV1PrvCampaignAnalyticsCampaignIdEngagementCountsNegativeResponseVariants>;
    "post /v1/prv/campaign-analytics/:campaignId/engagement-profiles-export": SomeOf<PostV1PrvCampaignAnalyticsCampaignIdEngagementProfilesExportNegativeResponseVariants>;
    "get /v1/prv/nps": SomeOf<GetV1PrvNpsNegativeResponseVariants>;
    "post /v1/prv/nps": SomeOf<PostV1PrvNpsNegativeResponseVariants>;
    "post /v1/prv/payments/campaign-session": SomeOf<PostV1PrvPaymentsCampaignSessionNegativeResponseVariants>;
    "post /v1/prv/payments/retry-payment": SomeOf<PostV1PrvPaymentsRetryPaymentNegativeResponseVariants>;
    "post /v1/prv/payments/deposit-budget": SomeOf<PostV1PrvPaymentsDepositBudgetNegativeResponseVariants>;
    "post /v1/prv/payments/checkout-session": SomeOf<PostV1PrvPaymentsCheckoutSessionNegativeResponseVariants>;
    "get /v1/prv/payments/campaign-wallet": SomeOf<GetV1PrvPaymentsCampaignWalletNegativeResponseVariants>;
    "get /v1/prv/payments/payouts": SomeOf<GetV1PrvPaymentsPayoutsNegativeResponseVariants>;
    "get /v1/prv/payments/portal-session": SomeOf<GetV1PrvPaymentsPortalSessionNegativeResponseVariants>;
    "get /v1/prv/payments/customer": SomeOf<GetV1PrvPaymentsCustomerNegativeResponseVariants>;
    "put /v1/prv/payments/customer": SomeOf<PutV1PrvPaymentsCustomerNegativeResponseVariants>;
    "get /v1/prv/payments/campaign-quote": SomeOf<GetV1PrvPaymentsCampaignQuoteNegativeResponseVariants>;
    "get /v1/prv/payments/deposit-details": SomeOf<GetV1PrvPaymentsDepositDetailsNegativeResponseVariants>;
    "get /v1/prv/payments/payouts-overview": SomeOf<GetV1PrvPaymentsPayoutsOverviewNegativeResponseVariants>;
    "get /v1/prv/payments/upcoming-settlements": SomeOf<GetV1PrvPaymentsUpcomingSettlementsNegativeResponseVariants>;
    "get /v1/prv/payments/campaign-results": SomeOf<GetV1PrvPaymentsCampaignResultsNegativeResponseVariants>;
    "get /v1/prv/saved-replies": SomeOf<GetV1PrvSavedRepliesNegativeResponseVariants>;
    "post /v1/prv/saved-replies": SomeOf<PostV1PrvSavedRepliesNegativeResponseVariants>;
    "delete /v1/prv/saved-replies/:savedReplyId": SomeOf<DeleteV1PrvSavedRepliesSavedReplyIdNegativeResponseVariants>;
    "put /v1/prv/saved-replies/:savedReplyId": SomeOf<PutV1PrvSavedRepliesSavedReplyIdNegativeResponseVariants>;
    "post /v1/prv/pusher/auth": SomeOf<PostV1PrvPusherAuthNegativeResponseVariants>;
    "get /v1/prv/linkedin-sender": SomeOf<GetV1PrvLinkedinSenderNegativeResponseVariants>;
    "delete /v1/prv/linkedin-sender": SomeOf<DeleteV1PrvLinkedinSenderNegativeResponseVariants>;
    "put /v1/prv/linkedin-sender/schedule": SomeOf<PutV1PrvLinkedinSenderScheduleNegativeResponseVariants>;
    "post /v1/prv/linkedin-sender/cloud-login": SomeOf<PostV1PrvLinkedinSenderCloudLoginNegativeResponseVariants>;
    "get /v1/prv/linkedin-sender/cloud-login": SomeOf<GetV1PrvLinkedinSenderCloudLoginNegativeResponseVariants>;
    "post /v1/prv/linkedin-sender/cloud-login/resume": SomeOf<PostV1PrvLinkedinSenderCloudLoginResumeNegativeResponseVariants>;
    "get /v1/smm-prv/campaigns": SomeOf<GetV1SmmPrvCampaignsNegativeResponseVariants>;
    "post /v1/smm-prv/campaigns/apply": SomeOf<PostV1SmmPrvCampaignsApplyNegativeResponseVariants>;
    "get /v1/smm-prv/campaigns/applied": SomeOf<GetV1SmmPrvCampaignsAppliedNegativeResponseVariants>;
    "get /v1/smm-prv/campaigns/:campaignId": SomeOf<GetV1SmmPrvCampaignsCampaignIdNegativeResponseVariants>;
    "get /v1/smm-prv/creator-applications": SomeOf<GetV1SmmPrvCreatorApplicationsNegativeResponseVariants>;
    "put /v1/smm-prv/creator-applications": SomeOf<PutV1SmmPrvCreatorApplicationsNegativeResponseVariants>;
    "get /v1/smm-prv/creator-applications/overview": SomeOf<GetV1SmmPrvCreatorApplicationsOverviewNegativeResponseVariants>;
    "get /v1/smm-prv/creator-applications/count": SomeOf<GetV1SmmPrvCreatorApplicationsCountNegativeResponseVariants>;
    "get /v1/smm-prv/creator-applications/has-any": SomeOf<GetV1SmmPrvCreatorApplicationsHasAnyNegativeResponseVariants>;
    "get /v1/smm-prv/creator-applications/by-id/:creatorApplicationId": SomeOf<GetV1SmmPrvCreatorApplicationsByIdCreatorApplicationIdNegativeResponseVariants>;
    "get /v1/smm-prv/creator-applications/:campaignId": SomeOf<GetV1SmmPrvCreatorApplicationsCampaignIdNegativeResponseVariants>;
    "post /v1/smm-prv/creator-applications/negociate": SomeOf<PostV1SmmPrvCreatorApplicationsNegociateNegativeResponseVariants>;
    "get /v1/smm-prv/brands/applied-to": SomeOf<GetV1SmmPrvBrandsAppliedToNegativeResponseVariants>;
    "get /v1/smm-prv/brands/:brandId": SomeOf<GetV1SmmPrvBrandsBrandIdNegativeResponseVariants>;
    "get /v1/smm-prv/creators/me": SomeOf<GetV1SmmPrvCreatorsMeNegativeResponseVariants>;
    "post /v1/smm-prv/creators/adopt-sourced": SomeOf<PostV1SmmPrvCreatorsAdoptSourcedNegativeResponseVariants>;
    "post /v1/smm-prv/creators/populate": SomeOf<PostV1SmmPrvCreatorsPopulateNegativeResponseVariants>;
    "put /v1/smm-prv/creators/privacy": SomeOf<PutV1SmmPrvCreatorsPrivacyNegativeResponseVariants>;
    "get /v1/smm-prv/conversations": SomeOf<GetV1SmmPrvConversationsNegativeResponseVariants>;
    "get /v1/smm-prv/conversations/unread-count": SomeOf<GetV1SmmPrvConversationsUnreadCountNegativeResponseVariants>;
    "post /v1/smm-prv/conversations/messages": SomeOf<PostV1SmmPrvConversationsMessagesNegativeResponseVariants>;
    "get /v1/smm-prv/conversations/:conversationId/messages": SomeOf<GetV1SmmPrvConversationsConversationIdMessagesNegativeResponseVariants>;
    "put /v1/smm-prv/conversations/:conversationId/read": SomeOf<PutV1SmmPrvConversationsConversationIdReadNegativeResponseVariants>;
    "put /v1/smm-prv/conversations/:conversationId/unread": SomeOf<PutV1SmmPrvConversationsConversationIdUnreadNegativeResponseVariants>;
    "post /v1/smm-prv/conversations/:conversationId/upload": SomeOf<PostV1SmmPrvConversationsConversationIdUploadNegativeResponseVariants>;
    "get /v1/smm-prv/nps": SomeOf<GetV1SmmPrvNpsNegativeResponseVariants>;
    "post /v1/smm-prv/nps": SomeOf<PostV1SmmPrvNpsNegativeResponseVariants>;
    "get /v1/smm-prv/payments/payouts": SomeOf<GetV1SmmPrvPaymentsPayoutsNegativeResponseVariants>;
    "get /v1/smm-prv/payments/earnings": SomeOf<GetV1SmmPrvPaymentsEarningsNegativeResponseVariants>;
    "get /v1/smm-prv/payments/recent-payouts": SomeOf<GetV1SmmPrvPaymentsRecentPayoutsNegativeResponseVariants>;
    "get /v1/smm-prv/saved-replies": SomeOf<GetV1SmmPrvSavedRepliesNegativeResponseVariants>;
    "post /v1/smm-prv/saved-replies": SomeOf<PostV1SmmPrvSavedRepliesNegativeResponseVariants>;
    "delete /v1/smm-prv/saved-replies/:savedReplyId": SomeOf<DeleteV1SmmPrvSavedRepliesSavedReplyIdNegativeResponseVariants>;
    "put /v1/smm-prv/saved-replies/:savedReplyId": SomeOf<PutV1SmmPrvSavedRepliesSavedReplyIdNegativeResponseVariants>;
    "get /v1/smm-prv/sponsors": SomeOf<GetV1SmmPrvSponsorsNegativeResponseVariants>;
    "get /v1/smm-prv/sponsors/tags": SomeOf<GetV1SmmPrvSponsorsTagsNegativeResponseVariants>;
    "get /v1/smm-prv/sponsors/contacts": SomeOf<GetV1SmmPrvSponsorsContactsNegativeResponseVariants>;
    "put /v1/smm-prv/sponsors/contact": SomeOf<PutV1SmmPrvSponsorsContactNegativeResponseVariants>;
    "delete /v1/smm-prv/sponsors/contact": SomeOf<DeleteV1SmmPrvSponsorsContactNegativeResponseVariants>;
    "get /v1/smm-prv/sponsors/:sponsorId": SomeOf<GetV1SmmPrvSponsorsSponsorIdNegativeResponseVariants>;
    "get /v1/open/me": SomeOf<GetV1OpenMeNegativeResponseVariants>;
    "get /v1/open/sponsors": SomeOf<GetV1OpenSponsorsNegativeResponseVariants>;
    "get /v1/open/sponsors/tags": SomeOf<GetV1OpenSponsorsTagsNegativeResponseVariants>;
    "get /v1/open/sponsors/tracked": SomeOf<GetV1OpenSponsorsTrackedNegativeResponseVariants>;
    "put /v1/open/sponsors/contact": SomeOf<PutV1OpenSponsorsContactNegativeResponseVariants>;
    "get /v1/open/sponsors/:sponsorId": SomeOf<GetV1OpenSponsorsSponsorIdNegativeResponseVariants>;
    "get /v1/open/sponsors/:sponsorId/outreach-context": SomeOf<GetV1OpenSponsorsSponsorIdOutreachContextNegativeResponseVariants>;
    "get /v1/open/brand/brands": SomeOf<GetV1OpenBrandBrandsNegativeResponseVariants>;
    "post /v1/open/brand/brands": SomeOf<PostV1OpenBrandBrandsNegativeResponseVariants>;
    "get /v1/open/brand/creators": SomeOf<GetV1OpenBrandCreatorsNegativeResponseVariants>;
    "post /v1/open/brand/campaigns": SomeOf<PostV1OpenBrandCampaignsNegativeResponseVariants>;
    "post /v1/open/brand/campaigns/invite": SomeOf<PostV1OpenBrandCampaignsInviteNegativeResponseVariants>;
    "post /v1/adm/conversations/send-automatic-message": SomeOf<PostV1AdmConversationsSendAutomaticMessageNegativeResponseVariants>;
    "post /v1/adm/populateOneCreator": SomeOf<PostV1AdmPopulateOneCreatorNegativeResponseVariants>;
    "post /v1/adm/populateAllCreators": SomeOf<PostV1AdmPopulateAllCreatorsNegativeResponseVariants>;
    "post /v1/adm/excludeCreator": SomeOf<PostV1AdmExcludeCreatorNegativeResponseVariants>;
    "post /v1/adm/runPostChecks": SomeOf<PostV1AdmRunPostChecksNegativeResponseVariants>;
    "get /v1/stf/linkedin-message-recovery": SomeOf<GetV1StfLinkedinMessageRecoveryNegativeResponseVariants>;
    "post /v1/stf/linkedin-message-recovery/confirm-not-sent": SomeOf<PostV1StfLinkedinMessageRecoveryConfirmNotSentNegativeResponseVariants>;
    "get /v1/stf/linkedin-pool": SomeOf<GetV1StfLinkedinPoolNegativeResponseVariants>;
    "post /v1/stf/linkedin-pool": SomeOf<PostV1StfLinkedinPoolNegativeResponseVariants>;
    "patch /v1/stf/linkedin-pool/:accountId": SomeOf<PatchV1StfLinkedinPoolAccountIdNegativeResponseVariants>;
    "delete /v1/stf/linkedin-pool/:accountId": SomeOf<DeleteV1StfLinkedinPoolAccountIdNegativeResponseVariants>;
    "post /v1/stf/linkedin-pool/:accountId/cloud-login": SomeOf<PostV1StfLinkedinPoolAccountIdCloudLoginNegativeResponseVariants>;
    "get /v1/stf/linkedin-pool/:accountId/cloud-login": SomeOf<GetV1StfLinkedinPoolAccountIdCloudLoginNegativeResponseVariants>;
    "post /v1/stf/linkedin-pool/:accountId/cloud-login/resume": SomeOf<PostV1StfLinkedinPoolAccountIdCloudLoginResumeNegativeResponseVariants>;
    "get /v1/stf/users": SomeOf<GetV1StfUsersNegativeResponseVariants>;
    "get /v1/stf/campaigns": SomeOf<GetV1StfCampaignsNegativeResponseVariants>;
    "post /v1/stf/campaigns/force-close": SomeOf<PostV1StfCampaignsForceCloseNegativeResponseVariants>;
    "post /v1/stf/campaigns/confirm-manual-refund": SomeOf<PostV1StfCampaignsConfirmManualRefundNegativeResponseVariants>;
    "post /v1/stf/campaigns/confirm-out-of-band-payment": SomeOf<PostV1StfCampaignsConfirmOutOfBandPaymentNegativeResponseVariants>;
    "post /v1/stf/campaigns/delete": SomeOf<PostV1StfCampaignsDeleteNegativeResponseVariants>;
    "post /v1/stf/creator-applications/reinstate": SomeOf<PostV1StfCreatorApplicationsReinstateNegativeResponseVariants>;
    "post /v1/stf/generate-actor-token": SomeOf<PostV1StfGenerateActorTokenNegativeResponseVariants>;
    "get /v1/stf/nps-ratings": SomeOf<GetV1StfNpsRatingsNegativeResponseVariants>;
    "post /v1/stf/trigger-pay-sponsored-posts": SomeOf<PostV1StfTriggerPaySponsoredPostsNegativeResponseVariants>;
    "get /v1/stf/payouts-to-pay": SomeOf<GetV1StfPayoutsToPayNegativeResponseVariants>;
    "get /v1/stf/payouts-paid": SomeOf<GetV1StfPayoutsPaidNegativeResponseVariants>;
    "get /v1/stf/payouts-blocked": SomeOf<GetV1StfPayoutsBlockedNegativeResponseVariants>;
    "post /v1/stf/payouts/cancel-export": SomeOf<PostV1StfPayoutsCancelExportNegativeResponseVariants>;
    "post /v1/stf/payouts/create-export": SomeOf<PostV1StfPayoutsCreateExportNegativeResponseVariants>;
    "post /v1/stf/payouts/get-export": SomeOf<PostV1StfPayoutsGetExportNegativeResponseVariants>;
    "post /v1/stf/payouts/mark-paid": SomeOf<PostV1StfPayoutsMarkPaidNegativeResponseVariants>;
    "post /v1/stf/payouts/upload-transfer-proof": SomeOf<PostV1StfPayoutsUploadTransferProofNegativeResponseVariants>;
    "post /v1/stf/payouts/verify-vat": SomeOf<PostV1StfPayoutsVerifyVatNegativeResponseVariants>;
}

export interface EncodedResponse {
    "post /v1/pub/clerk/webhook": PostV1PubClerkWebhookPositiveResponseVariants & PostV1PubClerkWebhookNegativeResponseVariants;
    "post /v1/pub/login": PostV1PubLoginPositiveResponseVariants & PostV1PubLoginNegativeResponseVariants;
    "get /v1/pub/campaigns": GetV1PubCampaignsPositiveResponseVariants & GetV1PubCampaignsNegativeResponseVariants;
    "get /v1/pub/campaign-invitations/:token": GetV1PubCampaignInvitationsTokenPositiveResponseVariants & GetV1PubCampaignInvitationsTokenNegativeResponseVariants;
    "post /v1/pub/campaign-invitations/:token/accept": PostV1PubCampaignInvitationsTokenAcceptPositiveResponseVariants & PostV1PubCampaignInvitationsTokenAcceptNegativeResponseVariants;
    "post /v1/pub/campaign-invitations/:token/decline": PostV1PubCampaignInvitationsTokenDeclinePositiveResponseVariants & PostV1PubCampaignInvitationsTokenDeclineNegativeResponseVariants;
    "get /v1/pub/creator-signup/:token": GetV1PubCreatorSignupTokenPositiveResponseVariants & GetV1PubCreatorSignupTokenNegativeResponseVariants;
    "post /v1/pub/webhook/stripe": PostV1PubWebhookStripePositiveResponseVariants & PostV1PubWebhookStripeNegativeResponseVariants;
    "get /v1/pub/creators": GetV1PubCreatorsPositiveResponseVariants & GetV1PubCreatorsNegativeResponseVariants;
    "get /v1/pub/creators/dashboard": GetV1PubCreatorsDashboardPositiveResponseVariants & GetV1PubCreatorsDashboardNegativeResponseVariants;
    "get /v1/pub/creators/posts": GetV1PubCreatorsPostsPositiveResponseVariants & GetV1PubCreatorsPostsNegativeResponseVariants;
    "get /v1/pub/creators/sitemap": GetV1PubCreatorsSitemapPositiveResponseVariants & GetV1PubCreatorsSitemapNegativeResponseVariants;
    "get /v1/pub/health": GetV1PubHealthPositiveResponseVariants & GetV1PubHealthNegativeResponseVariants;
    "get /v1/pub/sponsoring/stats": GetV1PubSponsoringStatsPositiveResponseVariants & GetV1PubSponsoringStatsNegativeResponseVariants;
    "get /v1/pub/translations/:language": GetV1PubTranslationsLanguagePositiveResponseVariants & GetV1PubTranslationsLanguageNegativeResponseVariants;
    "get /v1/prv/lists": GetV1PrvListsPositiveResponseVariants & GetV1PrvListsNegativeResponseVariants;
    "post /v1/prv/lists": PostV1PrvListsPositiveResponseVariants & PostV1PrvListsNegativeResponseVariants;
    "put /v1/prv/lists": PutV1PrvListsPositiveResponseVariants & PutV1PrvListsNegativeResponseVariants;
    "post /v1/prv/lists/delete": PostV1PrvListsDeletePositiveResponseVariants & PostV1PrvListsDeleteNegativeResponseVariants;
    "get /v1/prv/lists/all": GetV1PrvListsAllPositiveResponseVariants & GetV1PrvListsAllNegativeResponseVariants;
    "put /v1/prv/lists/creators/add": PutV1PrvListsCreatorsAddPositiveResponseVariants & PutV1PrvListsCreatorsAddNegativeResponseVariants;
    "put /v1/prv/lists/creators/remove": PutV1PrvListsCreatorsRemovePositiveResponseVariants & PutV1PrvListsCreatorsRemoveNegativeResponseVariants;
    "put /v1/prv/lists/creators/empty": PutV1PrvListsCreatorsEmptyPositiveResponseVariants & PutV1PrvListsCreatorsEmptyNegativeResponseVariants;
    "get /v1/prv/brands": GetV1PrvBrandsPositiveResponseVariants & GetV1PrvBrandsNegativeResponseVariants;
    "post /v1/prv/brands": PostV1PrvBrandsPositiveResponseVariants & PostV1PrvBrandsNegativeResponseVariants;
    "put /v1/prv/brands": PutV1PrvBrandsPositiveResponseVariants & PutV1PrvBrandsNegativeResponseVariants;
    "delete /v1/prv/brands": DeleteV1PrvBrandsPositiveResponseVariants & DeleteV1PrvBrandsNegativeResponseVariants;
    "post /v1/prv/brands/analyze": PostV1PrvBrandsAnalyzePositiveResponseVariants & PostV1PrvBrandsAnalyzeNegativeResponseVariants;
    "get /v1/prv/brands/analyze/:analysisId": GetV1PrvBrandsAnalyzeAnalysisIdPositiveResponseVariants & GetV1PrvBrandsAnalyzeAnalysisIdNegativeResponseVariants;
    "get /v1/prv/brands/:brandId": GetV1PrvBrandsBrandIdPositiveResponseVariants & GetV1PrvBrandsBrandIdNegativeResponseVariants;
    "patch /v1/prv/brands/:brandId": PatchV1PrvBrandsBrandIdPositiveResponseVariants & PatchV1PrvBrandsBrandIdNegativeResponseVariants;
    "get /v1/prv/brands/:brandId/subscription": GetV1PrvBrandsBrandIdSubscriptionPositiveResponseVariants & GetV1PrvBrandsBrandIdSubscriptionNegativeResponseVariants;
    "post /v1/prv/brands/:brandId/subscription/checkout": PostV1PrvBrandsBrandIdSubscriptionCheckoutPositiveResponseVariants & PostV1PrvBrandsBrandIdSubscriptionCheckoutNegativeResponseVariants;
    "post /v1/prv/brands/:brandId/subscription/portal": PostV1PrvBrandsBrandIdSubscriptionPortalPositiveResponseVariants & PostV1PrvBrandsBrandIdSubscriptionPortalNegativeResponseVariants;
    "post /v1/prv/brands/:brandId/subscription/cancel": PostV1PrvBrandsBrandIdSubscriptionCancelPositiveResponseVariants & PostV1PrvBrandsBrandIdSubscriptionCancelNegativeResponseVariants;
    "post /v1/prv/brands/upload/logo": PostV1PrvBrandsUploadLogoPositiveResponseVariants & PostV1PrvBrandsUploadLogoNegativeResponseVariants;
    "post /v1/prv/brands/upload/file": PostV1PrvBrandsUploadFilePositiveResponseVariants & PostV1PrvBrandsUploadFileNegativeResponseVariants;
    "get /v1/prv/brands/download/file": GetV1PrvBrandsDownloadFilePositiveResponseVariants & GetV1PrvBrandsDownloadFileNegativeResponseVariants;
    "post /v1/prv/brands/download/files": PostV1PrvBrandsDownloadFilesPositiveResponseVariants & PostV1PrvBrandsDownloadFilesNegativeResponseVariants;
    "get /v1/prv/creators": GetV1PrvCreatorsPositiveResponseVariants & GetV1PrvCreatorsNegativeResponseVariants;
    "post /v1/prv/creators/exclude": PostV1PrvCreatorsExcludePositiveResponseVariants & PostV1PrvCreatorsExcludeNegativeResponseVariants;
    "get /v1/prv/creators/checkCanExclude": GetV1PrvCreatorsCheckCanExcludePositiveResponseVariants & GetV1PrvCreatorsCheckCanExcludeNegativeResponseVariants;
    "get /v1/prv/creators/all": GetV1PrvCreatorsAllPositiveResponseVariants & GetV1PrvCreatorsAllNegativeResponseVariants;
    "get /v1/prv/creators/with-published-campaign-post": GetV1PrvCreatorsWithPublishedCampaignPostPositiveResponseVariants & GetV1PrvCreatorsWithPublishedCampaignPostNegativeResponseVariants;
    "get /v1/prv/creators/dormant": GetV1PrvCreatorsDormantPositiveResponseVariants & GetV1PrvCreatorsDormantNegativeResponseVariants;
    "post /v1/prv/creators/relaunch": PostV1PrvCreatorsRelaunchPositiveResponseVariants & PostV1PrvCreatorsRelaunchNegativeResponseVariants;
    "get /v1/prv/campaigns": GetV1PrvCampaignsPositiveResponseVariants & GetV1PrvCampaignsNegativeResponseVariants;
    "post /v1/prv/campaigns": PostV1PrvCampaignsPositiveResponseVariants & PostV1PrvCampaignsNegativeResponseVariants;
    "put /v1/prv/campaigns": PutV1PrvCampaignsPositiveResponseVariants & PutV1PrvCampaignsNegativeResponseVariants;
    "get /v1/prv/campaigns/open-to-offer": GetV1PrvCampaignsOpenToOfferPositiveResponseVariants & GetV1PrvCampaignsOpenToOfferNegativeResponseVariants;
    "get /v1/prv/campaigns/total": GetV1PrvCampaignsTotalPositiveResponseVariants & GetV1PrvCampaignsTotalNegativeResponseVariants;
    "post /v1/prv/campaigns/has-enough-creators": PostV1PrvCampaignsHasEnoughCreatorsPositiveResponseVariants & PostV1PrvCampaignsHasEnoughCreatorsNegativeResponseVariants;
    "get /v1/prv/campaigns/failed-payment": GetV1PrvCampaignsFailedPaymentPositiveResponseVariants & GetV1PrvCampaignsFailedPaymentNegativeResponseVariants;
    "post /v1/prv/campaigns/draft": PostV1PrvCampaignsDraftPositiveResponseVariants & PostV1PrvCampaignsDraftNegativeResponseVariants;
    "get /v1/prv/campaigns/audience-locations": GetV1PrvCampaignsAudienceLocationsPositiveResponseVariants & GetV1PrvCampaignsAudienceLocationsNegativeResponseVariants;
    "get /v1/prv/campaigns/overview": GetV1PrvCampaignsOverviewPositiveResponseVariants & GetV1PrvCampaignsOverviewNegativeResponseVariants;
    "get /v1/prv/campaigns/:campaignId": GetV1PrvCampaignsCampaignIdPositiveResponseVariants & GetV1PrvCampaignsCampaignIdNegativeResponseVariants;
    "put /v1/prv/campaigns/:campaignId": PutV1PrvCampaignsCampaignIdPositiveResponseVariants & PutV1PrvCampaignsCampaignIdNegativeResponseVariants;
    "patch /v1/prv/campaigns/:campaignId/draft": PatchV1PrvCampaignsCampaignIdDraftPositiveResponseVariants & PatchV1PrvCampaignsCampaignIdDraftNegativeResponseVariants;
    "delete /v1/prv/campaigns/:campaignId/draft": DeleteV1PrvCampaignsCampaignIdDraftPositiveResponseVariants & DeleteV1PrvCampaignsCampaignIdDraftNegativeResponseVariants;
    "post /v1/prv/campaigns/:campaignId/estimate": PostV1PrvCampaignsCampaignIdEstimatePositiveResponseVariants & PostV1PrvCampaignsCampaignIdEstimateNegativeResponseVariants;
    "post /v1/prv/campaigns/:campaignId/invitation-preview": PostV1PrvCampaignsCampaignIdInvitationPreviewPositiveResponseVariants & PostV1PrvCampaignsCampaignIdInvitationPreviewNegativeResponseVariants;
    "post /v1/prv/campaigns/:campaignId/key-message-suggestion": PostV1PrvCampaignsCampaignIdKeyMessageSuggestionPositiveResponseVariants & PostV1PrvCampaignsCampaignIdKeyMessageSuggestionNegativeResponseVariants;
    "get /v1/prv/campaigns/:campaignId/can-close": GetV1PrvCampaignsCampaignIdCanClosePositiveResponseVariants & GetV1PrvCampaignsCampaignIdCanCloseNegativeResponseVariants;
    "post /v1/prv/campaigns/:campaignId/close": PostV1PrvCampaignsCampaignIdClosePositiveResponseVariants & PostV1PrvCampaignsCampaignIdCloseNegativeResponseVariants;
    "post /v1/prv/campaigns/:campaignId/invite": PostV1PrvCampaignsCampaignIdInvitePositiveResponseVariants & PostV1PrvCampaignsCampaignIdInviteNegativeResponseVariants;
    "post /v1/prv/campaigns/:campaignId/upload": PostV1PrvCampaignsCampaignIdUploadPositiveResponseVariants & PostV1PrvCampaignsCampaignIdUploadNegativeResponseVariants;
    "get /v1/prv/campaigns/:campaignId/agent": GetV1PrvCampaignsCampaignIdAgentPositiveResponseVariants & GetV1PrvCampaignsCampaignIdAgentNegativeResponseVariants;
    "patch /v1/prv/campaigns/:campaignId/agent": PatchV1PrvCampaignsCampaignIdAgentPositiveResponseVariants & PatchV1PrvCampaignsCampaignIdAgentNegativeResponseVariants;
    "get /v1/prv/campaigns/:campaignId/agent/creators": GetV1PrvCampaignsCampaignIdAgentCreatorsPositiveResponseVariants & GetV1PrvCampaignsCampaignIdAgentCreatorsNegativeResponseVariants;
    "get /v1/prv/campaigns/:campaignId/agent/creators/:creatorId/timeline": GetV1PrvCampaignsCampaignIdAgentCreatorsCreatorIdTimelinePositiveResponseVariants & GetV1PrvCampaignsCampaignIdAgentCreatorsCreatorIdTimelineNegativeResponseVariants;
    "get /v1/prv/campaigns/:campaignId/agent/decisions": GetV1PrvCampaignsCampaignIdAgentDecisionsPositiveResponseVariants & GetV1PrvCampaignsCampaignIdAgentDecisionsNegativeResponseVariants;
    "post /v1/prv/campaigns/:campaignId/agent/decisions/:decisionId": PostV1PrvCampaignsCampaignIdAgentDecisionsDecisionIdPositiveResponseVariants & PostV1PrvCampaignsCampaignIdAgentDecisionsDecisionIdNegativeResponseVariants;
    "post /v1/prv/campaigns/:campaignId/agent/follow-up-now": PostV1PrvCampaignsCampaignIdAgentFollowUpNowPositiveResponseVariants & PostV1PrvCampaignsCampaignIdAgentFollowUpNowNegativeResponseVariants;
    "get /v1/prv/campaigns/:campaignId/agent/events": GetV1PrvCampaignsCampaignIdAgentEventsPositiveResponseVariants & GetV1PrvCampaignsCampaignIdAgentEventsNegativeResponseVariants;
    "post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/take-over": PostV1PrvCampaignsCampaignIdAgentThreadsThreadIdTakeOverPositiveResponseVariants & PostV1PrvCampaignsCampaignIdAgentThreadsThreadIdTakeOverNegativeResponseVariants;
    "post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/hand-back": PostV1PrvCampaignsCampaignIdAgentThreadsThreadIdHandBackPositiveResponseVariants & PostV1PrvCampaignsCampaignIdAgentThreadsThreadIdHandBackNegativeResponseVariants;
    "get /v1/prv/campaigns/:campaignId/agent/threads/:threadId/draft": GetV1PrvCampaignsCampaignIdAgentThreadsThreadIdDraftPositiveResponseVariants & GetV1PrvCampaignsCampaignIdAgentThreadsThreadIdDraftNegativeResponseVariants;
    "post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/draft": PostV1PrvCampaignsCampaignIdAgentThreadsThreadIdDraftPositiveResponseVariants & PostV1PrvCampaignsCampaignIdAgentThreadsThreadIdDraftNegativeResponseVariants;
    "put /v1/prv/campaigns/:campaignId/agent/threads/:threadId/draft": PutV1PrvCampaignsCampaignIdAgentThreadsThreadIdDraftPositiveResponseVariants & PutV1PrvCampaignsCampaignIdAgentThreadsThreadIdDraftNegativeResponseVariants;
    "post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/send": PostV1PrvCampaignsCampaignIdAgentThreadsThreadIdSendPositiveResponseVariants & PostV1PrvCampaignsCampaignIdAgentThreadsThreadIdSendNegativeResponseVariants;
    "get /v1/prv/campaigns/:campaignId/posts/:postId/checks": GetV1PrvCampaignsCampaignIdPostsPostIdChecksPositiveResponseVariants & GetV1PrvCampaignsCampaignIdPostsPostIdChecksNegativeResponseVariants;
    "get /v1/prv/campaigns/:campaignId/posts/:postId/reminder": GetV1PrvCampaignsCampaignIdPostsPostIdReminderPositiveResponseVariants & GetV1PrvCampaignsCampaignIdPostsPostIdReminderNegativeResponseVariants;
    "get /v1/prv/campaigns/:campaignId/posts/:postId/refusal-draft": GetV1PrvCampaignsCampaignIdPostsPostIdRefusalDraftPositiveResponseVariants & GetV1PrvCampaignsCampaignIdPostsPostIdRefusalDraftNegativeResponseVariants;
    "post /v1/prv/campaigns/:campaignId/applications/:applicationId/rejection-draft": PostV1PrvCampaignsCampaignIdApplicationsApplicationIdRejectionDraftPositiveResponseVariants & PostV1PrvCampaignsCampaignIdApplicationsApplicationIdRejectionDraftNegativeResponseVariants;
    "put /v1/prv/campaigns/:campaignId/agent-instructions": PutV1PrvCampaignsCampaignIdAgentInstructionsPositiveResponseVariants & PutV1PrvCampaignsCampaignIdAgentInstructionsNegativeResponseVariants;
    "get /v1/prv/campaigns/:campaignId/tracked-links/clicks": GetV1PrvCampaignsCampaignIdTrackedLinksClicksPositiveResponseVariants & GetV1PrvCampaignsCampaignIdTrackedLinksClicksNegativeResponseVariants;
    "put /v1/prv/conversations/:conversationId/inbox": PutV1PrvConversationsConversationIdInboxPositiveResponseVariants & PutV1PrvConversationsConversationIdInboxNegativeResponseVariants;
    "post /v1/prv/conversations/:conversationId/suggest-reply": PostV1PrvConversationsConversationIdSuggestReplyPositiveResponseVariants & PostV1PrvConversationsConversationIdSuggestReplyNegativeResponseVariants;
    "get /v1/prv/conversations": GetV1PrvConversationsPositiveResponseVariants & GetV1PrvConversationsNegativeResponseVariants;
    "get /v1/prv/conversations/unread-count": GetV1PrvConversationsUnreadCountPositiveResponseVariants & GetV1PrvConversationsUnreadCountNegativeResponseVariants;
    "post /v1/prv/conversations/bulk-message": PostV1PrvConversationsBulkMessagePositiveResponseVariants & PostV1PrvConversationsBulkMessageNegativeResponseVariants;
    "post /v1/prv/conversations/file/:campaignId/:creatorIds": PostV1PrvConversationsFileCampaignIdCreatorIdsPositiveResponseVariants & PostV1PrvConversationsFileCampaignIdCreatorIdsNegativeResponseVariants;
    "get /v1/prv/conversations/:conversationId/messages": GetV1PrvConversationsConversationIdMessagesPositiveResponseVariants & GetV1PrvConversationsConversationIdMessagesNegativeResponseVariants;
    "post /v1/prv/conversations/:conversationId/messages": PostV1PrvConversationsConversationIdMessagesPositiveResponseVariants & PostV1PrvConversationsConversationIdMessagesNegativeResponseVariants;
    "put /v1/prv/conversations/:conversationId/read": PutV1PrvConversationsConversationIdReadPositiveResponseVariants & PutV1PrvConversationsConversationIdReadNegativeResponseVariants;
    "put /v1/prv/conversations/:conversationId/unread": PutV1PrvConversationsConversationIdUnreadPositiveResponseVariants & PutV1PrvConversationsConversationIdUnreadNegativeResponseVariants;
    "post /v1/prv/conversations/:conversationId/upload": PostV1PrvConversationsConversationIdUploadPositiveResponseVariants & PostV1PrvConversationsConversationIdUploadNegativeResponseVariants;
    "get /v1/prv/creator-applications": GetV1PrvCreatorApplicationsPositiveResponseVariants & GetV1PrvCreatorApplicationsNegativeResponseVariants;
    "put /v1/prv/creator-applications": PutV1PrvCreatorApplicationsPositiveResponseVariants & PutV1PrvCreatorApplicationsNegativeResponseVariants;
    "get /v1/prv/creator-applications/:creatorApplicationId": GetV1PrvCreatorApplicationsCreatorApplicationIdPositiveResponseVariants & GetV1PrvCreatorApplicationsCreatorApplicationIdNegativeResponseVariants;
    "get /v1/prv/creator-applications/overview/:campaignId": GetV1PrvCreatorApplicationsOverviewCampaignIdPositiveResponseVariants & GetV1PrvCreatorApplicationsOverviewCampaignIdNegativeResponseVariants;
    "post /v1/prv/creator-applications/:creatorApplicationId/reinstate": PostV1PrvCreatorApplicationsCreatorApplicationIdReinstatePositiveResponseVariants & PostV1PrvCreatorApplicationsCreatorApplicationIdReinstateNegativeResponseVariants;
    "get /v1/prv/creator-applications/:campaignId/:creatorId": GetV1PrvCreatorApplicationsCampaignIdCreatorIdPositiveResponseVariants & GetV1PrvCreatorApplicationsCampaignIdCreatorIdNegativeResponseVariants;
    "post /v1/prv/creator-applications/negociate": PostV1PrvCreatorApplicationsNegociatePositiveResponseVariants & PostV1PrvCreatorApplicationsNegociateNegativeResponseVariants;
    "get /v1/prv/user": GetV1PrvUserPositiveResponseVariants & GetV1PrvUserNegativeResponseVariants;
    "get /v1/prv/user/readonly-token": GetV1PrvUserReadonlyTokenPositiveResponseVariants & GetV1PrvUserReadonlyTokenNegativeResponseVariants;
    "post /v1/prv/user/country": PostV1PrvUserCountryPositiveResponseVariants & PostV1PrvUserCountryNegativeResponseVariants;
    "get /v1/prv/user/api-key": GetV1PrvUserApiKeyPositiveResponseVariants & GetV1PrvUserApiKeyNegativeResponseVariants;
    "post /v1/prv/user/generate-api-key": PostV1PrvUserGenerateApiKeyPositiveResponseVariants & PostV1PrvUserGenerateApiKeyNegativeResponseVariants;
    "get /v1/prv/campaign-analytics/:campaignId": GetV1PrvCampaignAnalyticsCampaignIdPositiveResponseVariants & GetV1PrvCampaignAnalyticsCampaignIdNegativeResponseVariants;
    "get /v1/prv/campaign-analytics/:campaignId/engagement-profiles": GetV1PrvCampaignAnalyticsCampaignIdEngagementProfilesPositiveResponseVariants & GetV1PrvCampaignAnalyticsCampaignIdEngagementProfilesNegativeResponseVariants;
    "get /v1/prv/campaign-analytics/:campaignId/engagement-counts": GetV1PrvCampaignAnalyticsCampaignIdEngagementCountsPositiveResponseVariants & GetV1PrvCampaignAnalyticsCampaignIdEngagementCountsNegativeResponseVariants;
    "post /v1/prv/campaign-analytics/:campaignId/engagement-profiles-export": PostV1PrvCampaignAnalyticsCampaignIdEngagementProfilesExportPositiveResponseVariants & PostV1PrvCampaignAnalyticsCampaignIdEngagementProfilesExportNegativeResponseVariants;
    "get /v1/prv/nps": GetV1PrvNpsPositiveResponseVariants & GetV1PrvNpsNegativeResponseVariants;
    "post /v1/prv/nps": PostV1PrvNpsPositiveResponseVariants & PostV1PrvNpsNegativeResponseVariants;
    "post /v1/prv/payments/campaign-session": PostV1PrvPaymentsCampaignSessionPositiveResponseVariants & PostV1PrvPaymentsCampaignSessionNegativeResponseVariants;
    "post /v1/prv/payments/retry-payment": PostV1PrvPaymentsRetryPaymentPositiveResponseVariants & PostV1PrvPaymentsRetryPaymentNegativeResponseVariants;
    "post /v1/prv/payments/deposit-budget": PostV1PrvPaymentsDepositBudgetPositiveResponseVariants & PostV1PrvPaymentsDepositBudgetNegativeResponseVariants;
    "post /v1/prv/payments/checkout-session": PostV1PrvPaymentsCheckoutSessionPositiveResponseVariants & PostV1PrvPaymentsCheckoutSessionNegativeResponseVariants;
    "get /v1/prv/payments/campaign-wallet": GetV1PrvPaymentsCampaignWalletPositiveResponseVariants & GetV1PrvPaymentsCampaignWalletNegativeResponseVariants;
    "get /v1/prv/payments/payouts": GetV1PrvPaymentsPayoutsPositiveResponseVariants & GetV1PrvPaymentsPayoutsNegativeResponseVariants;
    "get /v1/prv/payments/portal-session": GetV1PrvPaymentsPortalSessionPositiveResponseVariants & GetV1PrvPaymentsPortalSessionNegativeResponseVariants;
    "get /v1/prv/payments/customer": GetV1PrvPaymentsCustomerPositiveResponseVariants & GetV1PrvPaymentsCustomerNegativeResponseVariants;
    "put /v1/prv/payments/customer": PutV1PrvPaymentsCustomerPositiveResponseVariants & PutV1PrvPaymentsCustomerNegativeResponseVariants;
    "get /v1/prv/payments/campaign-quote": GetV1PrvPaymentsCampaignQuotePositiveResponseVariants & GetV1PrvPaymentsCampaignQuoteNegativeResponseVariants;
    "get /v1/prv/payments/deposit-details": GetV1PrvPaymentsDepositDetailsPositiveResponseVariants & GetV1PrvPaymentsDepositDetailsNegativeResponseVariants;
    "get /v1/prv/payments/payouts-overview": GetV1PrvPaymentsPayoutsOverviewPositiveResponseVariants & GetV1PrvPaymentsPayoutsOverviewNegativeResponseVariants;
    "get /v1/prv/payments/upcoming-settlements": GetV1PrvPaymentsUpcomingSettlementsPositiveResponseVariants & GetV1PrvPaymentsUpcomingSettlementsNegativeResponseVariants;
    "get /v1/prv/payments/campaign-results": GetV1PrvPaymentsCampaignResultsPositiveResponseVariants & GetV1PrvPaymentsCampaignResultsNegativeResponseVariants;
    "get /v1/prv/saved-replies": GetV1PrvSavedRepliesPositiveResponseVariants & GetV1PrvSavedRepliesNegativeResponseVariants;
    "post /v1/prv/saved-replies": PostV1PrvSavedRepliesPositiveResponseVariants & PostV1PrvSavedRepliesNegativeResponseVariants;
    "delete /v1/prv/saved-replies/:savedReplyId": DeleteV1PrvSavedRepliesSavedReplyIdPositiveResponseVariants & DeleteV1PrvSavedRepliesSavedReplyIdNegativeResponseVariants;
    "put /v1/prv/saved-replies/:savedReplyId": PutV1PrvSavedRepliesSavedReplyIdPositiveResponseVariants & PutV1PrvSavedRepliesSavedReplyIdNegativeResponseVariants;
    "post /v1/prv/pusher/auth": PostV1PrvPusherAuthPositiveResponseVariants & PostV1PrvPusherAuthNegativeResponseVariants;
    "get /v1/prv/linkedin-sender": GetV1PrvLinkedinSenderPositiveResponseVariants & GetV1PrvLinkedinSenderNegativeResponseVariants;
    "delete /v1/prv/linkedin-sender": DeleteV1PrvLinkedinSenderPositiveResponseVariants & DeleteV1PrvLinkedinSenderNegativeResponseVariants;
    "put /v1/prv/linkedin-sender/schedule": PutV1PrvLinkedinSenderSchedulePositiveResponseVariants & PutV1PrvLinkedinSenderScheduleNegativeResponseVariants;
    "post /v1/prv/linkedin-sender/cloud-login": PostV1PrvLinkedinSenderCloudLoginPositiveResponseVariants & PostV1PrvLinkedinSenderCloudLoginNegativeResponseVariants;
    "get /v1/prv/linkedin-sender/cloud-login": GetV1PrvLinkedinSenderCloudLoginPositiveResponseVariants & GetV1PrvLinkedinSenderCloudLoginNegativeResponseVariants;
    "post /v1/prv/linkedin-sender/cloud-login/resume": PostV1PrvLinkedinSenderCloudLoginResumePositiveResponseVariants & PostV1PrvLinkedinSenderCloudLoginResumeNegativeResponseVariants;
    "get /v1/smm-prv/campaigns": GetV1SmmPrvCampaignsPositiveResponseVariants & GetV1SmmPrvCampaignsNegativeResponseVariants;
    "post /v1/smm-prv/campaigns/apply": PostV1SmmPrvCampaignsApplyPositiveResponseVariants & PostV1SmmPrvCampaignsApplyNegativeResponseVariants;
    "get /v1/smm-prv/campaigns/applied": GetV1SmmPrvCampaignsAppliedPositiveResponseVariants & GetV1SmmPrvCampaignsAppliedNegativeResponseVariants;
    "get /v1/smm-prv/campaigns/:campaignId": GetV1SmmPrvCampaignsCampaignIdPositiveResponseVariants & GetV1SmmPrvCampaignsCampaignIdNegativeResponseVariants;
    "get /v1/smm-prv/creator-applications": GetV1SmmPrvCreatorApplicationsPositiveResponseVariants & GetV1SmmPrvCreatorApplicationsNegativeResponseVariants;
    "put /v1/smm-prv/creator-applications": PutV1SmmPrvCreatorApplicationsPositiveResponseVariants & PutV1SmmPrvCreatorApplicationsNegativeResponseVariants;
    "get /v1/smm-prv/creator-applications/overview": GetV1SmmPrvCreatorApplicationsOverviewPositiveResponseVariants & GetV1SmmPrvCreatorApplicationsOverviewNegativeResponseVariants;
    "get /v1/smm-prv/creator-applications/count": GetV1SmmPrvCreatorApplicationsCountPositiveResponseVariants & GetV1SmmPrvCreatorApplicationsCountNegativeResponseVariants;
    "get /v1/smm-prv/creator-applications/has-any": GetV1SmmPrvCreatorApplicationsHasAnyPositiveResponseVariants & GetV1SmmPrvCreatorApplicationsHasAnyNegativeResponseVariants;
    "get /v1/smm-prv/creator-applications/by-id/:creatorApplicationId": GetV1SmmPrvCreatorApplicationsByIdCreatorApplicationIdPositiveResponseVariants & GetV1SmmPrvCreatorApplicationsByIdCreatorApplicationIdNegativeResponseVariants;
    "get /v1/smm-prv/creator-applications/:campaignId": GetV1SmmPrvCreatorApplicationsCampaignIdPositiveResponseVariants & GetV1SmmPrvCreatorApplicationsCampaignIdNegativeResponseVariants;
    "post /v1/smm-prv/creator-applications/negociate": PostV1SmmPrvCreatorApplicationsNegociatePositiveResponseVariants & PostV1SmmPrvCreatorApplicationsNegociateNegativeResponseVariants;
    "get /v1/smm-prv/brands/applied-to": GetV1SmmPrvBrandsAppliedToPositiveResponseVariants & GetV1SmmPrvBrandsAppliedToNegativeResponseVariants;
    "get /v1/smm-prv/brands/:brandId": GetV1SmmPrvBrandsBrandIdPositiveResponseVariants & GetV1SmmPrvBrandsBrandIdNegativeResponseVariants;
    "get /v1/smm-prv/creators/me": GetV1SmmPrvCreatorsMePositiveResponseVariants & GetV1SmmPrvCreatorsMeNegativeResponseVariants;
    "post /v1/smm-prv/creators/adopt-sourced": PostV1SmmPrvCreatorsAdoptSourcedPositiveResponseVariants & PostV1SmmPrvCreatorsAdoptSourcedNegativeResponseVariants;
    "post /v1/smm-prv/creators/populate": PostV1SmmPrvCreatorsPopulatePositiveResponseVariants & PostV1SmmPrvCreatorsPopulateNegativeResponseVariants;
    "put /v1/smm-prv/creators/privacy": PutV1SmmPrvCreatorsPrivacyPositiveResponseVariants & PutV1SmmPrvCreatorsPrivacyNegativeResponseVariants;
    "get /v1/smm-prv/conversations": GetV1SmmPrvConversationsPositiveResponseVariants & GetV1SmmPrvConversationsNegativeResponseVariants;
    "get /v1/smm-prv/conversations/unread-count": GetV1SmmPrvConversationsUnreadCountPositiveResponseVariants & GetV1SmmPrvConversationsUnreadCountNegativeResponseVariants;
    "post /v1/smm-prv/conversations/messages": PostV1SmmPrvConversationsMessagesPositiveResponseVariants & PostV1SmmPrvConversationsMessagesNegativeResponseVariants;
    "get /v1/smm-prv/conversations/:conversationId/messages": GetV1SmmPrvConversationsConversationIdMessagesPositiveResponseVariants & GetV1SmmPrvConversationsConversationIdMessagesNegativeResponseVariants;
    "put /v1/smm-prv/conversations/:conversationId/read": PutV1SmmPrvConversationsConversationIdReadPositiveResponseVariants & PutV1SmmPrvConversationsConversationIdReadNegativeResponseVariants;
    "put /v1/smm-prv/conversations/:conversationId/unread": PutV1SmmPrvConversationsConversationIdUnreadPositiveResponseVariants & PutV1SmmPrvConversationsConversationIdUnreadNegativeResponseVariants;
    "post /v1/smm-prv/conversations/:conversationId/upload": PostV1SmmPrvConversationsConversationIdUploadPositiveResponseVariants & PostV1SmmPrvConversationsConversationIdUploadNegativeResponseVariants;
    "get /v1/smm-prv/nps": GetV1SmmPrvNpsPositiveResponseVariants & GetV1SmmPrvNpsNegativeResponseVariants;
    "post /v1/smm-prv/nps": PostV1SmmPrvNpsPositiveResponseVariants & PostV1SmmPrvNpsNegativeResponseVariants;
    "get /v1/smm-prv/payments/payouts": GetV1SmmPrvPaymentsPayoutsPositiveResponseVariants & GetV1SmmPrvPaymentsPayoutsNegativeResponseVariants;
    "get /v1/smm-prv/payments/earnings": GetV1SmmPrvPaymentsEarningsPositiveResponseVariants & GetV1SmmPrvPaymentsEarningsNegativeResponseVariants;
    "get /v1/smm-prv/payments/recent-payouts": GetV1SmmPrvPaymentsRecentPayoutsPositiveResponseVariants & GetV1SmmPrvPaymentsRecentPayoutsNegativeResponseVariants;
    "get /v1/smm-prv/saved-replies": GetV1SmmPrvSavedRepliesPositiveResponseVariants & GetV1SmmPrvSavedRepliesNegativeResponseVariants;
    "post /v1/smm-prv/saved-replies": PostV1SmmPrvSavedRepliesPositiveResponseVariants & PostV1SmmPrvSavedRepliesNegativeResponseVariants;
    "delete /v1/smm-prv/saved-replies/:savedReplyId": DeleteV1SmmPrvSavedRepliesSavedReplyIdPositiveResponseVariants & DeleteV1SmmPrvSavedRepliesSavedReplyIdNegativeResponseVariants;
    "put /v1/smm-prv/saved-replies/:savedReplyId": PutV1SmmPrvSavedRepliesSavedReplyIdPositiveResponseVariants & PutV1SmmPrvSavedRepliesSavedReplyIdNegativeResponseVariants;
    "get /v1/smm-prv/sponsors": GetV1SmmPrvSponsorsPositiveResponseVariants & GetV1SmmPrvSponsorsNegativeResponseVariants;
    "get /v1/smm-prv/sponsors/tags": GetV1SmmPrvSponsorsTagsPositiveResponseVariants & GetV1SmmPrvSponsorsTagsNegativeResponseVariants;
    "get /v1/smm-prv/sponsors/contacts": GetV1SmmPrvSponsorsContactsPositiveResponseVariants & GetV1SmmPrvSponsorsContactsNegativeResponseVariants;
    "put /v1/smm-prv/sponsors/contact": PutV1SmmPrvSponsorsContactPositiveResponseVariants & PutV1SmmPrvSponsorsContactNegativeResponseVariants;
    "delete /v1/smm-prv/sponsors/contact": DeleteV1SmmPrvSponsorsContactPositiveResponseVariants & DeleteV1SmmPrvSponsorsContactNegativeResponseVariants;
    "get /v1/smm-prv/sponsors/:sponsorId": GetV1SmmPrvSponsorsSponsorIdPositiveResponseVariants & GetV1SmmPrvSponsorsSponsorIdNegativeResponseVariants;
    "get /v1/open/me": GetV1OpenMePositiveResponseVariants & GetV1OpenMeNegativeResponseVariants;
    "get /v1/open/sponsors": GetV1OpenSponsorsPositiveResponseVariants & GetV1OpenSponsorsNegativeResponseVariants;
    "get /v1/open/sponsors/tags": GetV1OpenSponsorsTagsPositiveResponseVariants & GetV1OpenSponsorsTagsNegativeResponseVariants;
    "get /v1/open/sponsors/tracked": GetV1OpenSponsorsTrackedPositiveResponseVariants & GetV1OpenSponsorsTrackedNegativeResponseVariants;
    "put /v1/open/sponsors/contact": PutV1OpenSponsorsContactPositiveResponseVariants & PutV1OpenSponsorsContactNegativeResponseVariants;
    "get /v1/open/sponsors/:sponsorId": GetV1OpenSponsorsSponsorIdPositiveResponseVariants & GetV1OpenSponsorsSponsorIdNegativeResponseVariants;
    "get /v1/open/sponsors/:sponsorId/outreach-context": GetV1OpenSponsorsSponsorIdOutreachContextPositiveResponseVariants & GetV1OpenSponsorsSponsorIdOutreachContextNegativeResponseVariants;
    "get /v1/open/brand/brands": GetV1OpenBrandBrandsPositiveResponseVariants & GetV1OpenBrandBrandsNegativeResponseVariants;
    "post /v1/open/brand/brands": PostV1OpenBrandBrandsPositiveResponseVariants & PostV1OpenBrandBrandsNegativeResponseVariants;
    "get /v1/open/brand/creators": GetV1OpenBrandCreatorsPositiveResponseVariants & GetV1OpenBrandCreatorsNegativeResponseVariants;
    "post /v1/open/brand/campaigns": PostV1OpenBrandCampaignsPositiveResponseVariants & PostV1OpenBrandCampaignsNegativeResponseVariants;
    "post /v1/open/brand/campaigns/invite": PostV1OpenBrandCampaignsInvitePositiveResponseVariants & PostV1OpenBrandCampaignsInviteNegativeResponseVariants;
    "post /v1/adm/conversations/send-automatic-message": PostV1AdmConversationsSendAutomaticMessagePositiveResponseVariants & PostV1AdmConversationsSendAutomaticMessageNegativeResponseVariants;
    "post /v1/adm/populateOneCreator": PostV1AdmPopulateOneCreatorPositiveResponseVariants & PostV1AdmPopulateOneCreatorNegativeResponseVariants;
    "post /v1/adm/populateAllCreators": PostV1AdmPopulateAllCreatorsPositiveResponseVariants & PostV1AdmPopulateAllCreatorsNegativeResponseVariants;
    "post /v1/adm/excludeCreator": PostV1AdmExcludeCreatorPositiveResponseVariants & PostV1AdmExcludeCreatorNegativeResponseVariants;
    "post /v1/adm/runPostChecks": PostV1AdmRunPostChecksPositiveResponseVariants & PostV1AdmRunPostChecksNegativeResponseVariants;
    "get /v1/stf/linkedin-message-recovery": GetV1StfLinkedinMessageRecoveryPositiveResponseVariants & GetV1StfLinkedinMessageRecoveryNegativeResponseVariants;
    "post /v1/stf/linkedin-message-recovery/confirm-not-sent": PostV1StfLinkedinMessageRecoveryConfirmNotSentPositiveResponseVariants & PostV1StfLinkedinMessageRecoveryConfirmNotSentNegativeResponseVariants;
    "get /v1/stf/linkedin-pool": GetV1StfLinkedinPoolPositiveResponseVariants & GetV1StfLinkedinPoolNegativeResponseVariants;
    "post /v1/stf/linkedin-pool": PostV1StfLinkedinPoolPositiveResponseVariants & PostV1StfLinkedinPoolNegativeResponseVariants;
    "patch /v1/stf/linkedin-pool/:accountId": PatchV1StfLinkedinPoolAccountIdPositiveResponseVariants & PatchV1StfLinkedinPoolAccountIdNegativeResponseVariants;
    "delete /v1/stf/linkedin-pool/:accountId": DeleteV1StfLinkedinPoolAccountIdPositiveResponseVariants & DeleteV1StfLinkedinPoolAccountIdNegativeResponseVariants;
    "post /v1/stf/linkedin-pool/:accountId/cloud-login": PostV1StfLinkedinPoolAccountIdCloudLoginPositiveResponseVariants & PostV1StfLinkedinPoolAccountIdCloudLoginNegativeResponseVariants;
    "get /v1/stf/linkedin-pool/:accountId/cloud-login": GetV1StfLinkedinPoolAccountIdCloudLoginPositiveResponseVariants & GetV1StfLinkedinPoolAccountIdCloudLoginNegativeResponseVariants;
    "post /v1/stf/linkedin-pool/:accountId/cloud-login/resume": PostV1StfLinkedinPoolAccountIdCloudLoginResumePositiveResponseVariants & PostV1StfLinkedinPoolAccountIdCloudLoginResumeNegativeResponseVariants;
    "get /v1/stf/users": GetV1StfUsersPositiveResponseVariants & GetV1StfUsersNegativeResponseVariants;
    "get /v1/stf/campaigns": GetV1StfCampaignsPositiveResponseVariants & GetV1StfCampaignsNegativeResponseVariants;
    "post /v1/stf/campaigns/force-close": PostV1StfCampaignsForceClosePositiveResponseVariants & PostV1StfCampaignsForceCloseNegativeResponseVariants;
    "post /v1/stf/campaigns/confirm-manual-refund": PostV1StfCampaignsConfirmManualRefundPositiveResponseVariants & PostV1StfCampaignsConfirmManualRefundNegativeResponseVariants;
    "post /v1/stf/campaigns/confirm-out-of-band-payment": PostV1StfCampaignsConfirmOutOfBandPaymentPositiveResponseVariants & PostV1StfCampaignsConfirmOutOfBandPaymentNegativeResponseVariants;
    "post /v1/stf/campaigns/delete": PostV1StfCampaignsDeletePositiveResponseVariants & PostV1StfCampaignsDeleteNegativeResponseVariants;
    "post /v1/stf/creator-applications/reinstate": PostV1StfCreatorApplicationsReinstatePositiveResponseVariants & PostV1StfCreatorApplicationsReinstateNegativeResponseVariants;
    "post /v1/stf/generate-actor-token": PostV1StfGenerateActorTokenPositiveResponseVariants & PostV1StfGenerateActorTokenNegativeResponseVariants;
    "get /v1/stf/nps-ratings": GetV1StfNpsRatingsPositiveResponseVariants & GetV1StfNpsRatingsNegativeResponseVariants;
    "post /v1/stf/trigger-pay-sponsored-posts": PostV1StfTriggerPaySponsoredPostsPositiveResponseVariants & PostV1StfTriggerPaySponsoredPostsNegativeResponseVariants;
    "get /v1/stf/payouts-to-pay": GetV1StfPayoutsToPayPositiveResponseVariants & GetV1StfPayoutsToPayNegativeResponseVariants;
    "get /v1/stf/payouts-paid": GetV1StfPayoutsPaidPositiveResponseVariants & GetV1StfPayoutsPaidNegativeResponseVariants;
    "get /v1/stf/payouts-blocked": GetV1StfPayoutsBlockedPositiveResponseVariants & GetV1StfPayoutsBlockedNegativeResponseVariants;
    "post /v1/stf/payouts/cancel-export": PostV1StfPayoutsCancelExportPositiveResponseVariants & PostV1StfPayoutsCancelExportNegativeResponseVariants;
    "post /v1/stf/payouts/create-export": PostV1StfPayoutsCreateExportPositiveResponseVariants & PostV1StfPayoutsCreateExportNegativeResponseVariants;
    "post /v1/stf/payouts/get-export": PostV1StfPayoutsGetExportPositiveResponseVariants & PostV1StfPayoutsGetExportNegativeResponseVariants;
    "post /v1/stf/payouts/mark-paid": PostV1StfPayoutsMarkPaidPositiveResponseVariants & PostV1StfPayoutsMarkPaidNegativeResponseVariants;
    "post /v1/stf/payouts/upload-transfer-proof": PostV1StfPayoutsUploadTransferProofPositiveResponseVariants & PostV1StfPayoutsUploadTransferProofNegativeResponseVariants;
    "post /v1/stf/payouts/verify-vat": PostV1StfPayoutsVerifyVatPositiveResponseVariants & PostV1StfPayoutsVerifyVatNegativeResponseVariants;
}

export interface Response {
    "post /v1/pub/clerk/webhook": PositiveResponse["post /v1/pub/clerk/webhook"] | NegativeResponse["post /v1/pub/clerk/webhook"];
    "post /v1/pub/login": PositiveResponse["post /v1/pub/login"] | NegativeResponse["post /v1/pub/login"];
    "get /v1/pub/campaigns": PositiveResponse["get /v1/pub/campaigns"] | NegativeResponse["get /v1/pub/campaigns"];
    "get /v1/pub/campaign-invitations/:token": PositiveResponse["get /v1/pub/campaign-invitations/:token"] | NegativeResponse["get /v1/pub/campaign-invitations/:token"];
    "post /v1/pub/campaign-invitations/:token/accept": PositiveResponse["post /v1/pub/campaign-invitations/:token/accept"] | NegativeResponse["post /v1/pub/campaign-invitations/:token/accept"];
    "post /v1/pub/campaign-invitations/:token/decline": PositiveResponse["post /v1/pub/campaign-invitations/:token/decline"] | NegativeResponse["post /v1/pub/campaign-invitations/:token/decline"];
    "get /v1/pub/creator-signup/:token": PositiveResponse["get /v1/pub/creator-signup/:token"] | NegativeResponse["get /v1/pub/creator-signup/:token"];
    "post /v1/pub/webhook/stripe": PositiveResponse["post /v1/pub/webhook/stripe"] | NegativeResponse["post /v1/pub/webhook/stripe"];
    "get /v1/pub/creators": PositiveResponse["get /v1/pub/creators"] | NegativeResponse["get /v1/pub/creators"];
    "get /v1/pub/creators/dashboard": PositiveResponse["get /v1/pub/creators/dashboard"] | NegativeResponse["get /v1/pub/creators/dashboard"];
    "get /v1/pub/creators/posts": PositiveResponse["get /v1/pub/creators/posts"] | NegativeResponse["get /v1/pub/creators/posts"];
    "get /v1/pub/creators/sitemap": PositiveResponse["get /v1/pub/creators/sitemap"] | NegativeResponse["get /v1/pub/creators/sitemap"];
    "get /v1/pub/health": PositiveResponse["get /v1/pub/health"] | NegativeResponse["get /v1/pub/health"];
    "get /v1/pub/sponsoring/stats": PositiveResponse["get /v1/pub/sponsoring/stats"] | NegativeResponse["get /v1/pub/sponsoring/stats"];
    "get /v1/pub/translations/:language": PositiveResponse["get /v1/pub/translations/:language"] | NegativeResponse["get /v1/pub/translations/:language"];
    "get /v1/prv/lists": PositiveResponse["get /v1/prv/lists"] | NegativeResponse["get /v1/prv/lists"];
    "post /v1/prv/lists": PositiveResponse["post /v1/prv/lists"] | NegativeResponse["post /v1/prv/lists"];
    "put /v1/prv/lists": PositiveResponse["put /v1/prv/lists"] | NegativeResponse["put /v1/prv/lists"];
    "post /v1/prv/lists/delete": PositiveResponse["post /v1/prv/lists/delete"] | NegativeResponse["post /v1/prv/lists/delete"];
    "get /v1/prv/lists/all": PositiveResponse["get /v1/prv/lists/all"] | NegativeResponse["get /v1/prv/lists/all"];
    "put /v1/prv/lists/creators/add": PositiveResponse["put /v1/prv/lists/creators/add"] | NegativeResponse["put /v1/prv/lists/creators/add"];
    "put /v1/prv/lists/creators/remove": PositiveResponse["put /v1/prv/lists/creators/remove"] | NegativeResponse["put /v1/prv/lists/creators/remove"];
    "put /v1/prv/lists/creators/empty": PositiveResponse["put /v1/prv/lists/creators/empty"] | NegativeResponse["put /v1/prv/lists/creators/empty"];
    "get /v1/prv/brands": PositiveResponse["get /v1/prv/brands"] | NegativeResponse["get /v1/prv/brands"];
    "post /v1/prv/brands": PositiveResponse["post /v1/prv/brands"] | NegativeResponse["post /v1/prv/brands"];
    "put /v1/prv/brands": PositiveResponse["put /v1/prv/brands"] | NegativeResponse["put /v1/prv/brands"];
    "delete /v1/prv/brands": PositiveResponse["delete /v1/prv/brands"] | NegativeResponse["delete /v1/prv/brands"];
    "post /v1/prv/brands/analyze": PositiveResponse["post /v1/prv/brands/analyze"] | NegativeResponse["post /v1/prv/brands/analyze"];
    "get /v1/prv/brands/analyze/:analysisId": PositiveResponse["get /v1/prv/brands/analyze/:analysisId"] | NegativeResponse["get /v1/prv/brands/analyze/:analysisId"];
    "get /v1/prv/brands/:brandId": PositiveResponse["get /v1/prv/brands/:brandId"] | NegativeResponse["get /v1/prv/brands/:brandId"];
    "patch /v1/prv/brands/:brandId": PositiveResponse["patch /v1/prv/brands/:brandId"] | NegativeResponse["patch /v1/prv/brands/:brandId"];
    "get /v1/prv/brands/:brandId/subscription": PositiveResponse["get /v1/prv/brands/:brandId/subscription"] | NegativeResponse["get /v1/prv/brands/:brandId/subscription"];
    "post /v1/prv/brands/:brandId/subscription/checkout": PositiveResponse["post /v1/prv/brands/:brandId/subscription/checkout"] | NegativeResponse["post /v1/prv/brands/:brandId/subscription/checkout"];
    "post /v1/prv/brands/:brandId/subscription/portal": PositiveResponse["post /v1/prv/brands/:brandId/subscription/portal"] | NegativeResponse["post /v1/prv/brands/:brandId/subscription/portal"];
    "post /v1/prv/brands/:brandId/subscription/cancel": PositiveResponse["post /v1/prv/brands/:brandId/subscription/cancel"] | NegativeResponse["post /v1/prv/brands/:brandId/subscription/cancel"];
    "post /v1/prv/brands/upload/logo": PositiveResponse["post /v1/prv/brands/upload/logo"] | NegativeResponse["post /v1/prv/brands/upload/logo"];
    "post /v1/prv/brands/upload/file": PositiveResponse["post /v1/prv/brands/upload/file"] | NegativeResponse["post /v1/prv/brands/upload/file"];
    "get /v1/prv/brands/download/file": PositiveResponse["get /v1/prv/brands/download/file"] | NegativeResponse["get /v1/prv/brands/download/file"];
    "post /v1/prv/brands/download/files": PositiveResponse["post /v1/prv/brands/download/files"] | NegativeResponse["post /v1/prv/brands/download/files"];
    "get /v1/prv/creators": PositiveResponse["get /v1/prv/creators"] | NegativeResponse["get /v1/prv/creators"];
    "post /v1/prv/creators/exclude": PositiveResponse["post /v1/prv/creators/exclude"] | NegativeResponse["post /v1/prv/creators/exclude"];
    "get /v1/prv/creators/checkCanExclude": PositiveResponse["get /v1/prv/creators/checkCanExclude"] | NegativeResponse["get /v1/prv/creators/checkCanExclude"];
    "get /v1/prv/creators/all": PositiveResponse["get /v1/prv/creators/all"] | NegativeResponse["get /v1/prv/creators/all"];
    "get /v1/prv/creators/with-published-campaign-post": PositiveResponse["get /v1/prv/creators/with-published-campaign-post"] | NegativeResponse["get /v1/prv/creators/with-published-campaign-post"];
    "get /v1/prv/creators/dormant": PositiveResponse["get /v1/prv/creators/dormant"] | NegativeResponse["get /v1/prv/creators/dormant"];
    "post /v1/prv/creators/relaunch": PositiveResponse["post /v1/prv/creators/relaunch"] | NegativeResponse["post /v1/prv/creators/relaunch"];
    "get /v1/prv/campaigns": PositiveResponse["get /v1/prv/campaigns"] | NegativeResponse["get /v1/prv/campaigns"];
    "post /v1/prv/campaigns": PositiveResponse["post /v1/prv/campaigns"] | NegativeResponse["post /v1/prv/campaigns"];
    "put /v1/prv/campaigns": PositiveResponse["put /v1/prv/campaigns"] | NegativeResponse["put /v1/prv/campaigns"];
    "get /v1/prv/campaigns/open-to-offer": PositiveResponse["get /v1/prv/campaigns/open-to-offer"] | NegativeResponse["get /v1/prv/campaigns/open-to-offer"];
    "get /v1/prv/campaigns/total": PositiveResponse["get /v1/prv/campaigns/total"] | NegativeResponse["get /v1/prv/campaigns/total"];
    "post /v1/prv/campaigns/has-enough-creators": PositiveResponse["post /v1/prv/campaigns/has-enough-creators"] | NegativeResponse["post /v1/prv/campaigns/has-enough-creators"];
    "get /v1/prv/campaigns/failed-payment": PositiveResponse["get /v1/prv/campaigns/failed-payment"] | NegativeResponse["get /v1/prv/campaigns/failed-payment"];
    "post /v1/prv/campaigns/draft": PositiveResponse["post /v1/prv/campaigns/draft"] | NegativeResponse["post /v1/prv/campaigns/draft"];
    "get /v1/prv/campaigns/audience-locations": PositiveResponse["get /v1/prv/campaigns/audience-locations"] | NegativeResponse["get /v1/prv/campaigns/audience-locations"];
    "get /v1/prv/campaigns/overview": PositiveResponse["get /v1/prv/campaigns/overview"] | NegativeResponse["get /v1/prv/campaigns/overview"];
    "get /v1/prv/campaigns/:campaignId": PositiveResponse["get /v1/prv/campaigns/:campaignId"] | NegativeResponse["get /v1/prv/campaigns/:campaignId"];
    "put /v1/prv/campaigns/:campaignId": PositiveResponse["put /v1/prv/campaigns/:campaignId"] | NegativeResponse["put /v1/prv/campaigns/:campaignId"];
    "patch /v1/prv/campaigns/:campaignId/draft": PositiveResponse["patch /v1/prv/campaigns/:campaignId/draft"] | NegativeResponse["patch /v1/prv/campaigns/:campaignId/draft"];
    "delete /v1/prv/campaigns/:campaignId/draft": PositiveResponse["delete /v1/prv/campaigns/:campaignId/draft"] | NegativeResponse["delete /v1/prv/campaigns/:campaignId/draft"];
    "post /v1/prv/campaigns/:campaignId/estimate": PositiveResponse["post /v1/prv/campaigns/:campaignId/estimate"] | NegativeResponse["post /v1/prv/campaigns/:campaignId/estimate"];
    "post /v1/prv/campaigns/:campaignId/invitation-preview": PositiveResponse["post /v1/prv/campaigns/:campaignId/invitation-preview"] | NegativeResponse["post /v1/prv/campaigns/:campaignId/invitation-preview"];
    "post /v1/prv/campaigns/:campaignId/key-message-suggestion": PositiveResponse["post /v1/prv/campaigns/:campaignId/key-message-suggestion"] | NegativeResponse["post /v1/prv/campaigns/:campaignId/key-message-suggestion"];
    "get /v1/prv/campaigns/:campaignId/can-close": PositiveResponse["get /v1/prv/campaigns/:campaignId/can-close"] | NegativeResponse["get /v1/prv/campaigns/:campaignId/can-close"];
    "post /v1/prv/campaigns/:campaignId/close": PositiveResponse["post /v1/prv/campaigns/:campaignId/close"] | NegativeResponse["post /v1/prv/campaigns/:campaignId/close"];
    "post /v1/prv/campaigns/:campaignId/invite": PositiveResponse["post /v1/prv/campaigns/:campaignId/invite"] | NegativeResponse["post /v1/prv/campaigns/:campaignId/invite"];
    "post /v1/prv/campaigns/:campaignId/upload": PositiveResponse["post /v1/prv/campaigns/:campaignId/upload"] | NegativeResponse["post /v1/prv/campaigns/:campaignId/upload"];
    "get /v1/prv/campaigns/:campaignId/agent": PositiveResponse["get /v1/prv/campaigns/:campaignId/agent"] | NegativeResponse["get /v1/prv/campaigns/:campaignId/agent"];
    "patch /v1/prv/campaigns/:campaignId/agent": PositiveResponse["patch /v1/prv/campaigns/:campaignId/agent"] | NegativeResponse["patch /v1/prv/campaigns/:campaignId/agent"];
    "get /v1/prv/campaigns/:campaignId/agent/creators": PositiveResponse["get /v1/prv/campaigns/:campaignId/agent/creators"] | NegativeResponse["get /v1/prv/campaigns/:campaignId/agent/creators"];
    "get /v1/prv/campaigns/:campaignId/agent/creators/:creatorId/timeline": PositiveResponse["get /v1/prv/campaigns/:campaignId/agent/creators/:creatorId/timeline"] | NegativeResponse["get /v1/prv/campaigns/:campaignId/agent/creators/:creatorId/timeline"];
    "get /v1/prv/campaigns/:campaignId/agent/decisions": PositiveResponse["get /v1/prv/campaigns/:campaignId/agent/decisions"] | NegativeResponse["get /v1/prv/campaigns/:campaignId/agent/decisions"];
    "post /v1/prv/campaigns/:campaignId/agent/decisions/:decisionId": PositiveResponse["post /v1/prv/campaigns/:campaignId/agent/decisions/:decisionId"] | NegativeResponse["post /v1/prv/campaigns/:campaignId/agent/decisions/:decisionId"];
    "post /v1/prv/campaigns/:campaignId/agent/follow-up-now": PositiveResponse["post /v1/prv/campaigns/:campaignId/agent/follow-up-now"] | NegativeResponse["post /v1/prv/campaigns/:campaignId/agent/follow-up-now"];
    "get /v1/prv/campaigns/:campaignId/agent/events": PositiveResponse["get /v1/prv/campaigns/:campaignId/agent/events"] | NegativeResponse["get /v1/prv/campaigns/:campaignId/agent/events"];
    "post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/take-over": PositiveResponse["post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/take-over"] | NegativeResponse["post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/take-over"];
    "post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/hand-back": PositiveResponse["post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/hand-back"] | NegativeResponse["post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/hand-back"];
    "get /v1/prv/campaigns/:campaignId/agent/threads/:threadId/draft": PositiveResponse["get /v1/prv/campaigns/:campaignId/agent/threads/:threadId/draft"] | NegativeResponse["get /v1/prv/campaigns/:campaignId/agent/threads/:threadId/draft"];
    "post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/draft": PositiveResponse["post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/draft"] | NegativeResponse["post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/draft"];
    "put /v1/prv/campaigns/:campaignId/agent/threads/:threadId/draft": PositiveResponse["put /v1/prv/campaigns/:campaignId/agent/threads/:threadId/draft"] | NegativeResponse["put /v1/prv/campaigns/:campaignId/agent/threads/:threadId/draft"];
    "post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/send": PositiveResponse["post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/send"] | NegativeResponse["post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/send"];
    "get /v1/prv/campaigns/:campaignId/posts/:postId/checks": PositiveResponse["get /v1/prv/campaigns/:campaignId/posts/:postId/checks"] | NegativeResponse["get /v1/prv/campaigns/:campaignId/posts/:postId/checks"];
    "get /v1/prv/campaigns/:campaignId/posts/:postId/reminder": PositiveResponse["get /v1/prv/campaigns/:campaignId/posts/:postId/reminder"] | NegativeResponse["get /v1/prv/campaigns/:campaignId/posts/:postId/reminder"];
    "get /v1/prv/campaigns/:campaignId/posts/:postId/refusal-draft": PositiveResponse["get /v1/prv/campaigns/:campaignId/posts/:postId/refusal-draft"] | NegativeResponse["get /v1/prv/campaigns/:campaignId/posts/:postId/refusal-draft"];
    "post /v1/prv/campaigns/:campaignId/applications/:applicationId/rejection-draft": PositiveResponse["post /v1/prv/campaigns/:campaignId/applications/:applicationId/rejection-draft"] | NegativeResponse["post /v1/prv/campaigns/:campaignId/applications/:applicationId/rejection-draft"];
    "put /v1/prv/campaigns/:campaignId/agent-instructions": PositiveResponse["put /v1/prv/campaigns/:campaignId/agent-instructions"] | NegativeResponse["put /v1/prv/campaigns/:campaignId/agent-instructions"];
    "get /v1/prv/campaigns/:campaignId/tracked-links/clicks": PositiveResponse["get /v1/prv/campaigns/:campaignId/tracked-links/clicks"] | NegativeResponse["get /v1/prv/campaigns/:campaignId/tracked-links/clicks"];
    "put /v1/prv/conversations/:conversationId/inbox": PositiveResponse["put /v1/prv/conversations/:conversationId/inbox"] | NegativeResponse["put /v1/prv/conversations/:conversationId/inbox"];
    "post /v1/prv/conversations/:conversationId/suggest-reply": PositiveResponse["post /v1/prv/conversations/:conversationId/suggest-reply"] | NegativeResponse["post /v1/prv/conversations/:conversationId/suggest-reply"];
    "get /v1/prv/conversations": PositiveResponse["get /v1/prv/conversations"] | NegativeResponse["get /v1/prv/conversations"];
    "get /v1/prv/conversations/unread-count": PositiveResponse["get /v1/prv/conversations/unread-count"] | NegativeResponse["get /v1/prv/conversations/unread-count"];
    "post /v1/prv/conversations/bulk-message": PositiveResponse["post /v1/prv/conversations/bulk-message"] | NegativeResponse["post /v1/prv/conversations/bulk-message"];
    "post /v1/prv/conversations/file/:campaignId/:creatorIds": PositiveResponse["post /v1/prv/conversations/file/:campaignId/:creatorIds"] | NegativeResponse["post /v1/prv/conversations/file/:campaignId/:creatorIds"];
    "get /v1/prv/conversations/:conversationId/messages": PositiveResponse["get /v1/prv/conversations/:conversationId/messages"] | NegativeResponse["get /v1/prv/conversations/:conversationId/messages"];
    "post /v1/prv/conversations/:conversationId/messages": PositiveResponse["post /v1/prv/conversations/:conversationId/messages"] | NegativeResponse["post /v1/prv/conversations/:conversationId/messages"];
    "put /v1/prv/conversations/:conversationId/read": PositiveResponse["put /v1/prv/conversations/:conversationId/read"] | NegativeResponse["put /v1/prv/conversations/:conversationId/read"];
    "put /v1/prv/conversations/:conversationId/unread": PositiveResponse["put /v1/prv/conversations/:conversationId/unread"] | NegativeResponse["put /v1/prv/conversations/:conversationId/unread"];
    "post /v1/prv/conversations/:conversationId/upload": PositiveResponse["post /v1/prv/conversations/:conversationId/upload"] | NegativeResponse["post /v1/prv/conversations/:conversationId/upload"];
    "get /v1/prv/creator-applications": PositiveResponse["get /v1/prv/creator-applications"] | NegativeResponse["get /v1/prv/creator-applications"];
    "put /v1/prv/creator-applications": PositiveResponse["put /v1/prv/creator-applications"] | NegativeResponse["put /v1/prv/creator-applications"];
    "get /v1/prv/creator-applications/:creatorApplicationId": PositiveResponse["get /v1/prv/creator-applications/:creatorApplicationId"] | NegativeResponse["get /v1/prv/creator-applications/:creatorApplicationId"];
    "get /v1/prv/creator-applications/overview/:campaignId": PositiveResponse["get /v1/prv/creator-applications/overview/:campaignId"] | NegativeResponse["get /v1/prv/creator-applications/overview/:campaignId"];
    "post /v1/prv/creator-applications/:creatorApplicationId/reinstate": PositiveResponse["post /v1/prv/creator-applications/:creatorApplicationId/reinstate"] | NegativeResponse["post /v1/prv/creator-applications/:creatorApplicationId/reinstate"];
    "get /v1/prv/creator-applications/:campaignId/:creatorId": PositiveResponse["get /v1/prv/creator-applications/:campaignId/:creatorId"] | NegativeResponse["get /v1/prv/creator-applications/:campaignId/:creatorId"];
    "post /v1/prv/creator-applications/negociate": PositiveResponse["post /v1/prv/creator-applications/negociate"] | NegativeResponse["post /v1/prv/creator-applications/negociate"];
    "get /v1/prv/user": PositiveResponse["get /v1/prv/user"] | NegativeResponse["get /v1/prv/user"];
    "get /v1/prv/user/readonly-token": PositiveResponse["get /v1/prv/user/readonly-token"] | NegativeResponse["get /v1/prv/user/readonly-token"];
    "post /v1/prv/user/country": PositiveResponse["post /v1/prv/user/country"] | NegativeResponse["post /v1/prv/user/country"];
    "get /v1/prv/user/api-key": PositiveResponse["get /v1/prv/user/api-key"] | NegativeResponse["get /v1/prv/user/api-key"];
    "post /v1/prv/user/generate-api-key": PositiveResponse["post /v1/prv/user/generate-api-key"] | NegativeResponse["post /v1/prv/user/generate-api-key"];
    "get /v1/prv/campaign-analytics/:campaignId": PositiveResponse["get /v1/prv/campaign-analytics/:campaignId"] | NegativeResponse["get /v1/prv/campaign-analytics/:campaignId"];
    "get /v1/prv/campaign-analytics/:campaignId/engagement-profiles": PositiveResponse["get /v1/prv/campaign-analytics/:campaignId/engagement-profiles"] | NegativeResponse["get /v1/prv/campaign-analytics/:campaignId/engagement-profiles"];
    "get /v1/prv/campaign-analytics/:campaignId/engagement-counts": PositiveResponse["get /v1/prv/campaign-analytics/:campaignId/engagement-counts"] | NegativeResponse["get /v1/prv/campaign-analytics/:campaignId/engagement-counts"];
    "post /v1/prv/campaign-analytics/:campaignId/engagement-profiles-export": PositiveResponse["post /v1/prv/campaign-analytics/:campaignId/engagement-profiles-export"] | NegativeResponse["post /v1/prv/campaign-analytics/:campaignId/engagement-profiles-export"];
    "get /v1/prv/nps": PositiveResponse["get /v1/prv/nps"] | NegativeResponse["get /v1/prv/nps"];
    "post /v1/prv/nps": PositiveResponse["post /v1/prv/nps"] | NegativeResponse["post /v1/prv/nps"];
    "post /v1/prv/payments/campaign-session": PositiveResponse["post /v1/prv/payments/campaign-session"] | NegativeResponse["post /v1/prv/payments/campaign-session"];
    "post /v1/prv/payments/retry-payment": PositiveResponse["post /v1/prv/payments/retry-payment"] | NegativeResponse["post /v1/prv/payments/retry-payment"];
    "post /v1/prv/payments/deposit-budget": PositiveResponse["post /v1/prv/payments/deposit-budget"] | NegativeResponse["post /v1/prv/payments/deposit-budget"];
    "post /v1/prv/payments/checkout-session": PositiveResponse["post /v1/prv/payments/checkout-session"] | NegativeResponse["post /v1/prv/payments/checkout-session"];
    "get /v1/prv/payments/campaign-wallet": PositiveResponse["get /v1/prv/payments/campaign-wallet"] | NegativeResponse["get /v1/prv/payments/campaign-wallet"];
    "get /v1/prv/payments/payouts": PositiveResponse["get /v1/prv/payments/payouts"] | NegativeResponse["get /v1/prv/payments/payouts"];
    "get /v1/prv/payments/portal-session": PositiveResponse["get /v1/prv/payments/portal-session"] | NegativeResponse["get /v1/prv/payments/portal-session"];
    "get /v1/prv/payments/customer": PositiveResponse["get /v1/prv/payments/customer"] | NegativeResponse["get /v1/prv/payments/customer"];
    "put /v1/prv/payments/customer": PositiveResponse["put /v1/prv/payments/customer"] | NegativeResponse["put /v1/prv/payments/customer"];
    "get /v1/prv/payments/campaign-quote": PositiveResponse["get /v1/prv/payments/campaign-quote"] | NegativeResponse["get /v1/prv/payments/campaign-quote"];
    "get /v1/prv/payments/deposit-details": PositiveResponse["get /v1/prv/payments/deposit-details"] | NegativeResponse["get /v1/prv/payments/deposit-details"];
    "get /v1/prv/payments/payouts-overview": PositiveResponse["get /v1/prv/payments/payouts-overview"] | NegativeResponse["get /v1/prv/payments/payouts-overview"];
    "get /v1/prv/payments/upcoming-settlements": PositiveResponse["get /v1/prv/payments/upcoming-settlements"] | NegativeResponse["get /v1/prv/payments/upcoming-settlements"];
    "get /v1/prv/payments/campaign-results": PositiveResponse["get /v1/prv/payments/campaign-results"] | NegativeResponse["get /v1/prv/payments/campaign-results"];
    "get /v1/prv/saved-replies": PositiveResponse["get /v1/prv/saved-replies"] | NegativeResponse["get /v1/prv/saved-replies"];
    "post /v1/prv/saved-replies": PositiveResponse["post /v1/prv/saved-replies"] | NegativeResponse["post /v1/prv/saved-replies"];
    "delete /v1/prv/saved-replies/:savedReplyId": PositiveResponse["delete /v1/prv/saved-replies/:savedReplyId"] | NegativeResponse["delete /v1/prv/saved-replies/:savedReplyId"];
    "put /v1/prv/saved-replies/:savedReplyId": PositiveResponse["put /v1/prv/saved-replies/:savedReplyId"] | NegativeResponse["put /v1/prv/saved-replies/:savedReplyId"];
    "post /v1/prv/pusher/auth": PositiveResponse["post /v1/prv/pusher/auth"] | NegativeResponse["post /v1/prv/pusher/auth"];
    "get /v1/prv/linkedin-sender": PositiveResponse["get /v1/prv/linkedin-sender"] | NegativeResponse["get /v1/prv/linkedin-sender"];
    "delete /v1/prv/linkedin-sender": PositiveResponse["delete /v1/prv/linkedin-sender"] | NegativeResponse["delete /v1/prv/linkedin-sender"];
    "put /v1/prv/linkedin-sender/schedule": PositiveResponse["put /v1/prv/linkedin-sender/schedule"] | NegativeResponse["put /v1/prv/linkedin-sender/schedule"];
    "post /v1/prv/linkedin-sender/cloud-login": PositiveResponse["post /v1/prv/linkedin-sender/cloud-login"] | NegativeResponse["post /v1/prv/linkedin-sender/cloud-login"];
    "get /v1/prv/linkedin-sender/cloud-login": PositiveResponse["get /v1/prv/linkedin-sender/cloud-login"] | NegativeResponse["get /v1/prv/linkedin-sender/cloud-login"];
    "post /v1/prv/linkedin-sender/cloud-login/resume": PositiveResponse["post /v1/prv/linkedin-sender/cloud-login/resume"] | NegativeResponse["post /v1/prv/linkedin-sender/cloud-login/resume"];
    "get /v1/smm-prv/campaigns": PositiveResponse["get /v1/smm-prv/campaigns"] | NegativeResponse["get /v1/smm-prv/campaigns"];
    "post /v1/smm-prv/campaigns/apply": PositiveResponse["post /v1/smm-prv/campaigns/apply"] | NegativeResponse["post /v1/smm-prv/campaigns/apply"];
    "get /v1/smm-prv/campaigns/applied": PositiveResponse["get /v1/smm-prv/campaigns/applied"] | NegativeResponse["get /v1/smm-prv/campaigns/applied"];
    "get /v1/smm-prv/campaigns/:campaignId": PositiveResponse["get /v1/smm-prv/campaigns/:campaignId"] | NegativeResponse["get /v1/smm-prv/campaigns/:campaignId"];
    "get /v1/smm-prv/creator-applications": PositiveResponse["get /v1/smm-prv/creator-applications"] | NegativeResponse["get /v1/smm-prv/creator-applications"];
    "put /v1/smm-prv/creator-applications": PositiveResponse["put /v1/smm-prv/creator-applications"] | NegativeResponse["put /v1/smm-prv/creator-applications"];
    "get /v1/smm-prv/creator-applications/overview": PositiveResponse["get /v1/smm-prv/creator-applications/overview"] | NegativeResponse["get /v1/smm-prv/creator-applications/overview"];
    "get /v1/smm-prv/creator-applications/count": PositiveResponse["get /v1/smm-prv/creator-applications/count"] | NegativeResponse["get /v1/smm-prv/creator-applications/count"];
    "get /v1/smm-prv/creator-applications/has-any": PositiveResponse["get /v1/smm-prv/creator-applications/has-any"] | NegativeResponse["get /v1/smm-prv/creator-applications/has-any"];
    "get /v1/smm-prv/creator-applications/by-id/:creatorApplicationId": PositiveResponse["get /v1/smm-prv/creator-applications/by-id/:creatorApplicationId"] | NegativeResponse["get /v1/smm-prv/creator-applications/by-id/:creatorApplicationId"];
    "get /v1/smm-prv/creator-applications/:campaignId": PositiveResponse["get /v1/smm-prv/creator-applications/:campaignId"] | NegativeResponse["get /v1/smm-prv/creator-applications/:campaignId"];
    "post /v1/smm-prv/creator-applications/negociate": PositiveResponse["post /v1/smm-prv/creator-applications/negociate"] | NegativeResponse["post /v1/smm-prv/creator-applications/negociate"];
    "get /v1/smm-prv/brands/applied-to": PositiveResponse["get /v1/smm-prv/brands/applied-to"] | NegativeResponse["get /v1/smm-prv/brands/applied-to"];
    "get /v1/smm-prv/brands/:brandId": PositiveResponse["get /v1/smm-prv/brands/:brandId"] | NegativeResponse["get /v1/smm-prv/brands/:brandId"];
    "get /v1/smm-prv/creators/me": PositiveResponse["get /v1/smm-prv/creators/me"] | NegativeResponse["get /v1/smm-prv/creators/me"];
    "post /v1/smm-prv/creators/adopt-sourced": PositiveResponse["post /v1/smm-prv/creators/adopt-sourced"] | NegativeResponse["post /v1/smm-prv/creators/adopt-sourced"];
    "post /v1/smm-prv/creators/populate": PositiveResponse["post /v1/smm-prv/creators/populate"] | NegativeResponse["post /v1/smm-prv/creators/populate"];
    "put /v1/smm-prv/creators/privacy": PositiveResponse["put /v1/smm-prv/creators/privacy"] | NegativeResponse["put /v1/smm-prv/creators/privacy"];
    "get /v1/smm-prv/conversations": PositiveResponse["get /v1/smm-prv/conversations"] | NegativeResponse["get /v1/smm-prv/conversations"];
    "get /v1/smm-prv/conversations/unread-count": PositiveResponse["get /v1/smm-prv/conversations/unread-count"] | NegativeResponse["get /v1/smm-prv/conversations/unread-count"];
    "post /v1/smm-prv/conversations/messages": PositiveResponse["post /v1/smm-prv/conversations/messages"] | NegativeResponse["post /v1/smm-prv/conversations/messages"];
    "get /v1/smm-prv/conversations/:conversationId/messages": PositiveResponse["get /v1/smm-prv/conversations/:conversationId/messages"] | NegativeResponse["get /v1/smm-prv/conversations/:conversationId/messages"];
    "put /v1/smm-prv/conversations/:conversationId/read": PositiveResponse["put /v1/smm-prv/conversations/:conversationId/read"] | NegativeResponse["put /v1/smm-prv/conversations/:conversationId/read"];
    "put /v1/smm-prv/conversations/:conversationId/unread": PositiveResponse["put /v1/smm-prv/conversations/:conversationId/unread"] | NegativeResponse["put /v1/smm-prv/conversations/:conversationId/unread"];
    "post /v1/smm-prv/conversations/:conversationId/upload": PositiveResponse["post /v1/smm-prv/conversations/:conversationId/upload"] | NegativeResponse["post /v1/smm-prv/conversations/:conversationId/upload"];
    "get /v1/smm-prv/nps": PositiveResponse["get /v1/smm-prv/nps"] | NegativeResponse["get /v1/smm-prv/nps"];
    "post /v1/smm-prv/nps": PositiveResponse["post /v1/smm-prv/nps"] | NegativeResponse["post /v1/smm-prv/nps"];
    "get /v1/smm-prv/payments/payouts": PositiveResponse["get /v1/smm-prv/payments/payouts"] | NegativeResponse["get /v1/smm-prv/payments/payouts"];
    "get /v1/smm-prv/payments/earnings": PositiveResponse["get /v1/smm-prv/payments/earnings"] | NegativeResponse["get /v1/smm-prv/payments/earnings"];
    "get /v1/smm-prv/payments/recent-payouts": PositiveResponse["get /v1/smm-prv/payments/recent-payouts"] | NegativeResponse["get /v1/smm-prv/payments/recent-payouts"];
    "get /v1/smm-prv/saved-replies": PositiveResponse["get /v1/smm-prv/saved-replies"] | NegativeResponse["get /v1/smm-prv/saved-replies"];
    "post /v1/smm-prv/saved-replies": PositiveResponse["post /v1/smm-prv/saved-replies"] | NegativeResponse["post /v1/smm-prv/saved-replies"];
    "delete /v1/smm-prv/saved-replies/:savedReplyId": PositiveResponse["delete /v1/smm-prv/saved-replies/:savedReplyId"] | NegativeResponse["delete /v1/smm-prv/saved-replies/:savedReplyId"];
    "put /v1/smm-prv/saved-replies/:savedReplyId": PositiveResponse["put /v1/smm-prv/saved-replies/:savedReplyId"] | NegativeResponse["put /v1/smm-prv/saved-replies/:savedReplyId"];
    "get /v1/smm-prv/sponsors": PositiveResponse["get /v1/smm-prv/sponsors"] | NegativeResponse["get /v1/smm-prv/sponsors"];
    "get /v1/smm-prv/sponsors/tags": PositiveResponse["get /v1/smm-prv/sponsors/tags"] | NegativeResponse["get /v1/smm-prv/sponsors/tags"];
    "get /v1/smm-prv/sponsors/contacts": PositiveResponse["get /v1/smm-prv/sponsors/contacts"] | NegativeResponse["get /v1/smm-prv/sponsors/contacts"];
    "put /v1/smm-prv/sponsors/contact": PositiveResponse["put /v1/smm-prv/sponsors/contact"] | NegativeResponse["put /v1/smm-prv/sponsors/contact"];
    "delete /v1/smm-prv/sponsors/contact": PositiveResponse["delete /v1/smm-prv/sponsors/contact"] | NegativeResponse["delete /v1/smm-prv/sponsors/contact"];
    "get /v1/smm-prv/sponsors/:sponsorId": PositiveResponse["get /v1/smm-prv/sponsors/:sponsorId"] | NegativeResponse["get /v1/smm-prv/sponsors/:sponsorId"];
    "get /v1/open/me": PositiveResponse["get /v1/open/me"] | NegativeResponse["get /v1/open/me"];
    "get /v1/open/sponsors": PositiveResponse["get /v1/open/sponsors"] | NegativeResponse["get /v1/open/sponsors"];
    "get /v1/open/sponsors/tags": PositiveResponse["get /v1/open/sponsors/tags"] | NegativeResponse["get /v1/open/sponsors/tags"];
    "get /v1/open/sponsors/tracked": PositiveResponse["get /v1/open/sponsors/tracked"] | NegativeResponse["get /v1/open/sponsors/tracked"];
    "put /v1/open/sponsors/contact": PositiveResponse["put /v1/open/sponsors/contact"] | NegativeResponse["put /v1/open/sponsors/contact"];
    "get /v1/open/sponsors/:sponsorId": PositiveResponse["get /v1/open/sponsors/:sponsorId"] | NegativeResponse["get /v1/open/sponsors/:sponsorId"];
    "get /v1/open/sponsors/:sponsorId/outreach-context": PositiveResponse["get /v1/open/sponsors/:sponsorId/outreach-context"] | NegativeResponse["get /v1/open/sponsors/:sponsorId/outreach-context"];
    "get /v1/open/brand/brands": PositiveResponse["get /v1/open/brand/brands"] | NegativeResponse["get /v1/open/brand/brands"];
    "post /v1/open/brand/brands": PositiveResponse["post /v1/open/brand/brands"] | NegativeResponse["post /v1/open/brand/brands"];
    "get /v1/open/brand/creators": PositiveResponse["get /v1/open/brand/creators"] | NegativeResponse["get /v1/open/brand/creators"];
    "post /v1/open/brand/campaigns": PositiveResponse["post /v1/open/brand/campaigns"] | NegativeResponse["post /v1/open/brand/campaigns"];
    "post /v1/open/brand/campaigns/invite": PositiveResponse["post /v1/open/brand/campaigns/invite"] | NegativeResponse["post /v1/open/brand/campaigns/invite"];
    "post /v1/adm/conversations/send-automatic-message": PositiveResponse["post /v1/adm/conversations/send-automatic-message"] | NegativeResponse["post /v1/adm/conversations/send-automatic-message"];
    "post /v1/adm/populateOneCreator": PositiveResponse["post /v1/adm/populateOneCreator"] | NegativeResponse["post /v1/adm/populateOneCreator"];
    "post /v1/adm/populateAllCreators": PositiveResponse["post /v1/adm/populateAllCreators"] | NegativeResponse["post /v1/adm/populateAllCreators"];
    "post /v1/adm/excludeCreator": PositiveResponse["post /v1/adm/excludeCreator"] | NegativeResponse["post /v1/adm/excludeCreator"];
    "post /v1/adm/runPostChecks": PositiveResponse["post /v1/adm/runPostChecks"] | NegativeResponse["post /v1/adm/runPostChecks"];
    "get /v1/stf/linkedin-message-recovery": PositiveResponse["get /v1/stf/linkedin-message-recovery"] | NegativeResponse["get /v1/stf/linkedin-message-recovery"];
    "post /v1/stf/linkedin-message-recovery/confirm-not-sent": PositiveResponse["post /v1/stf/linkedin-message-recovery/confirm-not-sent"] | NegativeResponse["post /v1/stf/linkedin-message-recovery/confirm-not-sent"];
    "get /v1/stf/linkedin-pool": PositiveResponse["get /v1/stf/linkedin-pool"] | NegativeResponse["get /v1/stf/linkedin-pool"];
    "post /v1/stf/linkedin-pool": PositiveResponse["post /v1/stf/linkedin-pool"] | NegativeResponse["post /v1/stf/linkedin-pool"];
    "patch /v1/stf/linkedin-pool/:accountId": PositiveResponse["patch /v1/stf/linkedin-pool/:accountId"] | NegativeResponse["patch /v1/stf/linkedin-pool/:accountId"];
    "delete /v1/stf/linkedin-pool/:accountId": PositiveResponse["delete /v1/stf/linkedin-pool/:accountId"] | NegativeResponse["delete /v1/stf/linkedin-pool/:accountId"];
    "post /v1/stf/linkedin-pool/:accountId/cloud-login": PositiveResponse["post /v1/stf/linkedin-pool/:accountId/cloud-login"] | NegativeResponse["post /v1/stf/linkedin-pool/:accountId/cloud-login"];
    "get /v1/stf/linkedin-pool/:accountId/cloud-login": PositiveResponse["get /v1/stf/linkedin-pool/:accountId/cloud-login"] | NegativeResponse["get /v1/stf/linkedin-pool/:accountId/cloud-login"];
    "post /v1/stf/linkedin-pool/:accountId/cloud-login/resume": PositiveResponse["post /v1/stf/linkedin-pool/:accountId/cloud-login/resume"] | NegativeResponse["post /v1/stf/linkedin-pool/:accountId/cloud-login/resume"];
    "get /v1/stf/users": PositiveResponse["get /v1/stf/users"] | NegativeResponse["get /v1/stf/users"];
    "get /v1/stf/campaigns": PositiveResponse["get /v1/stf/campaigns"] | NegativeResponse["get /v1/stf/campaigns"];
    "post /v1/stf/campaigns/force-close": PositiveResponse["post /v1/stf/campaigns/force-close"] | NegativeResponse["post /v1/stf/campaigns/force-close"];
    "post /v1/stf/campaigns/confirm-manual-refund": PositiveResponse["post /v1/stf/campaigns/confirm-manual-refund"] | NegativeResponse["post /v1/stf/campaigns/confirm-manual-refund"];
    "post /v1/stf/campaigns/confirm-out-of-band-payment": PositiveResponse["post /v1/stf/campaigns/confirm-out-of-band-payment"] | NegativeResponse["post /v1/stf/campaigns/confirm-out-of-band-payment"];
    "post /v1/stf/campaigns/delete": PositiveResponse["post /v1/stf/campaigns/delete"] | NegativeResponse["post /v1/stf/campaigns/delete"];
    "post /v1/stf/creator-applications/reinstate": PositiveResponse["post /v1/stf/creator-applications/reinstate"] | NegativeResponse["post /v1/stf/creator-applications/reinstate"];
    "post /v1/stf/generate-actor-token": PositiveResponse["post /v1/stf/generate-actor-token"] | NegativeResponse["post /v1/stf/generate-actor-token"];
    "get /v1/stf/nps-ratings": PositiveResponse["get /v1/stf/nps-ratings"] | NegativeResponse["get /v1/stf/nps-ratings"];
    "post /v1/stf/trigger-pay-sponsored-posts": PositiveResponse["post /v1/stf/trigger-pay-sponsored-posts"] | NegativeResponse["post /v1/stf/trigger-pay-sponsored-posts"];
    "get /v1/stf/payouts-to-pay": PositiveResponse["get /v1/stf/payouts-to-pay"] | NegativeResponse["get /v1/stf/payouts-to-pay"];
    "get /v1/stf/payouts-paid": PositiveResponse["get /v1/stf/payouts-paid"] | NegativeResponse["get /v1/stf/payouts-paid"];
    "get /v1/stf/payouts-blocked": PositiveResponse["get /v1/stf/payouts-blocked"] | NegativeResponse["get /v1/stf/payouts-blocked"];
    "post /v1/stf/payouts/cancel-export": PositiveResponse["post /v1/stf/payouts/cancel-export"] | NegativeResponse["post /v1/stf/payouts/cancel-export"];
    "post /v1/stf/payouts/create-export": PositiveResponse["post /v1/stf/payouts/create-export"] | NegativeResponse["post /v1/stf/payouts/create-export"];
    "post /v1/stf/payouts/get-export": PositiveResponse["post /v1/stf/payouts/get-export"] | NegativeResponse["post /v1/stf/payouts/get-export"];
    "post /v1/stf/payouts/mark-paid": PositiveResponse["post /v1/stf/payouts/mark-paid"] | NegativeResponse["post /v1/stf/payouts/mark-paid"];
    "post /v1/stf/payouts/upload-transfer-proof": PositiveResponse["post /v1/stf/payouts/upload-transfer-proof"] | NegativeResponse["post /v1/stf/payouts/upload-transfer-proof"];
    "post /v1/stf/payouts/verify-vat": PositiveResponse["post /v1/stf/payouts/verify-vat"] | NegativeResponse["post /v1/stf/payouts/verify-vat"];
}

export type Request = keyof Input;

export const endpointTags = { "post /v1/pub/clerk/webhook": [], "post /v1/pub/login": [], "get /v1/pub/campaigns": [], "get /v1/pub/campaign-invitations/:token": [], "post /v1/pub/campaign-invitations/:token/accept": [], "post /v1/pub/campaign-invitations/:token/decline": [], "get /v1/pub/creator-signup/:token": [], "post /v1/pub/webhook/stripe": [], "get /v1/pub/creators": [], "get /v1/pub/creators/dashboard": [], "get /v1/pub/creators/posts": [], "get /v1/pub/creators/sitemap": [], "get /v1/pub/health": [], "get /v1/pub/sponsoring/stats": [], "get /v1/pub/translations/:language": [], "get /v1/prv/lists": [], "post /v1/prv/lists": [], "put /v1/prv/lists": [], "post /v1/prv/lists/delete": [], "get /v1/prv/lists/all": [], "put /v1/prv/lists/creators/add": [], "put /v1/prv/lists/creators/remove": [], "put /v1/prv/lists/creators/empty": [], "get /v1/prv/brands": [], "post /v1/prv/brands": [], "put /v1/prv/brands": [], "delete /v1/prv/brands": [], "post /v1/prv/brands/analyze": [], "get /v1/prv/brands/analyze/:analysisId": [], "get /v1/prv/brands/:brandId": [], "patch /v1/prv/brands/:brandId": [], "get /v1/prv/brands/:brandId/subscription": [], "post /v1/prv/brands/:brandId/subscription/checkout": [], "post /v1/prv/brands/:brandId/subscription/portal": [], "post /v1/prv/brands/:brandId/subscription/cancel": [], "post /v1/prv/brands/upload/logo": [], "post /v1/prv/brands/upload/file": [], "get /v1/prv/brands/download/file": [], "post /v1/prv/brands/download/files": [], "get /v1/prv/creators": [], "post /v1/prv/creators/exclude": [], "get /v1/prv/creators/checkCanExclude": [], "get /v1/prv/creators/all": [], "get /v1/prv/creators/with-published-campaign-post": [], "get /v1/prv/creators/dormant": [], "post /v1/prv/creators/relaunch": [], "get /v1/prv/campaigns": [], "post /v1/prv/campaigns": [], "put /v1/prv/campaigns": [], "get /v1/prv/campaigns/open-to-offer": [], "get /v1/prv/campaigns/total": [], "post /v1/prv/campaigns/has-enough-creators": [], "get /v1/prv/campaigns/failed-payment": [], "post /v1/prv/campaigns/draft": [], "get /v1/prv/campaigns/audience-locations": [], "get /v1/prv/campaigns/overview": [], "get /v1/prv/campaigns/:campaignId": [], "put /v1/prv/campaigns/:campaignId": [], "patch /v1/prv/campaigns/:campaignId/draft": [], "delete /v1/prv/campaigns/:campaignId/draft": [], "post /v1/prv/campaigns/:campaignId/estimate": [], "post /v1/prv/campaigns/:campaignId/invitation-preview": [], "post /v1/prv/campaigns/:campaignId/key-message-suggestion": [], "get /v1/prv/campaigns/:campaignId/can-close": [], "post /v1/prv/campaigns/:campaignId/close": [], "post /v1/prv/campaigns/:campaignId/invite": [], "post /v1/prv/campaigns/:campaignId/upload": [], "get /v1/prv/campaigns/:campaignId/agent": [], "patch /v1/prv/campaigns/:campaignId/agent": [], "get /v1/prv/campaigns/:campaignId/agent/creators": [], "get /v1/prv/campaigns/:campaignId/agent/creators/:creatorId/timeline": [], "get /v1/prv/campaigns/:campaignId/agent/decisions": [], "post /v1/prv/campaigns/:campaignId/agent/decisions/:decisionId": [], "post /v1/prv/campaigns/:campaignId/agent/follow-up-now": [], "get /v1/prv/campaigns/:campaignId/agent/events": [], "post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/take-over": [], "post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/hand-back": [], "get /v1/prv/campaigns/:campaignId/agent/threads/:threadId/draft": [], "post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/draft": [], "put /v1/prv/campaigns/:campaignId/agent/threads/:threadId/draft": [], "post /v1/prv/campaigns/:campaignId/agent/threads/:threadId/send": [], "get /v1/prv/campaigns/:campaignId/posts/:postId/checks": [], "get /v1/prv/campaigns/:campaignId/posts/:postId/reminder": [], "get /v1/prv/campaigns/:campaignId/posts/:postId/refusal-draft": [], "post /v1/prv/campaigns/:campaignId/applications/:applicationId/rejection-draft": [], "put /v1/prv/campaigns/:campaignId/agent-instructions": [], "get /v1/prv/campaigns/:campaignId/tracked-links/clicks": [], "put /v1/prv/conversations/:conversationId/inbox": [], "post /v1/prv/conversations/:conversationId/suggest-reply": [], "get /v1/prv/conversations": [], "get /v1/prv/conversations/unread-count": [], "post /v1/prv/conversations/bulk-message": [], "post /v1/prv/conversations/file/:campaignId/:creatorIds": [], "get /v1/prv/conversations/:conversationId/messages": [], "post /v1/prv/conversations/:conversationId/messages": [], "put /v1/prv/conversations/:conversationId/read": [], "put /v1/prv/conversations/:conversationId/unread": [], "post /v1/prv/conversations/:conversationId/upload": [], "get /v1/prv/creator-applications": [], "put /v1/prv/creator-applications": [], "get /v1/prv/creator-applications/:creatorApplicationId": [], "get /v1/prv/creator-applications/overview/:campaignId": [], "post /v1/prv/creator-applications/:creatorApplicationId/reinstate": [], "get /v1/prv/creator-applications/:campaignId/:creatorId": [], "post /v1/prv/creator-applications/negociate": [], "get /v1/prv/user": [], "get /v1/prv/user/readonly-token": [], "post /v1/prv/user/country": [], "get /v1/prv/user/api-key": [], "post /v1/prv/user/generate-api-key": [], "get /v1/prv/campaign-analytics/:campaignId": [], "get /v1/prv/campaign-analytics/:campaignId/engagement-profiles": [], "get /v1/prv/campaign-analytics/:campaignId/engagement-counts": [], "post /v1/prv/campaign-analytics/:campaignId/engagement-profiles-export": [], "get /v1/prv/nps": [], "post /v1/prv/nps": [], "post /v1/prv/payments/campaign-session": [], "post /v1/prv/payments/retry-payment": [], "post /v1/prv/payments/deposit-budget": [], "post /v1/prv/payments/checkout-session": [], "get /v1/prv/payments/campaign-wallet": [], "get /v1/prv/payments/payouts": [], "get /v1/prv/payments/portal-session": [], "get /v1/prv/payments/customer": [], "put /v1/prv/payments/customer": [], "get /v1/prv/payments/campaign-quote": [], "get /v1/prv/payments/deposit-details": [], "get /v1/prv/payments/payouts-overview": [], "get /v1/prv/payments/upcoming-settlements": [], "get /v1/prv/payments/campaign-results": [], "get /v1/prv/saved-replies": [], "post /v1/prv/saved-replies": [], "delete /v1/prv/saved-replies/:savedReplyId": [], "put /v1/prv/saved-replies/:savedReplyId": [], "post /v1/prv/pusher/auth": [], "get /v1/prv/linkedin-sender": [], "delete /v1/prv/linkedin-sender": [], "put /v1/prv/linkedin-sender/schedule": [], "post /v1/prv/linkedin-sender/cloud-login": [], "get /v1/prv/linkedin-sender/cloud-login": [], "post /v1/prv/linkedin-sender/cloud-login/resume": [], "get /v1/smm-prv/campaigns": [], "post /v1/smm-prv/campaigns/apply": [], "get /v1/smm-prv/campaigns/applied": [], "get /v1/smm-prv/campaigns/:campaignId": [], "get /v1/smm-prv/creator-applications": [], "put /v1/smm-prv/creator-applications": [], "get /v1/smm-prv/creator-applications/overview": [], "get /v1/smm-prv/creator-applications/count": [], "get /v1/smm-prv/creator-applications/has-any": [], "get /v1/smm-prv/creator-applications/by-id/:creatorApplicationId": [], "get /v1/smm-prv/creator-applications/:campaignId": [], "post /v1/smm-prv/creator-applications/negociate": [], "get /v1/smm-prv/brands/applied-to": [], "get /v1/smm-prv/brands/:brandId": [], "get /v1/smm-prv/creators/me": [], "post /v1/smm-prv/creators/adopt-sourced": [], "post /v1/smm-prv/creators/populate": [], "put /v1/smm-prv/creators/privacy": [], "get /v1/smm-prv/conversations": [], "get /v1/smm-prv/conversations/unread-count": [], "post /v1/smm-prv/conversations/messages": [], "get /v1/smm-prv/conversations/:conversationId/messages": [], "put /v1/smm-prv/conversations/:conversationId/read": [], "put /v1/smm-prv/conversations/:conversationId/unread": [], "post /v1/smm-prv/conversations/:conversationId/upload": [], "get /v1/smm-prv/nps": [], "post /v1/smm-prv/nps": [], "get /v1/smm-prv/payments/payouts": [], "get /v1/smm-prv/payments/earnings": [], "get /v1/smm-prv/payments/recent-payouts": [], "get /v1/smm-prv/saved-replies": [], "post /v1/smm-prv/saved-replies": [], "delete /v1/smm-prv/saved-replies/:savedReplyId": [], "put /v1/smm-prv/saved-replies/:savedReplyId": [], "get /v1/smm-prv/sponsors": [], "get /v1/smm-prv/sponsors/tags": [], "get /v1/smm-prv/sponsors/contacts": [], "put /v1/smm-prv/sponsors/contact": [], "delete /v1/smm-prv/sponsors/contact": [], "get /v1/smm-prv/sponsors/:sponsorId": [], "get /v1/open/me": [], "get /v1/open/sponsors": [], "get /v1/open/sponsors/tags": [], "get /v1/open/sponsors/tracked": [], "put /v1/open/sponsors/contact": [], "get /v1/open/sponsors/:sponsorId": [], "get /v1/open/sponsors/:sponsorId/outreach-context": [], "get /v1/open/brand/brands": [], "post /v1/open/brand/brands": [], "get /v1/open/brand/creators": [], "post /v1/open/brand/campaigns": [], "post /v1/open/brand/campaigns/invite": [], "post /v1/adm/conversations/send-automatic-message": [], "post /v1/adm/populateOneCreator": [], "post /v1/adm/populateAllCreators": [], "post /v1/adm/excludeCreator": [], "post /v1/adm/runPostChecks": [], "get /v1/stf/linkedin-message-recovery": [], "post /v1/stf/linkedin-message-recovery/confirm-not-sent": [], "get /v1/stf/linkedin-pool": [], "post /v1/stf/linkedin-pool": [], "patch /v1/stf/linkedin-pool/:accountId": [], "delete /v1/stf/linkedin-pool/:accountId": [], "post /v1/stf/linkedin-pool/:accountId/cloud-login": [], "get /v1/stf/linkedin-pool/:accountId/cloud-login": [], "post /v1/stf/linkedin-pool/:accountId/cloud-login/resume": [], "get /v1/stf/users": [], "get /v1/stf/campaigns": [], "post /v1/stf/campaigns/force-close": [], "post /v1/stf/campaigns/confirm-manual-refund": [], "post /v1/stf/campaigns/confirm-out-of-band-payment": [], "post /v1/stf/campaigns/delete": [], "post /v1/stf/creator-applications/reinstate": [], "post /v1/stf/generate-actor-token": [], "get /v1/stf/nps-ratings": [], "post /v1/stf/trigger-pay-sponsored-posts": [], "get /v1/stf/payouts-to-pay": [], "get /v1/stf/payouts-paid": [], "get /v1/stf/payouts-blocked": [], "post /v1/stf/payouts/cancel-export": [], "post /v1/stf/payouts/create-export": [], "post /v1/stf/payouts/get-export": [], "post /v1/stf/payouts/mark-paid": [], "post /v1/stf/payouts/upload-transfer-proof": [], "post /v1/stf/payouts/verify-vat": [] };

const parseRequest = (request: string) => request.split(/ (.+)/, 2) as [
    Method,
    Path
];

const substitute = (path: string, params: Record<string, any>) => { const rest = { ...params }; for (const key in params) {
    path = path.replace(`:${key}`, () => { delete rest[key]; return params[key]; });
} return [path, rest] as const; };

export type Implementation<T = unknown> = (method: Method, path: string, params: Record<string, any>, ctx?: T) => Promise<any>;

const defaultImplementation: Implementation = async (method, path, params) => { const hasBody = !["get", "delete"].includes(method); const searchParams = hasBody ? "" : `?${new URLSearchParams(params)}`; const response = await fetch(new URL(`${path}${searchParams}`, "https://example.com"), { method: method.toUpperCase(), headers: hasBody ? { "Content-Type": "application/json" } : undefined, body: hasBody ? JSON.stringify(params) : undefined }); const contentType = response.headers.get("content-type"); if (!contentType)
    return; const isJSON = contentType.startsWith("application/json"); return response[isJSON ? "json" : "text"](); };

export class Client<T> {
    public constructor(protected readonly implementation: Implementation<T> = defaultImplementation) { }
    public provide<K extends Request>(request: K, params: Input[K], ctx?: T): Promise<Response[K]> { const [method, path] = parseRequest(request); return this.implementation(method, ...substitute(path, params), ctx); }
}

export class Subscription<K extends Extract<Request, `get ${string}`>, R extends Extract<PositiveResponse[K], { event: string; }>> {
    public source: EventSource;
    public constructor(request: K, params: Input[K]) { const [path, rest] = substitute(parseRequest(request)[1], params); const searchParams = `?${new URLSearchParams(rest)}`; this.source = new EventSource(new URL(`${path}${searchParams}`, "https://example.com")); }
    public on<E extends R["event"]>(event: E, handler: (data: Extract<R, { event: E; }>["data"]) => void | Promise<void>) { this.source.addEventListener(event, msg => handler(JSON.parse((msg as MessageEvent).data))); return this; }
}

// Usage example:
/*
const client = new Client();
client.provide("get /v1/user/retrieve", { id: "10" })
new Subscription("get /v1/events/stream", {}).on("time", time => { })*/ 